(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("@retainit/shared", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["@retainit/shared"] = factory(require("react"), require("react-dom"));
	else
		root["@retainit/shared"] = factory(root["react"], root["react-dom"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__115__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ([
/* 0 */,
/* 1 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(106);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(105);
/* harmony import */ var _requests__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);
/* harmony import */ var _components_QuizModal_QuizModalFull__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(107);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var resizeWindowMeasure = function () {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
};
window.addEventListener("resize", resizeWindowMeasure);
resizeWindowMeasure();
function QuizModal(props) {
    var _this = this;
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), quiz = _a[0], setQuiz = _a[1];
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(window.innerWidth < _config__WEBPACK_IMPORTED_MODULE_2__.MOBILE_BREAKPOINT), isMobile = _b[0], setIsMobile = _b[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        window.addEventListener("resize", handleWindowSizeChange);
        return function () {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    });
    function handleWindowSizeChange() {
        if (isMobile && window.innerWidth >= _config__WEBPACK_IMPORTED_MODULE_2__.MOBILE_BREAKPOINT) {
            setIsMobile(false);
            return;
        }
        if (!isMobile && window.innerWidth < _config__WEBPACK_IMPORTED_MODULE_2__.MOBILE_BREAKPOINT) {
            setIsMobile(true);
            return;
        }
    }
    var loadQuiz = function (quizId) { return __awaiter(_this, void 0, void 0, function () {
        var quiz;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0,_requests__WEBPACK_IMPORTED_MODULE_3__.getQuizData)(quizId)];
                case 1:
                    quiz = _a.sent();
                    if (quiz) {
                        setQuiz(quiz);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        (0,_requests__WEBPACK_IMPORTED_MODULE_3__.setupRequests)({
            "X-Retainit-Origin": props.origin,
        });
        loadQuiz(props.quizId);
    }, []);
    var handleFinished = props.handleClose
        ? function (result) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!result.openNext) return [3 /*break*/, 2];
                        return [4 /*yield*/, loadQuiz(result.openNext.quiz)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        (_a = props === null || props === void 0 ? void 0 : props.handleClose) === null || _a === void 0 ? void 0 : _a.call(props, result);
                        return [2 /*return*/];
                }
            });
        }); }
        : undefined;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_4__.AppConfigContext), stats = _c.stats, refreshStats = _c.refreshStats;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        refreshStats();
    }, [refreshStats]);
    var startingXp = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
        return stats === null || stats === void 0 ? void 0 : stats.xp;
    }, [stats === null || stats === void 0 ? void 0 : stats.xp]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__.ErrorBoundary, { children: quiz && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_QuizModal_QuizModalFull__WEBPACK_IMPORTED_MODULE_6__["default"], { quiz: quiz, show: true, handleClose: handleFinished, meta: props.meta, quizId: props.quizId, origin: props.origin, nextUp: props.nextUp, userData: {
                startingXP: startingXp,
            }, hideChapterCards: props.hideChapterCards, noBackground: props.noBackground }, quiz.id)) }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizModal);


/***/ }),
/* 2 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (process.env.NODE_ENV === 'production') {
  module.exports = __webpack_require__(3);
} else {
  module.exports = __webpack_require__(5);
}


/***/ }),
/* 3 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=__webpack_require__(4),k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}exports.Fragment=l;exports.jsx=q;exports.jsxs=q;


/***/ }),
/* 4 */
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),
/* 5 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {
'use strict';

var React = __webpack_require__(4);

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types.
var REACT_ELEMENT_TYPE = Symbol.for('react.element');
var REACT_PORTAL_TYPE = Symbol.for('react.portal');
var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
var REACT_CONTEXT_TYPE = Symbol.for('react.context');
var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
var REACT_MEMO_TYPE = Symbol.for('react.memo');
var REACT_LAZY_TYPE = Symbol.for('react.lazy');
var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

function error(format) {
  {
    {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      printWarning('error', format, args);
    }
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    } // eslint-disable-next-line react-internal/safe-string-coercion


    var argsWithFormat = args.map(function (item) {
      return String(item);
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

// -----------------------------------------------------------------------------

var enableScopeAPI = false; // Experimental Create Event Handle API.
var enableCacheElement = false;
var enableTransitionTracing = false; // No known bugs, but needs performance testing

var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
// stuff. Intended to enable React core members to more easily debug scheduling
// issues in DEV builds.

var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

var REACT_MODULE_REFERENCE;

{
  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
}

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
    // types supported by any Flight configuration anywhere since
    // we don't know which Flight build this will end up being used
    // with.
    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
      return true;
    }
  }

  return false;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var displayName = outerType.displayName;

  if (displayName) {
    return displayName;
  }

  var functionName = innerType.displayName || innerType.name || '';
  return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
} // Keep in sync with react-reconciler/getComponentNameFromFiber


function getContextName(type) {
  return type.displayName || 'Context';
} // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.


function getComponentNameFromType(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case REACT_FRAGMENT_TYPE:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return 'Profiler';

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';

  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        var outerName = type.displayName || null;

        if (outerName !== null) {
          return outerName;
        }

        return getComponentNameFromType(type.type) || 'Memo';

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentNameFromType(init(payload));
          } catch (x) {
            return null;
          }
        }

      // eslint-disable-next-line no-fallthrough
    }
  }

  return null;
}

var assign = Object.assign;

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: assign({}, props, {
          value: prevLog
        }),
        info: assign({}, props, {
          value: prevInfo
        }),
        warn: assign({}, props, {
          value: prevWarn
        }),
        error: assign({}, props, {
          value: prevError
        }),
        group: assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if ( !fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                // but we have a user-provided "displayName"
                // splice it in to make the stack more readable.


                if (fn.displayName && _frame.includes('<anonymous>')) {
                  _frame = _frame.replace('<anonymous>', fn.displayName);
                }

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case REACT_SUSPENSE_TYPE:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

var loggedTypeFailures = {};
var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            // eslint-disable-next-line react-internal/prod-error-codes
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

function isArray(a) {
  return isArrayImpl(a);
}

/*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */
// $FlowFixMe only called in DEV, so void return is not possible.
function typeName(value) {
  {
    // toStringTag is needed for namespaced types like Temporal.Instant
    var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
    var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
    return type;
  }
} // $FlowFixMe only called in DEV, so void return is not possible.


function willCoercionThrow(value) {
  {
    try {
      testStringCoercion(value);
      return false;
    } catch (e) {
      return true;
    }
  }
}

function testStringCoercion(value) {
  // If you ended up here by following an exception call stack, here's what's
  // happened: you supplied an object or symbol value to React (as a prop, key,
  // DOM attribute, CSS property, string ref, etc.) and when React tried to
  // coerce it to a string using `'' + value`, an exception was thrown.
  //
  // The most common types that will cause this exception are `Symbol` instances
  // and Temporal objects like `Temporal.Instant`. But any object that has a
  // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
  // exception. (Library authors do this to prevent users from using built-in
  // numeric operators like `+` or comparison operators like `>=` because custom
  // methods are needed to perform accurate arithmetic or comparison.)
  //
  // To fix the problem, coerce this object or symbol value to a string before
  // passing it to React. The most reliable way is usually `String(value)`.
  //
  // To find which value is throwing, check the browser or debugger console.
  // Before this exception was thrown, there should be `console.error` output
  // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
  // problem and how that type was used: key, atrribute, input value prop, etc.
  // In most cases, this console output also shows the component and its
  // ancestor components where the exception happened.
  //
  // eslint-disable-next-line react-internal/safe-string-coercion
  return '' + value;
}
function checkKeyStringCoercion(value) {
  {
    if (willCoercionThrow(value)) {
      error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));

      return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
    }
  }
}

var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown;
var specialPropRefWarningShown;
var didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function warnIfStringRefCannotBeAutoConverted(config, self) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
      var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}

function defineKeyPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingKey = function () {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingKey.isReactWarning = true;
    Object.defineProperty(props, 'key', {
      get: warnAboutAccessingKey,
      configurable: true
    });
  }
}

function defineRefPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingRef = function () {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingRef.isReactWarning = true;
    Object.defineProperty(props, 'ref', {
      get: warnAboutAccessingRef,
      configurable: true
    });
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */

function jsxDEV(type, config, maybeKey, source, self) {
  {
    var propName; // Reserved names are extracted

    var props = {};
    var key = null;
    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
    // but as an intermediary step, we will use jsxDEV for everything except
    // <div {...props} key="Hi" />, because we aren't currently able to tell if
    // key is explicitly declared to be undefined or not.

    if (maybeKey !== undefined) {
      {
        checkKeyStringCoercion(maybeKey);
      }

      key = '' + maybeKey;
    }

    if (hasValidKey(config)) {
      {
        checkKeyStringCoercion(config.key);
      }

      key = '' + config.key;
    }

    if (hasValidRef(config)) {
      ref = config.ref;
      warnIfStringRefCannotBeAutoConverted(config, self);
    } // Remaining properties are added to a new props object


    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    } // Resolve default props


    if (type && type.defaultProps) {
      var defaultProps = type.defaultProps;

      for (propName in defaultProps) {
        if (props[propName] === undefined) {
          props[propName] = defaultProps[propName];
        }
      }
    }

    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }

    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
  }
}

var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement$1(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */


function isValidElement(object) {
  {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  }
}

function getDeclarationErrorAddendum() {
  {
    if (ReactCurrentOwner$1.current) {
      var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);

      if (name) {
        return '\n\nCheck the render method of `' + name + '`.';
      }
    }

    return '';
  }
}

function getSourceInfoErrorAddendum(source) {
  {
    if (source !== undefined) {
      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
      var lineNumber = source.lineNumber;
      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
    }

    return '';
  }
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  {
    var info = getDeclarationErrorAddendum();

    if (!info) {
      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

      if (parentName) {
        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
      }
    }

    return info;
  }
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  {
    if (!element._store || element._store.validated || element.key != null) {
      return;
    }

    element._store.validated = true;
    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
      return;
    }

    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
    // property, it may be the creator of the child that's responsible for
    // assigning it a key.

    var childOwner = '';

    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
      // Give the component that originally created this child.
      childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
    }

    setCurrentlyValidatingElement$1(element);

    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

    setCurrentlyValidatingElement$1(null);
  }
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  {
    if (typeof node !== 'object') {
      return;
    }

    if (isArray(node)) {
      for (var i = 0; i < node.length; i++) {
        var child = node[i];

        if (isValidElement(child)) {
          validateExplicitKey(child, parentType);
        }
      }
    } else if (isValidElement(node)) {
      // This element was passed in a valid location.
      if (node._store) {
        node._store.validated = true;
      }
    } else if (node) {
      var iteratorFn = getIteratorFn(node);

      if (typeof iteratorFn === 'function') {
        // Entry iterators used to provide implicit keys,
        // but now we print a separate warning for them later.
        if (iteratorFn !== node.entries) {
          var iterator = iteratorFn.call(node);
          var step;

          while (!(step = iterator.next()).done) {
            if (isValidElement(step.value)) {
              validateExplicitKey(step.value, parentType);
            }
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      // Intentionally inside to avoid triggering lazy initializers:
      var name = getComponentNameFromType(type);
      checkPropTypes(propTypes, element.props, 'prop', name, element);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

      var _name = getComponentNameFromType(type);

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        setCurrentlyValidatingElement$1(fragment);

        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        setCurrentlyValidatingElement$1(null);
        break;
      }
    }

    if (fragment.ref !== null) {
      setCurrentlyValidatingElement$1(fragment);

      error('Invalid attribute `ref` supplied to `React.Fragment`.');

      setCurrentlyValidatingElement$1(null);
    }
  }
}

function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
  {
    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
    // succeed and there will likely be errors in render.

    if (!validType) {
      var info = '';

      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
      }

      var sourceInfo = getSourceInfoErrorAddendum(source);

      if (sourceInfo) {
        info += sourceInfo;
      } else {
        info += getDeclarationErrorAddendum();
      }

      var typeString;

      if (type === null) {
        typeString = 'null';
      } else if (isArray(type)) {
        typeString = 'array';
      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
        typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
        info = ' Did you accidentally export a JSX literal instead of a component?';
      } else {
        typeString = typeof type;
      }

      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }

    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
    // TODO: Drop this when these are no longer allowed as the type argument.

    if (element == null) {
      return element;
    } // Skip key warning if the type isn't valid since our key validation logic
    // doesn't expect a non-string/function type and can throw confusing errors.
    // We don't want exception behavior to differ between dev and prod.
    // (Rendering will throw with a helpful message and as soon as the type is
    // fixed, the key warnings will appear.)


    if (validType) {
      var children = props.children;

      if (children !== undefined) {
        if (isStaticChildren) {
          if (isArray(children)) {
            for (var i = 0; i < children.length; i++) {
              validateChildKeys(children[i], type);
            }

            if (Object.freeze) {
              Object.freeze(children);
            }
          } else {
            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
          }
        } else {
          validateChildKeys(children, type);
        }
      }
    }

    if (type === REACT_FRAGMENT_TYPE) {
      validateFragmentProps(element);
    } else {
      validatePropTypes(element);
    }

    return element;
  }
} // These two functions exist to still get child warnings in dev
// even with the prod transform. This means that jsxDEV is purely
// opt-in behavior for better messages but that we won't stop
// giving you warnings if you use production apis.

function jsxWithValidationStatic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, true);
  }
}
function jsxWithValidationDynamic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, false);
  }
}

var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
// for now we can ship identical prod functions

var jsxs =  jsxWithValidationStatic ;

exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsx;
exports.jsxs = jsxs;
  })();
}


/***/ }),
/* 6 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BASE_API": () => (/* binding */ BASE_API),
/* harmony export */   "BASE_LINK": () => (/* binding */ BASE_LINK),
/* harmony export */   "BASE_URL": () => (/* binding */ BASE_URL),
/* harmony export */   "MOBILE_BREAKPOINT": () => (/* binding */ MOBILE_BREAKPOINT),
/* harmony export */   "ROOTID": () => (/* binding */ ROOTID),
/* harmony export */   "THRESHOLD": () => (/* binding */ THRESHOLD),
/* harmony export */   "VERSION": () => (/* binding */ VERSION),
/* harmony export */   "WIDGETHEIGHT": () => (/* binding */ WIDGETHEIGHT),
/* harmony export */   "WIDGETOFFSET": () => (/* binding */ WIDGETOFFSET)
/* harmony export */ });
var BASE_URL = "https://storage.googleapis.com/staging.retainit.appspot.com/demo-widget";
// export const BASE_URL = "http://127.0.0.1:8080/";
//export const BASE_API= "https://retainit.app/api"
var BASE_API = process.env.REACT_APP_BASE ? "https://api.".concat(process.env.REACT_APP_BASE, "/api") : "http://localhost:4000/api";
var BASE_LINK = process.env.REACT_APP_BASE ? "https://".concat(process.env.REACT_APP_BASE) : "http://localhost:3000";
// export const BASE_API = "https://backendv2-staging-47nee6n7sa-ew.a.run.app/api"
var WIDGETHEIGHT = 61;
var WIDGETOFFSET = 87 / 100;
var THRESHOLD = 20;
var ROOTID = "retainit-root";
var MOBILE_BREAKPOINT = 992;
var VERSION = "1.0.0";


/***/ }),
/* 7 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FeedItemType": () => (/* binding */ FeedItemType),
/* harmony export */   "createChapter": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.createChapter),
/* harmony export */   "createCourse": () => (/* binding */ createCourse),
/* harmony export */   "createMedia": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.createMedia),
/* harmony export */   "createMediaForLink": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.createMediaForLink),
/* harmony export */   "createPartner": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.createPartner),
/* harmony export */   "createPublisher": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.createPublisher),
/* harmony export */   "createQuestion": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.createQuestion),
/* harmony export */   "createUploadMedia": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.createUploadMedia),
/* harmony export */   "createUserCourse": () => (/* binding */ createUserCourse),
/* harmony export */   "deleteChapter": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.deleteChapter),
/* harmony export */   "deleteCourse": () => (/* binding */ deleteCourse),
/* harmony export */   "deleteMedia": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.deleteMedia),
/* harmony export */   "deletePartner": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.deletePartner),
/* harmony export */   "deleteReview": () => (/* binding */ deleteReview),
/* harmony export */   "deleteTopic": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.deleteTopic),
/* harmony export */   "deleteUser": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.deleteUser),
/* harmony export */   "dismissAllNotifications": () => (/* binding */ dismissAllNotifications),
/* harmony export */   "fetchData": () => (/* binding */ fetchData),
/* harmony export */   "generatePartnerQuiz": () => (/* binding */ generatePartnerQuiz),
/* harmony export */   "generateQuiz": () => (/* binding */ generateQuiz),
/* harmony export */   "getAdminHomeFeed": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.getAdminHomeFeed),
/* harmony export */   "getAllMedia": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.getAllMedia),
/* harmony export */   "getAllPartners": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.getAllPartners),
/* harmony export */   "getAllPublishers": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.getAllPublishers),
/* harmony export */   "getAllRequests": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.getAllRequests),
/* harmony export */   "getAllTopics": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.getAllTopics),
/* harmony export */   "getAllUsers": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.getAllUsers),
/* harmony export */   "getCountedUsers": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.getCountedUsers),
/* harmony export */   "getCourse": () => (/* binding */ getCourse),
/* harmony export */   "getCourses": () => (/* binding */ getCourses),
/* harmony export */   "getFilteredMedia": () => (/* binding */ getFilteredMedia),
/* harmony export */   "getGenerations": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.getGenerations),
/* harmony export */   "getHomeFeed": () => (/* binding */ getHomeFeed),
/* harmony export */   "getMedia": () => (/* binding */ getMedia),
/* harmony export */   "getMediaData": () => (/* binding */ getMediaData),
/* harmony export */   "getMediaFromQuiz": () => (/* binding */ getMediaFromQuiz),
/* harmony export */   "getMediaReview": () => (/* binding */ getMediaReview),
/* harmony export */   "getMedias": () => (/* binding */ getMedias),
/* harmony export */   "getMyNotifications": () => (/* binding */ getMyNotifications),
/* harmony export */   "getMyTopics": () => (/* binding */ getMyTopics),
/* harmony export */   "getPublisher": () => (/* binding */ getPublisher),
/* harmony export */   "getQuestionFeedback": () => (/* binding */ getQuestionFeedback),
/* harmony export */   "getQuiz": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.getQuiz),
/* harmony export */   "getQuizData": () => (/* binding */ getQuizData),
/* harmony export */   "getQuizFeedback": () => (/* binding */ getQuizFeedback),
/* harmony export */   "getQuizzes": () => (/* binding */ getQuizzes),
/* harmony export */   "getRecommendations": () => (/* binding */ getRecommendations),
/* harmony export */   "getRecommendationsForMedia": () => (/* binding */ getRecommendationsForMedia),
/* harmony export */   "getTags": () => (/* binding */ getTags),
/* harmony export */   "getTopic": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.getTopic),
/* harmony export */   "getTopics": () => (/* binding */ getTopics),
/* harmony export */   "getTranscript": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.getTranscript),
/* harmony export */   "getUserAchievements": () => (/* binding */ getUserAchievements),
/* harmony export */   "getUserCourse": () => (/* binding */ getUserCourse),
/* harmony export */   "getUserCourses": () => (/* binding */ getUserCourses),
/* harmony export */   "getUserData": () => (/* binding */ getUserData),
/* harmony export */   "getUserMediaTags": () => (/* binding */ getUserMediaTags),
/* harmony export */   "getUserPinned": () => (/* binding */ getUserPinned),
/* harmony export */   "getUserStats": () => (/* binding */ getUserStats),
/* harmony export */   "logMetrics": () => (/* binding */ logMetrics),
/* harmony export */   "refreshToken": () => (/* binding */ refreshToken),
/* harmony export */   "registerFCMToken": () => (/* binding */ registerFCMToken),
/* harmony export */   "requestQuiz": () => (/* binding */ requestQuiz),
/* harmony export */   "requestReminder": () => (/* binding */ requestReminder),
/* harmony export */   "saveAllChanges": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.saveAllChanges),
/* harmony export */   "saveChapter": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.saveChapter),
/* harmony export */   "saveNewUser": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.saveNewUser),
/* harmony export */   "saveQuestionAnswer": () => (/* binding */ saveQuestionAnswer),
/* harmony export */   "saveQuizAnswers": () => (/* binding */ saveQuizAnswers),
/* harmony export */   "saveQuizToLibrary": () => (/* binding */ saveQuizToLibrary),
/* harmony export */   "saveUserChange": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.saveUserChange),
/* harmony export */   "saveUserTopics": () => (/* binding */ saveUserTopics),
/* harmony export */   "sendMeTestNotification": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.sendMeTestNotification),
/* harmony export */   "setCourse": () => (/* binding */ setCourse),
/* harmony export */   "setPartner": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.setPartner),
/* harmony export */   "setQuestionFeedback": () => (/* binding */ setQuestionFeedback),
/* harmony export */   "setQuizFeedback": () => (/* binding */ setQuizFeedback),
/* harmony export */   "setUserCourse": () => (/* binding */ setUserCourse),
/* harmony export */   "setUserMediaTags": () => (/* binding */ setUserMediaTags),
/* harmony export */   "setUserPinned": () => (/* binding */ setUserPinned),
/* harmony export */   "setUserPublisher": () => (/* binding */ setUserPublisher),
/* harmony export */   "setUserTopic": () => (/* binding */ setUserTopic),
/* harmony export */   "setupRequests": () => (/* binding */ setupRequests),
/* harmony export */   "signUserOut": () => (/* binding */ signUserOut),
/* harmony export */   "updateFeedItem": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.updateFeedItem),
/* harmony export */   "updateMedia": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.updateMedia),
/* harmony export */   "updateNotification": () => (/* binding */ updateNotification),
/* harmony export */   "updateORCreateTopic": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.updateORCreateTopic),
/* harmony export */   "updatePublisher": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.updatePublisher),
/* harmony export */   "updateQuestion": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.updateQuestion),
/* harmony export */   "updateQuestionsForChapter": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.updateQuestionsForChapter),
/* harmony export */   "useAllUsers": () => (/* reexport safe */ _admin__WEBPACK_IMPORTED_MODULE_3__.useAllUsers),
/* harmony export */   "useMedia": () => (/* binding */ useMedia),
/* harmony export */   "useMediaReview": () => (/* binding */ useMediaReview),
/* harmony export */   "useReview": () => (/* binding */ useReview),
/* harmony export */   "useUserAchievements": () => (/* binding */ useUserAchievements),
/* harmony export */   "useUserActivity": () => (/* binding */ useUserActivity),
/* harmony export */   "useUserStats": () => (/* binding */ useUserStats)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var _buildUseFetch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
/* harmony import */ var _admin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



// rename this to directory to api, not done now to avoid breaking changes
var headers = new Headers({
    "Content-Type": "application/json",
});
var setupRequests = function (otherHeaders) {
    Object.keys(otherHeaders).forEach(function (key) {
        headers.set(key, otherHeaders[key]);
    });
};
var fetchData = function (path, method, body, query, signal) {
    if (path === void 0) { path = "/"; }
    if (method === void 0) { method = "GET"; }
    if (body === void 0) { body = undefined; }
    if (query === void 0) { query = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var searchParams, queryString, url, config, response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    searchParams = new URLSearchParams((0,_utils__WEBPACK_IMPORTED_MODULE_0__.stripUndefined)(query));
                    queryString = searchParams.toString() ? "?".concat(searchParams.toString()) : "";
                    url = "".concat(_config__WEBPACK_IMPORTED_MODULE_1__.BASE_API).concat(path).concat(queryString);
                    config = {
                        method: method,
                        headers: headers,
                        body: JSON.stringify(body),
                        credentials: "include",
                        signal: signal,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, config)];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, response.json()];
                case 3: return [2 /*return*/, _a.sent()];
                case 4:
                    err_1 = _a.sent();
                    if (process.env.NODE_ENV !== "production") {
                        console.error("Error fetching ".concat(url, ": ").concat(err_1));
                    }
                    // todo, allow this to throw so that reacy-query can handle it
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    });
};
var updateNotification = function (notificationId, status) {
    return fetchData("/user/notifications/".concat(notificationId), "PUT", { status: status });
};
var dismissAllNotifications = function () { return fetchData("/user/notifications/dismiss", "POST"); };
var getMyNotifications = function () { return fetchData("/user/notifications"); };
var getQuizData = function (quizId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/quiz/".concat(quizId))];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getMyTopics = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/user/topics")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getTopics = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/media/tags")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var saveUserTopics = function (topics) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/user/topics", "POST", topics)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var requestQuiz = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var body;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                body = { url: url };
                return [4 /*yield*/, fetchData("/requests", "POST", body)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getRecommendations = function (topic) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/media/recommendations", "GET", undefined, { topic: topic })];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var saveQuizToLibrary = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var body;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                body = { quiz: id };
                return [4 /*yield*/, fetchData("/library/quizzes", "POST", body)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getRecommendationsForMedia = function (mediaId, opts) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/media/".concat(mediaId, "/recommendations"), "GET", undefined, opts)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var generateQuiz = function (url, options, reviewAt) { return __awaiter(void 0, void 0, void 0, function () {
    var body;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                body = __assign(__assign({ url: url }, (reviewAt ? { reviewAt: reviewAt } : {})), options);
                return [4 /*yield*/, fetchData("/media/generate", "POST", body)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var generatePartnerQuiz = function (url) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/partner/quiz", "GET", undefined, { url: url })];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var requestReminder = function (selection, mediaId, next) { return __awaiter(void 0, void 0, void 0, function () {
    var body;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                body = {
                    dateTime: selection === null || selection === void 0 ? void 0 : selection.toISOString(),
                    timezone: selection === null || selection === void 0 ? void 0 : selection.getTimezoneOffset(),
                    next: next || false,
                };
                return [4 /*yield*/, fetchData("/media/".concat(mediaId, "/review"), "POST", body)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getTags = function (search, page) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchData("/tags", "GET", undefined, __assign(__assign({}, (search !== undefined ? { search: search } : {})), (page !== undefined ? { page: page } : {})))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getUserMediaTags = function (mediaId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/media/".concat(mediaId, "/tags"), "GET")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var setUserMediaTags = function (mediaId, tags) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/media/".concat(mediaId, "/tags"), "POST", { tags: tags })];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var saveQuestionAnswer = function (quizId, questionId, data) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/quiz/answer/".concat(quizId, "/").concat(questionId), "POST", data)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var saveQuizAnswers = function (quizId, answerIds) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/quiz/answer/".concat(quizId), "POST", answerIds)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var logMetrics = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var nav, navigator;
    return __generator(this, function (_a) {
        nav = window.navigator;
        navigator = {
            userAgentData: nav.userAgentData,
            languages: nav.languages,
            platform: nav.platform,
            innerHeight: window.innerHeight,
            innerWidth: window.innerWidth,
        };
        fetchData("/metrics", "POST", __assign(__assign({}, data), { navigator: navigator }));
        return [2 /*return*/];
    });
}); };
var getUserData = function (user) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/auth/login", "POST", user)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getQuestionFeedback = function (quizId, questionId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, fetchData("/quiz/feedback/".concat(quizId, "/").concat(questionId))];
}); }); };
var setQuestionFeedback = function (quizId, questionId, feedback) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, fetchData("/quiz/feedback/".concat(quizId, "/").concat(questionId), "POST", feedback)];
}); }); };
var getQuizFeedback = function (quizId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, fetchData("/quiz/feedback/".concat(quizId))];
}); }); };
var setQuizFeedback = function (quizId, feedback) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, fetchData("/quiz/feedback/".concat(quizId), "POST", feedback)];
}); }); };
var getMedia = function (mediaId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/media/".concat(mediaId), "GET")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var signUserOut = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/auth/logout", "POST")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getMediaData = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var body;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                body = JSON.stringify({ url: url });
                return [4 /*yield*/, fetchData("/media", "POST", body)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var deleteReview = function (mediaId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/user/reviews/".concat(mediaId), "DELETE")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getUserStats = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/user/stats")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var useUserStats = (0,_buildUseFetch__WEBPACK_IMPORTED_MODULE_2__.buildUseFetch)("/user/stats", "GET");
var useMedia = (0,_buildUseFetch__WEBPACK_IMPORTED_MODULE_2__.buildUseFetch)("/media/url", "GET");
var useMediaReview = (0,_buildUseFetch__WEBPACK_IMPORTED_MODULE_2__.buildUseFetch)("/media/:mediaId/review", "GET");
var registerFCMToken = function (token, device) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchData("/user/notifications/registration", "POST", {
                    token: token,
                    device: device,
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var useReview = (0,_buildUseFetch__WEBPACK_IMPORTED_MODULE_2__.buildUseFetch)("/user/reviews", "GET");
var useUserActivity = (0,_buildUseFetch__WEBPACK_IMPORTED_MODULE_2__.buildUseFetch)("/user/activity", "GET");
var useUserAchievements = (0,_buildUseFetch__WEBPACK_IMPORTED_MODULE_2__.buildUseFetch)("/user/achievements", "GET");
var getUserAchievements = function (query) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/user/achievements", "GET", undefined, query)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var setUserTopic = function (topicId, value) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/user/topics/".concat(topicId), "PUT", value)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var setUserPublisher = function (publisherId, value) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/user/publishers/".concat(publisherId), "PUT", value)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getMediaReview = function (mediaId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/user/reviews/".concat(mediaId))];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var refreshToken = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/auth/refresh")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getCourses = function (search, publisher) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchData("/course/", "GET", undefined, __assign(__assign({}, (search ? { search: search } : {})), (publisher ? { publisher: publisher } : {})))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var createCourse = function (course) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/course", "POST", course)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getCourse = function (courseId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/course/".concat(courseId), "GET")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var setCourse = function (course) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/course/".concat(course.id), "PUT", course)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var deleteCourse = function (courseId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/course/".concat(courseId), "DELETE")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getPublisher = function (publisherId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/publishers/".concat(publisherId), "GET", undefined)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getQuizzes = function (search) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/quiz/", "GET", undefined, search ? { search: search } : {})];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
/**
 * @deprecated
 */
var getFilteredMedia = function (filter, config) { return __awaiter(void 0, void 0, void 0, function () {
    var confType, newConfig;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                confType = config.type;
                newConfig = __assign({}, config);
                delete newConfig.type;
                return [4 /*yield*/, fetchData("/media", "GET", undefined, __assign((_a = {}, _a[confType] = filter, _a), newConfig))];
            case 1: return [2 /*return*/, _b.sent()];
        }
    });
}); };
// todo, merge the above deprecated getFilteredMedia and getMedias, such that all query parameters are expoesed as parameters of the function
var getMedias = function (title) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/media", "GET", undefined, title ? { title: title } : {})];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getMediaFromQuiz = function (quizId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/quiz/".concat(quizId, "/media"), "GET")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getUserCourses = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/user/course", "GET")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getUserCourse = function (courseId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/user/course/".concat(courseId), "GET")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var createUserCourse = function (course) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/user/course/", "POST", course)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var setUserCourse = function (course) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/user/course/".concat(course.id), "PUT")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getUserPinned = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/user/pinned/", "GET")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var setUserPinned = function (pinned) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fetchData("/user/pinned/", "PUT", pinned)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var FeedItemType = ["QuizCreated"];
var getHomeFeed = function (params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, fetchData("/feed", "GET", undefined, params)];
}); }); };



/***/ }),
/* 8 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "stripUndefined": () => (/* binding */ stripUndefined)
/* harmony export */ });
// Return a *new* object with properties === undefined filtered out
function stripUndefined(object) {
    return Object.fromEntries(Object.entries(object).filter(function (_a) {
        var val = _a[1];
        return val !== undefined;
    }));
}


/***/ }),
/* 9 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildUseFetch": () => (/* binding */ buildUseFetch)
/* harmony export */ });
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/**
 * @deprecated use react-query instead
 */
var buildUseFetch = function (url, method) {
    return function (args, options) {
        var _a = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), result = _a[0], setResult = _a[1];
        var _b = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("loading"), status = _b[0], setStatus = _b[1];
        var _c = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), error = _c[0], setError = _c[1];
        var _d = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(args === null || args === void 0 ? void 0 : args.body), cachedBody = _d[0], setCachedBody = _d[1];
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
            if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default()(cachedBody, args === null || args === void 0 ? void 0 : args.body)) {
                // deep equals
                setCachedBody(args === null || args === void 0 ? void 0 : args.body);
            }
        }, [cachedBody, args === null || args === void 0 ? void 0 : args.body]);
        var _e = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(args === null || args === void 0 ? void 0 : args.quary), cachedQuary = _e[0], setCachedQuary = _e[1];
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
            if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default()(cachedQuary, args === null || args === void 0 ? void 0 : args.quary)) {
                // deep equals
                setCachedQuary(args === null || args === void 0 ? void 0 : args.quary);
            }
        }, [cachedQuary, args === null || args === void 0 ? void 0 : args.quary]);
        var _f = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(args === null || args === void 0 ? void 0 : args.params), cachedParams = _f[0], setCachedParams = _f[1];
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
            if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default()(cachedParams, args === null || args === void 0 ? void 0 : args.params)) {
                // deep equals
                setCachedParams(args === null || args === void 0 ? void 0 : args.params);
            }
        }, [cachedParams, args === null || args === void 0 ? void 0 : args.params]);
        var load = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (overrideArgs, previewData) { return __awaiter(void 0, void 0, void 0, function () {
            var params, filledUrl, unfilledParams, newResult;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (previewData) {
                            setResult(previewData);
                            setStatus("success");
                        }
                        else {
                            setStatus("loading");
                        }
                        params = (_a = overrideArgs === null || overrideArgs === void 0 ? void 0 : overrideArgs.params) !== null && _a !== void 0 ? _a : cachedParams;
                        filledUrl = params && !lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default()(params, {})
                            ? Object.keys(params).reduce(function (acc, cur) { return (params[cur] === undefined ? acc : acc.replace(":".concat(cur), params[cur])); }, url)
                            : url;
                        unfilledParams = filledUrl.match(/:.*\//);
                        if (unfilledParams) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_2__.fetchData)(filledUrl, method, (_b = overrideArgs === null || overrideArgs === void 0 ? void 0 : overrideArgs.body) !== null && _b !== void 0 ? _b : cachedBody, (_c = overrideArgs === null || overrideArgs === void 0 ? void 0 : overrideArgs.quary) !== null && _c !== void 0 ? _c : cachedQuary)];
                    case 1:
                        newResult = _d.sent();
                        if (newResult === null) {
                            setError("".concat(newResult));
                            setResult(null);
                            setStatus("failed");
                            return [2 /*return*/, null];
                        }
                        else {
                            setResult(newResult);
                            setStatus("success");
                            return [2 /*return*/, newResult];
                        }
                        return [2 /*return*/];
                }
            });
        }); }, [cachedBody, cachedQuary, cachedParams]);
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
            var _a;
            if ((_a = options === null || options === void 0 ? void 0 : options.autoLoad) !== null && _a !== void 0 ? _a : true) {
                load();
            }
        }, [load, options === null || options === void 0 ? void 0 : options.autoLoad]);
        return {
            result: result,
            status: status,
            error: error,
            forceReload: load,
        };
    };
};


/***/ }),
/* 10 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsEqual = __webpack_require__(11);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 11 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsEqualDeep = __webpack_require__(12),
    isObjectLike = __webpack_require__(80);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 12 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__(13),
    equalArrays = __webpack_require__(57),
    equalByTag = __webpack_require__(63),
    equalObjects = __webpack_require__(67),
    getTag = __webpack_require__(94),
    isArray = __webpack_require__(71),
    isBuffer = __webpack_require__(81),
    isTypedArray = __webpack_require__(84);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 13 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(14),
    stackClear = __webpack_require__(22),
    stackDelete = __webpack_require__(23),
    stackGet = __webpack_require__(24),
    stackHas = __webpack_require__(25),
    stackSet = __webpack_require__(26);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 14 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var listCacheClear = __webpack_require__(15),
    listCacheDelete = __webpack_require__(16),
    listCacheGet = __webpack_require__(19),
    listCacheHas = __webpack_require__(20),
    listCacheSet = __webpack_require__(21);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 15 */
/***/ ((module) => {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 16 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(17);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 17 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var eq = __webpack_require__(18);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 18 */
/***/ ((module) => {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 19 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(17);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 20 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(17);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 21 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(17);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 22 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(14);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 23 */
/***/ ((module) => {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 24 */
/***/ ((module) => {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 25 */
/***/ ((module) => {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 26 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(14),
    Map = __webpack_require__(27),
    MapCache = __webpack_require__(42);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 27 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(28),
    root = __webpack_require__(33);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 28 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsNative = __webpack_require__(29),
    getValue = __webpack_require__(41);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 29 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(30),
    isMasked = __webpack_require__(38),
    isObject = __webpack_require__(37),
    toSource = __webpack_require__(40);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 30 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(31),
    isObject = __webpack_require__(37);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 31 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(32),
    getRawTag = __webpack_require__(35),
    objectToString = __webpack_require__(36);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 32 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(33);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 33 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var freeGlobal = __webpack_require__(34);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 34 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),
/* 35 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(32);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 36 */
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 37 */
/***/ ((module) => {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 38 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var coreJsData = __webpack_require__(39);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 39 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(33);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 40 */
/***/ ((module) => {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 41 */
/***/ ((module) => {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 42 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var mapCacheClear = __webpack_require__(43),
    mapCacheDelete = __webpack_require__(51),
    mapCacheGet = __webpack_require__(54),
    mapCacheHas = __webpack_require__(55),
    mapCacheSet = __webpack_require__(56);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 43 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Hash = __webpack_require__(44),
    ListCache = __webpack_require__(14),
    Map = __webpack_require__(27);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 44 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hashClear = __webpack_require__(45),
    hashDelete = __webpack_require__(47),
    hashGet = __webpack_require__(48),
    hashHas = __webpack_require__(49),
    hashSet = __webpack_require__(50);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 45 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(46);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 46 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 47 */
/***/ ((module) => {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 48 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(46);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 49 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(46);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 50 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(46);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 51 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(52);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 52 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isKeyable = __webpack_require__(53);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 53 */
/***/ ((module) => {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 54 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(52);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 55 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(52);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 56 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(52);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 57 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var SetCache = __webpack_require__(58),
    arraySome = __webpack_require__(61),
    cacheHas = __webpack_require__(62);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 58 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var MapCache = __webpack_require__(42),
    setCacheAdd = __webpack_require__(59),
    setCacheHas = __webpack_require__(60);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 59 */
/***/ ((module) => {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 60 */
/***/ ((module) => {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 61 */
/***/ ((module) => {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 62 */
/***/ ((module) => {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 63 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(32),
    Uint8Array = __webpack_require__(64),
    eq = __webpack_require__(18),
    equalArrays = __webpack_require__(57),
    mapToArray = __webpack_require__(65),
    setToArray = __webpack_require__(66);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 64 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(33);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 65 */
/***/ ((module) => {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 66 */
/***/ ((module) => {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 67 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getAllKeys = __webpack_require__(68);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 68 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetAllKeys = __webpack_require__(69),
    getSymbols = __webpack_require__(72),
    keys = __webpack_require__(75);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 69 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayPush = __webpack_require__(70),
    isArray = __webpack_require__(71);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 70 */
/***/ ((module) => {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 71 */
/***/ ((module) => {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 72 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayFilter = __webpack_require__(73),
    stubArray = __webpack_require__(74);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 73 */
/***/ ((module) => {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 74 */
/***/ ((module) => {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 75 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayLikeKeys = __webpack_require__(76),
    baseKeys = __webpack_require__(89),
    isArrayLike = __webpack_require__(93);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 76 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseTimes = __webpack_require__(77),
    isArguments = __webpack_require__(78),
    isArray = __webpack_require__(71),
    isBuffer = __webpack_require__(81),
    isIndex = __webpack_require__(83),
    isTypedArray = __webpack_require__(84);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 77 */
/***/ ((module) => {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 78 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsArguments = __webpack_require__(79),
    isObjectLike = __webpack_require__(80);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 79 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(31),
    isObjectLike = __webpack_require__(80);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 80 */
/***/ ((module) => {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 81 */
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(33),
    stubFalse = __webpack_require__(82);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),
/* 82 */
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 83 */
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 84 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsTypedArray = __webpack_require__(85),
    baseUnary = __webpack_require__(87),
    nodeUtil = __webpack_require__(88);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 85 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(31),
    isLength = __webpack_require__(86),
    isObjectLike = __webpack_require__(80);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 86 */
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 87 */
/***/ ((module) => {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 88 */
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(34);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),
/* 89 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isPrototype = __webpack_require__(90),
    nativeKeys = __webpack_require__(91);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 90 */
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 91 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var overArg = __webpack_require__(92);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 92 */
/***/ ((module) => {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 93 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(30),
    isLength = __webpack_require__(86);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 94 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DataView = __webpack_require__(95),
    Map = __webpack_require__(27),
    Promise = __webpack_require__(96),
    Set = __webpack_require__(97),
    WeakMap = __webpack_require__(98),
    baseGetTag = __webpack_require__(31),
    toSource = __webpack_require__(40);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 95 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(28),
    root = __webpack_require__(33);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 96 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(28),
    root = __webpack_require__(33);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 97 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(28),
    root = __webpack_require__(33);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 98 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(28),
    root = __webpack_require__(33);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 99 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "createChapter": () => (/* binding */ createChapter),
/* harmony export */   "createMedia": () => (/* binding */ createMedia),
/* harmony export */   "createMediaForLink": () => (/* binding */ createMediaForLink),
/* harmony export */   "createPartner": () => (/* reexport safe */ _partners__WEBPACK_IMPORTED_MODULE_1__.createPartner),
/* harmony export */   "createPublisher": () => (/* binding */ createPublisher),
/* harmony export */   "createQuestion": () => (/* binding */ createQuestion),
/* harmony export */   "createUploadMedia": () => (/* binding */ createUploadMedia),
/* harmony export */   "deleteChapter": () => (/* binding */ deleteChapter),
/* harmony export */   "deleteMedia": () => (/* binding */ deleteMedia),
/* harmony export */   "deletePartner": () => (/* reexport safe */ _partners__WEBPACK_IMPORTED_MODULE_1__.deletePartner),
/* harmony export */   "deleteTopic": () => (/* binding */ deleteTopic),
/* harmony export */   "deleteUser": () => (/* reexport safe */ _user__WEBPACK_IMPORTED_MODULE_3__.deleteUser),
/* harmony export */   "getAdminHomeFeed": () => (/* reexport safe */ _feed__WEBPACK_IMPORTED_MODULE_4__.getAdminHomeFeed),
/* harmony export */   "getAllMedia": () => (/* reexport safe */ _publisher__WEBPACK_IMPORTED_MODULE_2__.getAllMedia),
/* harmony export */   "getAllPartners": () => (/* reexport safe */ _partners__WEBPACK_IMPORTED_MODULE_1__.getAllPartners),
/* harmony export */   "getAllPublishers": () => (/* reexport safe */ _publisher__WEBPACK_IMPORTED_MODULE_2__.getAllPublishers),
/* harmony export */   "getAllRequests": () => (/* binding */ getAllRequests),
/* harmony export */   "getAllTopics": () => (/* binding */ getAllTopics),
/* harmony export */   "getAllUsers": () => (/* reexport safe */ _user__WEBPACK_IMPORTED_MODULE_3__.getAllUsers),
/* harmony export */   "getCountedUsers": () => (/* binding */ getCountedUsers),
/* harmony export */   "getGenerations": () => (/* reexport safe */ _generations__WEBPACK_IMPORTED_MODULE_5__.getGenerations),
/* harmony export */   "getQuiz": () => (/* binding */ getQuiz),
/* harmony export */   "getTopic": () => (/* binding */ getTopic),
/* harmony export */   "getTranscript": () => (/* binding */ getTranscript),
/* harmony export */   "saveAllChanges": () => (/* binding */ saveAllChanges),
/* harmony export */   "saveChapter": () => (/* binding */ saveChapter),
/* harmony export */   "saveNewUser": () => (/* reexport safe */ _user__WEBPACK_IMPORTED_MODULE_3__.saveNewUser),
/* harmony export */   "saveUserChange": () => (/* reexport safe */ _user__WEBPACK_IMPORTED_MODULE_3__.saveUserChange),
/* harmony export */   "sendMeTestNotification": () => (/* binding */ sendMeTestNotification),
/* harmony export */   "setPartner": () => (/* reexport safe */ _partners__WEBPACK_IMPORTED_MODULE_1__.setPartner),
/* harmony export */   "updateFeedItem": () => (/* reexport safe */ _feed__WEBPACK_IMPORTED_MODULE_4__.updateFeedItem),
/* harmony export */   "updateMedia": () => (/* binding */ updateMedia),
/* harmony export */   "updateORCreateTopic": () => (/* binding */ updateORCreateTopic),
/* harmony export */   "updatePublisher": () => (/* binding */ updatePublisher),
/* harmony export */   "updateQuestion": () => (/* binding */ updateQuestion),
/* harmony export */   "updateQuestionsForChapter": () => (/* binding */ updateQuestionsForChapter),
/* harmony export */   "useAllUsers": () => (/* reexport safe */ _user__WEBPACK_IMPORTED_MODULE_3__.useAllUsers)
/* harmony export */ });
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
/* harmony import */ var _partners__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(100);
/* harmony import */ var _publisher__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(101);
/* harmony import */ var _user__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(102);
/* harmony import */ var _feed__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(103);
/* harmony import */ var _generations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(104);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var getAllTopics = function (name) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/topics", "GET", undefined, name ? { name: name } : {})];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getTopic = function (topicId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/topics/".concat(topicId), "GET")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var deleteTopic = function (topicId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/topics/".concat(topicId), "DELETE")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var updateORCreateTopic = function (topic) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/topics".concat(topic.id ? "/" + topic.id : ""), "POST", __assign({}, topic))];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getCountedUsers = function (itemId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/requests/".concat(itemId, "/users"))];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var createMediaForLink = function (url) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/media", "POST", { url: url })];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var createUploadMedia = function (files, body) { return __awaiter(void 0, void 0, void 0, function () {
    var formData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                formData = new FormData();
                files.forEach(function (file) {
                    formData.append("file", file);
                });
                Object.keys(body).forEach(function (key) {
                    formData.append(key, body[key]);
                });
                return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/media/file", "POST", formData)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getTranscript = function (mediaId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/media/".concat(mediaId, "/transcript"), "GET")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var sendMeTestNotification = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/notifications/test")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
// export const getAllNotifications = async () => {
//     const response = await fetchData("/admin/notifications");
//     //     return response;
// };
//
// export const getAllNotificationTypes = async () => {
//     const response = await fetchData("/admin/notifications/types");
//     //     return response;
// };
//
// export const getTemplatesForType = async (typeId: string, ) => {
//     const response = await fetchData(`/admin/notifications/types/${typeId}/templates`);
//     //     return response;
// };
//
// export const saveNotification = async (data: any, ) => {
//     const response = await fetchData(`/admin/notifications${data.id ? "/" + data.id : ""}`, "POST", data);
//     //     return response;
// };
// export const deleteNotification = async (notifId: any, ) => {
//     const response = await fetchData(`/admin/notifications/${notifId}`, "DELETE");
//     //     return response;
// };
// export const sendNotification = async (notifId: any, ) => {
//     const response = await fetchData(`/admin/notifications/${notifId}/send`, "POST");
//     //     return response;
// };
var getAllRequests = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/requests")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var updatePublisher = function (publisher) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!!publisher.id) return [3 /*break*/, 2];
                return [4 /*yield*/, createPublisher(publisher)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/publisher/".concat(publisher.id), "POST", publisher)];
            case 3: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var createPublisher = function (publisher) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/publisher", "POST", publisher)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getQuiz = function (mediaId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/media/".concat(mediaId, "/quiz"))];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var updateQuestion = function (question, quizId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/quiz/".concat(quizId, "/question/").concat(question.id), "POST", question)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var createQuestion = function (question, quizId, chapterId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/quiz/".concat(quizId, "/chapter/").concat(chapterId, "/question"), "POST", question)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var createChapter = function (mediaId, data) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/media/".concat(mediaId, "/chapters"), "POST", data)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var saveChapter = function (
// this is called updateChapter on the back end
quizId, chapterId, data) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/quiz/".concat(quizId, "/chapter/").concat(chapterId), "POST", data)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var deleteChapter = function (quizId, chapterId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/quiz/".concat(quizId, "/chapter/").concat(chapterId), "DELETE")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var saveAllChanges = function (questions, quizId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/quiz/".concat(quizId, "/questions"), "POST", questions)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var updateQuestionsForChapter = function (quizId, chapterId, data) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/quiz/".concat(quizId, "/chapter/").concat(chapterId, "/questions"), "POST", data)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var updateMedia = function (media, publisher) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!!media.id) return [3 /*break*/, 2];
                return [4 /*yield*/, createMedia(media, publisher)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/media/".concat(media.id), "POST", media)];
            case 3: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var createMedia = function (media, publisher) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/publisher/".concat(publisher.id, "/media"), "POST", media)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var deleteMedia = function (mediaId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/media/".concat(mediaId), "DELETE")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };







/***/ }),
/* 100 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "createPartner": () => (/* binding */ createPartner),
/* harmony export */   "deletePartner": () => (/* binding */ deletePartner),
/* harmony export */   "getAllPartners": () => (/* binding */ getAllPartners),
/* harmony export */   "setPartner": () => (/* binding */ setPartner)
/* harmony export */ });
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var getAllPartners = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/partner")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var deletePartner = function (partnerId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/partner/".concat(partnerId), "DELETE")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var setPartner = function (partner) { return __awaiter(void 0, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
    switch (_b.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/partner/".concat((_a = partner.id) !== null && _a !== void 0 ? _a : ""), "PUT", partner)];
        case 1: return [2 /*return*/, _b.sent()];
    }
}); }); };
var createPartner = function (partner) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/partner", "POST", partner)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };


/***/ }),
/* 101 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getAllMedia": () => (/* binding */ getAllMedia),
/* harmony export */   "getAllPublishers": () => (/* binding */ getAllPublishers)
/* harmony export */ });
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var getAllMedia = function (publisherId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/publisher/".concat(publisherId, "/media"))];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var getAllPublishers = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/publisher")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };


/***/ }),
/* 102 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "deleteUser": () => (/* binding */ deleteUser),
/* harmony export */   "getAllUsers": () => (/* binding */ getAllUsers),
/* harmony export */   "saveNewUser": () => (/* binding */ saveNewUser),
/* harmony export */   "saveUserChange": () => (/* binding */ saveUserChange),
/* harmony export */   "useAllUsers": () => (/* binding */ useAllUsers)
/* harmony export */ });
/* harmony import */ var _buildUseFetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var getAllUsers = function (page) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/user?page=".concat(page !== null && page !== void 0 ? page : 0))];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var useAllUsers = (0,_buildUseFetch__WEBPACK_IMPORTED_MODULE_1__.buildUseFetch)("/admin/user", "GET");
var saveUserChange = function (userId, changes) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/user/".concat(userId), "POST", changes)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var deleteUser = function (userId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/user/".concat(userId), "DELETE")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var saveNewUser = function (user) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/user", "POST", user)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };


/***/ }),
/* 103 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getAdminHomeFeed": () => (/* binding */ getAdminHomeFeed),
/* harmony export */   "updateFeedItem": () => (/* binding */ updateFeedItem)
/* harmony export */ });
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var getAdminHomeFeed = function (params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/feed", "GET", undefined, params)];
}); }); };
var updateFeedItem = function (input) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/feed/".concat(input.id), "POST", input)];
}); }); };


/***/ }),
/* 104 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getGenerations": () => (/* binding */ getGenerations)
/* harmony export */ });
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var getGenerations = function (_a, signal) {
    var offset = _a.offset, limit = _a.limit, sort = _a.sort;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2 /*return*/, (0,_index__WEBPACK_IMPORTED_MODULE_0__.fetchData)("/admin/generation", "GET", undefined, {
                    offset: offset,
                    limit: limit,
                    sort: sort ? "".concat(sort.by, ":").concat(sort.mode) : undefined,
                }, signal)];
        });
    });
};


/***/ }),
/* 105 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AppConfigContext": () => (/* binding */ AppConfigContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var AppConfigContext = react__WEBPACK_IMPORTED_MODULE_0___default().createContext({
    user: {
        firstName: "",
        lastName: "",
        id: "",
        email: "",
        role: "user",
        training: "",
    },
    stats: {
        answers: {
            total: 0,
            correct: 0,
        },
        streak: undefined,
        reviews: 0,
        library: 0,
        xp: 0,
    },
    ping: 0,
    sendPing: function () { },
    refreshStats: function (stats) { },
    setUser: function (user) { },
    resetUser: function () { },
});


/***/ }),
/* 106 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ErrorBoundary": () => (/* binding */ ErrorBoundary)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { error: null };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error, errorInfo) {
        return { error: error };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        var _a, _b;
        (_b = (_a = this.props).onError) === null || _b === void 0 ? void 0 : _b.call(_a, error, errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        if (!this.state.error) {
            return this.props.children;
        }
        // You can render any custom fallback UI
        return !this.props.fallbackComponent ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", { children: "Ops! Something went wrong!" }) })) : typeof this.props.fallbackComponent === "function" ? (this.props.fallbackComponent(this.state.error)) : (this.props.fallbackComponent);
    };
    return ErrorBoundary;
}((react__WEBPACK_IMPORTED_MODULE_1___default().Component)));



/***/ }),
/* 107 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _react_spring_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(108);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var immutability_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(117);
/* harmony import */ var immutability_helper__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(immutability_helper__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(106);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(164);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(165);
/* harmony import */ var _providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(105);
/* harmony import */ var _providers_ThemeContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(118);
/* harmony import */ var _requests__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7);
/* harmony import */ var _assets_close_button_svg__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(213);
/* harmony import */ var _hooks_UseFeedbackSound__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(119);
/* harmony import */ var _cards_EndPage__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(214);
/* harmony import */ var _cards_NextChapterCard__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(121);
/* harmony import */ var _cards_QuestionCard__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(134);
/* harmony import */ var _Navigation_module_scss__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(200);
/* harmony import */ var _ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(211);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};


















function QuizModalFull(props) {
    var _a, _b, _c, _d;
    var _this = this;
    var _e, _f, _g, _h, _j, _k;
    var theme = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(_providers_ThemeContext__WEBPACK_IMPORTED_MODULE_5__.ThemeContext);
    var user = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(_providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_6__.AppConfigContext).user;
    var bottom = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    var canContinueAtStart = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function () { return props.quiz.quizContent.length > 1; }, [props.quiz]);
    var _l = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        timestamp: Date.now(),
        quizId: props.quizId,
        canContinue: canContinueAtStart,
        activeCardId: props.quiz.quizContent.length === 1 ? 1 : 0,
        chapterIndex: props.quiz.quizContent.length === 1 ? 1 : 0,
        mode: "quiz",
        answers: {},
        scores: [],
        lastScoreOverride: null,
    }), quizState = _l[0], setQuizState = _l[1];
    var resetQuiz = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function () {
        return setQuizState(function (state) { return ({
            timestamp: Date.now(),
            quizId: props.quizId,
            answers: {},
            scores: [],
            activeCardId: props.quiz.quizContent.length === 1 ? 1 : 0,
            chapterIndex: props.quiz.quizContent.length === 1 ? 1 : 0,
            mode: "quiz",
            canContinue: canContinueAtStart,
            lastScoreOverride: state.scores.length !== 0 ? computeScore(state.scores) : null,
        }); });
    }, [canContinueAtStart, props.quiz.quizContent.length, props.quizId]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {
        if (quizState.mode === "end") {
            (0,_requests__WEBPACK_IMPORTED_MODULE_7__.logMetrics)({
                eventName: "quizFinish",
                quizId: props.quizId,
                origin: props.origin,
                theme: theme.mode,
                layout: theme.layout,
                fullLink: window.location.href,
                hostname: new URL(window.location.href).host,
                value: props.quiz.quizContent.length,
            });
        }
    }, [quizState.mode]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {
        resetQuiz();
    }, [props.quiz.id, resetQuiz]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {
        setTimeout(function () {
            var _a;
            (_a = bottom === null || bottom === void 0 ? void 0 : bottom.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
        }, 100);
    }, [quizState.activeCardId]);
    var computeScore = function (scores) {
        var totalScore = scores.map(function (it) { return it.score; }).reduce(function (a, b) { return a + b; }, 0);
        var maxScore = scores.map(function (it) { return it.maxScore; }).reduce(function (a, b) { return a + b; }, 0);
        return Math.round((totalScore / maxScore) * 100);
    };
    var playFeedbackSound = (0,_hooks_UseFeedbackSound__WEBPACK_IMPORTED_MODULE_8__.useFeedbackSound)();
    var saveAnswer = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function (questionId, qResponse, scoreData) { return __awaiter(_this, void 0, void 0, function () {
        var payload, answerId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = {
                        quizId: props.quiz.id,
                        question: {
                            id: questionId,
                            responses: qResponse,
                        },
                    };
                    return [4 /*yield*/, (0,_requests__WEBPACK_IMPORTED_MODULE_7__.saveQuestionAnswer)(props.quiz.id, questionId, qResponse)];
                case 1:
                    answerId = _a.sent();
                    setQuizState(function (quiz) {
                        var _a;
                        return immutability_helper__WEBPACK_IMPORTED_MODULE_3___default()(quiz, {
                            answers: (_a = {},
                                _a[questionId] = {
                                    $set: {
                                        answerId: answerId,
                                        isCorrect: scoreData.score !== 0,
                                        xpGained: scoreData.addedXp,
                                    },
                                },
                                _a),
                        });
                    });
                    return [4 /*yield*/, (0,_requests__WEBPACK_IMPORTED_MODULE_7__.logMetrics)({
                            eventName: "answerQuestion",
                            quizId: props.quizId,
                            origin: props.origin,
                            theme: theme.mode,
                            layout: theme.layout,
                            fullLink: window.location.href,
                            hostname: new URL(window.location.href).host,
                            value: __assign(__assign({}, payload), { questionIndex: quizState.activeCardId, quizId: props.quiz.id }),
                        })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [quizState.activeCardId, props.origin, props.quiz.id, props.quizId, theme.layout, theme.mode]);
    var saveQuiz = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0,_requests__WEBPACK_IMPORTED_MODULE_7__.saveQuizAnswers)(props.quizId, Object.fromEntries(Object.entries(quizState.answers).map(function (_a) {
                        var questionId = _a[0], answer = _a[1];
                        return [questionId, answer.answerId];
                    })))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleAnswer = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function (questionId, questionResponse, scoreData) {
        setQuizState(function (state) { return (__assign(__assign({}, state), { canContinue: true, scores: __spreadArray(__spreadArray([], state.scores, true), [scoreData], false) })); });
        if (user.id !== "") {
            saveAnswer(questionId, questionResponse, scoreData);
        }
    }, [saveAnswer]);
    var handleContinueClick = function () {
        var _a;
        if (quizState.activeCardId === cards.length - 1) {
            if (user.id !== "") {
                saveQuiz();
            }
            setQuizState(function (state) { return (__assign(__assign({}, state), { mode: "end" })); });
        }
        else {
            var nextIsChapter_1 = ((_a = cards[quizState.activeCardId + 1]) === null || _a === void 0 ? void 0 : _a.type) === _cards_NextChapterCard__WEBPACK_IMPORTED_MODULE_9__["default"];
            setQuizState(function (state) { return (__assign(__assign({}, state), { canContinue: nextIsChapter_1, activeCardId: state.activeCardId + 1, chapterIndex: nextIsChapter_1 ? state.chapterIndex + 1 : state.chapterIndex })); });
        }
    };
    var unflattenedCards = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function () {
        return props.quiz.quizContent
            .map(function (ch, chapterIndex) {
            var _a;
            return __spreadArray([
                props.hideChapterCards ? ({ type: undefined }) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards_NextChapterCard__WEBPACK_IMPORTED_MODULE_9__["default"], { publisher: props.quiz.publisher, chapter: ch, chapterIndex: chapterIndex, chaptersCount: props.quiz.quizContent.length, hideNumber: props.quiz.quizContent.length === 1 }, ch.id))
            ], ((_a = ch.questions.map(function (question) {
                if (!question.type) {
                    return null;
                }
                var savedAnswer = quizState.answers[question.id];
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards_QuestionCard__WEBPACK_IMPORTED_MODULE_10__.QuestionCard, { question: question, quizId: props.quiz.id, handleEnd: handleAnswer, isLocked: savedAnswer !== undefined, savedAnswers: savedAnswer, playFeedbackSound: playFeedbackSound }, question.id));
            })) !== null && _a !== void 0 ? _a : []), true);
        })
            .filter(Boolean);
    }, [handleAnswer, playFeedbackSound, props.quiz.id, props.quiz.publisher, props.quiz.quizContent, quizState]);
    var questions = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function () { return props.quiz.quizContent.flatMap(function (it) { return __spreadArray([it], it.questions, true); }); }, [props.quiz.quizContent]);
    var currentQuestion = questions[quizState.activeCardId];
    var cards = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function () { return unflattenedCards.flat(); }, [unflattenedCards]);
    var handleClose = function (next) {
        var _a;
        if (quizState.mode === "quiz") {
            (0,_requests__WEBPACK_IMPORTED_MODULE_7__.logMetrics)({
                eventName: "quizClose",
                quizId: props.quizId,
                origin: props.origin,
                theme: theme.mode,
                layout: theme.layout,
                fullLink: window.location.href,
                hostname: new URL(window.location.href).host,
                value: quizState.activeCardId,
            });
        }
        resetQuiz();
        (_a = props === null || props === void 0 ? void 0 : props.handleClose) === null || _a === void 0 ? void 0 : _a.call(props, { completed: quizState.mode === "end", openNext: next });
    };
    var handleRestart = function () {
        (0,_requests__WEBPACK_IMPORTED_MODULE_7__.logMetrics)({
            eventName: "quizRestart",
            quizId: props.quizId,
            origin: props.origin,
            theme: theme.mode,
            layout: theme.layout,
            fullLink: window.location.href,
            hostname: new URL(window.location.href).host,
            value: props.quiz.quizContent.length,
        });
        resetQuiz();
    };
    var imageURL = (_e = props.meta) === null || _e === void 0 ? void 0 : _e.pubLogo;
    var cardTransitions = (0,_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.useTransition)(__spreadArray([], Array(cards.length), true).map(function (_, i) { return i; }).slice(0, quizState.activeCardId + 1), {
        from: { opacity: 0, y: 150, scale: 1 },
        enter: { opacity: 1, y: 0, scale: 1 },
        // leave: { opacity: 0 },
        config: _react_spring_web__WEBPACK_IMPORTED_MODULE_1__.config["default"],
    });
    var continueButtonBop = (0,_hooks__WEBPACK_IMPORTED_MODULE_11__.useButtonBopAnimation)();
    (0,_hooks__WEBPACK_IMPORTED_MODULE_12__.useKey)("Space", function () {
        var _a;
        continueButtonBop.play();
        if (!(((_a = cards[quizState.activeCardId]) === null || _a === void 0 ? void 0 : _a.type) !== _cards_NextChapterCard__WEBPACK_IMPORTED_MODULE_9__["default"]) || quizState.canContinue) {
            handleContinueClick();
        }
    }, [continueButtonBop, handleContinueClick, quizState.activeCardId, quizState.canContinue, cards]);
    var continueButtonTransition = (0,_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.useTransition)(true, {
        from: { opacity: 0, y: 150 },
        enter: { opacity: 1, y: 0 },
        config: _react_spring_web__WEBPACK_IMPORTED_MODULE_1__.config["default"],
    });
    var _m = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true), progressOpen = _m[0], setProgressOpen = _m[1];
    var progressWidth = (0,_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.useSpring)({
        left: progressOpen ? 0 : -155,
        messageOpacity: progressOpen ? 0 : 1,
        contentsOpacity: progressOpen ? 1 : 0,
        transform: progressOpen ? "rotateZ(0deg)" : "rotateZ(180deg)",
    });
    if (!props.show) {
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    else if (quizState.mode === "quiz") {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_a = {},
                _a[_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"]["theme-light"]] = theme.mode === "light",
                _a[_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"]["theme-dark"]] = theme.mode === "dark",
                _a)) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].backdrop) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].body, (_b = {}, _b[_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].noBackground] = props.noBackground, _b)) }, { children: [props.handleClose && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { className: _ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].closeButton, src: _assets_close_button_svg__WEBPACK_IMPORTED_MODULE_14__, alt: "close", onClick: function () { return handleClose(); } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].progress, (_c = {}, _c[_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].open] = progressOpen, _c)), style: { left: progressWidth.left } }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.img, { className: _ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].closeProgressButton, src: _assets_close_button_svg__WEBPACK_IMPORTED_MODULE_14__, alt: "close", onClick: function () { return setProgressOpen(function (it) { return !it; }); }, style: { transform: progressWidth.transform } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, __assign({ className: _ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].message, style: { opacity: progressWidth.messageOpacity } }, { children: "Quiz Progress" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, __assign({ style: { opacity: progressWidth.contentsOpacity } }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].title }, { children: props.meta.title })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].items }, { children: props.quiz.quizContent
                                                .flatMap(function (chapter, chapterIndex) { return chapter.questions.map(function (question) { return [chapterIndex, question]; }); })
                                                .map(function (_a, questionIndex) {
                                                var _b;
                                                var _c, _d, _e, _f, _g, _h, _j, _k;
                                                var chapterIndex = _a[0], question = _a[1];
                                                var index = chapterIndex + questionIndex + 1;
                                                var isCurrentOrFuture = index >= quizState.activeCardId;
                                                var isCurrent = index === quizState.activeCardId;
                                                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].item, (_b = {},
                                                        _b[_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].current] = isCurrent,
                                                        _b[_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].correct] = ((_d = (_c = quizState.answers) === null || _c === void 0 ? void 0 : _c[question.id]) === null || _d === void 0 ? void 0 : _d.isCorrect) === true,
                                                        _b)) }, { children: [((_f = (_e = quizState.answers) === null || _e === void 0 ? void 0 : _e[question.id]) === null || _f === void 0 ? void 0 : _f.isCorrect) === true ? ( // correct
                                                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", __assign({ width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", { cx: "5", cy: "5", r: "5", fill: "#FFF597" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M7.1045 2.98258C6.97335 2.98695 6.84909 3.04232 6.75814 3.13684C5.79309 4.10398 5.05601 4.91178 4.16041 5.82591L3.20629 5.01982V5.01987C3.10405 4.93341 2.97159 4.89117 2.83817 4.90252C2.70478 4.91388 2.58134 4.97789 2.49519 5.08034C2.40899 5.18284 2.36717 5.31539 2.37889 5.44878C2.39061 5.58216 2.45493 5.70539 2.55764 5.79132L3.86753 6.89971V6.89966C3.96394 6.98086 4.08722 7.02299 4.2131 7.01773C4.33904 7.01252 4.45841 6.96028 4.54769 6.87133C5.6329 5.78378 6.40542 4.9152 7.46982 3.84853V3.84858C7.5679 3.75379 7.62337 3.62332 7.62352 3.48697C7.62372 3.35057 7.56862 3.22 7.47081 3.12494C7.373 3.02989 7.24086 2.97854 7.10456 2.98265L7.1045 2.98258Z", fill: "#2C2A5D" })] }))) : ((_h = (_g = quizState.answers) === null || _g === void 0 ? void 0 : _g[question.id]) === null || _h === void 0 ? void 0 : _h.isCorrect) === false ? ( // incorrect
                                                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", __assign({ width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", { cx: "5", cy: "5", r: "5", fill: "#908FAC" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", { x: "2.05566", y: "2.83838", width: "1.20117", height: "7.20704", rx: "0.600586", transform: "rotate(-44.2537 2.05566 2.83838)", fill: "#2C2B5E" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", { x: "2.83838", y: "7.94531", width: "1.20117", height: "7.20704", rx: "0.600586", transform: "rotate(-134.254 2.83838 7.94531)", fill: "#2C2B5E" })] }))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", { cx: "5", cy: "5", r: "4.5", stroke: isCurrent ? "white" : "#908FAC" }) }))), "Question ", questionIndex + 1, !!((_k = (_j = quizState.answers) === null || _j === void 0 ? void 0 : _j[question.id]) === null || _k === void 0 ? void 0 : _k.xpGained) && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", __assign({ className: _ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].xp }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "7", height: "11", viewBox: "0 0 7 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M6.42386 4.87115L1.72485 10.9349C1.69205 10.9764 1.64195 11.0005 1.58907 11.0002C1.56153 11.0009 1.53425 10.9944 1.51001 10.9813C1.4742 10.9629 1.44598 10.9325 1.43026 10.8955C1.41458 10.8584 1.41236 10.817 1.42407 10.7785L2.69081 6.59162H0.178044C0.146319 6.59151 0.115202 6.58263 0.0882036 6.56594C0.061205 6.54926 0.0393628 6.52545 0.0250756 6.49709C0.0120415 6.46977 0.00641961 6.43947 0.00885519 6.40929C0.0112543 6.3791 0.0216024 6.3501 0.0388256 6.32521L4.59695 0.0707021C4.62721 0.0288434 4.67469 0.00281194 4.72625 -0.000196566C4.77784 -0.00320433 4.82801 0.0171697 4.86292 0.0552334C4.89783 0.093297 4.91377 0.145038 4.90632 0.196171L4.30304 4.59443H6.28818C6.3204 4.59436 6.35198 4.60335 6.37931 4.62039C6.40666 4.6374 6.42868 4.66175 6.44286 4.69068C6.45686 4.71954 6.46252 4.75173 6.45916 4.7836C6.45583 4.81551 6.44362 4.84584 6.42396 4.87115H6.42386Z", fill: "#FFF597" }) })), quizState.answers[question.id].xpGained, "XP"] })))] }), question.id));
                                            }) }))] }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"]["cards-container"] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_15__.ErrorBoundary, { children: [cardTransitions(function (style, item) {
                                        var _a;
                                        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, __assign({ className: _ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].animationWrapper, style: style }, { children: ((_a = cards[item]) === null || _a === void 0 ? void 0 : _a.type) && cards[item] })));
                                    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: _ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"]["bottom-buffer"], ref: bottom }), continueButtonTransition(function (style) {
                                        var _a;
                                        var _b, _c, _d;
                                        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, __assign({ style: __assign(__assign({}, style), continueButtonBop.buttonProps.style), className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_16__["default"]["continue-btn"], (_a = {},
                                                _a[_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_16__["default"].disabled] = ((_b = cards[quizState.activeCardId]) === null || _b === void 0 ? void 0 : _b.type) !== _cards_NextChapterCard__WEBPACK_IMPORTED_MODULE_9__["default"] && !quizState.canContinue,
                                                _a)), onClick: !(((_c = cards[quizState.activeCardId]) === null || _c === void 0 ? void 0 : _c.type) !== _cards_NextChapterCard__WEBPACK_IMPORTED_MODULE_9__["default"]) || quizState.canContinue
                                                ? handleContinueClick
                                                : undefined }, { children: !(((_d = cards[quizState.activeCardId]) === null || _d === void 0 ? void 0 : _d.type) !== _cards_NextChapterCard__WEBPACK_IMPORTED_MODULE_9__["default"])
                                                ? "Start Chapter"
                                                : quizState.canContinue
                                                    ? "Continue"
                                                    : "type" in currentQuestion
                                                        ? (0,_cards_QuestionCard__WEBPACK_IMPORTED_MODULE_10__.getQuestionGuide)(currentQuestion.type)
                                                        : "" })));
                                    })] }) }))] })) })) })));
    }
    else {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_d = {},
                _d[_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"]["theme-light"]] = theme.mode === "light",
                _d[_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"]["theme-dark"]] = theme.mode === "dark",
                _d)) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_13__["default"].backdrop) }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards_EndPage__WEBPACK_IMPORTED_MODULE_17__["default"], { startingXP: (_g = (_f = props === null || props === void 0 ? void 0 : props.userData) === null || _f === void 0 ? void 0 : _f.startingXP) !== null && _g !== void 0 ? _g : 0, lastScore: (_h = quizState.lastScoreOverride) !== null && _h !== void 0 ? _h : (((_j = props.quiz) === null || _j === void 0 ? void 0 : _j.lastScore) ? Math.round(((_k = props.quiz) === null || _k === void 0 ? void 0 : _k.lastScore) * 100) : undefined), isBehind: false, headerImg: imageURL, 
                    // cardType={props.meta.cardType}
                    handleRestart: handleRestart, handleShare: function () { }, handleClose: handleClose, score: computeScore(quizState.scores), handleNext: function (next) { return handleClose(next); }, nextUp: props.nextUp, addedXp: quizState.scores.map(function (it) { return it.addedXp; }).reduce(function (a, b) { return a + b; }, 0), quizId: props.quizId }) })) })));
    }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizModalFull);


/***/ }),
/* 108 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ animated),
/* harmony export */   "animated": () => (/* binding */ animated)
/* harmony export */ });
/* harmony import */ var _react_spring_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(109);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _react_spring_core__WEBPACK_IMPORTED_MODULE_0__) if(["default","a","animated"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _react_spring_core__WEBPACK_IMPORTED_MODULE_0__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(115);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_spring_shared__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(110);
/* harmony import */ var _react_spring_animated__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(112);






function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const _excluded$2 = ["style", "children", "scrollTop", "scrollLeft"];
const isCustomPropRE = /^--/;

function dangerousStyleValue(name, value) {
  if (value == null || typeof value === 'boolean' || value === '') return '';
  if (typeof value === 'number' && value !== 0 && !isCustomPropRE.test(name) && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px';
  return ('' + value).trim();
}

const attributeCache = {};
function applyAnimatedValues(instance, props) {
  if (!instance.nodeType || !instance.setAttribute) {
    return false;
  }

  const isFilterElement = instance.nodeName === 'filter' || instance.parentNode && instance.parentNode.nodeName === 'filter';

  const _ref = props,
        {
    style,
    children,
    scrollTop,
    scrollLeft
  } = _ref,
        attributes = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  const values = Object.values(attributes);
  const names = Object.keys(attributes).map(name => isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, n => '-' + n.toLowerCase())));

  if (children !== void 0) {
    instance.textContent = children;
  }

  for (let name in style) {
    if (style.hasOwnProperty(name)) {
      const value = dangerousStyleValue(name, style[name]);

      if (isCustomPropRE.test(name)) {
        instance.style.setProperty(name, value);
      } else {
        instance.style[name] = value;
      }
    }
  }

  names.forEach((name, i) => {
    instance.setAttribute(name, values[i]);
  });

  if (scrollTop !== void 0) {
    instance.scrollTop = scrollTop;
  }

  if (scrollLeft !== void 0) {
    instance.scrollLeft = scrollLeft;
  }
}
let isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

const prefixKey = (prefix, key) => prefix + key.charAt(0).toUpperCase() + key.substring(1);

const prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
  prefixes.forEach(prefix => acc[prefixKey(prefix, prop)] = acc[prop]);
  return acc;
}, isUnitlessNumber);

const _excluded$1 = ["x", "y", "z"];
const domTransforms = /^(matrix|translate|scale|rotate|skew)/;
const pxTransforms = /^(translate)/;
const degTransforms = /^(rotate|skew)/;

const addUnit = (value, unit) => _react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.is.num(value) && value !== 0 ? value + unit : value;

const isValueIdentity = (value, id) => _react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.is.arr(value) ? value.every(v => isValueIdentity(v, id)) : _react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.is.num(value) ? value === id : parseFloat(value) === id;

class AnimatedStyle extends _react_spring_animated__WEBPACK_IMPORTED_MODULE_3__.AnimatedObject {
  constructor(_ref) {
    let {
      x,
      y,
      z
    } = _ref,
        style = _objectWithoutPropertiesLoose(_ref, _excluded$1);

    const inputs = [];
    const transforms = [];

    if (x || y || z) {
      inputs.push([x || 0, y || 0, z || 0]);
      transforms.push(xyz => [`translate3d(${xyz.map(v => addUnit(v, 'px')).join(',')})`, isValueIdentity(xyz, 0)]);
    }

    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.eachProp)(style, (value, key) => {
      if (key === 'transform') {
        inputs.push([value || '']);
        transforms.push(transform => [transform, transform === '']);
      } else if (domTransforms.test(key)) {
        delete style[key];
        if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.is.und(value)) return;
        const unit = pxTransforms.test(key) ? 'px' : degTransforms.test(key) ? 'deg' : '';
        inputs.push((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.toArray)(value));
        transforms.push(key === 'rotate3d' ? ([x, y, z, deg]) => [`rotate3d(${x},${y},${z},${addUnit(deg, unit)})`, isValueIdentity(deg, 0)] : input => [`${key}(${input.map(v => addUnit(v, unit)).join(',')})`, isValueIdentity(input, key.startsWith('scale') ? 1 : 0)]);
      }
    });

    if (inputs.length) {
      style.transform = new FluidTransform(inputs, transforms);
    }

    super(style);
  }

}

class FluidTransform extends _react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.FluidValue {
  constructor(inputs, transforms) {
    super();
    this._value = null;
    this.inputs = inputs;
    this.transforms = transforms;
  }

  get() {
    return this._value || (this._value = this._get());
  }

  _get() {
    let transform = '';
    let identity = true;
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.each)(this.inputs, (input, i) => {
      const arg1 = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.getFluidValue)(input[0]);
      const [t, id] = this.transforms[i](_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.is.arr(arg1) ? arg1 : input.map(_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.getFluidValue));
      transform += ' ' + t;
      identity = identity && id;
    });
    return identity ? 'none' : transform;
  }

  observerAdded(count) {
    if (count == 1) (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.each)(this.inputs, input => (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.each)(input, value => (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.hasFluidValue)(value) && (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.addFluidObserver)(value, this)));
  }

  observerRemoved(count) {
    if (count == 0) (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.each)(this.inputs, input => (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.each)(input, value => (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.hasFluidValue)(value) && (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.removeFluidObserver)(value, this)));
  }

  eventObserved(event) {
    if (event.type == 'change') {
      this._value = null;
    }

    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.callFluidObservers)(this, event);
  }

}

const primitives = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

const _excluded = ["scrollTop", "scrollLeft"];
_react_spring_core__WEBPACK_IMPORTED_MODULE_0__.Globals.assign({
  batchedUpdates: react_dom__WEBPACK_IMPORTED_MODULE_1__.unstable_batchedUpdates,
  createStringInterpolator: _react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.createStringInterpolator,
  colors: _react_spring_shared__WEBPACK_IMPORTED_MODULE_2__.colors
});
const host = (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_3__.createHost)(primitives, {
  applyAnimatedValues,
  createAnimatedStyle: style => new AnimatedStyle(style),
  getComponentProps: _ref => {
    let props = _objectWithoutPropertiesLoose(_ref, _excluded);

    return props;
  }
});
const animated = host.animated;




/***/ }),
/* 109 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BailSignal": () => (/* binding */ BailSignal),
/* harmony export */   "Controller": () => (/* binding */ Controller),
/* harmony export */   "FrameValue": () => (/* binding */ FrameValue),
/* harmony export */   "Globals": () => (/* reexport safe */ _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.Globals),
/* harmony export */   "Interpolation": () => (/* binding */ Interpolation),
/* harmony export */   "Spring": () => (/* binding */ Spring),
/* harmony export */   "SpringContext": () => (/* binding */ SpringContext),
/* harmony export */   "SpringRef": () => (/* binding */ SpringRef),
/* harmony export */   "SpringValue": () => (/* binding */ SpringValue),
/* harmony export */   "Trail": () => (/* binding */ Trail),
/* harmony export */   "Transition": () => (/* binding */ Transition),
/* harmony export */   "config": () => (/* binding */ config),
/* harmony export */   "createInterpolator": () => (/* reexport safe */ _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.createInterpolator),
/* harmony export */   "easings": () => (/* binding */ easings),
/* harmony export */   "inferTo": () => (/* binding */ inferTo),
/* harmony export */   "interpolate": () => (/* binding */ interpolate),
/* harmony export */   "to": () => (/* binding */ to),
/* harmony export */   "update": () => (/* binding */ update),
/* harmony export */   "useChain": () => (/* binding */ useChain),
/* harmony export */   "useIsomorphicLayoutEffect": () => (/* reexport safe */ _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useIsomorphicLayoutEffect),
/* harmony export */   "useReducedMotion": () => (/* reexport safe */ _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useReducedMotion),
/* harmony export */   "useSpring": () => (/* binding */ useSpring),
/* harmony export */   "useSpringRef": () => (/* binding */ useSpringRef),
/* harmony export */   "useSprings": () => (/* binding */ useSprings),
/* harmony export */   "useTrail": () => (/* binding */ useTrail),
/* harmony export */   "useTransition": () => (/* binding */ useTransition)
/* harmony export */ });
/* harmony import */ var _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(110);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _react_spring_animated__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(112);
/* harmony import */ var _react_spring_types_animated__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(113);
/* harmony import */ var _react_spring_types_animated__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_react_spring_types_animated__WEBPACK_IMPORTED_MODULE_3__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _react_spring_types_animated__WEBPACK_IMPORTED_MODULE_3__) if(["default","Globals","createInterpolator","useIsomorphicLayoutEffect","useReducedMotion","BailSignal","Controller","FrameValue","Interpolation","Spring","SpringContext","SpringRef","SpringValue","Trail","Transition","config","easings","inferTo","interpolate","to","update","useChain","useSpring","useSpringRef","useSprings","useTrail","useTransition"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _react_spring_types_animated__WEBPACK_IMPORTED_MODULE_3__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
/* harmony import */ var _react_spring_types_interpolation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(114);
/* harmony import */ var _react_spring_types_interpolation__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_react_spring_types_interpolation__WEBPACK_IMPORTED_MODULE_4__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _react_spring_types_interpolation__WEBPACK_IMPORTED_MODULE_4__) if(["default","Globals","createInterpolator","useIsomorphicLayoutEffect","useReducedMotion","BailSignal","Controller","FrameValue","Interpolation","Spring","SpringContext","SpringRef","SpringValue","Trail","Transition","config","easings","inferTo","interpolate","to","update","useChain","useSpring","useSpringRef","useSprings","useTrail","useTransition"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _react_spring_types_interpolation__WEBPACK_IMPORTED_MODULE_4__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);








function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function callProp(value, ...args) {
  return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(value) ? value(...args) : value;
}
const matchProp = (value, key) => value === true || !!(key && value && (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(value) ? value(key) : (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.toArray)(value).includes(key)));
const resolveProp = (prop, key) => _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.obj(prop) ? key && prop[key] : prop;
const getDefaultProp = (props, key) => props.default === true ? props[key] : props.default ? props.default[key] : undefined;

const noopTransform = value => value;

const getDefaultProps = (props, transform = noopTransform) => {
  let keys = DEFAULT_PROPS;

  if (props.default && props.default !== true) {
    props = props.default;
    keys = Object.keys(props);
  }

  const defaults = {};

  for (const key of keys) {
    const value = transform(props[key], key);

    if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(value)) {
      defaults[key] = value;
    }
  }

  return defaults;
};
const DEFAULT_PROPS = ['config', 'onProps', 'onStart', 'onChange', 'onPause', 'onResume', 'onRest'];
const RESERVED_PROPS = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  keys: 1,
  callId: 1,
  parentId: 1
};

function getForwardProps(props) {
  const forward = {};
  let count = 0;
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.eachProp)(props, (value, prop) => {
    if (!RESERVED_PROPS[prop]) {
      forward[prop] = value;
      count++;
    }
  });

  if (count) {
    return forward;
  }
}

function inferTo(props) {
  const to = getForwardProps(props);

  if (to) {
    const out = {
      to
    };
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.eachProp)(props, (val, key) => key in to || (out[key] = val));
    return out;
  }

  return _extends({}, props);
}
function computeGoal(value) {
  value = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.getFluidValue)(value);
  return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.arr(value) ? value.map(computeGoal) : (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.isAnimatedString)(value) ? _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.Globals.createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
}
function hasProps(props) {
  for (const _ in props) return true;

  return false;
}
function isAsyncTo(to) {
  return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(to) || _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.arr(to) && _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.obj(to[0]);
}
function detachRefs(ctrl, ref) {
  var _ctrl$ref;

  (_ctrl$ref = ctrl.ref) == null ? void 0 : _ctrl$ref.delete(ctrl);
  ref == null ? void 0 : ref.delete(ctrl);
}
function replaceRef(ctrl, ref) {
  if (ref && ctrl.ref !== ref) {
    var _ctrl$ref2;

    (_ctrl$ref2 = ctrl.ref) == null ? void 0 : _ctrl$ref2.delete(ctrl);
    ref.add(ctrl);
    ctrl.ref = ref;
  }
}

function useChain(refs, timeSteps, timeFrame = 1000) {
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useIsomorphicLayoutEffect)(() => {
    if (timeSteps) {
      let prevDelay = 0;
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(refs, (ref, i) => {
        const controllers = ref.current;

        if (controllers.length) {
          let delay = timeFrame * timeSteps[i];
          if (isNaN(delay)) delay = prevDelay;else prevDelay = delay;
          (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(controllers, ctrl => {
            (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(ctrl.queue, props => {
              const memoizedDelayProp = props.delay;

              props.delay = key => delay + callProp(memoizedDelayProp || 0, key);
            });
          });
          ref.start();
        }
      });
    } else {
      let p = Promise.resolve();
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(refs, ref => {
        const controllers = ref.current;

        if (controllers.length) {
          const queues = controllers.map(ctrl => {
            const q = ctrl.queue;
            ctrl.queue = [];
            return q;
          });
          p = p.then(() => {
            (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(controllers, (ctrl, i) => (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(queues[i] || [], update => ctrl.queue.push(update)));
            return Promise.all(ref.start());
          });
        }
      });
    }
  });
}

const config = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};
const c1 = 1.70158;
const c2 = c1 * 1.525;
const c3 = c1 + 1;
const c4 = 2 * Math.PI / 3;
const c5 = 2 * Math.PI / 4.5;

const bounceOut = x => {
  const n1 = 7.5625;
  const d1 = 2.75;

  if (x < 1 / d1) {
    return n1 * x * x;
  } else if (x < 2 / d1) {
    return n1 * (x -= 1.5 / d1) * x + 0.75;
  } else if (x < 2.5 / d1) {
    return n1 * (x -= 2.25 / d1) * x + 0.9375;
  } else {
    return n1 * (x -= 2.625 / d1) * x + 0.984375;
  }
};

const easings = {
  linear: x => x,
  easeInQuad: x => x * x,
  easeOutQuad: x => 1 - (1 - x) * (1 - x),
  easeInOutQuad: x => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
  easeInCubic: x => x * x * x,
  easeOutCubic: x => 1 - Math.pow(1 - x, 3),
  easeInOutCubic: x => x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
  easeInQuart: x => x * x * x * x,
  easeOutQuart: x => 1 - Math.pow(1 - x, 4),
  easeInOutQuart: x => x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
  easeInQuint: x => x * x * x * x * x,
  easeOutQuint: x => 1 - Math.pow(1 - x, 5),
  easeInOutQuint: x => x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
  easeInSine: x => 1 - Math.cos(x * Math.PI / 2),
  easeOutSine: x => Math.sin(x * Math.PI / 2),
  easeInOutSine: x => -(Math.cos(Math.PI * x) - 1) / 2,
  easeInExpo: x => x === 0 ? 0 : Math.pow(2, 10 * x - 10),
  easeOutExpo: x => x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
  easeInOutExpo: x => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
  easeInCirc: x => 1 - Math.sqrt(1 - Math.pow(x, 2)),
  easeOutCirc: x => Math.sqrt(1 - Math.pow(x - 1, 2)),
  easeInOutCirc: x => x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
  easeInBack: x => c3 * x * x * x - c1 * x * x,
  easeOutBack: x => 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2),
  easeInOutBack: x => x < 0.5 ? Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2,
  easeInElastic: x => x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * c4),
  easeOutElastic: x => x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1,
  easeInOutElastic: x => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5) / 2 + 1,
  easeInBounce: x => 1 - bounceOut(1 - x),
  easeOutBounce: bounceOut,
  easeInOutBounce: x => x < 0.5 ? (1 - bounceOut(1 - 2 * x)) / 2 : (1 + bounceOut(2 * x - 1)) / 2
};

const defaults = _extends({}, config.default, {
  mass: 1,
  damping: 1,
  easing: easings.linear,
  clamp: false
});

class AnimationConfig {
  constructor() {
    this.tension = void 0;
    this.friction = void 0;
    this.frequency = void 0;
    this.damping = void 0;
    this.mass = void 0;
    this.velocity = 0;
    this.restVelocity = void 0;
    this.precision = void 0;
    this.progress = void 0;
    this.duration = void 0;
    this.easing = void 0;
    this.clamp = void 0;
    this.bounce = void 0;
    this.decay = void 0;
    this.round = void 0;
    Object.assign(this, defaults);
  }

}
function mergeConfig(config, newConfig, defaultConfig) {
  if (defaultConfig) {
    defaultConfig = _extends({}, defaultConfig);
    sanitizeConfig(defaultConfig, newConfig);
    newConfig = _extends({}, defaultConfig, newConfig);
  }

  sanitizeConfig(config, newConfig);
  Object.assign(config, newConfig);

  for (const key in defaults) {
    if (config[key] == null) {
      config[key] = defaults[key];
    }
  }

  let {
    mass,
    frequency,
    damping
  } = config;

  if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(frequency)) {
    if (frequency < 0.01) frequency = 0.01;
    if (damping < 0) damping = 0;
    config.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
    config.friction = 4 * Math.PI * damping * mass / frequency;
  }

  return config;
}

function sanitizeConfig(config, props) {
  if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(props.decay)) {
    config.duration = undefined;
  } else {
    const isTensionConfig = !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(props.tension) || !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(props.friction);

    if (isTensionConfig || !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(props.frequency) || !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(props.damping) || !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(props.mass)) {
      config.duration = undefined;
      config.decay = undefined;
    }

    if (isTensionConfig) {
      config.frequency = undefined;
    }
  }
}

const emptyArray = [];
class Animation {
  constructor() {
    this.changed = false;
    this.values = emptyArray;
    this.toValues = null;
    this.fromValues = emptyArray;
    this.to = void 0;
    this.from = void 0;
    this.config = new AnimationConfig();
    this.immediate = false;
  }

}

function scheduleProps(callId, {
  key,
  props,
  defaultProps,
  state,
  actions
}) {
  return new Promise((resolve, reject) => {
    var _props$cancel;

    let delay;
    let timeout;
    let cancel = matchProp((_props$cancel = props.cancel) != null ? _props$cancel : defaultProps == null ? void 0 : defaultProps.cancel, key);

    if (cancel) {
      onStart();
    } else {
      if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(props.pause)) {
        state.paused = matchProp(props.pause, key);
      }

      let pause = defaultProps == null ? void 0 : defaultProps.pause;

      if (pause !== true) {
        pause = state.paused || matchProp(pause, key);
      }

      delay = callProp(props.delay || 0, key);

      if (pause) {
        state.resumeQueue.add(onResume);
        actions.pause();
      } else {
        actions.resume();
        onResume();
      }
    }

    function onPause() {
      state.resumeQueue.add(onResume);
      state.timeouts.delete(timeout);
      timeout.cancel();
      delay = timeout.time - _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.raf.now();
    }

    function onResume() {
      if (delay > 0 && !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.Globals.skipAnimation) {
        state.delayed = true;
        timeout = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.raf.setTimeout(onStart, delay);
        state.pauseQueue.add(onPause);
        state.timeouts.add(timeout);
      } else {
        onStart();
      }
    }

    function onStart() {
      if (state.delayed) {
        state.delayed = false;
      }

      state.pauseQueue.delete(onPause);
      state.timeouts.delete(timeout);

      if (callId <= (state.cancelId || 0)) {
        cancel = true;
      }

      try {
        actions.start(_extends({}, props, {
          callId,
          cancel
        }), resolve);
      } catch (err) {
        reject(err);
      }
    }
  });
}

const getCombinedResult = (target, results) => results.length == 1 ? results[0] : results.some(result => result.cancelled) ? getCancelledResult(target.get()) : results.every(result => result.noop) ? getNoopResult(target.get()) : getFinishedResult(target.get(), results.every(result => result.finished));
const getNoopResult = value => ({
  value,
  noop: true,
  finished: true,
  cancelled: false
});
const getFinishedResult = (value, finished, cancelled = false) => ({
  value,
  finished,
  cancelled
});
const getCancelledResult = value => ({
  value,
  cancelled: true,
  finished: false
});

function runAsync(to, props, state, target) {
  const {
    callId,
    parentId,
    onRest
  } = props;
  const {
    asyncTo: prevTo,
    promise: prevPromise
  } = state;

  if (!parentId && to === prevTo && !props.reset) {
    return prevPromise;
  }

  return state.promise = (async () => {
    state.asyncId = callId;
    state.asyncTo = to;
    const defaultProps = getDefaultProps(props, (value, key) => key === 'onRest' ? undefined : value);
    let preventBail;
    let bail;
    const bailPromise = new Promise((resolve, reject) => (preventBail = resolve, bail = reject));

    const bailIfEnded = bailSignal => {
      const bailResult = callId <= (state.cancelId || 0) && getCancelledResult(target) || callId !== state.asyncId && getFinishedResult(target, false);

      if (bailResult) {
        bailSignal.result = bailResult;
        bail(bailSignal);
        throw bailSignal;
      }
    };

    const animate = (arg1, arg2) => {
      const bailSignal = new BailSignal();
      const skipAnimationSignal = new SkipAniamtionSignal();
      return (async () => {
        if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.Globals.skipAnimation) {
          stopAsync(state);
          skipAnimationSignal.result = getFinishedResult(target, false);
          bail(skipAnimationSignal);
          throw skipAnimationSignal;
        }

        bailIfEnded(bailSignal);
        const props = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.obj(arg1) ? _extends({}, arg1) : _extends({}, arg2, {
          to: arg1
        });
        props.parentId = callId;
        (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.eachProp)(defaultProps, (value, key) => {
          if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(props[key])) {
            props[key] = value;
          }
        });
        const result = await target.start(props);
        bailIfEnded(bailSignal);

        if (state.paused) {
          await new Promise(resume => {
            state.resumeQueue.add(resume);
          });
        }

        return result;
      })();
    };

    let result;

    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.Globals.skipAnimation) {
      stopAsync(state);
      return getFinishedResult(target, false);
    }

    try {
      let animating;

      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.arr(to)) {
        animating = (async queue => {
          for (const props of queue) {
            await animate(props);
          }
        })(to);
      } else {
        animating = Promise.resolve(to(animate, target.stop.bind(target)));
      }

      await Promise.all([animating.then(preventBail), bailPromise]);
      result = getFinishedResult(target.get(), true, false);
    } catch (err) {
      if (err instanceof BailSignal) {
        result = err.result;
      } else if (err instanceof SkipAniamtionSignal) {
        result = err.result;
      } else {
        throw err;
      }
    } finally {
      if (callId == state.asyncId) {
        state.asyncId = parentId;
        state.asyncTo = parentId ? prevTo : undefined;
        state.promise = parentId ? prevPromise : undefined;
      }
    }

    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(onRest)) {
      _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.raf.batchedUpdates(() => {
        onRest(result, target, target.item);
      });
    }

    return result;
  })();
}
function stopAsync(state, cancelId) {
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.flush)(state.timeouts, t => t.cancel());
  state.pauseQueue.clear();
  state.resumeQueue.clear();
  state.asyncId = state.asyncTo = state.promise = undefined;
  if (cancelId) state.cancelId = cancelId;
}
class BailSignal extends Error {
  constructor() {
    super('An async animation has been interrupted. You see this error because you ' + 'forgot to use `await` or `.catch(...)` on its returned promise.');
    this.result = void 0;
  }

}
class SkipAniamtionSignal extends Error {
  constructor() {
    super('SkipAnimationSignal');
    this.result = void 0;
  }

}

const isFrameValue = value => value instanceof FrameValue;
let nextId$1 = 1;
class FrameValue extends _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.FluidValue {
  constructor(...args) {
    super(...args);
    this.id = nextId$1++;
    this.key = void 0;
    this._priority = 0;
  }

  get priority() {
    return this._priority;
  }

  set priority(priority) {
    if (this._priority != priority) {
      this._priority = priority;

      this._onPriorityChange(priority);
    }
  }

  get() {
    const node = (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.getAnimated)(this);
    return node && node.getValue();
  }

  to(...args) {
    return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.Globals.to(this, args);
  }

  interpolate(...args) {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.deprecateInterpolate)();
    return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.Globals.to(this, args);
  }

  toJSON() {
    return this.get();
  }

  observerAdded(count) {
    if (count == 1) this._attach();
  }

  observerRemoved(count) {
    if (count == 0) this._detach();
  }

  _attach() {}

  _detach() {}

  _onChange(value, idle = false) {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.callFluidObservers)(this, {
      type: 'change',
      parent: this,
      value,
      idle
    });
  }

  _onPriorityChange(priority) {
    if (!this.idle) {
      _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.frameLoop.sort(this);
    }

    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.callFluidObservers)(this, {
      type: 'priority',
      parent: this,
      priority
    });
  }

}

const $P = Symbol.for('SpringPhase');
const HAS_ANIMATED = 1;
const IS_ANIMATING = 2;
const IS_PAUSED = 4;
const hasAnimated = target => (target[$P] & HAS_ANIMATED) > 0;
const isAnimating = target => (target[$P] & IS_ANIMATING) > 0;
const isPaused = target => (target[$P] & IS_PAUSED) > 0;
const setActiveBit = (target, active) => active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;
const setPausedBit = (target, paused) => paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED;

class SpringValue extends FrameValue {
  constructor(arg1, arg2) {
    super();
    this.key = void 0;
    this.animation = new Animation();
    this.queue = void 0;
    this.defaultProps = {};
    this._state = {
      paused: false,
      delayed: false,
      pauseQueue: new Set(),
      resumeQueue: new Set(),
      timeouts: new Set()
    };
    this._pendingCalls = new Set();
    this._lastCallId = 0;
    this._lastToId = 0;
    this._memoizedDuration = 0;

    if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(arg1) || !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(arg2)) {
      const props = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.obj(arg1) ? _extends({}, arg1) : _extends({}, arg2, {
        from: arg1
      });

      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(props.default)) {
        props.default = true;
      }

      this.start(props);
    }
  }

  get idle() {
    return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
  }

  get goal() {
    return (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.getFluidValue)(this.animation.to);
  }

  get velocity() {
    const node = (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.getAnimated)(this);
    return node instanceof _react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.AnimatedValue ? node.lastVelocity || 0 : node.getPayload().map(node => node.lastVelocity || 0);
  }

  get hasAnimated() {
    return hasAnimated(this);
  }

  get isAnimating() {
    return isAnimating(this);
  }

  get isPaused() {
    return isPaused(this);
  }

  get isDelayed() {
    return this._state.delayed;
  }

  advance(dt) {
    let idle = true;
    let changed = false;
    const anim = this.animation;
    let {
      config,
      toValues
    } = anim;
    const payload = (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.getPayload)(anim.to);

    if (!payload && (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.hasFluidValue)(anim.to)) {
      toValues = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.toArray)((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.getFluidValue)(anim.to));
    }

    anim.values.forEach((node, i) => {
      if (node.done) return;
      const to = node.constructor == _react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.AnimatedString ? 1 : payload ? payload[i].lastPosition : toValues[i];
      let finished = anim.immediate;
      let position = to;

      if (!finished) {
        position = node.lastPosition;

        if (config.tension <= 0) {
          node.done = true;
          return;
        }

        let elapsed = node.elapsedTime += dt;
        const from = anim.fromValues[i];
        const v0 = node.v0 != null ? node.v0 : node.v0 = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.arr(config.velocity) ? config.velocity[i] : config.velocity;
        let velocity;
        const precision = config.precision || (from == to ? 0.005 : Math.min(1, Math.abs(to - from) * 0.001));

        if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(config.duration)) {
          let p = 1;

          if (config.duration > 0) {
            if (this._memoizedDuration !== config.duration) {
              this._memoizedDuration = config.duration;

              if (node.durationProgress > 0) {
                node.elapsedTime = config.duration * node.durationProgress;
                elapsed = node.elapsedTime += dt;
              }
            }

            p = (config.progress || 0) + elapsed / this._memoizedDuration;
            p = p > 1 ? 1 : p < 0 ? 0 : p;
            node.durationProgress = p;
          }

          position = from + config.easing(p) * (to - from);
          velocity = (position - node.lastPosition) / dt;
          finished = p == 1;
        } else if (config.decay) {
          const decay = config.decay === true ? 0.998 : config.decay;
          const e = Math.exp(-(1 - decay) * elapsed);
          position = from + v0 / (1 - decay) * (1 - e);
          finished = Math.abs(node.lastPosition - position) <= precision;
          velocity = v0 * e;
        } else {
          velocity = node.lastVelocity == null ? v0 : node.lastVelocity;
          const restVelocity = config.restVelocity || precision / 10;
          const bounceFactor = config.clamp ? 0 : config.bounce;
          const canBounce = !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(bounceFactor);
          const isGrowing = from == to ? node.v0 > 0 : from < to;
          let isMoving;
          let isBouncing = false;
          const step = 1;
          const numSteps = Math.ceil(dt / step);

          for (let n = 0; n < numSteps; ++n) {
            isMoving = Math.abs(velocity) > restVelocity;

            if (!isMoving) {
              finished = Math.abs(to - position) <= precision;

              if (finished) {
                break;
              }
            }

            if (canBounce) {
              isBouncing = position == to || position > to == isGrowing;

              if (isBouncing) {
                velocity = -velocity * bounceFactor;
                position = to;
              }
            }

            const springForce = -config.tension * 0.000001 * (position - to);
            const dampingForce = -config.friction * 0.001 * velocity;
            const acceleration = (springForce + dampingForce) / config.mass;
            velocity = velocity + acceleration * step;
            position = position + velocity * step;
          }
        }

        node.lastVelocity = velocity;

        if (Number.isNaN(position)) {
          console.warn(`Got NaN while animating:`, this);
          finished = true;
        }
      }

      if (payload && !payload[i].done) {
        finished = false;
      }

      if (finished) {
        node.done = true;
      } else {
        idle = false;
      }

      if (node.setValue(position, config.round)) {
        changed = true;
      }
    });
    const node = (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.getAnimated)(this);
    const currVal = node.getValue();

    if (idle) {
      const finalVal = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.getFluidValue)(anim.to);

      if ((currVal !== finalVal || changed) && !config.decay) {
        node.setValue(finalVal);

        this._onChange(finalVal);
      } else if (changed && config.decay) {
        this._onChange(currVal);
      }

      this._stop();
    } else if (changed) {
      this._onChange(currVal);
    }
  }

  set(value) {
    _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.raf.batchedUpdates(() => {
      this._stop();

      this._focus(value);

      this._set(value);
    });
    return this;
  }

  pause() {
    this._update({
      pause: true
    });
  }

  resume() {
    this._update({
      pause: false
    });
  }

  finish() {
    if (isAnimating(this)) {
      const {
        to,
        config
      } = this.animation;
      _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.raf.batchedUpdates(() => {
        this._onStart();

        if (!config.decay) {
          this._set(to, false);
        }

        this._stop();
      });
    }

    return this;
  }

  update(props) {
    const queue = this.queue || (this.queue = []);
    queue.push(props);
    return this;
  }

  start(to, arg2) {
    let queue;

    if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(to)) {
      queue = [_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.obj(to) ? to : _extends({}, arg2, {
        to
      })];
    } else {
      queue = this.queue || [];
      this.queue = [];
    }

    return Promise.all(queue.map(props => {
      const up = this._update(props);

      return up;
    })).then(results => getCombinedResult(this, results));
  }

  stop(cancel) {
    const {
      to
    } = this.animation;

    this._focus(this.get());

    stopAsync(this._state, cancel && this._lastCallId);
    _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.raf.batchedUpdates(() => this._stop(to, cancel));
    return this;
  }

  reset() {
    this._update({
      reset: true
    });
  }

  eventObserved(event) {
    if (event.type == 'change') {
      this._start();
    } else if (event.type == 'priority') {
      this.priority = event.priority + 1;
    }
  }

  _prepareNode(props) {
    const key = this.key || '';
    let {
      to,
      from
    } = props;
    to = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.obj(to) ? to[key] : to;

    if (to == null || isAsyncTo(to)) {
      to = undefined;
    }

    from = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.obj(from) ? from[key] : from;

    if (from == null) {
      from = undefined;
    }

    const range = {
      to,
      from
    };

    if (!hasAnimated(this)) {
      if (props.reverse) [to, from] = [from, to];
      from = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.getFluidValue)(from);

      if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(from)) {
        this._set(from);
      } else if (!(0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.getAnimated)(this)) {
        this._set(to);
      }
    }

    return range;
  }

  _update(_ref, isLoop) {
    let props = _extends({}, _ref);

    const {
      key,
      defaultProps
    } = this;
    if (props.default) Object.assign(defaultProps, getDefaultProps(props, (value, prop) => /^on/.test(prop) ? resolveProp(value, key) : value));
    mergeActiveFn(this, props, 'onProps');
    sendEvent(this, 'onProps', props, this);

    const range = this._prepareNode(props);

    if (Object.isFrozen(this)) {
      throw Error('Cannot animate a `SpringValue` object that is frozen. ' + 'Did you forget to pass your component to `animated(...)` before animating its props?');
    }

    const state = this._state;
    return scheduleProps(++this._lastCallId, {
      key,
      props,
      defaultProps,
      state,
      actions: {
        pause: () => {
          if (!isPaused(this)) {
            setPausedBit(this, true);
            (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.flushCalls)(state.pauseQueue);
            sendEvent(this, 'onPause', getFinishedResult(this, checkFinished(this, this.animation.to)), this);
          }
        },
        resume: () => {
          if (isPaused(this)) {
            setPausedBit(this, false);

            if (isAnimating(this)) {
              this._resume();
            }

            (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.flushCalls)(state.resumeQueue);
            sendEvent(this, 'onResume', getFinishedResult(this, checkFinished(this, this.animation.to)), this);
          }
        },
        start: this._merge.bind(this, range)
      }
    }).then(result => {
      if (props.loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = createLoopUpdate(props);

        if (nextProps) {
          return this._update(nextProps, true);
        }
      }

      return result;
    });
  }

  _merge(range, props, resolve) {
    if (props.cancel) {
      this.stop(true);
      return resolve(getCancelledResult(this));
    }

    const hasToProp = !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(range.to);
    const hasFromProp = !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(range.from);

    if (hasToProp || hasFromProp) {
      if (props.callId > this._lastToId) {
        this._lastToId = props.callId;
      } else {
        return resolve(getCancelledResult(this));
      }
    }

    const {
      key,
      defaultProps,
      animation: anim
    } = this;
    const {
      to: prevTo,
      from: prevFrom
    } = anim;
    let {
      to = prevTo,
      from = prevFrom
    } = range;

    if (hasFromProp && !hasToProp && (!props.default || _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(to))) {
      to = from;
    }

    if (props.reverse) [to, from] = [from, to];
    const hasFromChanged = !(0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.isEqual)(from, prevFrom);

    if (hasFromChanged) {
      anim.from = from;
    }

    from = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.getFluidValue)(from);
    const hasToChanged = !(0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.isEqual)(to, prevTo);

    if (hasToChanged) {
      this._focus(to);
    }

    const hasAsyncTo = isAsyncTo(props.to);
    const {
      config
    } = anim;
    const {
      decay,
      velocity
    } = config;

    if (hasToProp || hasFromProp) {
      config.velocity = 0;
    }

    if (props.config && !hasAsyncTo) {
      mergeConfig(config, callProp(props.config, key), props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0);
    }

    let node = (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.getAnimated)(this);

    if (!node || _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(to)) {
      return resolve(getFinishedResult(this, true));
    }

    const reset = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(props.reset) ? hasFromProp && !props.default : !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(from) && matchProp(props.reset, key);
    const value = reset ? from : this.get();
    const goal = computeGoal(to);
    const isAnimatable = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.num(goal) || _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.arr(goal) || (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.isAnimatedString)(goal);
    const immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));

    if (hasToChanged) {
      const nodeType = (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.getAnimatedType)(to);

      if (nodeType !== node.constructor) {
        if (immediate) {
          node = this._set(goal);
        } else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
      }
    }

    const goalType = node.constructor;
    let started = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.hasFluidValue)(to);
    let finished = false;

    if (!started) {
      const hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;

      if (hasToChanged || hasValueChanged) {
        finished = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.isEqual)(computeGoal(value), goal);
        started = !finished;
      }

      if (!(0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.isEqual)(anim.immediate, immediate) && !immediate || !(0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.isEqual)(config.decay, decay) || !(0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.isEqual)(config.velocity, velocity)) {
        started = true;
      }
    }

    if (finished && isAnimating(this)) {
      if (anim.changed && !reset) {
        started = true;
      } else if (!started) {
        this._stop(prevTo);
      }
    }

    if (!hasAsyncTo) {
      if (started || (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.hasFluidValue)(prevTo)) {
        anim.values = node.getPayload();
        anim.toValues = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.hasFluidValue)(to) ? null : goalType == _react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.AnimatedString ? [1] : (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.toArray)(goal);
      }

      if (anim.immediate != immediate) {
        anim.immediate = immediate;

        if (!immediate && !reset) {
          this._set(prevTo);
        }
      }

      if (started) {
        const {
          onRest
        } = anim;
        (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(ACTIVE_EVENTS, type => mergeActiveFn(this, props, type));
        const result = getFinishedResult(this, checkFinished(this, prevTo));
        (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.flushCalls)(this._pendingCalls, result);

        this._pendingCalls.add(resolve);

        if (anim.changed) _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.raf.batchedUpdates(() => {
          anim.changed = !reset;
          onRest == null ? void 0 : onRest(result, this);

          if (reset) {
            callProp(defaultProps.onRest, result);
          } else {
            anim.onStart == null ? void 0 : anim.onStart(result, this);
          }
        });
      }
    }

    if (reset) {
      this._set(value);
    }

    if (hasAsyncTo) {
      resolve(runAsync(props.to, props, this._state, this));
    } else if (started) {
      this._start();
    } else if (isAnimating(this) && !hasToChanged) {
      this._pendingCalls.add(resolve);
    } else {
      resolve(getNoopResult(value));
    }
  }

  _focus(value) {
    const anim = this.animation;

    if (value !== anim.to) {
      if ((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.getFluidObservers)(this)) {
        this._detach();
      }

      anim.to = value;

      if ((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.getFluidObservers)(this)) {
        this._attach();
      }
    }
  }

  _attach() {
    let priority = 0;
    const {
      to
    } = this.animation;

    if ((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.hasFluidValue)(to)) {
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.addFluidObserver)(to, this);

      if (isFrameValue(to)) {
        priority = to.priority + 1;
      }
    }

    this.priority = priority;
  }

  _detach() {
    const {
      to
    } = this.animation;

    if ((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.hasFluidValue)(to)) {
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.removeFluidObserver)(to, this);
    }
  }

  _set(arg, idle = true) {
    const value = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.getFluidValue)(arg);

    if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(value)) {
      const oldNode = (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.getAnimated)(this);

      if (!oldNode || !(0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.isEqual)(value, oldNode.getValue())) {
        const nodeType = (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.getAnimatedType)(value);

        if (!oldNode || oldNode.constructor != nodeType) {
          (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.setAnimated)(this, nodeType.create(value));
        } else {
          oldNode.setValue(value);
        }

        if (oldNode) {
          _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.raf.batchedUpdates(() => {
            this._onChange(value, idle);
          });
        }
      }
    }

    return (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.getAnimated)(this);
  }

  _onStart() {
    const anim = this.animation;

    if (!anim.changed) {
      anim.changed = true;
      sendEvent(this, 'onStart', getFinishedResult(this, checkFinished(this, anim.to)), this);
    }
  }

  _onChange(value, idle) {
    if (!idle) {
      this._onStart();

      callProp(this.animation.onChange, value, this);
    }

    callProp(this.defaultProps.onChange, value, this);

    super._onChange(value, idle);
  }

  _start() {
    const anim = this.animation;
    (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.getAnimated)(this).reset((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.getFluidValue)(anim.to));

    if (!anim.immediate) {
      anim.fromValues = anim.values.map(node => node.lastPosition);
    }

    if (!isAnimating(this)) {
      setActiveBit(this, true);

      if (!isPaused(this)) {
        this._resume();
      }
    }
  }

  _resume() {
    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.Globals.skipAnimation) {
      this.finish();
    } else {
      _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.frameLoop.start(this);
    }
  }

  _stop(goal, cancel) {
    if (isAnimating(this)) {
      setActiveBit(this, false);
      const anim = this.animation;
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(anim.values, node => {
        node.done = true;
      });

      if (anim.toValues) {
        anim.onChange = anim.onPause = anim.onResume = undefined;
      }

      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.callFluidObservers)(this, {
        type: 'idle',
        parent: this
      });
      const result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal != null ? goal : anim.to));
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.flushCalls)(this._pendingCalls, result);

      if (anim.changed) {
        anim.changed = false;
        sendEvent(this, 'onRest', result, this);
      }
    }
  }

}

function checkFinished(target, to) {
  const goal = computeGoal(to);
  const value = computeGoal(target.get());
  return (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.isEqual)(value, goal);
}

function createLoopUpdate(props, loop = props.loop, to = props.to) {
  let loopRet = callProp(loop);

  if (loopRet) {
    const overrides = loopRet !== true && inferTo(loopRet);
    const reverse = (overrides || props).reverse;
    const reset = !overrides || overrides.reset;
    return createUpdate(_extends({}, props, {
      loop,
      default: false,
      pause: undefined,
      to: !reverse || isAsyncTo(to) ? to : undefined,
      from: reset ? props.from : undefined,
      reset
    }, overrides));
  }
}
function createUpdate(props) {
  const {
    to,
    from
  } = props = inferTo(props);
  const keys = new Set();
  if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.obj(to)) findDefined(to, keys);
  if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.obj(from)) findDefined(from, keys);
  props.keys = keys.size ? Array.from(keys) : null;
  return props;
}
function declareUpdate(props) {
  const update = createUpdate(props);

  if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(update.default)) {
    update.default = getDefaultProps(update);
  }

  return update;
}

function findDefined(values, keys) {
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.eachProp)(values, (value, key) => value != null && keys.add(key));
}

const ACTIVE_EVENTS = ['onStart', 'onRest', 'onChange', 'onPause', 'onResume'];

function mergeActiveFn(target, props, type) {
  target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : undefined;
}

function sendEvent(target, type, ...args) {
  var _target$animation$typ, _target$animation, _target$defaultProps$, _target$defaultProps;

  (_target$animation$typ = (_target$animation = target.animation)[type]) == null ? void 0 : _target$animation$typ.call(_target$animation, ...args);
  (_target$defaultProps$ = (_target$defaultProps = target.defaultProps)[type]) == null ? void 0 : _target$defaultProps$.call(_target$defaultProps, ...args);
}

const BATCHED_EVENTS = ['onStart', 'onChange', 'onRest'];
let nextId = 1;
class Controller {
  constructor(props, flush) {
    this.id = nextId++;
    this.springs = {};
    this.queue = [];
    this.ref = void 0;
    this._flush = void 0;
    this._initialProps = void 0;
    this._lastAsyncId = 0;
    this._active = new Set();
    this._changed = new Set();
    this._started = false;
    this._item = void 0;
    this._state = {
      paused: false,
      pauseQueue: new Set(),
      resumeQueue: new Set(),
      timeouts: new Set()
    };
    this._events = {
      onStart: new Map(),
      onChange: new Map(),
      onRest: new Map()
    };
    this._onFrame = this._onFrame.bind(this);

    if (flush) {
      this._flush = flush;
    }

    if (props) {
      this.start(_extends({
        default: true
      }, props));
    }
  }

  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every(spring => {
      return spring.idle && !spring.isDelayed && !spring.isPaused;
    });
  }

  get item() {
    return this._item;
  }

  set item(item) {
    this._item = item;
  }

  get() {
    const values = {};
    this.each((spring, key) => values[key] = spring.get());
    return values;
  }

  set(values) {
    for (const key in values) {
      const value = values[key];

      if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(value)) {
        this.springs[key].set(value);
      }
    }
  }

  update(props) {
    if (props) {
      this.queue.push(createUpdate(props));
    }

    return this;
  }

  start(props) {
    let {
      queue
    } = this;

    if (props) {
      queue = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.toArray)(props).map(createUpdate);
    } else {
      this.queue = [];
    }

    if (this._flush) {
      return this._flush(this, queue);
    }

    prepareKeys(this, queue);
    return flushUpdateQueue(this, queue);
  }

  stop(arg, keys) {
    if (arg !== !!arg) {
      keys = arg;
    }

    if (keys) {
      const springs = this.springs;
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.toArray)(keys), key => springs[key].stop(!!arg));
    } else {
      stopAsync(this._state, this._lastAsyncId);
      this.each(spring => spring.stop(!!arg));
    }

    return this;
  }

  pause(keys) {
    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(keys)) {
      this.start({
        pause: true
      });
    } else {
      const springs = this.springs;
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.toArray)(keys), key => springs[key].pause());
    }

    return this;
  }

  resume(keys) {
    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(keys)) {
      this.start({
        pause: false
      });
    } else {
      const springs = this.springs;
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.toArray)(keys), key => springs[key].resume());
    }

    return this;
  }

  each(iterator) {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.eachProp)(this.springs, iterator);
  }

  _onFrame() {
    const {
      onStart,
      onChange,
      onRest
    } = this._events;
    const active = this._active.size > 0;
    const changed = this._changed.size > 0;

    if (active && !this._started || changed && !this._started) {
      this._started = true;
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.flush)(onStart, ([onStart, result]) => {
        result.value = this.get();
        onStart(result, this, this._item);
      });
    }

    const idle = !active && this._started;
    const values = changed || idle && onRest.size ? this.get() : null;

    if (changed && onChange.size) {
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.flush)(onChange, ([onChange, result]) => {
        result.value = values;
        onChange(result, this, this._item);
      });
    }

    if (idle) {
      this._started = false;
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.flush)(onRest, ([onRest, result]) => {
        result.value = values;
        onRest(result, this, this._item);
      });
    }
  }

  eventObserved(event) {
    if (event.type == 'change') {
      this._changed.add(event.parent);

      if (!event.idle) {
        this._active.add(event.parent);
      }
    } else if (event.type == 'idle') {
      this._active.delete(event.parent);
    } else return;

    _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.raf.onFrame(this._onFrame);
  }

}
function flushUpdateQueue(ctrl, queue) {
  return Promise.all(queue.map(props => flushUpdate(ctrl, props))).then(results => getCombinedResult(ctrl, results));
}
async function flushUpdate(ctrl, props, isLoop) {
  const {
    keys,
    to,
    from,
    loop,
    onRest,
    onResolve
  } = props;
  const defaults = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.obj(props.default) && props.default;

  if (loop) {
    props.loop = false;
  }

  if (to === false) props.to = null;
  if (from === false) props.from = null;
  const asyncTo = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.arr(to) || _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(to) ? to : undefined;

  if (asyncTo) {
    props.to = undefined;
    props.onRest = undefined;

    if (defaults) {
      defaults.onRest = undefined;
    }
  } else {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(BATCHED_EVENTS, key => {
      const handler = props[key];

      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(handler)) {
        const queue = ctrl['_events'][key];

        props[key] = ({
          finished,
          cancelled
        }) => {
          const result = queue.get(handler);

          if (result) {
            if (!finished) result.finished = false;
            if (cancelled) result.cancelled = true;
          } else {
            queue.set(handler, {
              value: null,
              finished: finished || false,
              cancelled: cancelled || false
            });
          }
        };

        if (defaults) {
          defaults[key] = props[key];
        }
      }
    });
  }

  const state = ctrl['_state'];

  if (props.pause === !state.paused) {
    state.paused = props.pause;
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.flushCalls)(props.pause ? state.pauseQueue : state.resumeQueue);
  } else if (state.paused) {
    props.pause = true;
  }

  const promises = (keys || Object.keys(ctrl.springs)).map(key => ctrl.springs[key].start(props));
  const cancel = props.cancel === true || getDefaultProp(props, 'cancel') === true;

  if (asyncTo || cancel && state.asyncId) {
    promises.push(scheduleProps(++ctrl['_lastAsyncId'], {
      props,
      state,
      actions: {
        pause: _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.noop,
        resume: _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.noop,

        start(props, resolve) {
          if (cancel) {
            stopAsync(state, ctrl['_lastAsyncId']);
            resolve(getCancelledResult(ctrl));
          } else {
            props.onRest = onRest;
            resolve(runAsync(asyncTo, props, state, ctrl));
          }
        }

      }
    }));
  }

  if (state.paused) {
    await new Promise(resume => {
      state.resumeQueue.add(resume);
    });
  }

  const result = getCombinedResult(ctrl, await Promise.all(promises));

  if (loop && result.finished && !(isLoop && result.noop)) {
    const nextProps = createLoopUpdate(props, loop, to);

    if (nextProps) {
      prepareKeys(ctrl, [nextProps]);
      return flushUpdate(ctrl, nextProps, true);
    }
  }

  if (onResolve) {
    _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.raf.batchedUpdates(() => onResolve(result, ctrl, ctrl.item));
  }

  return result;
}
function getSprings(ctrl, props) {
  const springs = _extends({}, ctrl.springs);

  if (props) {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.toArray)(props), props => {
      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(props.keys)) {
        props = createUpdate(props);
      }

      if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.obj(props.to)) {
        props = _extends({}, props, {
          to: undefined
        });
      }

      prepareSprings(springs, props, key => {
        return createSpring(key);
      });
    });
  }

  setSprings(ctrl, springs);
  return springs;
}
function setSprings(ctrl, springs) {
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.eachProp)(springs, (spring, key) => {
    if (!ctrl.springs[key]) {
      ctrl.springs[key] = spring;
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.addFluidObserver)(spring, ctrl);
    }
  });
}

function createSpring(key, observer) {
  const spring = new SpringValue();
  spring.key = key;

  if (observer) {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.addFluidObserver)(spring, observer);
  }

  return spring;
}

function prepareSprings(springs, props, create) {
  if (props.keys) {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(props.keys, key => {
      const spring = springs[key] || (springs[key] = create(key));
      spring['_prepareNode'](props);
    });
  }
}

function prepareKeys(ctrl, queue) {
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(queue, props => {
    prepareSprings(ctrl.springs, props, key => {
      return createSpring(key, ctrl);
    });
  });
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const _excluded$3 = ["children"];
const SpringContext = _ref => {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  const inherited = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ctx);
  const pause = props.pause || !!inherited.pause,
        immediate = props.immediate || !!inherited.immediate;
  props = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useMemoOne)(() => ({
    pause,
    immediate
  }), [pause, immediate]);
  const {
    Provider
  } = ctx;
  return react__WEBPACK_IMPORTED_MODULE_1__.createElement(Provider, {
    value: props
  }, children);
};
const ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;

function makeContext(target, init) {
  Object.assign(target, react__WEBPACK_IMPORTED_MODULE_1__.createContext(init));
  target.Provider._context = target;
  target.Consumer._context = target;
  return target;
}

const SpringRef = () => {
  const current = [];

  const SpringRef = function SpringRef(props) {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.deprecateDirectCall)();
    const results = [];
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(current, (ctrl, i) => {
      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(props)) {
        results.push(ctrl.start());
      } else {
        const update = _getProps(props, ctrl, i);

        if (update) {
          results.push(ctrl.start(update));
        }
      }
    });
    return results;
  };

  SpringRef.current = current;

  SpringRef.add = function (ctrl) {
    if (!current.includes(ctrl)) {
      current.push(ctrl);
    }
  };

  SpringRef.delete = function (ctrl) {
    const i = current.indexOf(ctrl);
    if (~i) current.splice(i, 1);
  };

  SpringRef.pause = function () {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(current, ctrl => ctrl.pause(...arguments));
    return this;
  };

  SpringRef.resume = function () {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(current, ctrl => ctrl.resume(...arguments));
    return this;
  };

  SpringRef.set = function (values) {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(current, ctrl => ctrl.set(values));
  };

  SpringRef.start = function (props) {
    const results = [];
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(current, (ctrl, i) => {
      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(props)) {
        results.push(ctrl.start());
      } else {
        const update = this._getProps(props, ctrl, i);

        if (update) {
          results.push(ctrl.start(update));
        }
      }
    });
    return results;
  };

  SpringRef.stop = function () {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(current, ctrl => ctrl.stop(...arguments));
    return this;
  };

  SpringRef.update = function (props) {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(current, (ctrl, i) => ctrl.update(this._getProps(props, ctrl, i)));
    return this;
  };

  const _getProps = function _getProps(arg, ctrl, index) {
    return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(arg) ? arg(index, ctrl) : arg;
  };

  SpringRef._getProps = _getProps;
  return SpringRef;
};

function useSprings(length, props, deps) {
  const propsFn = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(props) && props;
  if (propsFn && !deps) deps = [];
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => propsFn || arguments.length == 3 ? SpringRef() : void 0, []);
  const layoutId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
  const forceUpdate = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useForceUpdate)();
  const state = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => ({
    ctrls: [],
    queue: [],

    flush(ctrl, updates) {
      const springs = getSprings(ctrl, updates);
      const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs).some(key => !ctrl.springs[key]);
      return canFlushSync ? flushUpdateQueue(ctrl, updates) : new Promise(resolve => {
        setSprings(ctrl, springs);
        state.queue.push(() => {
          resolve(flushUpdateQueue(ctrl, updates));
        });
        forceUpdate();
      });
    }

  }), []);
  const ctrls = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([...state.ctrls]);
  const updates = [];
  const prevLength = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.usePrev)(length) || 0;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(ctrls.current.slice(length, prevLength), ctrl => {
      detachRefs(ctrl, ref);
      ctrl.stop(true);
    });
    ctrls.current.length = length;
    declareUpdates(prevLength, length);
  }, [length]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    declareUpdates(0, Math.min(prevLength, length));
  }, deps);

  function declareUpdates(startIndex, endIndex) {
    for (let i = startIndex; i < endIndex; i++) {
      const ctrl = ctrls.current[i] || (ctrls.current[i] = new Controller(null, state.flush));
      const update = propsFn ? propsFn(i, ctrl) : props[i];

      if (update) {
        updates[i] = declareUpdate(update);
      }
    }
  }

  const springs = ctrls.current.map((ctrl, i) => getSprings(ctrl, updates[i]));
  const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(SpringContext);
  const prevContext = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.usePrev)(context);
  const hasContext = context !== prevContext && hasProps(context);
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useIsomorphicLayoutEffect)(() => {
    layoutId.current++;
    state.ctrls = ctrls.current;
    const {
      queue
    } = state;

    if (queue.length) {
      state.queue = [];
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(queue, cb => cb());
    }

    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(ctrls.current, (ctrl, i) => {
      ref == null ? void 0 : ref.add(ctrl);

      if (hasContext) {
        ctrl.start({
          default: context
        });
      }

      const update = updates[i];

      if (update) {
        replaceRef(ctrl, update.ref);

        if (ctrl.ref) {
          ctrl.queue.push(update);
        } else {
          ctrl.start(update);
        }
      }
    });
  });
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useOnce)(() => () => {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(state.ctrls, ctrl => ctrl.stop(true));
  });
  const values = springs.map(x => _extends({}, x));
  return ref ? [values, ref] : values;
}

function useSpring(props, deps) {
  const isFn = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(props);
  const [[values], ref] = useSprings(1, isFn ? props : [props], isFn ? deps || [] : deps);
  return isFn || arguments.length == 2 ? [values, ref] : values;
}

const initSpringRef = () => SpringRef();

const useSpringRef = () => (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initSpringRef)[0];

function useTrail(length, propsArg, deps) {
  var _passedRef;

  const propsFn = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(propsArg) && propsArg;
  if (propsFn && !deps) deps = [];
  let reverse = true;
  let passedRef = undefined;
  const result = useSprings(length, (i, ctrl) => {
    const props = propsFn ? propsFn(i, ctrl) : propsArg;
    passedRef = props.ref;
    reverse = reverse && props.reverse;
    return props;
  }, deps || [{}]);
  const ref = (_passedRef = passedRef) != null ? _passedRef : result[1];
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useIsomorphicLayoutEffect)(() => {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(ref.current, (ctrl, i) => {
      const parent = ref.current[i + (reverse ? 1 : -1)];

      if (parent) {
        ctrl.start({
          to: parent.springs
        });
      } else {
        ctrl.start();
      }
    });
  }, deps);

  if (propsFn || arguments.length == 3) {
    ref['_getProps'] = (propsArg, ctrl, i) => {
      const props = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(propsArg) ? propsArg(i, ctrl) : propsArg;

      if (props) {
        const parent = ref.current[i + (props.reverse ? 1 : -1)];
        if (parent) props.to = parent.springs;
        return props;
      }
    };

    return result;
  }

  ref['start'] = propsArg => {
    const results = [];
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(ref.current, (ctrl, i) => {
      const props = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(propsArg) ? propsArg(i, ctrl) : propsArg;
      const parent = ref.current[i + (reverse ? 1 : -1)];

      if (parent) {
        results.push(ctrl.start(_extends({}, props, {
          to: parent.springs
        })));
      } else {
        results.push(ctrl.start(_extends({}, props)));
      }
    });
    return results;
  };

  return result[0];
}

let TransitionPhase;

(function (TransitionPhase) {
  TransitionPhase["MOUNT"] = "mount";
  TransitionPhase["ENTER"] = "enter";
  TransitionPhase["UPDATE"] = "update";
  TransitionPhase["LEAVE"] = "leave";
})(TransitionPhase || (TransitionPhase = {}));

function useTransition(data, props, deps) {
  const propsFn = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(props) && props;
  const {
    reset,
    sort,
    trail = 0,
    expires = true,
    exitBeforeEnter = false,
    onDestroyed,
    ref: propsRef,
    config: propsConfig
  } = propsFn ? propsFn() : props;
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => propsFn || arguments.length == 3 ? SpringRef() : void 0, []);
  const items = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.toArray)(data);
  const transitions = [];
  const usedTransitions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const prevTransitions = reset ? null : usedTransitions.current;
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useIsomorphicLayoutEffect)(() => {
    usedTransitions.current = transitions;
  });
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useOnce)(() => {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(transitions, t => {
      ref == null ? void 0 : ref.add(t.ctrl);
      t.ctrl.ref = ref;
    });
    return () => {
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(usedTransitions.current, t => {
        if (t.expired) {
          clearTimeout(t.expirationId);
        }

        detachRefs(t.ctrl, ref);
        t.ctrl.stop(true);
      });
    };
  });
  const keys = getKeys(items, propsFn ? propsFn() : props, prevTransitions);
  const expired = reset && usedTransitions.current || [];
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useIsomorphicLayoutEffect)(() => (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(expired, ({
    ctrl,
    item,
    key
  }) => {
    detachRefs(ctrl, ref);
    callProp(onDestroyed, item, key);
  }));
  const reused = [];
  if (prevTransitions) (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(prevTransitions, (t, i) => {
    if (t.expired) {
      clearTimeout(t.expirationId);
      expired.push(t);
    } else {
      i = reused[i] = keys.indexOf(t.key);
      if (~i) transitions[i] = t;
    }
  });
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(items, (item, i) => {
    if (!transitions[i]) {
      transitions[i] = {
        key: keys[i],
        item,
        phase: TransitionPhase.MOUNT,
        ctrl: new Controller()
      };
      transitions[i].ctrl.item = item;
    }
  });

  if (reused.length) {
    let i = -1;
    const {
      leave
    } = propsFn ? propsFn() : props;
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(reused, (keyIndex, prevIndex) => {
      const t = prevTransitions[prevIndex];

      if (~keyIndex) {
        i = transitions.indexOf(t);
        transitions[i] = _extends({}, t, {
          item: items[keyIndex]
        });
      } else if (leave) {
        transitions.splice(++i, 0, t);
      }
    });
  }

  if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(sort)) {
    transitions.sort((a, b) => sort(a.item, b.item));
  }

  let delay = -trail;
  const forceUpdate = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useForceUpdate)();
  const defaultProps = getDefaultProps(props);
  const changes = new Map();
  const exitingTransitions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(new Map());
  const forceChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(transitions, (t, i) => {
    const key = t.key;
    const prevPhase = t.phase;
    const p = propsFn ? propsFn() : props;
    let to;
    let phase;
    let propsDelay = callProp(p.delay || 0, key);

    if (prevPhase == TransitionPhase.MOUNT) {
      to = p.enter;
      phase = TransitionPhase.ENTER;
    } else {
      const isLeave = keys.indexOf(key) < 0;

      if (prevPhase != TransitionPhase.LEAVE) {
        if (isLeave) {
          to = p.leave;
          phase = TransitionPhase.LEAVE;
        } else if (to = p.update) {
          phase = TransitionPhase.UPDATE;
        } else return;
      } else if (!isLeave) {
        to = p.enter;
        phase = TransitionPhase.ENTER;
      } else return;
    }

    to = callProp(to, t.item, i);
    to = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.obj(to) ? inferTo(to) : {
      to
    };

    if (!to.config) {
      const config = propsConfig || defaultProps.config;
      to.config = callProp(config, t.item, i, phase);
    }

    delay += trail;

    const payload = _extends({}, defaultProps, {
      delay: propsDelay + delay,
      ref: propsRef,
      immediate: p.immediate,
      reset: false
    }, to);

    if (phase == TransitionPhase.ENTER && _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(payload.from)) {
      const _p = propsFn ? propsFn() : props;

      const from = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(_p.initial) || prevTransitions ? _p.from : _p.initial;
      payload.from = callProp(from, t.item, i);
    }

    const {
      onResolve
    } = payload;

    payload.onResolve = result => {
      callProp(onResolve, result);
      const transitions = usedTransitions.current;
      const t = transitions.find(t => t.key === key);
      if (!t) return;

      if (result.cancelled && t.phase != TransitionPhase.UPDATE) {
        return;
      }

      if (t.ctrl.idle) {
        const idle = transitions.every(t => t.ctrl.idle);

        if (t.phase == TransitionPhase.LEAVE) {
          const expiry = callProp(expires, t.item);

          if (expiry !== false) {
            const expiryMs = expiry === true ? 0 : expiry;
            t.expired = true;

            if (!idle && expiryMs > 0) {
              if (expiryMs <= 0x7fffffff) t.expirationId = setTimeout(forceUpdate, expiryMs);
              return;
            }
          }
        }

        if (idle && transitions.some(t => t.expired)) {
          exitingTransitions.current.delete(t);

          if (exitBeforeEnter) {
            forceChange.current = true;
          }

          forceUpdate();
        }
      }
    };

    const springs = getSprings(t.ctrl, payload);

    if (phase === TransitionPhase.LEAVE && exitBeforeEnter) {
      exitingTransitions.current.set(t, {
        phase,
        springs,
        payload
      });
    } else {
      changes.set(t, {
        phase,
        springs,
        payload
      });
    }
  });
  const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(SpringContext);
  const prevContext = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.usePrev)(context);
  const hasContext = context !== prevContext && hasProps(context);
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useIsomorphicLayoutEffect)(() => {
    if (hasContext) {
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(transitions, t => {
        t.ctrl.start({
          default: context
        });
      });
    }
  }, [context]);
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(changes, (_, t) => {
    if (exitingTransitions.current.size) {
      const ind = transitions.findIndex(state => state.key === t.key);
      transitions.splice(ind, 1);
    }
  });
  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useIsomorphicLayoutEffect)(() => {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({
      phase,
      payload
    }, t) => {
      const {
        ctrl
      } = t;
      t.phase = phase;
      ref == null ? void 0 : ref.add(ctrl);

      if (hasContext && phase == TransitionPhase.ENTER) {
        ctrl.start({
          default: context
        });
      }

      if (payload) {
        replaceRef(ctrl, payload.ref);

        if ((ctrl.ref || ref) && !forceChange.current) {
          ctrl.update(payload);
        } else {
          ctrl.start(payload);

          if (forceChange.current) {
            forceChange.current = false;
          }
        }
      }
    });
  }, reset ? void 0 : deps);

  const renderTransitions = render => react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, transitions.map((t, i) => {
    const {
      springs
    } = changes.get(t) || t.ctrl;
    const elem = render(_extends({}, springs), t.item, t, i);
    return elem && elem.type ? react__WEBPACK_IMPORTED_MODULE_1__.createElement(elem.type, _extends({}, elem.props, {
      key: _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.str(t.key) || _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.num(t.key) ? t.key : t.ctrl.id,
      ref: elem.ref
    })) : elem;
  }));

  return ref ? [renderTransitions, ref] : renderTransitions;
}
let nextKey = 1;

function getKeys(items, {
  key,
  keys = key
}, prevTransitions) {
  if (keys === null) {
    const reused = new Set();
    return items.map(item => {
      const t = prevTransitions && prevTransitions.find(t => t.item === item && t.phase !== TransitionPhase.LEAVE && !reused.has(t));

      if (t) {
        reused.add(t);
        return t.key;
      }

      return nextKey++;
    });
  }

  return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.und(keys) ? items : _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(keys) ? items.map(keys) : (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.toArray)(keys);
}

const _excluded$2 = ["children"];
function Spring(_ref) {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  return children(useSpring(props));
}

const _excluded$1 = ["items", "children"];
function Trail(_ref) {
  let {
    items,
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  const trails = useTrail(items.length, props);
  return items.map((item, index) => {
    const result = children(item, index);
    return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(result) ? result(trails[index]) : result;
  });
}

const _excluded = ["items", "children"];
function Transition(_ref) {
  let {
    items,
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return useTransition(items, props)(children);
}

class Interpolation extends FrameValue {
  constructor(source, args) {
    super();
    this.key = void 0;
    this.idle = true;
    this.calc = void 0;
    this._active = new Set();
    this.source = source;
    this.calc = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.createInterpolator)(...args);

    const value = this._get();

    const nodeType = (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.getAnimatedType)(value);
    (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.setAnimated)(this, nodeType.create(value));
  }

  advance(_dt) {
    const value = this._get();

    const oldValue = this.get();

    if (!(0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.isEqual)(value, oldValue)) {
      (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.getAnimated)(this).setValue(value);

      this._onChange(value, this.idle);
    }

    if (!this.idle && checkIdle(this._active)) {
      becomeIdle(this);
    }
  }

  _get() {
    const inputs = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.arr(this.source) ? this.source.map(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.getFluidValue) : (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.toArray)((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.getFluidValue)(this.source));
    return this.calc(...inputs);
  }

  _start() {
    if (this.idle && !checkIdle(this._active)) {
      this.idle = false;
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)((0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.getPayload)(this), node => {
        node.done = false;
      });

      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.Globals.skipAnimation) {
        _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.raf.batchedUpdates(() => this.advance());
        becomeIdle(this);
      } else {
        _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.frameLoop.start(this);
      }
    }
  }

  _attach() {
    let priority = 1;
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.toArray)(this.source), source => {
      if ((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.hasFluidValue)(source)) {
        (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.addFluidObserver)(source, this);
      }

      if (isFrameValue(source)) {
        if (!source.idle) {
          this._active.add(source);
        }

        priority = Math.max(priority, source.priority + 1);
      }
    });
    this.priority = priority;

    this._start();
  }

  _detach() {
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.toArray)(this.source), source => {
      if ((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.hasFluidValue)(source)) {
        (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.removeFluidObserver)(source, this);
      }
    });

    this._active.clear();

    becomeIdle(this);
  }

  eventObserved(event) {
    if (event.type == 'change') {
      if (event.idle) {
        this.advance();
      } else {
        this._active.add(event.parent);

        this._start();
      }
    } else if (event.type == 'idle') {
      this._active.delete(event.parent);
    } else if (event.type == 'priority') {
      this.priority = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.toArray)(this.source).reduce((highest, parent) => Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
  }

}

function isIdle(source) {
  return source.idle !== false;
}

function checkIdle(active) {
  return !active.size || Array.from(active).every(isIdle);
}

function becomeIdle(self) {
  if (!self.idle) {
    self.idle = true;
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)((0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__.getPayload)(self), node => {
      node.done = true;
    });
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.callFluidObservers)(self, {
      type: 'idle',
      parent: self
    });
  }
}

const to = (source, ...args) => new Interpolation(source, args);
const interpolate = (source, ...args) => ((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.deprecateInterpolate)(), new Interpolation(source, args));

_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.Globals.assign({
  createStringInterpolator: _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.createStringInterpolator,
  to: (source, args) => new Interpolation(source, args)
});
const update = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.frameLoop.advance;




/***/ }),
/* 110 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FluidValue": () => (/* binding */ FluidValue),
/* harmony export */   "Globals": () => (/* binding */ globals),
/* harmony export */   "addFluidObserver": () => (/* binding */ addFluidObserver),
/* harmony export */   "callFluidObserver": () => (/* binding */ callFluidObserver),
/* harmony export */   "callFluidObservers": () => (/* binding */ callFluidObservers),
/* harmony export */   "colorToRgba": () => (/* binding */ colorToRgba),
/* harmony export */   "colors": () => (/* binding */ colors),
/* harmony export */   "createInterpolator": () => (/* binding */ createInterpolator),
/* harmony export */   "createStringInterpolator": () => (/* binding */ createStringInterpolator),
/* harmony export */   "defineHidden": () => (/* binding */ defineHidden),
/* harmony export */   "deprecateDirectCall": () => (/* binding */ deprecateDirectCall),
/* harmony export */   "deprecateInterpolate": () => (/* binding */ deprecateInterpolate),
/* harmony export */   "each": () => (/* binding */ each),
/* harmony export */   "eachProp": () => (/* binding */ eachProp),
/* harmony export */   "flush": () => (/* binding */ flush),
/* harmony export */   "flushCalls": () => (/* binding */ flushCalls),
/* harmony export */   "frameLoop": () => (/* binding */ frameLoop),
/* harmony export */   "getFluidObservers": () => (/* binding */ getFluidObservers),
/* harmony export */   "getFluidValue": () => (/* binding */ getFluidValue),
/* harmony export */   "hasFluidValue": () => (/* binding */ hasFluidValue),
/* harmony export */   "hex3": () => (/* binding */ hex3),
/* harmony export */   "hex4": () => (/* binding */ hex4),
/* harmony export */   "hex6": () => (/* binding */ hex6),
/* harmony export */   "hex8": () => (/* binding */ hex8),
/* harmony export */   "hsl": () => (/* binding */ hsl),
/* harmony export */   "hsla": () => (/* binding */ hsla),
/* harmony export */   "is": () => (/* binding */ is),
/* harmony export */   "isAnimatedString": () => (/* binding */ isAnimatedString),
/* harmony export */   "isEqual": () => (/* binding */ isEqual),
/* harmony export */   "isSSR": () => (/* binding */ isSSR),
/* harmony export */   "noop": () => (/* binding */ noop),
/* harmony export */   "raf": () => (/* reexport safe */ _react_spring_rafz__WEBPACK_IMPORTED_MODULE_0__.raf),
/* harmony export */   "removeFluidObserver": () => (/* binding */ removeFluidObserver),
/* harmony export */   "rgb": () => (/* binding */ rgb),
/* harmony export */   "rgba": () => (/* binding */ rgba),
/* harmony export */   "setFluidGetter": () => (/* binding */ setFluidGetter),
/* harmony export */   "toArray": () => (/* binding */ toArray),
/* harmony export */   "useForceUpdate": () => (/* binding */ useForceUpdate),
/* harmony export */   "useIsomorphicLayoutEffect": () => (/* binding */ useIsomorphicLayoutEffect),
/* harmony export */   "useMemoOne": () => (/* binding */ useMemoOne),
/* harmony export */   "useOnce": () => (/* binding */ useOnce),
/* harmony export */   "usePrev": () => (/* binding */ usePrev),
/* harmony export */   "useReducedMotion": () => (/* binding */ useReducedMotion)
/* harmony export */ });
/* harmony import */ var _react_spring_rafz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(111);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);




function noop() {}
const defineHidden = (obj, key, value) => Object.defineProperty(obj, key, {
  value,
  writable: true,
  configurable: true
});
const is = {
  arr: Array.isArray,
  obj: a => !!a && a.constructor.name === 'Object',
  fun: a => typeof a === 'function',
  str: a => typeof a === 'string',
  num: a => typeof a === 'number',
  und: a => a === undefined
};
function isEqual(a, b) {
  if (is.arr(a)) {
    if (!is.arr(b) || a.length !== b.length) return false;

    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }

    return true;
  }

  return a === b;
}
const each = (obj, fn) => obj.forEach(fn);
function eachProp(obj, fn, ctx) {
  if (is.arr(obj)) {
    for (let i = 0; i < obj.length; i++) {
      fn.call(ctx, obj[i], `${i}`);
    }

    return;
  }

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      fn.call(ctx, obj[key], key);
    }
  }
}
const toArray = a => is.und(a) ? [] : is.arr(a) ? a : [a];
function flush(queue, iterator) {
  if (queue.size) {
    const items = Array.from(queue);
    queue.clear();
    each(items, iterator);
  }
}
const flushCalls = (queue, ...args) => flush(queue, fn => fn(...args));
const isSSR = () => typeof window === 'undefined' || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);

let createStringInterpolator$1;
let to;
let colors$1 = null;
let skipAnimation = false;
let willAdvance = noop;
const assign = globals => {
  if (globals.to) to = globals.to;
  if (globals.now) _react_spring_rafz__WEBPACK_IMPORTED_MODULE_0__.raf.now = globals.now;
  if (globals.colors !== undefined) colors$1 = globals.colors;
  if (globals.skipAnimation != null) skipAnimation = globals.skipAnimation;
  if (globals.createStringInterpolator) createStringInterpolator$1 = globals.createStringInterpolator;
  if (globals.requestAnimationFrame) _react_spring_rafz__WEBPACK_IMPORTED_MODULE_0__.raf.use(globals.requestAnimationFrame);
  if (globals.batchedUpdates) _react_spring_rafz__WEBPACK_IMPORTED_MODULE_0__.raf.batchedUpdates = globals.batchedUpdates;
  if (globals.willAdvance) willAdvance = globals.willAdvance;
  if (globals.frameLoop) _react_spring_rafz__WEBPACK_IMPORTED_MODULE_0__.raf.frameLoop = globals.frameLoop;
};

var globals = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get createStringInterpolator () { return createStringInterpolator$1; },
  get to () { return to; },
  get colors () { return colors$1; },
  get skipAnimation () { return skipAnimation; },
  get willAdvance () { return willAdvance; },
  assign: assign
});

const startQueue = new Set();
let currentFrame = [];
let prevFrame = [];
let priority = 0;
const frameLoop = {
  get idle() {
    return !startQueue.size && !currentFrame.length;
  },

  start(animation) {
    if (priority > animation.priority) {
      startQueue.add(animation);
      _react_spring_rafz__WEBPACK_IMPORTED_MODULE_0__.raf.onStart(flushStartQueue);
    } else {
      startSafely(animation);
      (0,_react_spring_rafz__WEBPACK_IMPORTED_MODULE_0__.raf)(advance);
    }
  },

  advance,

  sort(animation) {
    if (priority) {
      _react_spring_rafz__WEBPACK_IMPORTED_MODULE_0__.raf.onFrame(() => frameLoop.sort(animation));
    } else {
      const prevIndex = currentFrame.indexOf(animation);

      if (~prevIndex) {
        currentFrame.splice(prevIndex, 1);
        startUnsafely(animation);
      }
    }
  },

  clear() {
    currentFrame = [];
    startQueue.clear();
  }

};

function flushStartQueue() {
  startQueue.forEach(startSafely);
  startQueue.clear();
  (0,_react_spring_rafz__WEBPACK_IMPORTED_MODULE_0__.raf)(advance);
}

function startSafely(animation) {
  if (!currentFrame.includes(animation)) startUnsafely(animation);
}

function startUnsafely(animation) {
  currentFrame.splice(findIndex(currentFrame, other => other.priority > animation.priority), 0, animation);
}

function advance(dt) {
  const nextFrame = prevFrame;

  for (let i = 0; i < currentFrame.length; i++) {
    const animation = currentFrame[i];
    priority = animation.priority;

    if (!animation.idle) {
      willAdvance(animation);
      animation.advance(dt);

      if (!animation.idle) {
        nextFrame.push(animation);
      }
    }
  }

  priority = 0;
  prevFrame = currentFrame;
  prevFrame.length = 0;
  currentFrame = nextFrame;
  return currentFrame.length > 0;
}

function findIndex(arr, test) {
  const index = arr.findIndex(test);
  return index < 0 ? arr.length : index;
}

const colors = {
  transparent: 0x00000000,
  aliceblue: 0xf0f8ffff,
  antiquewhite: 0xfaebd7ff,
  aqua: 0x00ffffff,
  aquamarine: 0x7fffd4ff,
  azure: 0xf0ffffff,
  beige: 0xf5f5dcff,
  bisque: 0xffe4c4ff,
  black: 0x000000ff,
  blanchedalmond: 0xffebcdff,
  blue: 0x0000ffff,
  blueviolet: 0x8a2be2ff,
  brown: 0xa52a2aff,
  burlywood: 0xdeb887ff,
  burntsienna: 0xea7e5dff,
  cadetblue: 0x5f9ea0ff,
  chartreuse: 0x7fff00ff,
  chocolate: 0xd2691eff,
  coral: 0xff7f50ff,
  cornflowerblue: 0x6495edff,
  cornsilk: 0xfff8dcff,
  crimson: 0xdc143cff,
  cyan: 0x00ffffff,
  darkblue: 0x00008bff,
  darkcyan: 0x008b8bff,
  darkgoldenrod: 0xb8860bff,
  darkgray: 0xa9a9a9ff,
  darkgreen: 0x006400ff,
  darkgrey: 0xa9a9a9ff,
  darkkhaki: 0xbdb76bff,
  darkmagenta: 0x8b008bff,
  darkolivegreen: 0x556b2fff,
  darkorange: 0xff8c00ff,
  darkorchid: 0x9932ccff,
  darkred: 0x8b0000ff,
  darksalmon: 0xe9967aff,
  darkseagreen: 0x8fbc8fff,
  darkslateblue: 0x483d8bff,
  darkslategray: 0x2f4f4fff,
  darkslategrey: 0x2f4f4fff,
  darkturquoise: 0x00ced1ff,
  darkviolet: 0x9400d3ff,
  deeppink: 0xff1493ff,
  deepskyblue: 0x00bfffff,
  dimgray: 0x696969ff,
  dimgrey: 0x696969ff,
  dodgerblue: 0x1e90ffff,
  firebrick: 0xb22222ff,
  floralwhite: 0xfffaf0ff,
  forestgreen: 0x228b22ff,
  fuchsia: 0xff00ffff,
  gainsboro: 0xdcdcdcff,
  ghostwhite: 0xf8f8ffff,
  gold: 0xffd700ff,
  goldenrod: 0xdaa520ff,
  gray: 0x808080ff,
  green: 0x008000ff,
  greenyellow: 0xadff2fff,
  grey: 0x808080ff,
  honeydew: 0xf0fff0ff,
  hotpink: 0xff69b4ff,
  indianred: 0xcd5c5cff,
  indigo: 0x4b0082ff,
  ivory: 0xfffff0ff,
  khaki: 0xf0e68cff,
  lavender: 0xe6e6faff,
  lavenderblush: 0xfff0f5ff,
  lawngreen: 0x7cfc00ff,
  lemonchiffon: 0xfffacdff,
  lightblue: 0xadd8e6ff,
  lightcoral: 0xf08080ff,
  lightcyan: 0xe0ffffff,
  lightgoldenrodyellow: 0xfafad2ff,
  lightgray: 0xd3d3d3ff,
  lightgreen: 0x90ee90ff,
  lightgrey: 0xd3d3d3ff,
  lightpink: 0xffb6c1ff,
  lightsalmon: 0xffa07aff,
  lightseagreen: 0x20b2aaff,
  lightskyblue: 0x87cefaff,
  lightslategray: 0x778899ff,
  lightslategrey: 0x778899ff,
  lightsteelblue: 0xb0c4deff,
  lightyellow: 0xffffe0ff,
  lime: 0x00ff00ff,
  limegreen: 0x32cd32ff,
  linen: 0xfaf0e6ff,
  magenta: 0xff00ffff,
  maroon: 0x800000ff,
  mediumaquamarine: 0x66cdaaff,
  mediumblue: 0x0000cdff,
  mediumorchid: 0xba55d3ff,
  mediumpurple: 0x9370dbff,
  mediumseagreen: 0x3cb371ff,
  mediumslateblue: 0x7b68eeff,
  mediumspringgreen: 0x00fa9aff,
  mediumturquoise: 0x48d1ccff,
  mediumvioletred: 0xc71585ff,
  midnightblue: 0x191970ff,
  mintcream: 0xf5fffaff,
  mistyrose: 0xffe4e1ff,
  moccasin: 0xffe4b5ff,
  navajowhite: 0xffdeadff,
  navy: 0x000080ff,
  oldlace: 0xfdf5e6ff,
  olive: 0x808000ff,
  olivedrab: 0x6b8e23ff,
  orange: 0xffa500ff,
  orangered: 0xff4500ff,
  orchid: 0xda70d6ff,
  palegoldenrod: 0xeee8aaff,
  palegreen: 0x98fb98ff,
  paleturquoise: 0xafeeeeff,
  palevioletred: 0xdb7093ff,
  papayawhip: 0xffefd5ff,
  peachpuff: 0xffdab9ff,
  peru: 0xcd853fff,
  pink: 0xffc0cbff,
  plum: 0xdda0ddff,
  powderblue: 0xb0e0e6ff,
  purple: 0x800080ff,
  rebeccapurple: 0x663399ff,
  red: 0xff0000ff,
  rosybrown: 0xbc8f8fff,
  royalblue: 0x4169e1ff,
  saddlebrown: 0x8b4513ff,
  salmon: 0xfa8072ff,
  sandybrown: 0xf4a460ff,
  seagreen: 0x2e8b57ff,
  seashell: 0xfff5eeff,
  sienna: 0xa0522dff,
  silver: 0xc0c0c0ff,
  skyblue: 0x87ceebff,
  slateblue: 0x6a5acdff,
  slategray: 0x708090ff,
  slategrey: 0x708090ff,
  snow: 0xfffafaff,
  springgreen: 0x00ff7fff,
  steelblue: 0x4682b4ff,
  tan: 0xd2b48cff,
  teal: 0x008080ff,
  thistle: 0xd8bfd8ff,
  tomato: 0xff6347ff,
  turquoise: 0x40e0d0ff,
  violet: 0xee82eeff,
  wheat: 0xf5deb3ff,
  white: 0xffffffff,
  whitesmoke: 0xf5f5f5ff,
  yellow: 0xffff00ff,
  yellowgreen: 0x9acd32ff
};

const NUMBER = '[-+]?\\d*\\.?\\d+';
const PERCENTAGE = NUMBER + '%';

function call(...parts) {
  return '\\(\\s*(' + parts.join(')\\s*,\\s*(') + ')\\s*\\)';
}

const rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
const rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
const hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
const hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
const hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex6 = /^#([0-9a-fA-F]{6})$/;
const hex8 = /^#([0-9a-fA-F]{8})$/;

function normalizeColor(color) {
  let match;

  if (typeof color === 'number') {
    return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
  }

  if (match = hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;

  if (colors$1 && colors$1[color] !== undefined) {
    return colors$1[color];
  }

  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | 0x000000ff) >>> 0;
  }

  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | parse1(match[4])) >>> 0;
  }

  if (match = hex3.exec(color)) {
    return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + 'ff', 16) >>> 0;
  }

  if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;

  if (match = hex4.exec(color)) {
    return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
  }

  if (match = hsl.exec(color)) {
    return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | 0x000000ff) >>> 0;
  }

  if (match = hsla.exec(color)) {
    return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | parse1(match[4])) >>> 0;
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}

function hslToRgb(h, s, l) {
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}

function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0) return 0;
  if (int > 255) return 255;
  return int;
}

function parse360(str) {
  const int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}

function parse1(str) {
  const num = parseFloat(str);
  if (num < 0) return 0;
  if (num > 1) return 255;
  return Math.round(num * 255);
}

function parsePercentage(str) {
  const int = parseFloat(str);
  if (int < 0) return 0;
  if (int > 100) return 1;
  return int / 100;
}

function colorToRgba(input) {
  let int32Color = normalizeColor(input);
  if (int32Color === null) return input;
  int32Color = int32Color || 0;
  let r = (int32Color & 0xff000000) >>> 24;
  let g = (int32Color & 0x00ff0000) >>> 16;
  let b = (int32Color & 0x0000ff00) >>> 8;
  let a = (int32Color & 0x000000ff) / 255;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

const createInterpolator = (range, output, extrapolate) => {
  if (is.fun(range)) {
    return range;
  }

  if (is.arr(range)) {
    return createInterpolator({
      range,
      output: output,
      extrapolate
    });
  }

  if (is.str(range.output[0])) {
    return createStringInterpolator$1(range);
  }

  const config = range;
  const outputRange = config.output;
  const inputRange = config.range || [0, 1];
  const extrapolateLeft = config.extrapolateLeft || config.extrapolate || 'extend';
  const extrapolateRight = config.extrapolateRight || config.extrapolate || 'extend';

  const easing = config.easing || (t => t);

  return input => {
    const range = findRange(input, inputRange);
    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
  };
};

function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  let result = map ? map(input) : input;

  if (result < inputMin) {
    if (extrapolateLeft === 'identity') return result;else if (extrapolateLeft === 'clamp') result = inputMin;
  }

  if (result > inputMax) {
    if (extrapolateRight === 'identity') return result;else if (extrapolateRight === 'clamp') result = inputMax;
  }

  if (outputMin === outputMax) return outputMin;
  if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
  if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin);
  result = easing(result);
  if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
  return result;
}

function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i) if (inputRange[i] >= input) break;

  return i - 1;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

const $get = Symbol.for('FluidValue.get');
const $observers = Symbol.for('FluidValue.observers');

const hasFluidValue = arg => Boolean(arg && arg[$get]);

const getFluidValue = arg => arg && arg[$get] ? arg[$get]() : arg;

const getFluidObservers = target => target[$observers] || null;

function callFluidObserver(observer, event) {
  if (observer.eventObserved) {
    observer.eventObserved(event);
  } else {
    observer(event);
  }
}

function callFluidObservers(target, event) {
  let observers = target[$observers];

  if (observers) {
    observers.forEach(observer => {
      callFluidObserver(observer, event);
    });
  }
}

class FluidValue {
  constructor(get) {
    this[$get] = void 0;
    this[$observers] = void 0;

    if (!get && !(get = this.get)) {
      throw Error('Unknown getter');
    }

    setFluidGetter(this, get);
  }

}

const setFluidGetter = (target, get) => setHidden(target, $get, get);

function addFluidObserver(target, observer) {
  if (target[$get]) {
    let observers = target[$observers];

    if (!observers) {
      setHidden(target, $observers, observers = new Set());
    }

    if (!observers.has(observer)) {
      observers.add(observer);

      if (target.observerAdded) {
        target.observerAdded(observers.size, observer);
      }
    }
  }

  return observer;
}

function removeFluidObserver(target, observer) {
  let observers = target[$observers];

  if (observers && observers.has(observer)) {
    const count = observers.size - 1;

    if (count) {
      observers.delete(observer);
    } else {
      target[$observers] = null;
    }

    if (target.observerRemoved) {
      target.observerRemoved(count, observer);
    }
  }
}

const setHidden = (target, key, value) => Object.defineProperty(target, key, {
  value,
  writable: true,
  configurable: true
});

const numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
const colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
const unitRegex = new RegExp(`(${numberRegex.source})(%|[a-z]+)`, 'i');
const rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
const cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;

const variableToRgba = input => {
  const [token, fallback] = parseCSSVariable(input);

  if (!token || isSSR()) {
    return input;
  }

  const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);

  if (value) {
    return value.trim();
  } else if (fallback && fallback.startsWith('--')) {
    const _value = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);

    if (_value) {
      return _value;
    } else {
      return input;
    }
  } else if (fallback && cssVariableRegex.test(fallback)) {
    return variableToRgba(fallback);
  } else if (fallback) {
    return fallback;
  }

  return input;
};

const parseCSSVariable = current => {
  const match = cssVariableRegex.exec(current);
  if (!match) return [,];
  const [, token, fallback] = match;
  return [token, fallback];
};

let namedColorRegex;

const rgbaRound = (_, p1, p2, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;

const createStringInterpolator = config => {
  if (!namedColorRegex) namedColorRegex = colors$1 ? new RegExp(`(${Object.keys(colors$1).join('|')})(?!\\w)`, 'g') : /^\b$/;
  const output = config.output.map(value => {
    return getFluidValue(value).replace(cssVariableRegex, variableToRgba).replace(colorRegex, colorToRgba).replace(namedColorRegex, colorToRgba);
  });
  const keyframes = output.map(value => value.match(numberRegex).map(Number));
  const outputRanges = keyframes[0].map((_, i) => keyframes.map(values => {
    if (!(i in values)) {
      throw Error('The arity of each "output" value must be equal');
    }

    return values[i];
  }));
  const interpolators = outputRanges.map(output => createInterpolator(_extends({}, config, {
    output
  })));
  return input => {
    var _output$find;

    const missingUnit = !unitRegex.test(output[0]) && ((_output$find = output.find(value => unitRegex.test(value))) == null ? void 0 : _output$find.replace(numberRegex, ''));
    let i = 0;
    return output[0].replace(numberRegex, () => `${interpolators[i++](input)}${missingUnit || ''}`).replace(rgbaRegex, rgbaRound);
  };
};

const prefix = 'react-spring: ';

const once = fn => {
  const func = fn;
  let called = false;

  if (typeof func != 'function') {
    throw new TypeError(`${prefix}once requires a function parameter`);
  }

  return (...args) => {
    if (!called) {
      func(...args);
      called = true;
    }
  };
};

const warnInterpolate = once(console.warn);
function deprecateInterpolate() {
  warnInterpolate(`${prefix}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
const warnDirectCall = once(console.warn);
function deprecateDirectCall() {
  warnDirectCall(`${prefix}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}

function isAnimatedString(value) {
  return is.str(value) && (value[0] == '#' || /\d/.test(value) || !isSSR() && cssVariableRegex.test(value) || value in (colors$1 || {}));
}

const useIsomorphicLayoutEffect = isSSR() ? react__WEBPACK_IMPORTED_MODULE_1__.useEffect : react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect;

const useIsMounted = () => {
  const isMounted = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
  useIsomorphicLayoutEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
};

function useForceUpdate() {
  const update = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)()[1];
  const isMounted = useIsMounted();
  return () => {
    if (isMounted.current) {
      update(Math.random());
    }
  };
}

function useMemoOne(getResult, inputs) {
  const [initial] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(() => ({
    inputs,
    result: getResult()
  }));
  const committed = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  const prevCache = committed.current;
  let cache = prevCache;

  if (cache) {
    const useCache = Boolean(inputs && cache.inputs && areInputsEqual(inputs, cache.inputs));

    if (!useCache) {
      cache = {
        inputs,
        result: getResult()
      };
    }
  } else {
    cache = initial;
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    committed.current = cache;

    if (prevCache == initial) {
      initial.inputs = initial.result = undefined;
    }
  }, [cache]);
  return cache.result;
}

function areInputsEqual(next, prev) {
  if (next.length !== prev.length) {
    return false;
  }

  for (let i = 0; i < next.length; i++) {
    if (next[i] !== prev[i]) {
      return false;
    }
  }

  return true;
}

const useOnce = effect => (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(effect, emptyDeps);
const emptyDeps = [];

function usePrev(value) {
  const prevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    prevRef.current = value;
  });
  return prevRef.current;
}

const useReducedMotion = () => {
  const [reducedMotion, setReducedMotion] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
  useIsomorphicLayoutEffect(() => {
    const mql = window.matchMedia('(prefers-reduced-motion)');

    const handleMediaChange = e => {
      setReducedMotion(e.matches);
      assign({
        skipAnimation: e.matches
      });
    };

    handleMediaChange(mql);
    mql.addEventListener('change', handleMediaChange);
    return () => {
      mql.removeEventListener('change', handleMediaChange);
    };
  }, []);
  return reducedMotion;
};




/***/ }),
/* 111 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__raf": () => (/* binding */ __raf),
/* harmony export */   "raf": () => (/* binding */ raf)
/* harmony export */ });
let updateQueue = makeQueue();
const raf = fn => schedule(fn, updateQueue);
let writeQueue = makeQueue();

raf.write = fn => schedule(fn, writeQueue);

let onStartQueue = makeQueue();

raf.onStart = fn => schedule(fn, onStartQueue);

let onFrameQueue = makeQueue();

raf.onFrame = fn => schedule(fn, onFrameQueue);

let onFinishQueue = makeQueue();

raf.onFinish = fn => schedule(fn, onFinishQueue);

let timeouts = [];

raf.setTimeout = (handler, ms) => {
  let time = raf.now() + ms;

  let cancel = () => {
    let i = timeouts.findIndex(t => t.cancel == cancel);
    if (~i) timeouts.splice(i, 1);
    pendingCount -= ~i ? 1 : 0;
  };

  let timeout = {
    time,
    handler,
    cancel
  };
  timeouts.splice(findTimeout(time), 0, timeout);
  pendingCount += 1;
  start();
  return timeout;
};

let findTimeout = time => ~(~timeouts.findIndex(t => t.time > time) || ~timeouts.length);

raf.cancel = fn => {
  onStartQueue.delete(fn);
  onFrameQueue.delete(fn);
  onFinishQueue.delete(fn);
  updateQueue.delete(fn);
  writeQueue.delete(fn);
};

raf.sync = fn => {
  sync = true;
  raf.batchedUpdates(fn);
  sync = false;
};

raf.throttle = fn => {
  let lastArgs;

  function queuedFn() {
    try {
      fn(...lastArgs);
    } finally {
      lastArgs = null;
    }
  }

  function throttled(...args) {
    lastArgs = args;
    raf.onStart(queuedFn);
  }

  throttled.handler = fn;

  throttled.cancel = () => {
    onStartQueue.delete(queuedFn);
    lastArgs = null;
  };

  return throttled;
};

let nativeRaf = typeof window != 'undefined' ? window.requestAnimationFrame : () => {};

raf.use = impl => nativeRaf = impl;

raf.now = typeof performance != 'undefined' ? () => performance.now() : Date.now;

raf.batchedUpdates = fn => fn();

raf.catch = console.error;
raf.frameLoop = 'always';

raf.advance = () => {
  if (raf.frameLoop !== 'demand') {
    console.warn('Cannot call the manual advancement of rafz whilst frameLoop is not set as demand');
  } else {
    update();
  }
};

let ts = -1;
let pendingCount = 0;
let sync = false;

function schedule(fn, queue) {
  if (sync) {
    queue.delete(fn);
    fn(0);
  } else {
    queue.add(fn);
    start();
  }
}

function start() {
  if (ts < 0) {
    ts = 0;

    if (raf.frameLoop !== 'demand') {
      nativeRaf(loop);
    }
  }
}

function stop() {
  ts = -1;
}

function loop() {
  if (~ts) {
    nativeRaf(loop);
    raf.batchedUpdates(update);
  }
}

function update() {
  let prevTs = ts;
  ts = raf.now();
  let count = findTimeout(ts);

  if (count) {
    eachSafely(timeouts.splice(0, count), t => t.handler());
    pendingCount -= count;
  }

  if (!pendingCount) {
    stop();
    return;
  }

  onStartQueue.flush();
  updateQueue.flush(prevTs ? Math.min(64, ts - prevTs) : 16.667);
  onFrameQueue.flush();
  writeQueue.flush();
  onFinishQueue.flush();
}

function makeQueue() {
  let next = new Set();
  let current = next;
  return {
    add(fn) {
      pendingCount += current == next && !next.has(fn) ? 1 : 0;
      next.add(fn);
    },

    delete(fn) {
      pendingCount -= current == next && next.has(fn) ? 1 : 0;
      return next.delete(fn);
    },

    flush(arg) {
      if (current.size) {
        next = new Set();
        pendingCount -= current.size;
        eachSafely(current, fn => fn(arg) && next.add(fn));
        pendingCount += next.size;
        current = next;
      }
    }

  };
}

function eachSafely(values, each) {
  values.forEach(value => {
    try {
      each(value);
    } catch (e) {
      raf.catch(e);
    }
  });
}

const __raf = {
  count() {
    return pendingCount;
  },

  isRunning() {
    return ts >= 0;
  },

  clear() {
    ts = -1;
    timeouts = [];
    onStartQueue = makeQueue();
    updateQueue = makeQueue();
    onFrameQueue = makeQueue();
    writeQueue = makeQueue();
    onFinishQueue = makeQueue();
    pendingCount = 0;
  }

};




/***/ }),
/* 112 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Animated": () => (/* binding */ Animated),
/* harmony export */   "AnimatedArray": () => (/* binding */ AnimatedArray),
/* harmony export */   "AnimatedObject": () => (/* binding */ AnimatedObject),
/* harmony export */   "AnimatedString": () => (/* binding */ AnimatedString),
/* harmony export */   "AnimatedValue": () => (/* binding */ AnimatedValue),
/* harmony export */   "createHost": () => (/* binding */ createHost),
/* harmony export */   "getAnimated": () => (/* binding */ getAnimated),
/* harmony export */   "getAnimatedType": () => (/* binding */ getAnimatedType),
/* harmony export */   "getPayload": () => (/* binding */ getPayload),
/* harmony export */   "isAnimated": () => (/* binding */ isAnimated),
/* harmony export */   "setAnimated": () => (/* binding */ setAnimated)
/* harmony export */ });
/* harmony import */ var _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(110);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);




const $node = Symbol.for('Animated:node');
const isAnimated = value => !!value && value[$node] === value;
const getAnimated = owner => owner && owner[$node];
const setAnimated = (owner, node) => (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.defineHidden)(owner, $node, node);
const getPayload = owner => owner && owner[$node] && owner[$node].getPayload();
class Animated {
  constructor() {
    this.payload = void 0;
    setAnimated(this, this);
  }

  getPayload() {
    return this.payload || [];
  }

}

class AnimatedValue extends Animated {
  constructor(_value) {
    super();
    this.done = true;
    this.elapsedTime = void 0;
    this.lastPosition = void 0;
    this.lastVelocity = void 0;
    this.v0 = void 0;
    this.durationProgress = 0;
    this._value = _value;

    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.num(this._value)) {
      this.lastPosition = this._value;
    }
  }

  static create(value) {
    return new AnimatedValue(value);
  }

  getPayload() {
    return [this];
  }

  getValue() {
    return this._value;
  }

  setValue(value, step) {
    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.num(value)) {
      this.lastPosition = value;

      if (step) {
        value = Math.round(value / step) * step;

        if (this.done) {
          this.lastPosition = value;
        }
      }
    }

    if (this._value === value) {
      return false;
    }

    this._value = value;
    return true;
  }

  reset() {
    const {
      done
    } = this;
    this.done = false;

    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.num(this._value)) {
      this.elapsedTime = 0;
      this.durationProgress = 0;
      this.lastPosition = this._value;
      if (done) this.lastVelocity = null;
      this.v0 = null;
    }
  }

}

class AnimatedString extends AnimatedValue {
  constructor(value) {
    super(0);
    this._string = null;
    this._toString = void 0;
    this._toString = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.createInterpolator)({
      output: [value, value]
    });
  }

  static create(value) {
    return new AnimatedString(value);
  }

  getValue() {
    let value = this._string;
    return value == null ? this._string = this._toString(this._value) : value;
  }

  setValue(value) {
    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.str(value)) {
      if (value == this._string) {
        return false;
      }

      this._string = value;
      this._value = 1;
    } else if (super.setValue(value)) {
      this._string = null;
    } else {
      return false;
    }

    return true;
  }

  reset(goal) {
    if (goal) {
      this._toString = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.createInterpolator)({
        output: [this.getValue(), goal]
      });
    }

    this._value = 0;
    super.reset();
  }

}

const TreeContext = {
  dependencies: null
};

class AnimatedObject extends Animated {
  constructor(source) {
    super();
    this.source = source;
    this.setValue(source);
  }

  getValue(animated) {
    const values = {};
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.eachProp)(this.source, (source, key) => {
      if (isAnimated(source)) {
        values[key] = source.getValue(animated);
      } else if ((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.hasFluidValue)(source)) {
        values[key] = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.getFluidValue)(source);
      } else if (!animated) {
        values[key] = source;
      }
    });
    return values;
  }

  setValue(source) {
    this.source = source;
    this.payload = this._makePayload(source);
  }

  reset() {
    if (this.payload) {
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(this.payload, node => node.reset());
    }
  }

  _makePayload(source) {
    if (source) {
      const payload = new Set();
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.eachProp)(source, this._addToPayload, payload);
      return Array.from(payload);
    }
  }

  _addToPayload(source) {
    if (TreeContext.dependencies && (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.hasFluidValue)(source)) {
      TreeContext.dependencies.add(source);
    }

    const payload = getPayload(source);

    if (payload) {
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(payload, node => this.add(node));
    }
  }

}

class AnimatedArray extends AnimatedObject {
  constructor(source) {
    super(source);
  }

  static create(source) {
    return new AnimatedArray(source);
  }

  getValue() {
    return this.source.map(node => node.getValue());
  }

  setValue(source) {
    const payload = this.getPayload();

    if (source.length == payload.length) {
      return payload.map((node, i) => node.setValue(source[i])).some(Boolean);
    }

    super.setValue(source.map(makeAnimated));
    return true;
  }

}

function makeAnimated(value) {
  const nodeType = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.isAnimatedString)(value) ? AnimatedString : AnimatedValue;
  return nodeType.create(value);
}

function getAnimatedType(value) {
  const parentNode = getAnimated(value);
  return parentNode ? parentNode.constructor : _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.arr(value) ? AnimatedArray : (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.isAnimatedString)(value) ? AnimatedString : AnimatedValue;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

const withAnimated = (Component, host) => {
  const hasInstance = !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(Component) || Component.prototype && Component.prototype.isReactComponent;
  return (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((givenProps, givenRef) => {
    const instanceRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const ref = hasInstance && (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(value => {
      instanceRef.current = updateRef(givenRef, value);
    }, [givenRef]);
    const [props, deps] = getAnimatedState(givenProps, host);
    const forceUpdate = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useForceUpdate)();

    const callback = () => {
      const instance = instanceRef.current;

      if (hasInstance && !instance) {
        return;
      }

      const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;

      if (didUpdate === false) {
        forceUpdate();
      }
    };

    const observer = new PropsObserver(callback, deps);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useIsomorphicLayoutEffect)(() => {
      observerRef.current = observer;
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(deps, dep => (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.addFluidObserver)(dep, observer));
      return () => {
        if (observerRef.current) {
          (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(observerRef.current.deps, dep => (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.removeFluidObserver)(dep, observerRef.current));
          _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.raf.cancel(observerRef.current.update);
        }
      };
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(callback, []);
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.useOnce)(() => () => {
      const observer = observerRef.current;
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.each)(observer.deps, dep => (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.removeFluidObserver)(dep, observer));
    });
    const usedProps = host.getComponentProps(props.getValue());
    return react__WEBPACK_IMPORTED_MODULE_1__.createElement(Component, _extends({}, usedProps, {
      ref: ref
    }));
  });
};

class PropsObserver {
  constructor(update, deps) {
    this.update = update;
    this.deps = deps;
  }

  eventObserved(event) {
    if (event.type == 'change') {
      _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.raf.write(this.update);
    }
  }

}

function getAnimatedState(props, host) {
  const dependencies = new Set();
  TreeContext.dependencies = dependencies;
  if (props.style) props = _extends({}, props, {
    style: host.createAnimatedStyle(props.style)
  });
  props = new AnimatedObject(props);
  TreeContext.dependencies = null;
  return [props, dependencies];
}

function updateRef(ref, value) {
  if (ref) {
    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(ref)) ref(value);else ref.current = value;
  }

  return value;
}

const cacheKey = Symbol.for('AnimatedComponent');
const createHost = (components, {
  applyAnimatedValues: _applyAnimatedValues = () => false,
  createAnimatedStyle: _createAnimatedStyle = style => new AnimatedObject(style),
  getComponentProps: _getComponentProps = props => props
} = {}) => {
  const hostConfig = {
    applyAnimatedValues: _applyAnimatedValues,
    createAnimatedStyle: _createAnimatedStyle,
    getComponentProps: _getComponentProps
  };

  const animated = Component => {
    const displayName = getDisplayName(Component) || 'Anonymous';

    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.str(Component)) {
      Component = animated[Component] || (animated[Component] = withAnimated(Component, hostConfig));
    } else {
      Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
    }

    Component.displayName = `Animated(${displayName})`;
    return Component;
  };

  (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.eachProp)(components, (Component, key) => {
    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.arr(components)) {
      key = getDisplayName(Component);
    }

    animated[key] = animated(Component);
  });
  return {
    animated
  };
};

const getDisplayName = arg => _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.str(arg) ? arg : arg && _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.str(arg.displayName) ? arg.displayName : _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__.is.fun(arg) && arg.name || null;




/***/ }),
/* 113 */
/***/ (() => {



/***/ }),
/* 114 */
/***/ (() => {



/***/ }),
/* 115 */
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__115__;

/***/ }),
/* 116 */
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),
/* 117 */
/***/ ((module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function stringifiable(obj) {
    // Safely stringify Object.create(null)
    /* istanbul ignore next */
    return typeof obj === 'object' && !('toString' in obj) ?
        Object.prototype.toString.call(obj).slice(8, -1) :
        obj;
}
var isProduction = typeof process === 'object' && process.env.NODE_ENV === 'production';
function invariant(condition, message) {
    if (!condition) {
        /* istanbul ignore next */
        if (isProduction) {
            throw new Error('Invariant failed');
        }
        throw new Error(message());
    }
}
exports.invariant = invariant;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;
var toString = Object.prototype.toString;
function type(obj) {
    return toString.call(obj).slice(8, -1);
}
var assign = Object.assign || /* istanbul ignore next */ (function (target, source) {
    getAllKeys(source).forEach(function (key) {
        if (hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    });
    return target;
});
var getAllKeys = typeof Object.getOwnPropertySymbols === 'function'
    ? function (obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)); }
    /* istanbul ignore next */
    : function (obj) { return Object.keys(obj); };
function copy(object) {
    return Array.isArray(object)
        ? assign(object.constructor(object.length), object)
        : (type(object) === 'Map')
            ? new Map(object)
            : (type(object) === 'Set')
                ? new Set(object)
                : (object && typeof object === 'object')
                    ? assign(Object.create(Object.getPrototypeOf(object)), object)
                    /* istanbul ignore next */
                    : object;
}
var Context = /** @class */ (function () {
    function Context() {
        this.commands = assign({}, defaultCommands);
        this.update = this.update.bind(this);
        // Deprecated: update.extend, update.isEquals and update.newContext
        this.update.extend = this.extend = this.extend.bind(this);
        this.update.isEquals = function (x, y) { return x === y; };
        this.update.newContext = function () { return new Context().update; };
    }
    Object.defineProperty(Context.prototype, "isEquals", {
        get: function () {
            return this.update.isEquals;
        },
        set: function (value) {
            this.update.isEquals = value;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.extend = function (directive, fn) {
        this.commands[directive] = fn;
    };
    Context.prototype.update = function (object, $spec) {
        var _this = this;
        var spec = (typeof $spec === 'function') ? { $apply: $spec } : $spec;
        if (!(Array.isArray(object) && Array.isArray(spec))) {
            invariant(!Array.isArray(spec), function () { return "update(): You provided an invalid spec to update(). The spec may " +
                "not contain an array except as the value of $set, $push, $unshift, " +
                "$splice or any custom command allowing an array value."; });
        }
        invariant(typeof spec === 'object' && spec !== null, function () { return "update(): You provided an invalid spec to update(). The spec and " +
            "every included key path must be plain objects containing one of the " +
            ("following commands: " + Object.keys(_this.commands).join(', ') + "."); });
        var nextObject = object;
        getAllKeys(spec).forEach(function (key) {
            if (hasOwnProperty.call(_this.commands, key)) {
                var objectWasNextObject = object === nextObject;
                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
                if (objectWasNextObject && _this.isEquals(nextObject, object)) {
                    nextObject = object;
                }
            }
            else {
                var nextValueForKey = type(object) === 'Map'
                    ? _this.update(object.get(key), spec[key])
                    : _this.update(object[key], spec[key]);
                var nextObjectValue = type(nextObject) === 'Map'
                    ? nextObject.get(key)
                    : nextObject[key];
                if (!_this.isEquals(nextValueForKey, nextObjectValue)
                    || typeof nextValueForKey === 'undefined'
                        && !hasOwnProperty.call(object, key)) {
                    if (nextObject === object) {
                        nextObject = copy(object);
                    }
                    if (type(nextObject) === 'Map') {
                        nextObject.set(key, nextValueForKey);
                    }
                    else {
                        nextObject[key] = nextValueForKey;
                    }
                }
            }
        });
        return nextObject;
    };
    return Context;
}());
exports.Context = Context;
var defaultCommands = {
    $push: function (value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$push');
        return value.length ? nextObject.concat(value) : nextObject;
    },
    $unshift: function (value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$unshift');
        return value.length ? value.concat(nextObject) : nextObject;
    },
    $splice: function (value, nextObject, spec, originalObject) {
        invariantSplices(nextObject, spec);
        value.forEach(function (args) {
            invariantSplice(args);
            if (nextObject === originalObject && args.length) {
                nextObject = copy(originalObject);
            }
            splice.apply(nextObject, args);
        });
        return nextObject;
    },
    $set: function (value, _nextObject, spec) {
        invariantSet(spec);
        return value;
    },
    $toggle: function (targets, nextObject) {
        invariantSpecArray(targets, '$toggle');
        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
        targets.forEach(function (target) {
            nextObjectCopy[target] = !nextObject[target];
        });
        return nextObjectCopy;
    },
    $unset: function (value, nextObject, _spec, originalObject) {
        invariantSpecArray(value, '$unset');
        value.forEach(function (key) {
            if (Object.hasOwnProperty.call(nextObject, key)) {
                if (nextObject === originalObject) {
                    nextObject = copy(originalObject);
                }
                delete nextObject[key];
            }
        });
        return nextObject;
    },
    $add: function (values, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$add');
        invariantSpecArray(values, '$add');
        if (type(nextObject) === 'Map') {
            values.forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (nextObject === originalObject && nextObject.get(key) !== value) {
                    nextObject = copy(originalObject);
                }
                nextObject.set(key, value);
            });
        }
        else {
            values.forEach(function (value) {
                if (nextObject === originalObject && !nextObject.has(value)) {
                    nextObject = copy(originalObject);
                }
                nextObject.add(value);
            });
        }
        return nextObject;
    },
    $remove: function (value, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$remove');
        invariantSpecArray(value, '$remove');
        value.forEach(function (key) {
            if (nextObject === originalObject && nextObject.has(key)) {
                nextObject = copy(originalObject);
            }
            nextObject.delete(key);
        });
        return nextObject;
    },
    $merge: function (value, nextObject, _spec, originalObject) {
        invariantMerge(nextObject, value);
        getAllKeys(value).forEach(function (key) {
            if (value[key] !== nextObject[key]) {
                if (nextObject === originalObject) {
                    nextObject = copy(originalObject);
                }
                nextObject[key] = value[key];
            }
        });
        return nextObject;
    },
    $apply: function (value, original) {
        invariantApply(value);
        return value(original);
    },
};
var defaultContext = new Context();
exports.isEquals = defaultContext.update.isEquals;
exports.extend = defaultContext.extend;
exports["default"] = defaultContext.update;
// @ts-ignore
exports["default"]["default"] = module.exports = assign(exports.default, exports);
// invariants
function invariantPushAndUnshift(value, spec, command) {
    invariant(Array.isArray(value), function () { return "update(): expected target of " + stringifiable(command) + " to be an array; got " + stringifiable(value) + "."; });
    invariantSpecArray(spec[command], command);
}
function invariantSpecArray(spec, command) {
    invariant(Array.isArray(spec), function () { return "update(): expected spec of " + stringifiable(command) + " to be an array; got " + stringifiable(spec) + ". " +
        "Did you forget to wrap your parameter in an array?"; });
}
function invariantSplices(value, spec) {
    invariant(Array.isArray(value), function () { return "Expected $splice target to be an array; got " + stringifiable(value); });
    invariantSplice(spec.$splice);
}
function invariantSplice(value) {
    invariant(Array.isArray(value), function () { return "update(): expected spec of $splice to be an array of arrays; got " + stringifiable(value) + ". " +
        "Did you forget to wrap your parameters in an array?"; });
}
function invariantApply(fn) {
    invariant(typeof fn === 'function', function () { return "update(): expected spec of $apply to be a function; got " + stringifiable(fn) + "."; });
}
function invariantSet(spec) {
    invariant(Object.keys(spec).length === 1, function () { return "Cannot have more than one key in an object with $set"; });
}
function invariantMerge(target, specValue) {
    invariant(specValue && typeof specValue === 'object', function () { return "update(): $merge expects a spec of type 'object'; got " + stringifiable(specValue); });
    invariant(target && typeof target === 'object', function () { return "update(): $merge expects a target of type 'object'; got " + stringifiable(target); });
}
function invariantMapOrSet(target, command) {
    var typeOfTarget = type(target);
    invariant(typeOfTarget === 'Map' || typeOfTarget === 'Set', function () { return "update(): " + stringifiable(command) + " expects a target of type Set or Map; got " + stringifiable(typeOfTarget); });
}


/***/ }),
/* 118 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ThemeContext": () => (/* binding */ ThemeContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ThemeContext = react__WEBPACK_IMPORTED_MODULE_0___default().createContext({
    mode: "light",
    layout: "full",
    sounds: {
        correct: "",
        incorrect: "",
    },
});


/***/ }),
/* 119 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useFeedbackSound": () => (/* binding */ useFeedbackSound)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var use_sound__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(120);
/* harmony import */ var _providers_ThemeContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(118);



var useFeedbackSound = function () {
    var theme = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_ThemeContext__WEBPACK_IMPORTED_MODULE_2__.ThemeContext);
    var playCorrect = (0,use_sound__WEBPACK_IMPORTED_MODULE_1__["default"])(theme.sounds.correct)[0];
    var playIncorrect = (0,use_sound__WEBPACK_IMPORTED_MODULE_1__["default"])(theme.sounds.incorrect)[0];
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (isCorrect) {
        if (isCorrect) {
            playCorrect();
        }
        else {
            playIncorrect();
        }
    }, [playCorrect, playIncorrect]);
};


/***/ }),
/* 120 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "useSound": () => (/* binding */ useSound)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function useOnMount(callback) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(callback, []);
}

function useSound(src, _ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$volume = _ref2.volume,
      volume = _ref2$volume === void 0 ? 1 : _ref2$volume,
      _ref2$playbackRate = _ref2.playbackRate,
      playbackRate = _ref2$playbackRate === void 0 ? 1 : _ref2$playbackRate,
      _ref2$soundEnabled = _ref2.soundEnabled,
      soundEnabled = _ref2$soundEnabled === void 0 ? true : _ref2$soundEnabled,
      _ref2$interrupt = _ref2.interrupt,
      interrupt = _ref2$interrupt === void 0 ? false : _ref2$interrupt,
      onload = _ref2.onload,
      delegated = _objectWithoutPropertiesLoose(_ref2, ["id", "volume", "playbackRate", "soundEnabled", "interrupt", "onload"]);

  var HowlConstructor = react__WEBPACK_IMPORTED_MODULE_0___default().useRef(null);
  var isMounted = react__WEBPACK_IMPORTED_MODULE_0___default().useRef(false);

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0___default().useState(null),
      duration = _React$useState[0],
      setDuration = _React$useState[1];

  var _React$useState2 = react__WEBPACK_IMPORTED_MODULE_0___default().useState(null),
      sound = _React$useState2[0],
      setSound = _React$useState2[1];

  var handleLoad = function handleLoad() {
    if (typeof onload === 'function') {
      // @ts-ignore
      onload.call(this);
    }

    if (isMounted.current) {
      // @ts-ignore
      setDuration(this.duration() * 1000);
    } // @ts-ignore


    setSound(this);
  }; // We want to lazy-load Howler, since sounds can't play on load anyway.


  useOnMount(function () {
    Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 257, 23)).then(function (mod) {
      if (!isMounted.current) {
        var _mod$Howl;

        // Depending on the module system used, `mod` might hold
        // the export directly, or it might be under `default`.
        HowlConstructor.current = (_mod$Howl = mod.Howl) !== null && _mod$Howl !== void 0 ? _mod$Howl : mod["default"].Howl;
        isMounted.current = true;
        new HowlConstructor.current(_extends({
          src: Array.isArray(src) ? src : [src],
          volume: volume,
          rate: playbackRate,
          onload: handleLoad
        }, delegated));
      }
    });
    return function () {
      isMounted.current = false;
    };
  }); // When the `src` changes, we have to do a whole thing where we recreate
  // the Howl instance. This is because Howler doesn't expose a way to
  // tweak the sound

  react__WEBPACK_IMPORTED_MODULE_0___default().useEffect(function () {
    if (HowlConstructor.current && sound) {
      setSound(new HowlConstructor.current(_extends({
        src: Array.isArray(src) ? src : [src],
        volume: volume,
        onload: handleLoad
      }, delegated)));
    } // The linter wants to run this effect whenever ANYTHING changes,
    // but very specifically I only want to recreate the Howl instance
    // when the `src` changes. Other changes should have no effect.
    // Passing array to the useEffect dependencies list will result in
    // ifinite loop so we need to stringify it, for more details check
    // https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [JSON.stringify(src)]); // Whenever volume/playbackRate are changed, change those properties
  // on the sound instance.

  react__WEBPACK_IMPORTED_MODULE_0___default().useEffect(function () {
    if (sound) {
      sound.volume(volume);
      sound.rate(playbackRate);
    } // A weird bug means that including the `sound` here can trigger an
    // error on unmount, where the state loses track of the sprites??
    // No idea, but anyway I don't need to re-run this if only the `sound`
    // changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [volume, playbackRate]);
  var play = react__WEBPACK_IMPORTED_MODULE_0___default().useCallback(function (options) {
    if (typeof options === 'undefined') {
      options = {};
    }

    if (!sound || !soundEnabled && !options.forceSoundEnabled) {
      return;
    }

    if (interrupt) {
      sound.stop();
    }

    if (options.playbackRate) {
      sound.rate(options.playbackRate);
    }

    sound.play(options.id);
  }, [sound, soundEnabled, interrupt]);
  var stop = react__WEBPACK_IMPORTED_MODULE_0___default().useCallback(function (id) {
    if (!sound) {
      return;
    }

    sound.stop(id);
  }, [sound]);
  var pause = react__WEBPACK_IMPORTED_MODULE_0___default().useCallback(function (id) {
    if (!sound) {
      return;
    }

    sound.pause(id);
  }, [sound]);
  var returnedValue = [play, {
    sound: sound,
    stop: stop,
    pause: pause,
    duration: duration
  }];
  return returnedValue;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useSound);

//# sourceMappingURL=use-sound.esm.js.map


/***/ }),
/* 121 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(122);
/* harmony import */ var _NextChapter_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(132);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



function NextChapterCard(_a) {
    var _b, _c, _d;
    var hideNumber = _a.hideNumber, props = __rest(_a, ["hideNumber"]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_1__["default"].qcard }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _NextChapter_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"].body }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _NextChapter_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"]["next-chapter"] }, { children: [props.chapter.image && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _NextChapter_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"]["chapter-image"] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: _NextChapter_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"]["img-wrapper"], style: {
                                backgroundImage: "url(\"".concat(props.chapter.image, "\")"),
                            } }) }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _NextChapter_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"]["custom-comp"] }, { children: [!hideNumber && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _NextChapter_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"]["chapter-number"] }, { children: props.chapterIndex + 1 })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _NextChapter_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"]["chapter-title"] }, { children: props.chapter.name || "" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _NextChapter_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"]["chapter-size"] }, { children: "".concat((_d = (_c = (_b = props.chapter) === null || _b === void 0 ? void 0 : _b.questions) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0, " Questions") }))] }))] })) })) })));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (NextChapterCard);


/***/ }),
/* 122 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(123);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(124);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(129);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),
/* 123 */
/***/ ((module) => {

"use strict";


var stylesInDOM = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };

    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);

  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }

      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };

  return updater;
}

module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();

        stylesInDOM.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),
/* 124 */
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";

  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }

  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }

  var needLayer = typeof obj.layer !== "undefined";

  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }

  css += obj.css;

  if (needLayer) {
    css += "}";
  }

  if (obj.media) {
    css += "}";
  }

  if (obj.supports) {
    css += "}";
  }

  var sourceMap = obj.sourceMap;

  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  options.styleTagTransform(css, styleElement, options.options);
}

function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }

  styleElement.parentNode.removeChild(styleElement);
}
/* istanbul ignore next  */


function domAPI(options) {
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}

module.exports = domAPI;

/***/ }),
/* 125 */
/***/ ((module) => {

"use strict";


var memo = {};
/* istanbul ignore next  */

function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }

    memo[target] = styleTarget;
  }

  return memo[target];
}
/* istanbul ignore next  */


function insertBySelector(insert, style) {
  var target = getTarget(insert);

  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }

  target.appendChild(style);
}

module.exports = insertBySelector;

/***/ }),
/* 126 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;

  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}

module.exports = setAttributesWithoutAttributes;

/***/ }),
/* 127 */
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}

module.exports = insertStyleElement;

/***/ }),
/* 128 */
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }

    styleElement.appendChild(document.createTextNode(css));
  }
}

module.exports = styleTagTransform;

/***/ }),
/* 129 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CardsFull-module__score {\n  position: absolute;\n  top: 55px;\n  color: green;\n  right: 40px;\n}\n\n.CardsFull-module__btns-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  position: fixed;\n  top: 16px;\n  right: 70px;\n  width: 80px;\n  height: 30px;\n  border: 1px solid rgba(235, 239, 243, 0.5);\n  border-radius: 44px;\n  overflow: hidden;\n}\n.CardsFull-module__btns-container .CardsFull-module__single-btn-container {\n  width: 50%;\n  border-radius: 44px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.CardsFull-module__btns-container .CardsFull-module__arrow {\n  cursor: pointer;\n  width: 6px;\n  height: 6px;\n  border-left: 1px solid #454545;\n  border-bottom: 1px solid #454545;\n}\n.CardsFull-module__btns-container .CardsFull-module__arrow.CardsFull-module__disabled {\n  cursor: default;\n  pointer-events: none;\n  opacity: 50%;\n}\n.CardsFull-module__btns-container .CardsFull-module__arrow.CardsFull-module__left-arrow {\n  transform: rotate(45deg);\n}\n.CardsFull-module__btns-container .CardsFull-module__arrow.CardsFull-module__right-arrow {\n  transform: rotate(-135deg);\n}\n\n.CardsFull-module__qcard {\n  width: 390px;\n  border-radius: 6px;\n  background-color: white;\n  margin: 0 auto;\n  padding: 0 !important;\n  margin: 15px auto;\n  position: relative;\n}\n.CardsFull-module__qcard .CardsFull-module__card-body {\n  padding: 0.75rem 0.75rem;\n}\n.CardsFull-module__qcard:first-child {\n  margin-top: 0;\n}\n.CardsFull-module__qcard .CardsFull-module__card-header {\n  display: none;\n}\n.CardsFull-module__qcard .CardsFull-module__card-body {\n  padding: 16px 30px;\n}\n.CardsFull-module__qcard .CardsFull-module__doubleXp {\n  z-index: -1;\n  position: absolute;\n  background: #ff4f4f;\n  filter: blur(10px);\n  border-radius: 30px;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.CardsFull-module__quiz-end-card {\n  width: 390px;\n  border-radius: 6px;\n  background-color: white;\n  margin: 0 auto;\n  position: relative;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__card-body {\n  padding: 0.75rem 0.75rem;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__header {\n  height: 115px;\n  position: relative;\n  padding: 22.5px 45px;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__header .CardsFull-module__header-main {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  position: relative;\n  width: 100%;\n  margin-bottom: 22.5px;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__header .CardsFull-module__header-main .CardsFull-module__image {\n  border-radius: 4px;\n  height: 49px;\n  overflow: hidden;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__header .CardsFull-module__header-main .CardsFull-module__image img {\n  width: auto;\n  height: 49px;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__header .CardsFull-module__header-main .CardsFull-module__header-text {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 28.5px;\n  line-height: 34.5px;\n  margin-left: 11.25px;\n}\n.CardsFull-module__theme-light .CardsFull-module__quiz-end-card .CardsFull-module__header .CardsFull-module__header-main .CardsFull-module__header-text {\n  color: #5b6171;\n}\n.CardsFull-module__theme-dark .CardsFull-module__quiz-end-card .CardsFull-module__header .CardsFull-module__header-main .CardsFull-module__header-text {\n  color: #5b6171;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__header .CardsFull-module__header-main .CardsFull-module__progress {\n  width: 50px;\n  height: 50px;\n  margin: 0 auto;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__header .CardsFull-module__header-main .CardsFull-module__buttons {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  width: 38.25px;\n  height: 42px;\n  position: absolute;\n  right: 30px;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__header .CardsFull-module__header-main .CardsFull-module__buttons .CardsFull-module__header-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-left: 11.25px;\n  font-size: 16px;\n  line-height: 21px;\n  cursor: pointer;\n  text-align: center;\n  color: #000;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__header .CardsFull-module__header-main .CardsFull-module__buttons .CardsFull-module__header-btn img {\n  margin-bottom: 12px;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__header .CardsFull-module__header-secondary {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n}\n.CardsFull-module__theme-light .CardsFull-module__quiz-end-card .CardsFull-module__header .CardsFull-module__header-secondary {\n  color: #5b6171;\n}\n.CardsFull-module__theme-dark .CardsFull-module__quiz-end-card .CardsFull-module__header .CardsFull-module__header-secondary {\n  color: #5b6171;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__other-articles {\n  min-height: 298.5px;\n  padding-bottom: 15px;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__other-articles a {\n  text-decoration: none !important;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__other-articles .CardsFull-module__article-container {\n  flex-direction: row;\n  border-top: 1px solid #d5dce4 !important;\n  padding: 15px 35px;\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  text-decoration: none !important;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__other-articles .CardsFull-module__article-container .CardsFull-module__article-image {\n  width: 107.25px;\n  height: 70.5px;\n  min-width: 107.25px;\n  min-height: 70.5px;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__other-articles .CardsFull-module__article-container .CardsFull-module__article-image img {\n  object-fit: fill;\n  width: 100%;\n  height: 100%;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__other-articles .CardsFull-module__article-container .CardsFull-module__article-text {\n  flex-direction: column;\n  margin-left: 17.25px;\n  max-height: 70.5px;\n  display: flex;\n  align-items: flex-start;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__other-articles .CardsFull-module__article-container .CardsFull-module__article-text .CardsFull-module__title {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14.25px;\n  line-height: 17.25px;\n  margin-bottom: 12px;\n  color: #000;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__other-articles .CardsFull-module__article-container .CardsFull-module__article-text .CardsFull-module__description {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 11.25px;\n  line-height: 18.75px;\n  max-height: 34.5px;\n  color: #000;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__card-footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 72.75px;\n  min-height: 73.5px;\n  padding: 7.5px 45px;\n  background: conic-gradient(from 180deg at 50% 50.02%, #3874fc 0deg, #1b4dce 155.62deg, #356dff 360deg);\n  mix-blend-mode: normal;\n  box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.05);\n  border-radius: 0px 0px 15px 15px !important;\n  color: white;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__card-footer .CardsFull-module__footer-logo {\n  margin-bottom: 5.25px;\n}\n.CardsFull-module__quiz-end-card .CardsFull-module__card-footer .CardsFull-module__footer-text {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10.5px;\n  line-height: 130%;\n  text-align: center;\n  color: hsla(0deg, 0%, 100%, 0.8);\n}\n\n@media only screen and (min-width: 992px) {\n  .CardsFull-module__qcard {\n    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2), 0 5px 8px rgba(0, 0, 0, 0.1);\n    width: 775px;\n    border-radius: 30px;\n    padding: 0 !important;\n  }\n  .CardsFull-module__qcard .CardsFull-module__card-body {\n    padding: 30px 45px;\n  }\n  .CardsFull-module__qcard .CardsFull-module__card-header {\n    background-color: white;\n    padding: 0 !important;\n    border-radius: 44px 44px 0 0 !important;\n    display: block;\n  }\n  .CardsFull-module__qcard .CardsFull-module__card-header .CardsFull-module__position-text {\n    font-family: Manrope, sans-serif;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 13px;\n    line-height: 16px;\n    color: rgb(91, 97, 113);\n  }\n  .CardsFull-module__qcard .CardsFull-module__card-header .CardsFull-module__btn-container {\n    display: flex;\n    flex-direction: row;\n    margin-left: auto;\n    margin-right: 0;\n  }\n  .CardsFull-module__qcard .CardsFull-module__card-header .CardsFull-module__btn-container .CardsFull-module__left-arrow {\n    cursor: pointer;\n  }\n  .CardsFull-module__qcard .CardsFull-module__card-header .CardsFull-module__btn-container .CardsFull-module__left-arrow.CardsFull-module__disabled {\n    cursor: default;\n  }\n  .CardsFull-module__qcard .CardsFull-module__card-header .CardsFull-module__btn-container .CardsFull-module__right-arrow {\n    cursor: pointer;\n  }\n  .CardsFull-module__qcard .CardsFull-module__card-header .CardsFull-module__btn-container .CardsFull-module__right-arrow.CardsFull-module__disabled {\n    cursor: default;\n  }\n  .CardsFull-module__quiz-end-card {\n    width: 775px;\n    border-radius: 30px;\n  }\n  .CardsFull-module__quiz-end-card .CardsFull-module__card-body {\n    padding: 30px 45px;\n  }\n}\n.CardsFull-module__light-bulb {\n  width: 150px;\n  height: auto;\n  margin: 70px auto 0;\n}\n.CardsFull-module__light-bulb img {\n  width: 150px;\n  height: auto;\n}\n\n.CardsFull-module__progress-container {\n  background-color: white;\n  padding: 16px;\n  width: 173px;\n  height: 96px;\n  border-radius: 80px;\n  margin: 70px auto 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.CardsFull-module__progress-container .CardsFull-module__progress-wrapper {\n  width: 64px;\n  height: 64px;\n  margin-right: 16px;\n}\n.CardsFull-module__progress-container .CardsFull-module__progress-text {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 29px;\n  letter-spacing: -0.02em;\n  color: #356dff;\n}\n\n.CardsFull-module__message {\n  margin: 40px auto 52px;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n}\n.CardsFull-module__message .CardsFull-module__primary {\n  font-weight: 700;\n  font-size: 38px;\n  line-height: 46px;\n  text-align: center;\n  margin-bottom: 8px;\n}\n.CardsFull-module__message .CardsFull-module__secondary {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n}\n\n.CardsFull-module__carousel-container {\n  width: 95vw;\n  max-width: 95vw;\n  margin: 0 auto;\n}\n\n.CardsFull-module__recommendations-container {\n  background: white;\n  border-radius: 30px;\n  width: 100%;\n  padding: 18px 34px;\n}\n.CardsFull-module__recommendations-container .CardsFull-module__recommendations-header {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 21px;\n  color: black;\n  margin-bottom: 22px;\n}\n.CardsFull-module__recommendations-container .CardsFull-module__recommendations-content .CardsFull-module__recommendations-card {\n  margin: 0 4px 10px;\n}\n\n@media only screen and (min-width: 992px) {\n  .CardsFull-module__light-bulb {\n    width: 225px;\n    margin: 0 auto;\n    margin-bottom: 30px;\n    margin-top: 20px;\n  }\n  .CardsFull-module__light-bulb img {\n    width: 225px;\n  }\n  .CardsFull-module__progress-container {\n    margin: 0 auto;\n  }\n  .CardsFull-module__message {\n    color: white;\n    margin: 32px auto;\n  }\n  .CardsFull-module__recommendations-container {\n    padding: 18px 0;\n  }\n  .CardsFull-module__recommendations-container .CardsFull-module__recommendations-header {\n    margin-left: 34px;\n  }\n  .CardsFull-module__carousel-container {\n    max-width: 95vw;\n  }\n}\n.CardsFull-module__popXp {\n  left: 0;\n  top: 0;\n  position: fixed;\n  z-index: 300001;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 27px;\n  color: #e3b275;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"score": "CardsFull-module__score",
	"btns-container": "CardsFull-module__btns-container",
	"single-btn-container": "CardsFull-module__single-btn-container",
	"arrow": "CardsFull-module__arrow",
	"disabled": "CardsFull-module__disabled",
	"left-arrow": "CardsFull-module__left-arrow",
	"right-arrow": "CardsFull-module__right-arrow",
	"qcard": "CardsFull-module__qcard",
	"card-body": "CardsFull-module__card-body",
	"card-header": "CardsFull-module__card-header",
	"doubleXp": "CardsFull-module__doubleXp",
	"quiz-end-card": "CardsFull-module__quiz-end-card",
	"header": "CardsFull-module__header",
	"header-main": "CardsFull-module__header-main",
	"image": "CardsFull-module__image",
	"header-text": "CardsFull-module__header-text",
	"theme-light": "CardsFull-module__theme-light",
	"theme-dark": "CardsFull-module__theme-dark",
	"progress": "CardsFull-module__progress",
	"buttons": "CardsFull-module__buttons",
	"header-btn": "CardsFull-module__header-btn",
	"header-secondary": "CardsFull-module__header-secondary",
	"other-articles": "CardsFull-module__other-articles",
	"article-container": "CardsFull-module__article-container",
	"article-image": "CardsFull-module__article-image",
	"article-text": "CardsFull-module__article-text",
	"title": "CardsFull-module__title",
	"description": "CardsFull-module__description",
	"card-footer": "CardsFull-module__card-footer",
	"footer-logo": "CardsFull-module__footer-logo",
	"footer-text": "CardsFull-module__footer-text",
	"position-text": "CardsFull-module__position-text",
	"btn-container": "CardsFull-module__btn-container",
	"light-bulb": "CardsFull-module__light-bulb",
	"progress-container": "CardsFull-module__progress-container",
	"progress-wrapper": "CardsFull-module__progress-wrapper",
	"progress-text": "CardsFull-module__progress-text",
	"message": "CardsFull-module__message",
	"primary": "CardsFull-module__primary",
	"secondary": "CardsFull-module__secondary",
	"carousel-container": "CardsFull-module__carousel-container",
	"recommendations-container": "CardsFull-module__recommendations-container",
	"recommendations-header": "CardsFull-module__recommendations-header",
	"recommendations-content": "CardsFull-module__recommendations-content",
	"recommendations-card": "CardsFull-module__recommendations-card",
	"popXp": "CardsFull-module__popXp"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 130 */
/***/ ((module) => {

"use strict";


module.exports = function (i) {
  return i[1];
};

/***/ }),
/* 131 */
/***/ ((module) => {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";

      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }

      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }

      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }

      content += cssWithMappingToString(item);

      if (needLayer) {
        content += "}";
      }

      if (item[2]) {
        content += "}";
      }

      if (item[4]) {
        content += "}";
      }

      return content;
    }).join("");
  }; // import a list of modules into the list


  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }

      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }

      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }

      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }

      list.push(item);
    }
  };

  return list;
};

/***/ }),
/* 132 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(123);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(124);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_NextChapter_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(133);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_NextChapter_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_NextChapter_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_NextChapter_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_NextChapter_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),
/* 133 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NextChapter-module__body {\n  padding: 0;\n}\n\n.NextChapter-module__chapter-image {\n  width: 100%;\n  height: 270px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.NextChapter-module__chapter-image .NextChapter-module__img-wrapper {\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100%;\n  width: 100%;\n  border-radius: 6px 6px 0 0;\n}\n\n.NextChapter-module__next-chapter {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 370px;\n}\n.NextChapter-module__next-chapter .NextChapter-module__custom-comp {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 200px;\n  justify-content: center;\n  width: 100%;\n}\n.NextChapter-module__next-chapter .NextChapter-module__custom-comp .NextChapter-module__chapter-number {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 18px;\n  color: #707682;\n  border: 2px solid #e7eaee;\n  border-radius: 50%;\n  margin-bottom: 16px;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.NextChapter-module__next-chapter .NextChapter-module__custom-comp .NextChapter-module__chapter-title {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: unset;\n  /* or 144% */\n  text-align: center;\n  color: #364c97;\n  margin-bottom: 12px;\n  max-width: 80%;\n  overflow: hidden;\n}\n.NextChapter-module__next-chapter .NextChapter-module__custom-comp .NextChapter-module__chapter-size {\n  color: #2c2b5e;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n}\n.NextChapter-module__next-chapter .NextChapter-module__next-quiz-accept {\n  width: 150px;\n  height: 50px;\n  background-color: rgb(53, 109, 255);\n  box-shadow: 0px 4px 14px rgba(73, 109, 219, 0.2);\n  border-radius: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  cursor: pointer;\n  margin-top: 20px;\n}\n.NextChapter-module__next-chapter .NextChapter-module__next-quiz-accept img {\n  height: 62px;\n  width: auto;\n  margin-left: -5px;\n  margin-top: 2px;\n}\n.NextChapter-module__next-chapter .NextChapter-module__next-quiz-accept div {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  margin-left: 10px;\n}\n\n@media only screen and (min-width: 992px) {\n  .NextChapter-module__next-chapter {\n    flex-direction: column;\n    height: 380px;\n  }\n  .NextChapter-module__next-chapter .NextChapter-module__chapter-image {\n    margin: 0;\n    height: 100%;\n  }\n  .NextChapter-module__next-chapter .NextChapter-module__chapter-image .NextChapter-module__img-wrapper {\n    border-radius: 3px;\n    width: 320px;\n    height: 180px;\n  }\n  .NextChapter-module__next-chapter .NextChapter-module__chapter-image .NextChapter-module__img-wrapper img {\n    overflow: hidden;\n    flex-shrink: 1;\n    flex-grow: 1;\n    flex-basis: 0;\n    width: 387px;\n    height: auto;\n  }\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": "NextChapter-module__body",
	"chapter-image": "NextChapter-module__chapter-image",
	"img-wrapper": "NextChapter-module__img-wrapper",
	"next-chapter": "NextChapter-module__next-chapter",
	"custom-comp": "NextChapter-module__custom-comp",
	"chapter-number": "NextChapter-module__chapter-number",
	"chapter-title": "NextChapter-module__chapter-title",
	"chapter-size": "NextChapter-module__chapter-size",
	"next-quiz-accept": "NextChapter-module__next-quiz-accept"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 134 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QuestionCard": () => (/* binding */ QuestionCard),
/* harmony export */   "getQuestionGuide": () => (/* binding */ getQuestionGuide)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(210);
/* harmony import */ var _FillInCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(173);
/* harmony import */ var _MatchingQuestionCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(202);
/* harmony import */ var _MultipleAnswersCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(135);
/* harmony import */ var _WritableCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(178);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};






var getQuestionGuide = function (type) {
    var guide = {
        MCM: "Select multiple answers",
        MCS: "Select one answer",
        BC: "Fill in the blanks",
        SW: "Write your answer",
        AB: "Select one answer",
        MQ: "Match the pairs",
    };
    return guide[type];
};
var QuestionCard = function (props) {
    if (props.question.type === "MCM") {
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MultipleAnswersCard__WEBPACK_IMPORTED_MODULE_1__["default"], __assign({}, props));
    }
    else if (props.question.type === "MCS") {
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MultipleAnswersCard__WEBPACK_IMPORTED_MODULE_1__["default"], __assign({}, props));
    }
    else if (props.question.type === "BC") {
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FillInCard__WEBPACK_IMPORTED_MODULE_2__["default"], __assign({}, props));
    }
    else if (props.question.type === "SW") {
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_WritableCard__WEBPACK_IMPORTED_MODULE_3__["default"], __assign({}, props));
    }
    else if (props.question.type === "AB") {
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MultipleAnswersCard__WEBPACK_IMPORTED_MODULE_1__["default"], __assign({}, props));
    }
    else if (props.question.type === "MQ") {
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MatchingQuestionCard__WEBPACK_IMPORTED_MODULE_4__["default"], __assign({}, props));
    }
    else {
        return (0,_utils__WEBPACK_IMPORTED_MODULE_5__._throw)("Unimplemented question type");
    }
};


/***/ }),
/* 135 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_questionTemplating__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(136);
/* harmony import */ var _answersLists_MultiClickableAnswerList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(141);
/* harmony import */ var _QuestionFeedbackWidget__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(167);
/* harmony import */ var _questionText_QuestionText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(138);
/* harmony import */ var _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(122);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};







function MultipleAnswersCard(props) {
    var _a, _b;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), answers = _c[0], setAnswers = _c[1];
    var handleEnd = function (receivedAnswers, scoreData) {
        var selectedAnswers = receivedAnswers.map(function (item) { return item.answerId; });
        setAnswers(selectedAnswers);
        console.log(selectedAnswers);
        props.handleEnd(props.question.id, selectedAnswers, scoreData);
    };
    var handleClick = function (receivedAnswers) {
        var selectedAnswers = receivedAnswers.map(function (item) { return item.answerId; });
        setAnswers(selectedAnswers);
    };
    var question = (0,_hooks_questionTemplating__WEBPACK_IMPORTED_MODULE_2__.useQuestionTemplating)(props.question.question, undefined)[0];
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_3__["default"].qcard }, { children: [((_a = props.question) === null || _a === void 0 ? void 0 : _a.isDoubleXp) && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_3__["default"].doubleXp }), props.header && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_3__["default"]["card-header"] }, { children: props.header })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_3__["default"]["card-body"] }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: "question-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_questionText_QuestionText__WEBPACK_IMPORTED_MODULE_4__["default"], __assign({ attachmentURL: props.question.attachmentURL, attachmentType: props.question.attachmentType }, { children: question })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: "answers" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_answersLists_MultiClickableAnswerList__WEBPACK_IMPORTED_MODULE_5__["default"], { entries: props.question.answers, answersIds: Object.keys(props.question.answers), handleEnd: handleEnd, handleClick: handleClick, answers: answers, playFeedbackSound: props.playFeedbackSound, isDoubleXp: !!((_b = props.question) === null || _b === void 0 ? void 0 : _b.isDoubleXp) }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_QuestionFeedbackWidget__WEBPACK_IMPORTED_MODULE_6__.QuestionFeedbackWidget, { questionId: props.question.id, quizId: props.quizId })] }))] })));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MultipleAnswersCard);


/***/ }),
/* 136 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useQuestionTemplating": () => (/* binding */ useQuestionTemplating)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _components_Tags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(137);


var components = {
    li: _components_Tags__WEBPACK_IMPORTED_MODULE_1__.CustomLI,
    ol: _components_Tags__WEBPACK_IMPORTED_MODULE_1__.CustomOL,
    p: _components_Tags__WEBPACK_IMPORTED_MODULE_1__.CustomP,
};
function useQuestionTemplating(question, getNextFillable) {
    var counter = 0;
    var answerIds = [];
    function getQ(nodesList) {
        var result = nodesList.map(function (node) {
            if (node.tag) {
                return processTag(node);
            }
            else {
                return processContent(node);
            }
        });
        return result;
    }
    function processContent(node) {
        var _a;
        if (node.type && node.type === "question") {
            return node.text;
        }
        else if (node.type && node.type === "blank") {
            var fillable = (_a = getNextFillable === null || getNextFillable === void 0 ? void 0 : getNextFillable(node, counter++)) !== null && _a !== void 0 ? _a : undefined;
            answerIds.push(node.answerId);
            return fillable;
        }
        return "";
    }
    function processTag(node) {
        var output = node.content.map(function (contentNode) {
            if (contentNode.tag) {
                return processTag(contentNode);
            }
            else {
                return processContent(contentNode);
            }
        });
        var key = node.tag;
        var Tag = components[key];
        var resultingTag = (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, { children: output }, counter);
        counter = counter + 1;
        return resultingTag;
    }
    return [getQ(question), answerIds];
}


/***/ }),
/* 137 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomLI": () => (/* binding */ CustomLI),
/* harmony export */   "CustomOL": () => (/* binding */ CustomOL),
/* harmony export */   "CustomP": () => (/* binding */ CustomP)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

function CustomP(props) {
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", { children: props.children });
}
function CustomOL(props) {
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", { children: props.children });
}
function CustomLI(props) {
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", { children: props.children });
}


/***/ }),
/* 138 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _QuestionText_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(139);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var QuestionText = function (props) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _QuestionText_module_scss__WEBPACK_IMPORTED_MODULE_1__["default"]["q-content"] }, { children: [props.attachmentURL && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _QuestionText_module_scss__WEBPACK_IMPORTED_MODULE_1__["default"]["q-image-container"] }, { children: [props.attachmentType === "image" && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { className: _QuestionText_module_scss__WEBPACK_IMPORTED_MODULE_1__["default"]["q-image"], src: props.attachmentURL }), props.attachmentType === "video" && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", { className: _QuestionText_module_scss__WEBPACK_IMPORTED_MODULE_1__["default"]["q-video"], width: "305", height: "205", src: props.attachmentURL, allow: "autoplay; modestbranding; rel; loop", 
                    // @ts-expect-error
                    allowFullScreen: "allowfullscreen" }))] }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _QuestionText_module_scss__WEBPACK_IMPORTED_MODULE_1__["default"].question }, { children: props.children }))] }))); };
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuestionText);


/***/ }),
/* 139 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(123);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(124);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_QuestionText_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(140);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_QuestionText_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_QuestionText_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_QuestionText_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_QuestionText_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),
/* 140 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuestionText-module__q-content {\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 16px;\n}\n.QuestionText-module__q-content .QuestionText-module__q-image-container .QuestionText-module__q-image {\n  border-radius: 4px;\n  height: auto;\n}\n.QuestionText-module__q-content .QuestionText-module__q-image-container .QuestionText-module__q-video,\n.QuestionText-module__q-content .QuestionText-module__q-image-container iframe {\n  border-radius: 4px;\n  height: 205px;\n}\n.QuestionText-module__q-content .QuestionText-module__question {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  color: #2c2b5e;\n  font-weight: 400;\n  color: #000;\n  align-self: stretch;\n  flex-grow: 0;\n  order: 0;\n  font-size: 24px;\n  line-height: unset;\n}\n.QuestionText-module__q-content .QuestionText-module__question > * {\n  color: #2c2b5e;\n}\n\n@media only screen and (min-width: 992px) {\n  .QuestionText-module__q-content {\n    display: flex;\n    flex-direction: column-reverse;\n    align-items: center;\n    margin-bottom: 20px;\n    gap: 16px;\n  }\n  .QuestionText-module__q-content .QuestionText-module__q-image-container {\n    margin-right: 20px;\n    margin-bottom: 0;\n  }\n  .QuestionText-module__q-content .QuestionText-module__question {\n    margin: 0;\n    color: #364c97;\n    font-weight: 700;\n  }\n  .QuestionText-module__q-content .QuestionText-module__question p {\n    margin-bottom: 0;\n  }\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"q-content": "QuestionText-module__q-content",
	"q-image-container": "QuestionText-module__q-image-container",
	"q-image": "QuestionText-module__q-image",
	"q-video": "QuestionText-module__q-video",
	"question": "QuestionText-module__question"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 141 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(143);
/* harmony import */ var _hooks_useXpPopAnimation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(142);
/* harmony import */ var _answers_ClickableAnswer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(161);
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};





function MultiClickableAnswerList(props) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false /*props.savedAnswers != undefined*/), lockedAnswer = _a[0], setLockedAnswer = _a[1];
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), selectedAlternative = _b[0], setSelectedAlternative = _b[1];
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false /*props.savedAnswers != undefined*/), reveal = _c[0], setReveal = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), addedXp = _d[0], setAddedXp = _d[1];
    var maxScore = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () { return props.answersIds.flatMap(function (entryId) { return props.entries[entryId]; }).filter(function (it) { return it.isCorrect; }).length; }, [props.answersIds, props.entries]);
    var _e = (0,_hooks_useXpPopAnimation__WEBPACK_IMPORTED_MODULE_2__.useXpPopAnimation)(), xpPopComponent = _e.xpPopComponent, playXpAnimation = _e.play;
    var handleAlternativeClick = function (userAnswer, x, y) {
        if (reveal && lockedAnswer) {
            return;
        }
        var newXp = !userAnswer.isCorrect ? 0 : props.isDoubleXp ? 10 : 5;
        var totalXp = addedXp + newXp;
        setAddedXp(totalXp);
        if (userAnswer.isCorrect) {
            playXpAnimation(newXp, x, y);
        }
        props.playFeedbackSound(userAnswer.isCorrect);
        var newSelection = __spreadArray([], selectedAlternative, true);
        var answerIndex = selectedAlternative.findIndex(function (ans) { return ans.index == userAnswer.index; });
        if (answerIndex > -1) {
            newSelection.splice(answerIndex, 1);
        }
        else {
            if (props.entries[0].filter(function (it) { return it.isCorrect; }).length === 1) {
                newSelection = [userAnswer];
                setLockedAnswer(true);
                setReveal(true);
                var score = userAnswer.isCorrect ? 1 : 0;
                props.handleEnd(newSelection, { score: score, maxScore: 1, addedXp: totalXp });
                return;
            }
            else {
                newSelection.push(userAnswer);
            }
        }
        setSelectedAlternative(newSelection);
        if (newSelection.length === maxScore) {
            setLockedAnswer(true);
            setReveal(true);
            var score = selectedAlternative.filter(function (item) { return item.isCorrect; }).length;
            props.handleEnd(selectedAlternative, { score: score, maxScore: maxScore, addedXp: totalXp });
        }
        props.handleClick(newSelection);
    };
    var chosenColors = (0,_hooks__WEBPACK_IMPORTED_MODULE_3__.useColourSample)();
    var listOfEntries = props.answersIds.map(function (entryId) {
        return props.entries[entryId].map(function (alternative, index) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_answers_ClickableAnswer__WEBPACK_IMPORTED_MODULE_4__["default"], { color: chosenColors[index % chosenColors.length], index: index, text: alternative.text, isCorrect: alternative.isCorrect, handleClick: function (x, y) {
                    return handleAlternativeClick({
                        index: index,
                        isCorrect: alternative.isCorrect,
                        answerId: alternative.id,
                    }, x, y);
                }, reveal: reveal, locked: lockedAnswer, allowToggle: true, wasAlreadySelected: false }, alternative.id));
        });
    });
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [xpPopComponent, listOfEntries[0]] }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MultiClickableAnswerList);


/***/ }),
/* 142 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useXpPopAnimation": () => (/* binding */ useXpPopAnimation)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _react_spring_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(108);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_cards_CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(122);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var useXpPopAnimation = function () {
    var _a = (0,_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.useSpring)(function () { return ({ x: 0, y: 0, scale: 1, opacity: 0, display: "none" }); }), popXpStyle = _a[0], api = _a[1];
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), addedXp = _b[0], setAddedXp = _b[1];
    var play = function (addedXP, x, y) {
        setAddedXp(addedXP);
        api.start({
            from: {
                x: x,
                y: y,
                opacity: 0,
                scale: 0,
                display: "block",
            },
            to: [
                {
                    x: x,
                    y: y - 25,
                    opacity: 1,
                    scale: 1,
                    display: "block",
                },
                {
                    opacity: 0,
                },
                {
                    display: "none",
                },
            ],
        });
    };
    var xpPopComponent = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, __assign({ style: popXpStyle, className: _components_cards_CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_3__["default"].popXp }, { children: ["+ ", addedXp, " XP"] }))); }, [addedXp, popXpStyle]);
    return {
        play: play,
        xpPopComponent: xpPopComponent,
    };
};


/***/ }),
/* 143 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useColourSample": () => (/* binding */ useColourSample)
/* harmony export */ });
/* harmony import */ var lodash_sampleSize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(144);
/* harmony import */ var lodash_sampleSize__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_sampleSize__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);


var useColourSample = function () {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
        var colors = ["#F15530", "#EE742C", "#5AC7A8", "#E3B275", "#41A5D1"];
        return lodash_sampleSize__WEBPACK_IMPORTED_MODULE_0___default()(colors, colors.length);
    }, []);
};


/***/ }),
/* 144 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arraySampleSize = __webpack_require__(145),
    baseSampleSize = __webpack_require__(150),
    isArray = __webpack_require__(71),
    isIterateeCall = __webpack_require__(154),
    toInteger = __webpack_require__(155);

/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */
function sampleSize(collection, n, guard) {
  if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = toInteger(n);
  }
  var func = isArray(collection) ? arraySampleSize : baseSampleSize;
  return func(collection, n);
}

module.exports = sampleSize;


/***/ }),
/* 145 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseClamp = __webpack_require__(146),
    copyArray = __webpack_require__(147),
    shuffleSelf = __webpack_require__(148);

/**
 * A specialized version of `_.sampleSize` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function arraySampleSize(array, n) {
  return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
}

module.exports = arraySampleSize;


/***/ }),
/* 146 */
/***/ ((module) => {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 147 */
/***/ ((module) => {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 148 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseRandom = __webpack_require__(149);

/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = baseRandom(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

module.exports = shuffleSelf;


/***/ }),
/* 149 */
/***/ ((module) => {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),
/* 150 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseClamp = __webpack_require__(146),
    shuffleSelf = __webpack_require__(148),
    values = __webpack_require__(151);

/**
 * The base implementation of `_.sampleSize` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function baseSampleSize(collection, n) {
  var array = values(collection);
  return shuffleSelf(array, baseClamp(n, 0, array.length));
}

module.exports = baseSampleSize;


/***/ }),
/* 151 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseValues = __webpack_require__(152),
    keys = __webpack_require__(75);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 152 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayMap = __webpack_require__(153);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 153 */
/***/ ((module) => {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 154 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var eq = __webpack_require__(18),
    isArrayLike = __webpack_require__(93),
    isIndex = __webpack_require__(83),
    isObject = __webpack_require__(37);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 155 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toFinite = __webpack_require__(156);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 156 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toNumber = __webpack_require__(157);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 157 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseTrim = __webpack_require__(158),
    isObject = __webpack_require__(37),
    isSymbol = __webpack_require__(160);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 158 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var trimmedEndIndex = __webpack_require__(159);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 159 */
/***/ ((module) => {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 160 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(31),
    isObjectLike = __webpack_require__(80);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 161 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _react_spring_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(108);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(164);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(165);
/* harmony import */ var _assets_white_x_png__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(166);
/* harmony import */ var _ClickableAnswers_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(162);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

//const classNames = require('classnames');






function ClickableAnswer(props) {
    var _a, _b, _c, _d;
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(props.wasAlreadySelected), isSelected = _e[0], setIsSelected = _e[1];
    var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()(_ClickableAnswers_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"].answer, (_a = {}, _a[_ClickableAnswers_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"].success] = props.reveal && isSelected && props.isCorrect, _a), (_b = {}, _b[_ClickableAnswers_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"].fail] = props.reveal && isSelected && !props.isCorrect, _b), (_c = {}, _c[_ClickableAnswers_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"].selected] = isSelected, _c), (_d = {}, _d[_ClickableAnswers_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"].skipped] = props.reveal && !isSelected && props.isCorrect, _d));
    var handleClick = function (event) {
        if (props.locked) {
            return;
        }
        setIsSelected(props.allowToggle ? !isSelected : true);
        props.handleClick(event.pageX, event.pageY);
    };
    var bop = (0,_hooks__WEBPACK_IMPORTED_MODULE_5__.useButtonBopAnimation)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    (0,_hooks__WEBPACK_IMPORTED_MODULE_6__.useKey)(undefined, function (key) {
        var div = ref.current;
        if (!div) {
            return;
        }
        var index = parseInt(key.replace(/^Digit/, "").replace(/^Numpad/, ""));
        if (isNaN(index)) {
            return;
        }
        console.log(index);
        if (index - 1 === props.index) {
            if (props.locked) {
                return;
            }
            setIsSelected(props.allowToggle ? !isSelected : true);
            var rect = div.getBoundingClientRect();
            props.handleClick(rect.left + rect.width / 2, rect.top + rect.height / 2);
        }
    }, [props.handleClick, props.index, props.locked, props.allowToggle, isSelected]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, __assign({}, bop.buttonProps, { className: classes, onClick: handleClick, ref: ref }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _ClickableAnswers_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"].letter, style: { backgroundColor: props.color } }, { children: props.reveal && isSelected ? (props.isCorrect ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: _ClickableAnswers_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"]["green-tick"] })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _ClickableAnswers_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"]["red-x"] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: _assets_white_x_png__WEBPACK_IMPORTED_MODULE_7__, alt: "cross" }) })))) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _ClickableAnswers_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"].word }, { children: props.text }))] })));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ClickableAnswer);


/***/ }),
/* 162 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(123);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(124);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_ClickableAnswers_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(163);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_ClickableAnswers_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_ClickableAnswers_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_ClickableAnswers_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_ClickableAnswers_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),
/* 163 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ClickableAnswers-module__answer {\n  user-select: none;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 9px 12px;\n  min-height: 50.25px;\n  background: rgba(255, 255, 255, 0.6);\n  border: 1px solid rgba(73, 109, 219, 0.1);\n  border-radius: 7.5px;\n  margin-bottom: 7.5px;\n  position: relative;\n}\n.ClickableAnswers-module__answer > * {\n  -webkit-transform: translateZ(0px);\n}\n.ClickableAnswers-module__answer .ClickableAnswers-module__green-tick {\n  width: 40%;\n  height: 60%;\n  border-bottom: 2px solid white;\n  border-right: 2px solid white;\n  transform: rotate(40deg);\n  margin: 3px auto;\n}\n.ClickableAnswers-module__answer .ClickableAnswers-module__red-x {\n  width: 15px;\n  height: 15px;\n  margin: 0 auto;\n}\n.ClickableAnswers-module__answer .ClickableAnswers-module__red-x img {\n  width: 15px;\n  height: 15px;\n}\n.ClickableAnswers-module__answer.ClickableAnswers-module__selected {\n  border: 1px solid #ffe88d;\n  box-sizing: border-box;\n  box-shadow: 0px 0px 2px #ffe88d;\n  border-radius: 7.5px;\n}\n.ClickableAnswers-module__answer.ClickableAnswers-module__selected:hover {\n  xborder: 1px solid #ffe88d;\n}\n.ClickableAnswers-module__answer:hover {\n  border: 1px solid #41a5d1;\n}\n.ClickableAnswers-module__answer.ClickableAnswers-module__success {\n  background-color: #bde5c1;\n  border: 1px solid #5ac7a8;\n}\n.ClickableAnswers-module__answer.ClickableAnswers-module__success .ClickableAnswers-module__letter {\n  background-color: #edfbf3;\n}\n.ClickableAnswers-module__answer.ClickableAnswers-module__success .ClickableAnswers-module__word {\n  background: #bde5c1;\n}\n.ClickableAnswers-module__answer.ClickableAnswers-module__success .ClickableAnswers-module__result-text {\n  color: #3caa46;\n}\n.ClickableAnswers-module__answer.ClickableAnswers-module__fail {\n  border: 2px solid #f15530;\n  background-color: rgba(241, 85, 48, 0.5);\n  box-shadow: unset;\n}\n.ClickableAnswers-module__answer.ClickableAnswers-module__fail .ClickableAnswers-module__letter {\n  background-color: rgb(213, 220, 228);\n}\n.ClickableAnswers-module__answer.ClickableAnswers-module__skipped {\n  background: #fff;\n  border: 1px solid #3caa46;\n}\n.ClickableAnswers-module__answer.ClickableAnswers-module__skipped .ClickableAnswers-module__letter {\n  background: #edf0fb;\n  color: white;\n}\n.ClickableAnswers-module__answer.ClickableAnswers-module__skipped .ClickableAnswers-module__word {\n  color: #232323;\n}\n\n.ClickableAnswers-module__result-text {\n  right: 18px;\n  position: absolute;\n}\n\n.ClickableAnswers-module__letter {\n  padding: 4.5px;\n  width: 27px;\n  height: 32.25px;\n  background: #ebeff3;\n  border-radius: 4.5px;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 9.76px;\n  line-height: 22.5px;\n  text-align: center;\n  color: white;\n  font-weight: 700;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.ClickableAnswers-module__word {\n  font-family: Manrope, sans-serif;\n  color: #2c2b5e;\n  font-size: 16px;\n  margin-left: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 15px;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"answer": "ClickableAnswers-module__answer",
	"green-tick": "ClickableAnswers-module__green-tick",
	"red-x": "ClickableAnswers-module__red-x",
	"selected": "ClickableAnswers-module__selected",
	"success": "ClickableAnswers-module__success",
	"letter": "ClickableAnswers-module__letter",
	"word": "ClickableAnswers-module__word",
	"result-text": "ClickableAnswers-module__result-text",
	"fail": "ClickableAnswers-module__fail",
	"skipped": "ClickableAnswers-module__skipped"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 164 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useButtonBopAnimation": () => (/* binding */ useButtonBopAnimation)
/* harmony export */ });
/* harmony import */ var _react_spring_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(108);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);


var useButtonBopAnimation = function (scaleFactor, animationConfig, playVelocity) {
    if (scaleFactor === void 0) { scaleFactor = 1.025; }
    if (animationConfig === void 0) { animationConfig = _react_spring_web__WEBPACK_IMPORTED_MODULE_0__.config["default"]; }
    if (playVelocity === void 0) { playVelocity = 0.001; }
    var _a = (0,_react_spring_web__WEBPACK_IMPORTED_MODULE_0__.useSpring)(function () { return ({
        scale: 1,
        config: animationConfig,
    }); }), style = _a[0], api = _a[1];
    var onMouseDown = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
        api.start({
            scale: scaleFactor,
        });
    }, [api, scaleFactor]);
    var onMouseUp = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
        api.start({
            scale: 1.0,
        });
    }, [api]);
    var play = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
        api.start({
            from: { scale: 0.99 },
            to: [{ scale: 1 }],
            config: { velocity: playVelocity },
        });
    }, [api, playVelocity]);
    return {
        buttonProps: {
            style: style,
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
        },
        play: play,
    };
};


/***/ }),
/* 165 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useKey": () => (/* binding */ useKey)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var useKey = function (key, callback, deps) {
    if (deps === void 0) { deps = []; }
    var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(callback, deps);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var handler = function (event) {
            if (key === undefined || (Array.isArray(key) && key.some(function (k) { return event.code === k; })) || (!Array.isArray(key) && event.code === key)) {
                callbackRef(event.code);
            }
        };
        document.addEventListener("keydown", handler);
        return function () { return document.removeEventListener("keydown", handler); };
    }, [callbackRef, key]);
};


/***/ }),
/* 166 */
/***/ ((module) => {

"use strict";
module.exports = "data:image/png;base64,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";

/***/ }),
/* 167 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QuestionFeedbackWidget": () => (/* binding */ QuestionFeedbackWidget)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var immutability_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(117);
/* harmony import */ var immutability_helper__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(immutability_helper__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useKey__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(165);
/* harmony import */ var _providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(105);
/* harmony import */ var _requests__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7);
/* harmony import */ var _assets_black_x_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(171);
/* harmony import */ var _assets_continue_png__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(172);
/* harmony import */ var _assets_thumb__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(170);
/* harmony import */ var _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(168);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};











var QuestionFeedbackWidget = function (_a) {
    var _b, _c;
    var questionId = _a.questionId, quizId = _a.quizId;
    var user = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_4__.AppConfigContext).user;
    var _d = useQuestionFeedback(questionId, quizId), feedback = _d.feedback, setFeedback = _d.setFeedback;
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), menuState = _e[0], setMenuState = _e[1];
    if (user.id === "") {
        return null;
    }
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].outer, _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].question) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].label }, { children: "How was this question?" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].inner }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_thumb__WEBPACK_IMPORTED_MODULE_6__.Thumb, { onClick: function () { return setMenuState("positive"); }, className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option, _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].positive, (_b = {}, _b[_FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].active] = (feedback === null || feedback === void 0 ? void 0 : feedback.result) === "positive", _b)) }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_thumb__WEBPACK_IMPORTED_MODULE_6__.Thumb, { onClick: function () { return setMenuState("negative"); }, className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option, _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].negative, (_c = {}, _c[_FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].active] = (feedback === null || feedback === void 0 ? void 0 : feedback.result) === "negative", _c)) })] })), menuState !== null && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuestionFeedbackModal, { type: menuState, setFeedback: function (feedback) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                setMenuState(null);
                                if (!feedback) return [3 /*break*/, 2];
                                return [4 /*yield*/, setFeedback(feedback)];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); } }))] })));
};
var QuestionFeedbackModal = function (_a) {
    var _b, _c;
    var type = _a.type, setFeedback = _a.setFeedback;
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        page: 0,
        choices: {
            difficulty: false,
            questionContent: false,
            answerContent: false,
            other: false,
        },
        feedback: {
            result: type,
            difficulty: undefined,
            relavance: undefined,
            questionText: {
                noSense: false,
            },
            answers: {
                hasNoCorrectAnswer: false,
                hasMultipleCorrectAnswers: false,
                correctIsIncorrect: false,
                hasIrrelevantAnswer: false,
                noSense: false,
            },
            isInsightful: false,
            other: undefined,
        },
    }), menuState = _d[0], setMenuState = _d[1];
    var mutateMenuState = function (spec) { return setMenuState(function (menuState) { return immutability_helper__WEBPACK_IMPORTED_MODULE_2___default()(menuState, spec); }); };
    (0,_hooks_useKey__WEBPACK_IMPORTED_MODULE_7__.useKey)("Escape", function () { return setFeedback(); }, [setFeedback]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].modalOuter, onClick: function () {
            setFeedback(menuState.feedback);
        } }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].modalInner, onClick: function (e) {
                e.stopPropagation();
            } }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].close, src: _assets_black_x_svg__WEBPACK_IMPORTED_MODULE_8__, onClick: function () {
                        setFeedback(menuState.feedback);
                    }, alt: "Close" }), menuState.page === 0 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].title }, { children: ["What parts of the question were you ", type === "positive" ? "satisfied" : "unsatisfied", " by?"] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].options }, { children: [type === "negative" && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "dif", checked: menuState.choices.difficulty, onChange: function (e) {
                                                        return mutateMenuState({
                                                            choices: {
                                                                difficulty: { $set: e.target.checked },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "dif" }, { children: "Difficulty level" }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "question", checked: menuState.choices.questionContent, onChange: function (e) {
                                                        return mutateMenuState({
                                                            choices: {
                                                                questionContent: { $set: e.target.checked },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "question" }, { children: "Question Content" }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "ans", checked: menuState.choices.answerContent, onChange: function (e) {
                                                        return mutateMenuState({
                                                            choices: {
                                                                answerContent: { $set: e.target.checked },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "ans" }, { children: "Answer Content" }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "other", checked: menuState.choices.other, onChange: function (e) {
                                                        return mutateMenuState({
                                                            choices: {
                                                                other: { $set: e.target.checked },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "other" }, { children: "Other" }))] }))] })), type === "positive" && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "difficulty", checked: menuState.feedback.relavance === "relevant", onChange: function (e) {
                                                        return mutateMenuState({
                                                            feedback: {
                                                                relavance: { $set: e.target.checked ? "relevant" : undefined },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "difficulty" }, { children: "This quiz was not too hard or too easy." }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "length", checked: menuState.feedback.difficulty === "just-right", onChange: function (e) {
                                                        return mutateMenuState({
                                                            feedback: {
                                                                difficulty: { $set: e.target.checked ? "just-right" : undefined },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "length" }, { children: "This question is not too hard or too easy." }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "info", checked: menuState.feedback.isInsightful, onChange: function (e) {
                                                        return mutateMenuState({
                                                            feedback: {
                                                                isInsightful: { $set: e.target.checked },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "info" }, { children: "I learned something new from this question." }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "other", checked: menuState.choices.other, onChange: function (e) {
                                                        return mutateMenuState({
                                                            choices: {
                                                                other: { $set: e.target.checked },
                                                            },
                                                            feedback: {
                                                                other: { $set: e.target.checked ? undefined : undefined },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "other" }, { children: "Other" }))] })), menuState.choices.other && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].subsubtitle }, { children: "Please explain why you chose \u201COther\u201D:" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", { value: (_b = menuState.feedback.other) !== null && _b !== void 0 ? _b : "", onChange: function (e) { return mutateMenuState({ feedback: { other: { $set: e.target.value } } }); } })] }))] }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].continueContainer }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["continue"] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: _assets_continue_png__WEBPACK_IMPORTED_MODULE_9__, alt: "continue", onClick: function () {
                                        if (type === "negative") {
                                            if ([
                                                menuState.choices.difficulty,
                                                menuState.choices.questionContent,
                                                menuState.choices.answerContent,
                                                menuState.choices.other,
                                            ].some(Boolean)) {
                                                mutateMenuState({ page: { $set: 1 } });
                                            }
                                            else {
                                                setFeedback(undefined);
                                            }
                                        }
                                        else {
                                            if ([
                                                menuState.feedback.relavance,
                                                menuState.feedback.difficulty,
                                                menuState.feedback.isInsightful,
                                                menuState.feedback.other,
                                            ].some(Boolean)) {
                                                mutateMenuState({ page: { $set: 2 } });
                                            }
                                        }
                                    } }) })) }))] })), menuState.page === 1 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [menuState.choices.difficulty && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].subtitle }, { children: "Difficulty level" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].options }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "hard", checked: menuState.feedback.difficulty === "too-hard", onChange: function (e) {
                                                        return mutateMenuState({
                                                            feedback: {
                                                                difficulty: {
                                                                    $set: e.target.checked ? "too-hard" : undefined,
                                                                },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "hard" }, { children: "This quiz was too hard." }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "easy", checked: menuState.feedback.difficulty === "too-easy", onChange: function (e) {
                                                        return mutateMenuState({
                                                            feedback: {
                                                                difficulty: {
                                                                    $set: e.target.checked ? "too-easy" : undefined,
                                                                },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "easy" }, { children: "This quiz was too easy." }))] }))] }))] })), menuState.choices.questionContent && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].subtitle }, { children: "Question Content" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].options }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "short", checked: menuState.feedback.relavance === "irrelevant", onChange: function (e) {
                                                        return mutateMenuState({
                                                            feedback: {
                                                                relavance: {
                                                                    $set: e.target.checked ? "irrelevant" : undefined,
                                                                },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "short" }, { children: "This question is not relevant." }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "long", checked: menuState.feedback.questionText.noSense, onChange: function (e) {
                                                        return mutateMenuState({
                                                            feedback: {
                                                                questionText: {
                                                                    noSense: { $set: e.target.checked },
                                                                },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "long" }, { children: "This question does not make sense" }))] }))] }))] })), menuState.choices.answerContent && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].subtitle }, { children: "Answer Content" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].options }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "missing", checked: menuState.feedback.answers.hasNoCorrectAnswer, onChange: function (e) {
                                                        return mutateMenuState({ feedback: { answers: { hasNoCorrectAnswer: { $set: e.target.checked } } } });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "missing" }, { children: "There is no correct answer" }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "multiple", checked: menuState.feedback.answers.hasMultipleCorrectAnswers, onChange: function (e) {
                                                        return mutateMenuState({ feedback: { answers: { hasMultipleCorrectAnswers: { $set: e.target.checked } } } });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "multiple" }, { children: "There are multiple correct answers." }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "correct", checked: menuState.feedback.answers.correctIsIncorrect, onChange: function (e) {
                                                        return mutateMenuState({ feedback: { answers: { correctIsIncorrect: { $set: e.target.checked } } } });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "correct" }, { children: "The correct answer is not actually correct." }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "relevant", checked: menuState.feedback.answers.hasIrrelevantAnswer, onChange: function (e) {
                                                        return mutateMenuState({ feedback: { answers: { hasIrrelevantAnswer: { $set: e.target.checked } } } });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "relevant" }, { children: "The answers are not relevant to the content" }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "noSense", checked: menuState.feedback.answers.noSense, onChange: function (e) { return mutateMenuState({ feedback: { answers: { noSense: { $set: e.target.checked } } } }); } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "noSense" }, { children: "The answers do not make sense." }))] }))] }))] })), menuState.choices.other && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].subsubtitle }, { children: "Please explain why you chose \u201COther\u201D:" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", { value: (_c = menuState.feedback.other) !== null && _c !== void 0 ? _c : "", onChange: function (e) { return mutateMenuState({ feedback: { other: { $set: e.target.value } } }); } })] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].continueContainer }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["continue"] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: _assets_continue_png__WEBPACK_IMPORTED_MODULE_9__, alt: "continue", onClick: function () {
                                        mutateMenuState({
                                            page: { $set: 2 },
                                        });
                                    } }) })) }))] })), menuState.page === 2 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].title }, { children: "Thank you for your feedback!" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].endCard, width: "229", height: "143", viewBox: "0 0 229 143", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M113.651 72.6546C116.81 68.2308 137.336 37.9768 122.922 17.6895C115.088 6.66256 98.328 0.720174 73.1049 0.031336C72.3258 0.0103032 71.5248 0.000149113 70.7002 0.000149113C54.4721 0.000149113 22.9703 4.589 7.84909 21.7895C-1.76121 32.7218 -2.55051 46.4791 5.50311 62.6854C17.9759 87.7806 40.5236 88.416 57.0542 88.416C73.3764 88.416 94.3924 84.8095 99.5106 80.5548L123.267 93.8975C123.46 93.9679 123.659 94.0002 123.864 94.0002C124.235 94.0002 124.601 93.8866 124.873 93.6738C125.294 93.3474 125.411 92.8495 125.166 92.4249L113.651 72.6546ZM99.7209 78.1784C99.1061 77.959 98.3829 78.1069 97.978 78.5272C94.8115 81.8349 74.3743 86.1898 57.0573 86.1898C41.419 86.1898 20.0591 85.8034 8.17256 61.8832C0.48065 46.4011 1.1657 33.3364 10.2096 23.0493C22.7872 8.7415 50.3848 2.22817 70.7041 2.22817C71.492 2.22817 72.2595 2.23724 73.0046 2.25827C97.1507 2.92009 113.102 8.47248 120.416 18.7635C134.889 39.1223 111.05 71.7158 110.81 72.0426C110.578 72.3534 110.551 72.7323 110.746 73.0609L120.977 90.63L99.7209 78.1784Z", fill: "#2C2A5D" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M28.2702 31L25.7742 22.36H26.6922L28.7142 29.494L30.7242 22.366L31.6482 22.36L33.6702 29.494L35.6802 22.36H36.6042L34.1142 31H33.2262L31.1862 23.914L29.1582 31H28.2702ZM39.6699 31.18C39.0379 31.18 38.4899 31.04 38.0259 30.76C37.5659 30.48 37.2079 30.086 36.9519 29.578C36.6959 29.07 36.5679 28.474 36.5679 27.79C36.5679 27.082 36.6939 26.47 36.9459 25.954C37.1979 25.438 37.5519 25.04 38.0079 24.76C38.4679 24.48 39.0099 24.34 39.6339 24.34C40.2739 24.34 40.8199 24.488 41.2719 24.784C41.7239 25.076 42.0659 25.496 42.2979 26.044C42.5299 26.592 42.6359 27.246 42.6159 28.006H41.7159V27.694C41.6999 26.854 41.5179 26.22 41.1699 25.792C40.8259 25.364 40.3219 25.15 39.6579 25.15C38.9619 25.15 38.4279 25.376 38.0559 25.828C37.6879 26.28 37.5039 26.924 37.5039 27.76C37.5039 28.576 37.6879 29.21 38.0559 29.662C38.4279 30.11 38.9539 30.334 39.6339 30.334C40.0979 30.334 40.5019 30.228 40.8459 30.016C41.1939 29.8 41.4679 29.49 41.6679 29.086L42.4899 29.404C42.2339 29.968 41.8559 30.406 41.3559 30.718C40.8599 31.026 40.2979 31.18 39.6699 31.18ZM37.1919 28.006V27.268H42.1419V28.006H37.1919ZM43.9474 24.88L44.0014 24.442C44.1614 24.454 44.2774 24.422 44.3494 24.346C44.4214 24.27 44.4654 24.168 44.4814 24.04C44.4974 23.912 44.5014 23.774 44.4934 23.626H43.9474V22.36H44.9734V23.866C44.9734 24.234 44.8794 24.51 44.6914 24.694C44.5074 24.878 44.2594 24.94 43.9474 24.88ZM47.0909 31V22.18H47.9729V31H47.0909ZM49.8916 31V22.18H50.7736V31H49.8916ZM57.4528 31.162C57.0648 31.162 56.7248 31.102 56.4328 30.982C56.1448 30.862 55.8988 30.7 55.6948 30.496C55.4948 30.292 55.3328 30.06 55.2088 29.8C55.0848 29.536 54.9948 29.258 54.9388 28.966C54.8828 28.67 54.8548 28.376 54.8548 28.084V24.52H55.7428V27.826C55.7428 28.182 55.7768 28.512 55.8448 28.816C55.9128 29.12 56.0208 29.386 56.1688 29.614C56.3208 29.838 56.5148 30.012 56.7508 30.136C56.9908 30.26 57.2808 30.322 57.6208 30.322C57.9328 30.322 58.2068 30.268 58.4428 30.16C58.6828 30.052 58.8828 29.898 59.0428 29.698C59.2068 29.494 59.3308 29.248 59.4148 28.96C59.4988 28.668 59.5408 28.34 59.5408 27.976L60.1648 28.114C60.1648 28.778 60.0488 29.336 59.8168 29.788C59.5848 30.24 59.2648 30.582 58.8568 30.814C58.4488 31.046 57.9808 31.162 57.4528 31.162ZM59.6308 31V29.404H59.5408V24.52H60.4228V31H59.6308ZM64.5178 31.174C63.7578 31.174 63.1318 31.01 62.6398 30.682C62.1518 30.354 61.8518 29.898 61.7398 29.314L62.6398 29.164C62.7358 29.532 62.9538 29.826 63.2938 30.046C63.6378 30.262 64.0618 30.37 64.5658 30.37C65.0578 30.37 65.4458 30.268 65.7298 30.064C66.0138 29.856 66.1558 29.574 66.1558 29.218C66.1558 29.018 66.1098 28.856 66.0178 28.732C65.9298 28.604 65.7478 28.486 65.4718 28.378C65.1958 28.27 64.7838 28.142 64.2358 27.994C63.6478 27.834 63.1878 27.674 62.8558 27.514C62.5238 27.354 62.2878 27.17 62.1478 26.962C62.0078 26.75 61.9378 26.492 61.9378 26.188C61.9378 25.82 62.0418 25.498 62.2498 25.222C62.4578 24.942 62.7458 24.726 63.1138 24.574C63.4818 24.418 63.9098 24.34 64.3978 24.34C64.8858 24.34 65.3218 24.42 65.7058 24.58C66.0938 24.736 66.4058 24.956 66.6418 25.24C66.8778 25.524 67.0178 25.854 67.0618 26.23L66.1618 26.392C66.1018 26.012 65.9118 25.712 65.5918 25.492C65.2758 25.268 64.8738 25.152 64.3858 25.144C63.9258 25.132 63.5518 25.22 63.2638 25.408C62.9758 25.592 62.8318 25.838 62.8318 26.146C62.8318 26.318 62.8838 26.466 62.9878 26.59C63.0918 26.71 63.2798 26.824 63.5518 26.932C63.8278 27.04 64.2198 27.158 64.7278 27.286C65.3238 27.438 65.7918 27.598 66.1318 27.766C66.4718 27.934 66.7138 28.132 66.8578 28.36C67.0018 28.588 67.0738 28.87 67.0738 29.206C67.0738 29.818 66.8458 30.3 66.3898 30.652C65.9378 31 65.3138 31.174 64.5178 31.174ZM71.1465 31.18C70.5145 31.18 69.9665 31.04 69.5025 30.76C69.0425 30.48 68.6845 30.086 68.4285 29.578C68.1725 29.07 68.0445 28.474 68.0445 27.79C68.0445 27.082 68.1705 26.47 68.4225 25.954C68.6745 25.438 69.0285 25.04 69.4845 24.76C69.9445 24.48 70.4865 24.34 71.1105 24.34C71.7505 24.34 72.2965 24.488 72.7485 24.784C73.2005 25.076 73.5425 25.496 73.7745 26.044C74.0065 26.592 74.1125 27.246 74.0925 28.006H73.1925V27.694C73.1765 26.854 72.9945 26.22 72.6465 25.792C72.3025 25.364 71.7985 25.15 71.1345 25.15C70.4385 25.15 69.9045 25.376 69.5325 25.828C69.1645 26.28 68.9805 26.924 68.9805 27.76C68.9805 28.576 69.1645 29.21 69.5325 29.662C69.9045 30.11 70.4305 30.334 71.1105 30.334C71.5745 30.334 71.9785 30.228 72.3225 30.016C72.6705 29.8 72.9445 29.49 73.1445 29.086L73.9665 29.404C73.7105 29.968 73.3325 30.406 72.8325 30.718C72.3365 31.026 71.7745 31.18 71.1465 31.18ZM68.6685 28.006V27.268H73.6185V28.006H68.6685ZM81.3543 31C80.9903 31.076 80.6303 31.106 80.2743 31.09C79.9223 31.074 79.6063 30.998 79.3263 30.862C79.0503 30.726 78.8403 30.514 78.6963 30.226C78.5803 29.986 78.5163 29.744 78.5043 29.5C78.4963 29.252 78.4923 28.97 78.4923 28.654V22.72H79.3683V28.618C79.3683 28.89 79.3703 29.118 79.3743 29.302C79.3823 29.482 79.4243 29.642 79.5003 29.782C79.6443 30.05 79.8723 30.21 80.1843 30.262C80.5003 30.314 80.8903 30.302 81.3543 30.226V31ZM77.1063 25.276V24.52H81.3543V25.276H77.1063ZM87.311 31V27.694C87.311 27.334 87.277 27.004 87.209 26.704C87.141 26.4 87.031 26.136 86.879 25.912C86.731 25.684 86.537 25.508 86.297 25.384C86.061 25.26 85.773 25.198 85.433 25.198C85.121 25.198 84.845 25.252 84.605 25.36C84.369 25.468 84.169 25.624 84.005 25.828C83.845 26.028 83.723 26.272 83.639 26.56C83.555 26.848 83.513 27.176 83.513 27.544L82.889 27.406C82.889 26.742 83.005 26.184 83.237 25.732C83.469 25.28 83.789 24.938 84.197 24.706C84.605 24.474 85.073 24.358 85.601 24.358C85.989 24.358 86.327 24.418 86.615 24.538C86.907 24.658 87.153 24.82 87.353 25.024C87.557 25.228 87.721 25.462 87.845 25.726C87.969 25.986 88.059 26.264 88.115 26.56C88.171 26.852 88.199 27.144 88.199 27.436V31H87.311ZM82.625 31V22.36H83.423V27.238H83.513V31H82.625ZM89.876 23.29V22.3H90.758V23.29H89.876ZM89.876 31V24.52H90.758V31H89.876ZM94.9748 31.174C94.2148 31.174 93.5888 31.01 93.0968 30.682C92.6088 30.354 92.3088 29.898 92.1968 29.314L93.0968 29.164C93.1928 29.532 93.4108 29.826 93.7508 30.046C94.0948 30.262 94.5188 30.37 95.0228 30.37C95.5148 30.37 95.9028 30.268 96.1868 30.064C96.4708 29.856 96.6128 29.574 96.6128 29.218C96.6128 29.018 96.5668 28.856 96.4748 28.732C96.3868 28.604 96.2048 28.486 95.9288 28.378C95.6528 28.27 95.2408 28.142 94.6928 27.994C94.1048 27.834 93.6448 27.674 93.3128 27.514C92.9808 27.354 92.7448 27.17 92.6048 26.962C92.4648 26.75 92.3948 26.492 92.3948 26.188C92.3948 25.82 92.4988 25.498 92.7068 25.222C92.9148 24.942 93.2028 24.726 93.5708 24.574C93.9388 24.418 94.3668 24.34 94.8548 24.34C95.3428 24.34 95.7788 24.42 96.1628 24.58C96.5508 24.736 96.8628 24.956 97.0988 25.24C97.3348 25.524 97.4748 25.854 97.5188 26.23L96.6188 26.392C96.5588 26.012 96.3688 25.712 96.0488 25.492C95.7328 25.268 95.3308 25.152 94.8428 25.144C94.3828 25.132 94.0088 25.22 93.7208 25.408C93.4328 25.592 93.2888 25.838 93.2888 26.146C93.2888 26.318 93.3408 26.466 93.4448 26.59C93.5488 26.71 93.7368 26.824 94.0088 26.932C94.2848 27.04 94.6768 27.158 95.1848 27.286C95.7808 27.438 96.2488 27.598 96.5888 27.766C96.9288 27.934 97.1708 28.132 97.3148 28.36C97.4588 28.588 97.5308 28.87 97.5308 29.206C97.5308 29.818 97.3028 30.3 96.8468 30.652C96.3948 31 95.7708 31.174 94.9748 31.174ZM30.7586 47C30.3946 47.076 30.0346 47.106 29.6786 47.09C29.3266 47.074 29.0106 46.998 28.7306 46.862C28.4546 46.726 28.2446 46.514 28.1006 46.226C27.9846 45.986 27.9206 45.744 27.9086 45.5C27.9006 45.252 27.8966 44.97 27.8966 44.654V38.72H28.7726V44.618C28.7726 44.89 28.7746 45.118 28.7786 45.302C28.7866 45.482 28.8286 45.642 28.9046 45.782C29.0486 46.05 29.2766 46.21 29.5886 46.262C29.9046 46.314 30.2946 46.302 30.7586 46.226V47ZM26.5106 41.276V40.52H30.7586V41.276H26.5106ZM34.5069 47.18C33.8629 47.18 33.3129 47.034 32.8569 46.742C32.4009 46.45 32.0509 46.046 31.8069 45.53C31.5629 45.014 31.4409 44.422 31.4409 43.754C31.4409 43.074 31.5649 42.478 31.8129 41.966C32.0609 41.454 32.4129 41.056 32.8689 40.772C33.3289 40.484 33.8749 40.34 34.5069 40.34C35.1549 40.34 35.7069 40.486 36.1629 40.778C36.6229 41.066 36.9729 41.468 37.2129 41.984C37.4569 42.496 37.5789 43.086 37.5789 43.754C37.5789 44.434 37.4569 45.032 37.2129 45.548C36.9689 46.06 36.6169 46.46 36.1569 46.748C35.6969 47.036 35.1469 47.18 34.5069 47.18ZM34.5069 46.334C35.2269 46.334 35.7629 46.096 36.1149 45.62C36.4669 45.14 36.6429 44.518 36.6429 43.754C36.6429 42.97 36.4649 42.346 36.1089 41.882C35.7569 41.418 35.2229 41.186 34.5069 41.186C34.0229 41.186 33.6229 41.296 33.3069 41.516C32.9949 41.732 32.7609 42.034 32.6049 42.422C32.4529 42.806 32.3769 43.25 32.3769 43.754C32.3769 44.534 32.5569 45.16 32.9169 45.632C33.2769 46.1 33.8069 46.334 34.5069 46.334ZM49.0328 47L49.0388 42.746C49.0388 42.246 48.8988 41.854 48.6188 41.57C48.3428 41.282 47.9908 41.138 47.5628 41.138C47.3188 41.138 47.0808 41.194 46.8488 41.306C46.6168 41.418 46.4248 41.598 46.2728 41.846C46.1248 42.094 46.0508 42.418 46.0508 42.818L45.5288 42.668C45.5168 42.204 45.6068 41.798 45.7988 41.45C45.9948 41.102 46.2628 40.832 46.6028 40.64C46.9468 40.444 47.3348 40.346 47.7668 40.346C48.4188 40.346 48.9408 40.548 49.3328 40.952C49.7248 41.352 49.9208 41.894 49.9208 42.578L49.9148 47H49.0328ZM41.2988 47V40.52H42.0908V42.116H42.1868V47H41.2988ZM45.1748 47L45.1808 42.806C45.1808 42.29 45.0428 41.884 44.7668 41.588C44.4948 41.288 44.1348 41.138 43.6868 41.138C43.2388 41.138 42.8768 41.292 42.6008 41.6C42.3248 41.904 42.1868 42.31 42.1868 42.818L41.6588 42.53C41.6588 42.114 41.7568 41.742 41.9528 41.414C42.1488 41.082 42.4168 40.822 42.7568 40.634C43.0968 40.442 43.4828 40.346 43.9148 40.346C44.3268 40.346 44.6928 40.434 45.0128 40.61C45.3368 40.786 45.5908 41.042 45.7748 41.378C45.9588 41.714 46.0508 42.122 46.0508 42.602L46.0448 47H45.1748ZM53.3307 47.18C52.8427 47.18 52.4327 47.092 52.1007 46.916C51.7727 46.74 51.5267 46.506 51.3627 46.214C51.1987 45.922 51.1167 45.604 51.1167 45.26C51.1167 44.908 51.1867 44.608 51.3267 44.36C51.4707 44.108 51.6647 43.902 51.9087 43.742C52.1567 43.582 52.4427 43.46 52.7667 43.376C53.0947 43.296 53.4567 43.226 53.8527 43.166C54.2527 43.102 54.6427 43.048 55.0227 43.004C55.4067 42.956 55.7427 42.91 56.0307 42.866L55.7187 43.058C55.7307 42.418 55.6067 41.944 55.3467 41.636C55.0867 41.328 54.6347 41.174 53.9907 41.174C53.5467 41.174 53.1707 41.274 52.8627 41.474C52.5587 41.674 52.3447 41.99 52.2207 42.422L51.3627 42.17C51.5107 41.59 51.8087 41.14 52.2567 40.82C52.7047 40.5 53.2867 40.34 54.0027 40.34C54.5947 40.34 55.0967 40.452 55.5087 40.676C55.9247 40.896 56.2187 41.216 56.3907 41.636C56.4707 41.824 56.5227 42.034 56.5467 42.266C56.5707 42.498 56.5827 42.734 56.5827 42.974V47H55.7967V45.374L56.0247 45.47C55.8047 46.026 55.4627 46.45 54.9987 46.742C54.5347 47.034 53.9787 47.18 53.3307 47.18ZM53.4327 46.418C53.8447 46.418 54.2047 46.344 54.5127 46.196C54.8207 46.048 55.0687 45.846 55.2567 45.59C55.4447 45.33 55.5667 45.038 55.6227 44.714C55.6707 44.506 55.6967 44.278 55.7007 44.03C55.7047 43.778 55.7067 43.59 55.7067 43.466L56.0427 43.64C55.7427 43.68 55.4167 43.72 55.0647 43.76C54.7167 43.8 54.3727 43.846 54.0327 43.898C53.6967 43.95 53.3927 44.012 53.1207 44.084C52.9367 44.136 52.7587 44.21 52.5867 44.306C52.4147 44.398 52.2727 44.522 52.1607 44.678C52.0527 44.834 51.9987 45.028 51.9987 45.26C51.9987 45.448 52.0447 45.63 52.1367 45.806C52.2327 45.982 52.3847 46.128 52.5927 46.244C52.8047 46.36 53.0847 46.418 53.4327 46.418ZM58.1387 47L58.1447 38.36H59.0327V43.64L61.9247 40.52H63.1007L60.0647 43.76L63.4967 47H62.2127L59.0327 43.88V47H58.1387ZM66.7226 47.18C66.0906 47.18 65.5426 47.04 65.0786 46.76C64.6186 46.48 64.2606 46.086 64.0046 45.578C63.7486 45.07 63.6206 44.474 63.6206 43.79C63.6206 43.082 63.7466 42.47 63.9986 41.954C64.2506 41.438 64.6046 41.04 65.0606 40.76C65.5206 40.48 66.0626 40.34 66.6866 40.34C67.3266 40.34 67.8726 40.488 68.3246 40.784C68.7766 41.076 69.1186 41.496 69.3506 42.044C69.5826 42.592 69.6886 43.246 69.6686 44.006H68.7686V43.694C68.7526 42.854 68.5706 42.22 68.2226 41.792C67.8786 41.364 67.3746 41.15 66.7106 41.15C66.0146 41.15 65.4806 41.376 65.1086 41.828C64.7406 42.28 64.5566 42.924 64.5566 43.76C64.5566 44.576 64.7406 45.21 65.1086 45.662C65.4806 46.11 66.0066 46.334 66.6866 46.334C67.1506 46.334 67.5546 46.228 67.8986 46.016C68.2466 45.8 68.5206 45.49 68.7206 45.086L69.5426 45.404C69.2866 45.968 68.9086 46.406 68.4086 46.718C67.9126 47.026 67.3506 47.18 66.7226 47.18ZM64.2446 44.006V43.268H69.1946V44.006H64.2446ZM74.3265 49.88L75.5805 46.478L75.5985 47.486L72.7605 40.52H73.6965L76.0245 46.346H75.6405L77.7885 40.52H78.6885L75.2085 49.88H74.3265ZM82.2023 47.18C81.5583 47.18 81.0083 47.034 80.5523 46.742C80.0963 46.45 79.7463 46.046 79.5023 45.53C79.2583 45.014 79.1363 44.422 79.1363 43.754C79.1363 43.074 79.2603 42.478 79.5083 41.966C79.7563 41.454 80.1083 41.056 80.5643 40.772C81.0243 40.484 81.5703 40.34 82.2023 40.34C82.8503 40.34 83.4023 40.486 83.8583 40.778C84.3183 41.066 84.6683 41.468 84.9083 41.984C85.1523 42.496 85.2743 43.086 85.2743 43.754C85.2743 44.434 85.1523 45.032 84.9083 45.548C84.6643 46.06 84.3123 46.46 83.8523 46.748C83.3923 47.036 82.8423 47.18 82.2023 47.18ZM82.2023 46.334C82.9223 46.334 83.4583 46.096 83.8103 45.62C84.1623 45.14 84.3383 44.518 84.3383 43.754C84.3383 42.97 84.1603 42.346 83.8043 41.882C83.4523 41.418 82.9183 41.186 82.2023 41.186C81.7183 41.186 81.3183 41.296 81.0023 41.516C80.6903 41.732 80.4563 42.034 80.3003 42.422C80.1483 42.806 80.0723 43.25 80.0723 43.754C80.0723 44.534 80.2523 45.16 80.6123 45.632C80.9723 46.1 81.5023 46.334 82.2023 46.334ZM89.0758 47.162C88.6878 47.162 88.3478 47.102 88.0558 46.982C87.7678 46.862 87.5218 46.7 87.3178 46.496C87.1178 46.292 86.9558 46.06 86.8318 45.8C86.7078 45.536 86.6178 45.258 86.5618 44.966C86.5058 44.67 86.4778 44.376 86.4778 44.084V40.52H87.3658V43.826C87.3658 44.182 87.3998 44.512 87.4678 44.816C87.5358 45.12 87.6438 45.386 87.7918 45.614C87.9438 45.838 88.1378 46.012 88.3738 46.136C88.6138 46.26 88.9038 46.322 89.2438 46.322C89.5558 46.322 89.8298 46.268 90.0658 46.16C90.3058 46.052 90.5058 45.898 90.6658 45.698C90.8298 45.494 90.9538 45.248 91.0378 44.96C91.1218 44.668 91.1638 44.34 91.1638 43.976L91.7878 44.114C91.7878 44.778 91.6718 45.336 91.4398 45.788C91.2078 46.24 90.8878 46.582 90.4798 46.814C90.0718 47.046 89.6038 47.162 89.0758 47.162ZM91.2538 47V45.404H91.1638V40.52H92.0458V47H91.2538ZM93.7228 47V40.52H94.5148V42.08L94.3588 41.876C94.4308 41.684 94.5248 41.508 94.6408 41.348C94.7568 41.184 94.8828 41.05 95.0188 40.946C95.1868 40.798 95.3828 40.686 95.6068 40.61C95.8308 40.53 96.0568 40.484 96.2848 40.472C96.5128 40.456 96.7208 40.472 96.9088 40.52V41.348C96.6728 41.288 96.4148 41.274 96.1348 41.306C95.8548 41.338 95.5968 41.45 95.3608 41.642C95.1448 41.81 94.9828 42.012 94.8748 42.248C94.7668 42.48 94.6948 42.728 94.6588 42.992C94.6228 43.252 94.6048 43.51 94.6048 43.766V47H93.7228ZM24.7993 63.18C24.1953 63.18 23.6793 63.03 23.2513 62.73C22.8233 62.426 22.4953 62.016 22.2673 61.5C22.0393 60.984 21.9253 60.402 21.9253 59.754C21.9253 59.11 22.0373 58.53 22.2613 58.014C22.4893 57.498 22.8153 57.09 23.2393 56.79C23.6633 56.49 24.1713 56.34 24.7633 56.34C25.3713 56.34 25.8833 56.488 26.2993 56.784C26.7153 57.08 27.0293 57.486 27.2413 58.002C27.4573 58.514 27.5653 59.098 27.5653 59.754C27.5653 60.398 27.4593 60.98 27.2473 61.5C27.0353 62.016 26.7233 62.426 26.3113 62.73C25.8993 63.03 25.3953 63.18 24.7993 63.18ZM24.8893 62.358C25.3493 62.358 25.7293 62.246 26.0293 62.022C26.3293 61.798 26.5533 61.49 26.7013 61.098C26.8493 60.702 26.9233 60.254 26.9233 59.754C26.9233 59.246 26.8493 58.798 26.7013 58.41C26.5533 58.018 26.3293 57.712 26.0293 57.492C25.7333 57.272 25.3593 57.162 24.9073 57.162C24.4433 57.162 24.0593 57.276 23.7553 57.504C23.4513 57.732 23.2253 58.042 23.0773 58.434C22.9333 58.826 22.8613 59.266 22.8613 59.754C22.8613 60.246 22.9353 60.69 23.0833 61.086C23.2353 61.478 23.4613 61.788 23.7613 62.016C24.0613 62.244 24.4373 62.358 24.8893 62.358ZM26.8273 65.88V61.398H26.9233V56.52H27.7153V65.88H26.8273ZM31.8766 63.162C31.4886 63.162 31.1486 63.102 30.8566 62.982C30.5686 62.862 30.3226 62.7 30.1186 62.496C29.9186 62.292 29.7566 62.06 29.6326 61.8C29.5086 61.536 29.4186 61.258 29.3626 60.966C29.3066 60.67 29.2786 60.376 29.2786 60.084V56.52H30.1666V59.826C30.1666 60.182 30.2006 60.512 30.2686 60.816C30.3366 61.12 30.4446 61.386 30.5926 61.614C30.7446 61.838 30.9386 62.012 31.1746 62.136C31.4146 62.26 31.7046 62.322 32.0446 62.322C32.3566 62.322 32.6306 62.268 32.8666 62.16C33.1066 62.052 33.3066 61.898 33.4666 61.698C33.6306 61.494 33.7546 61.248 33.8386 60.96C33.9226 60.668 33.9646 60.34 33.9646 59.976L34.5886 60.114C34.5886 60.778 34.4726 61.336 34.2406 61.788C34.0086 62.24 33.6886 62.582 33.2806 62.814C32.8726 63.046 32.4046 63.162 31.8766 63.162ZM34.0546 63V61.404H33.9646V56.52H34.8466V63H34.0546ZM36.6436 55.29V54.3H37.5256V55.29H36.6436ZM36.6436 63V56.52H37.5256V63H36.6436ZM38.7244 63V62.814L42.9064 57.342H39.0364V56.52H44.3584V56.724L40.1824 62.178H44.1304V63H38.7244ZM45.0759 63V62.814L49.2579 57.342H45.3879V56.52H50.7099V56.724L46.5339 62.178H50.4819V63H45.0759ZM54.289 63.18C53.657 63.18 53.109 63.04 52.645 62.76C52.185 62.48 51.827 62.086 51.571 61.578C51.315 61.07 51.187 60.474 51.187 59.79C51.187 59.082 51.313 58.47 51.565 57.954C51.817 57.438 52.171 57.04 52.627 56.76C53.087 56.48 53.629 56.34 54.253 56.34C54.893 56.34 55.439 56.488 55.891 56.784C56.343 57.076 56.685 57.496 56.917 58.044C57.149 58.592 57.255 59.246 57.235 60.006H56.335V59.694C56.319 58.854 56.137 58.22 55.789 57.792C55.445 57.364 54.941 57.15 54.277 57.15C53.581 57.15 53.047 57.376 52.675 57.828C52.307 58.28 52.123 58.924 52.123 59.76C52.123 60.576 52.307 61.21 52.675 61.662C53.047 62.11 53.573 62.334 54.253 62.334C54.717 62.334 55.121 62.228 55.465 62.016C55.813 61.8 56.087 61.49 56.287 61.086L57.109 61.404C56.853 61.968 56.475 62.406 55.975 62.718C55.479 63.026 54.917 63.18 54.289 63.18ZM51.811 60.006V59.268H56.761V60.006H51.811ZM60.9846 63.174C60.2246 63.174 59.5986 63.01 59.1066 62.682C58.6186 62.354 58.3186 61.898 58.2066 61.314L59.1066 61.164C59.2026 61.532 59.4206 61.826 59.7606 62.046C60.1046 62.262 60.5286 62.37 61.0326 62.37C61.5246 62.37 61.9126 62.268 62.1966 62.064C62.4806 61.856 62.6226 61.574 62.6226 61.218C62.6226 61.018 62.5766 60.856 62.4846 60.732C62.3966 60.604 62.2146 60.486 61.9386 60.378C61.6626 60.27 61.2506 60.142 60.7026 59.994C60.1146 59.834 59.6546 59.674 59.3226 59.514C58.9906 59.354 58.7546 59.17 58.6146 58.962C58.4746 58.75 58.4046 58.492 58.4046 58.188C58.4046 57.82 58.5086 57.498 58.7166 57.222C58.9246 56.942 59.2126 56.726 59.5806 56.574C59.9486 56.418 60.3766 56.34 60.8646 56.34C61.3526 56.34 61.7886 56.42 62.1726 56.58C62.5606 56.736 62.8726 56.956 63.1086 57.24C63.3446 57.524 63.4846 57.854 63.5286 58.23L62.6286 58.392C62.5686 58.012 62.3786 57.712 62.0586 57.492C61.7426 57.268 61.3406 57.152 60.8526 57.144C60.3926 57.132 60.0186 57.22 59.7306 57.408C59.4426 57.592 59.2986 57.838 59.2986 58.146C59.2986 58.318 59.3506 58.466 59.4546 58.59C59.5586 58.71 59.7466 58.824 60.0186 58.932C60.2946 59.04 60.6866 59.158 61.1946 59.286C61.7906 59.438 62.2586 59.598 62.5986 59.766C62.9386 59.934 63.1806 60.132 63.3246 60.36C63.4686 60.588 63.5406 60.87 63.5406 61.206C63.5406 61.818 63.3126 62.3 62.8566 62.652C62.4046 63 61.7806 63.174 60.9846 63.174ZM70.1836 63.18C69.5876 63.18 69.0836 63.03 68.6716 62.73C68.2596 62.426 67.9476 62.016 67.7356 61.5C67.5236 60.98 67.4176 60.398 67.4176 59.754C67.4176 59.098 67.5236 58.514 67.7356 58.002C67.9516 57.486 68.2676 57.08 68.6836 56.784C69.0996 56.488 69.6116 56.34 70.2196 56.34C70.8116 56.34 71.3196 56.49 71.7436 56.79C72.1676 57.09 72.4916 57.498 72.7156 58.014C72.9436 58.53 73.0576 59.11 73.0576 59.754C73.0576 60.402 72.9436 60.984 72.7156 61.5C72.4876 62.016 72.1596 62.426 71.7316 62.73C71.3036 63.03 70.7876 63.18 70.1836 63.18ZM67.2676 63V54.36H68.1556V58.122H68.0596V63H67.2676ZM70.0936 62.358C70.5456 62.358 70.9216 62.244 71.2216 62.016C71.5216 61.788 71.7456 61.478 71.8936 61.086C72.0456 60.69 72.1216 60.246 72.1216 59.754C72.1216 59.266 72.0476 58.826 71.8996 58.434C71.7516 58.042 71.5256 57.732 71.2216 57.504C70.9216 57.276 70.5396 57.162 70.0756 57.162C69.6236 57.162 69.2476 57.272 68.9476 57.492C68.6516 57.712 68.4296 58.018 68.2816 58.41C68.1336 58.798 68.0596 59.246 68.0596 59.754C68.0596 60.254 68.1336 60.702 68.2816 61.098C68.4296 61.49 68.6536 61.798 68.9536 62.022C69.2536 62.246 69.6336 62.358 70.0936 62.358ZM77.1172 63.18C76.4852 63.18 75.9372 63.04 75.4732 62.76C75.0132 62.48 74.6552 62.086 74.3992 61.578C74.1432 61.07 74.0152 60.474 74.0152 59.79C74.0152 59.082 74.1412 58.47 74.3932 57.954C74.6452 57.438 74.9992 57.04 75.4552 56.76C75.9152 56.48 76.4572 56.34 77.0812 56.34C77.7212 56.34 78.2672 56.488 78.7192 56.784C79.1712 57.076 79.5132 57.496 79.7452 58.044C79.9772 58.592 80.0832 59.246 80.0632 60.006H79.1632V59.694C79.1472 58.854 78.9652 58.22 78.6172 57.792C78.2732 57.364 77.7692 57.15 77.1052 57.15C76.4092 57.15 75.8752 57.376 75.5032 57.828C75.1352 58.28 74.9512 58.924 74.9512 59.76C74.9512 60.576 75.1352 61.21 75.5032 61.662C75.8752 62.11 76.4012 62.334 77.0812 62.334C77.5452 62.334 77.9492 62.228 78.2932 62.016C78.6412 61.8 78.9152 61.49 79.1152 61.086L79.9372 61.404C79.6812 61.968 79.3032 62.406 78.8032 62.718C78.3072 63.026 77.7452 63.18 77.1172 63.18ZM74.6392 60.006V59.268H79.5892V60.006H74.6392ZM84.9227 63C84.5587 63.076 84.1987 63.106 83.8427 63.09C83.4907 63.074 83.1747 62.998 82.8947 62.862C82.6187 62.726 82.4087 62.514 82.2647 62.226C82.1487 61.986 82.0847 61.744 82.0727 61.5C82.0647 61.252 82.0607 60.97 82.0607 60.654V54.72H82.9367V60.618C82.9367 60.89 82.9387 61.118 82.9427 61.302C82.9507 61.482 82.9927 61.642 83.0687 61.782C83.2127 62.05 83.4407 62.21 83.7527 62.262C84.0687 62.314 84.4587 62.302 84.9227 62.226V63ZM80.6747 57.276V56.52H84.9227V57.276H80.6747ZM89.0087 63C88.6447 63.076 88.2847 63.106 87.9287 63.09C87.5767 63.074 87.2607 62.998 86.9807 62.862C86.7047 62.726 86.4947 62.514 86.3507 62.226C86.2347 61.986 86.1707 61.744 86.1587 61.5C86.1507 61.252 86.1467 60.97 86.1467 60.654V54.72H87.0227V60.618C87.0227 60.89 87.0247 61.118 87.0287 61.302C87.0367 61.482 87.0787 61.642 87.1547 61.782C87.2987 62.05 87.5267 62.21 87.8387 62.262C88.1547 62.314 88.5447 62.302 89.0087 62.226V63ZM84.7607 57.276V56.52H89.0087V57.276H84.7607ZM93.0312 63.18C92.3992 63.18 91.8512 63.04 91.3872 62.76C90.9272 62.48 90.5692 62.086 90.3132 61.578C90.0572 61.07 89.9292 60.474 89.9292 59.79C89.9292 59.082 90.0552 58.47 90.3072 57.954C90.5592 57.438 90.9132 57.04 91.3692 56.76C91.8292 56.48 92.3712 56.34 92.9952 56.34C93.6352 56.34 94.1812 56.488 94.6332 56.784C95.0852 57.076 95.4272 57.496 95.6592 58.044C95.8912 58.592 95.9972 59.246 95.9772 60.006H95.0772V59.694C95.0612 58.854 94.8792 58.22 94.5312 57.792C94.1872 57.364 93.6832 57.15 93.0192 57.15C92.3232 57.15 91.7892 57.376 91.4172 57.828C91.0492 58.28 90.8652 58.924 90.8652 59.76C90.8652 60.576 91.0492 61.21 91.4172 61.662C91.7892 62.11 92.3152 62.334 92.9952 62.334C93.4592 62.334 93.8632 62.228 94.2072 62.016C94.5552 61.8 94.8292 61.49 95.0292 61.086L95.8512 61.404C95.5952 61.968 95.2172 62.406 94.7172 62.718C94.2212 63.026 93.6592 63.18 93.0312 63.18ZM90.5532 60.006V59.268H95.5032V60.006H90.5532ZM97.3088 63V56.52H98.1008V58.08L97.9448 57.876C98.0168 57.684 98.1108 57.508 98.2268 57.348C98.3428 57.184 98.4688 57.05 98.6048 56.946C98.7728 56.798 98.9688 56.686 99.1928 56.61C99.4168 56.53 99.6428 56.484 99.8708 56.472C100.099 56.456 100.307 56.472 100.495 56.52V57.348C100.259 57.288 100.001 57.274 99.7208 57.306C99.4408 57.338 99.1828 57.45 98.9468 57.642C98.7308 57.81 98.5688 58.012 98.4608 58.248C98.3528 58.48 98.2808 58.728 98.2448 58.992C98.2088 59.252 98.1908 59.51 98.1908 59.766V63H97.3088ZM102.233 63V62.01H103.115V63H102.233ZM102.233 60.84V54.36H103.115V60.84H102.233Z", fill: "#2C2B5E" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M219.317 137.16C219.317 140.362 207.483 142.957 192.883 142.957C178.285 142.957 166.45 140.362 166.45 137.16C166.45 133.961 178.283 131.363 192.883 131.363C207.482 131.362 219.317 133.959 219.317 137.16ZM226.87 118.186C225.595 119.86 221.048 116.035 219.672 115.695C214.907 114.521 213.105 118.637 209.474 120.89C203.776 124.428 201.186 119.791 196.761 116.727C191.9 113.361 189.983 117.271 185.292 117.603C180.86 117.918 179.483 112.735 175.693 111.614C171.555 110.391 167.703 113.24 165.108 115.241C163.431 116.531 159.62 118.768 157.774 116.896C157.509 116.628 158.659 97.256 159.872 79.8979C159.903 76.4991 157.495 70.7047 151.186 67.2882C146.192 64.583 147.284 59.9546 152.96 59.7179C158.637 59.4812 161.207 61.964 161.207 61.964C161.207 61.964 161.213 62.6944 161.399 60.8926C161.828 56.7099 162.258 52.5084 163.012 48.3668C164.615 39.5477 167.025 30.2635 174.528 24.5963C186.129 15.8253 204.707 17.5184 213.742 28.593C222.892 39.8109 224.561 57.1694 225.805 71.0717C227.931 94.8307 228.996 115.402 226.87 118.186L226.87 118.186ZM178.798 50.9722C178.798 45.4392 176.486 43.4778 174.507 43.4778C172.527 43.4778 170.214 45.4392 170.214 50.9722C170.214 51.4259 170.584 51.7974 171.039 51.7974C171.494 51.7974 171.864 51.4259 171.864 50.9722C171.864 46.9342 173.19 45.1269 174.505 45.1269C175.82 45.1269 177.146 46.9342 177.146 50.9722C177.146 51.4259 177.516 51.7974 177.972 51.7974C178.427 51.7974 178.798 51.4259 178.798 50.9722H178.798ZM193.389 51.8715C193.682 47.8609 195.239 46.1305 196.543 46.2351C198.062 46.3479 198.911 48.766 198.657 52.2524C198.624 52.7088 198.967 53.1036 199.42 53.1369C199.441 53.1396 199.462 53.1396 199.481 53.1396C199.91 53.1396 200.272 52.8094 200.304 52.3737C200.707 46.8612 198.687 44.736 196.664 44.5892C194.637 44.445 192.148 46.2302 191.742 51.7506C191.709 52.2043 192.05 52.5992 192.505 52.6351C192.968 52.6719 193.355 52.3251 193.389 51.8714L193.389 51.8715ZM211.437 66.4006C211.437 66.4006 211.118 65.9729 210.422 65.3373C210.082 65.0125 209.648 64.6414 209.105 64.2659C208.592 63.8463 207.926 63.5081 207.217 63.0939C206.477 62.7638 205.668 62.3581 204.752 62.1187C204.29 62.0059 203.816 61.8905 203.33 61.7692C202.846 61.625 202.325 61.6731 201.806 61.6165C201.276 61.6084 200.774 61.5037 200.193 61.5765C199.933 61.6012 199.696 61.6039 199.414 61.6492L198.538 61.8348C197.434 62.1564 196.246 62.7193 195.494 63.8468C194.736 64.9595 194.674 66.5138 195.229 67.6265C195.74 68.7707 196.614 69.5824 197.485 70.2001C197.905 70.4795 198.452 70.7917 198.761 70.9786C199.171 71.2234 199.571 71.4656 199.962 71.6978C200.787 72.1353 201.362 72.6811 201.981 73.1379C202.61 73.5755 203.085 74.1132 203.544 74.5503C203.773 74.7731 203.987 74.9793 204.185 75.1733C204.368 75.3768 204.52 75.5817 204.668 75.7591C205.263 76.4716 205.603 76.8786 205.603 76.8786C205.603 76.8786 205.361 76.4029 204.938 75.5704C204.826 75.367 204.712 75.1302 204.567 74.8854C204.401 74.6545 204.222 74.407 204.029 74.1415C203.634 73.6145 203.233 72.9807 202.612 72.4277C202.027 71.8554 201.402 71.1488 200.646 70.6714C200.279 70.4032 199.902 70.1269 199.516 69.8434C199.135 69.578 198.745 69.3057 198.349 69.0263C197.631 68.476 197.034 67.7609 196.697 66.995C196.342 66.2232 196.437 65.4078 196.868 64.7628C197.276 64.0863 198.113 63.6294 198.975 63.3626L199.615 63.2071C199.838 63.1537 200.115 63.1344 200.36 63.0971C200.792 63.0117 201.302 63.0805 201.76 63.0625C202.704 63.0117 203.601 63.1725 204.461 63.31C204.9 63.3446 205.293 63.5135 205.694 63.6141C206.087 63.735 206.485 63.8149 206.841 63.9578C207.542 64.27 208.231 64.4847 208.78 64.8009C209.349 65.0831 209.84 65.3454 210.225 65.5961C211.015 66.0678 211.437 66.4006 211.437 66.4006V66.4006Z", fill: "#2C2B5E" })] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].continueContainer }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["continue"], onClick: function () {
                                    setFeedback(menuState.feedback);
                                } }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: _assets_continue_png__WEBPACK_IMPORTED_MODULE_9__, alt: "continue" }), "Return"] })) }))] }))] })) })));
};
var useQuestionFeedback = function (questionId, quizId) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), feedback = _a[0], setFeed = _a[1];
    var user = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_4__.AppConfigContext).user;
    var set = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function (feedback) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setFeed(feedback);
                    return [4 /*yield*/, (0,_requests__WEBPACK_IMPORTED_MODULE_10__.setQuestionFeedback)(quizId, questionId, feedback)];
                case 1:
                    result = _b.sent();
                    setFeed((_a = result === null || result === void 0 ? void 0 : result.content) !== null && _a !== void 0 ? _a : null);
                    return [2 /*return*/];
            }
        });
    }); }, [questionId, quizId]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
        if (user.id !== "") {
            (0,_requests__WEBPACK_IMPORTED_MODULE_10__.getQuestionFeedback)(quizId, questionId).then(function (feedback) {
                var _a;
                setFeed((_a = feedback === null || feedback === void 0 ? void 0 : feedback.content) !== null && _a !== void 0 ? _a : null);
            });
        }
    }, [questionId, quizId, user.id]);
    return {
        feedback: feedback,
        setFeedback: set,
    };
};


/***/ }),
/* 168 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(123);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(124);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(169);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),
/* 169 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FeedbackWidget-module__outer {\n  display: flex;\n  flex-direction: column;\n  margin-top: 24px;\n  margin-bottom: -6px;\n  gap: 4px;\n  color: #2c2b5e;\n}\n.FeedbackWidget-module__outer:not(.FeedbackWidget-module__question) {\n  align-items: center;\n  width: min-content;\n  background-color: #273ea5;\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 10px;\n  color: #ffffff;\n  padding: 13px 17px 8px;\n}\n.FeedbackWidget-module__outer:not(.FeedbackWidget-module__question) .FeedbackWidget-module__label {\n  font-weight: 700;\n}\n@media only screen and (max-width: 992px) {\n  .FeedbackWidget-module__outer {\n    margin-top: 8px;\n    margin-bottom: 0;\n  }\n}\n.FeedbackWidget-module__outer .FeedbackWidget-module__label {\n  font-family: Inter, sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 15px;\n  width: max-content;\n}\n.FeedbackWidget-module__outer.FeedbackWidget-module__question .FeedbackWidget-module__inner .FeedbackWidget-module__option {\n  color: grey;\n}\n.FeedbackWidget-module__outer .FeedbackWidget-module__inner {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n}\n.FeedbackWidget-module__outer .FeedbackWidget-module__inner .FeedbackWidget-module__option {\n  border-radius: 4px;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  color: white;\n}\n.FeedbackWidget-module__outer .FeedbackWidget-module__inner .FeedbackWidget-module__option.FeedbackWidget-module__positive:hover, .FeedbackWidget-module__outer .FeedbackWidget-module__inner .FeedbackWidget-module__option.FeedbackWidget-module__positive.FeedbackWidget-module__active {\n  color: #5ac7a8;\n}\n.FeedbackWidget-module__outer .FeedbackWidget-module__inner .FeedbackWidget-module__option.FeedbackWidget-module__negative {\n  transform: rotateZ(180deg);\n}\n.FeedbackWidget-module__outer .FeedbackWidget-module__inner .FeedbackWidget-module__option.FeedbackWidget-module__negative:hover, .FeedbackWidget-module__outer .FeedbackWidget-module__inner .FeedbackWidget-module__option.FeedbackWidget-module__negative.FeedbackWidget-module__active {\n  color: #f15530;\n}\n\n.FeedbackWidget-module__modalOuter {\n  position: fixed;\n  inset: 0 0 0 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(15px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner {\n  position: relative;\n  padding: 31px 38px 21px;\n  width: 453px;\n  background: #ffffff;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner .FeedbackWidget-module__close {\n  position: absolute;\n  width: 12px;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n}\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner .FeedbackWidget-module__title,\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner .FeedbackWidget-module__subtitle,\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner .FeedbackWidget-module__subsubtitle {\n  font-family: Inter, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 19px;\n  color: #2c2b5e;\n}\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner .FeedbackWidget-module__title {\n  margin-bottom: 20px;\n  text-align: center;\n}\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner .FeedbackWidget-module__subtitle {\n  margin-bottom: 15px;\n}\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner .FeedbackWidget-module__subtitle:not(:first-of-type) {\n  margin-top: 30px;\n}\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner .FeedbackWidget-module__subsubtitle {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 15px;\n}\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner textarea {\n  margin-top: 6px;\n  border: 1px solid #2c2b5e;\n  font-family: Inter, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 19px;\n  color: #2c2b5e;\n  height: 57px;\n}\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner svg.FeedbackWidget-module__endCard {\n  margin: 0 auto;\n}\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner .FeedbackWidget-module__options {\n  font-family: Inter, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 17px;\n  /* identical to box height */\n  color: #2c2b5e;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner .FeedbackWidget-module__options .FeedbackWidget-module__option {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner .FeedbackWidget-module__options label {\n  margin-left: 8px;\n}\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner .FeedbackWidget-module__continueContainer {\n  margin: 20px auto 0;\n}\n.FeedbackWidget-module__modalOuter .FeedbackWidget-module__modalInner .FeedbackWidget-module__continueContainer .FeedbackWidget-module__continue {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 9px;\n  font-family: Inter, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 22px;\n  /* identical to box height */\n  color: #2c2b5e;\n  cursor: pointer;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outer": "FeedbackWidget-module__outer",
	"question": "FeedbackWidget-module__question",
	"label": "FeedbackWidget-module__label",
	"inner": "FeedbackWidget-module__inner",
	"option": "FeedbackWidget-module__option",
	"positive": "FeedbackWidget-module__positive",
	"active": "FeedbackWidget-module__active",
	"negative": "FeedbackWidget-module__negative",
	"modalOuter": "FeedbackWidget-module__modalOuter",
	"modalInner": "FeedbackWidget-module__modalInner",
	"close": "FeedbackWidget-module__close",
	"title": "FeedbackWidget-module__title",
	"subtitle": "FeedbackWidget-module__subtitle",
	"subsubtitle": "FeedbackWidget-module__subsubtitle",
	"endCard": "FeedbackWidget-module__endCard",
	"options": "FeedbackWidget-module__options",
	"continueContainer": "FeedbackWidget-module__continueContainer",
	"continue": "FeedbackWidget-module__continue"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 170 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Thumb": () => (/* binding */ Thumb)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Thumb = function (props) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "1200pt", height: "1200pt", version: "1.1", viewBox: "0 0 1200 1200", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m996.21 630.12c16.926-17.191 26.793-40.547 26.793-65.391 0-51.277-41.727-93.004-93.004-93.004h-75c-23.57 0-55.855 0-60.551-5.2578-0.015625-0.035156-1.4805-3.7266 2.6289-16.055 18.535-55.738 28.844-156.14-6.2969-204.87-13.594-18.844-32.887-28.812-55.781-28.812-58.25 0-74.23 43.441-94.461 98.43-12.246 33.289-27.48 74.723-55.797 120.03-43.594 69.66-114.96 83.883-162.46 84.75-3.3945-18.84-19.828-33.207-39.629-33.207l-165.31-0.007813c-22.242 0-40.348 18.105-40.348 40.348v375.32c0 22.242 18.105 40.344 40.348 40.344h165.31c19.5 0 35.809-13.914 39.539-32.328 30.254 0.28906 80.723 4.207 140.5 30.777 59.898 26.625 150.78 42.047 235.23 42.039 74.727 0 144.42-12.086 183.03-39.191 30.844-21.645 35.785-47.605 34.496-65.582-0.85547-12.086-3.4727-22.887-7.793-32.293 9.9688-14.18 15.344-31.121 15.344-48.926 0-19.363-6.4062-37.707-18.004-52.5 11.594-14.785 18.004-33.129 18.004-52.5 0.007812-23.855-10.004-46.23-26.785-62.109zm-609.21 272.27c0 2.3945-1.9492 4.3359-4.3438 4.3359h-165.31c-2.3945 0-4.3438-1.9414-4.3438-4.3359v-375.32c0-2.3945 1.9492-4.3438 4.3438-4.3438h165.31c2.3945 0 4.3438 1.9492 4.3438 4.3438zm571.1-255.12c17.555 7.9922 28.902 25.641 28.902 44.965 0 15.102-6.7109 29.105-18.406 38.414-4.293 3.4141-6.7891 8.5977-6.7969 14.086 0 5.4766 2.4961 10.664 6.7891 14.086 11.703 9.3164 18.414 23.32 18.414 38.414 0 13.074-4.9727 25.305-14.004 34.453-6.2344 6.3203-6.9375 16.246-1.6484 23.371 4.6641 6.2852 7.418 15.016 8.2031 25.957 0.57812 8.1875-0.77734 20.574-19.27 33.551-65.477 45.98-273.05 42.562-382.97-6.2852-65.609-29.156-121.17-33.559-154.3-33.926l-0.003906-318.39c55.648-1.0117 139.91-18.012 192.26-101.68 30.293-48.473 46.246-91.84 59.062-126.69 20.465-55.621 29.145-74.852 60.672-74.852 11.309 0 19.754 4.4023 26.578 13.871 24.031 33.316 20.098 116.06 1.3477 172.43-4.4297 13.281-9.0078 32.746 2.2773 48.406 14.617 20.289 44.523 20.289 89.793 20.289h75c31.43 0 56.996 25.57 56.996 56.996 0 21.012-11.5 40.297-30.016 50.324-6.0078 3.2539-9.6523 9.625-9.418 16.449 0.24219 6.8281 4.3242 12.938 10.539 15.762z", fill: "currentColor" }) }))); };


/***/ }),
/* 171 */
/***/ ((module) => {

"use strict";
module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzciIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNyAzNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBjb2xvcj0iIzQ0NCI+CiAgICA8bGluZSB4MT0iNS4xNjk0NyIgeTE9IjMuNzM0MzgiIHgyPSIzMi43MjUyIiB5Mj0iMzEuMjkwMSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CiAgICA8bGluZSB4MT0iMy44NzE1OCIgeTE9IjMxLjY3MDkiIHgyPSIzMS40MjczIiB5Mj0iNC4xMTUxIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSI3IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";

/***/ }),
/* 172 */
/***/ ((module) => {

"use strict";
module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AYht+mSsVWOthBxCFDdbIgKuKoVShChVArtOpgcukfNDEkKS6OgmvBwZ/FqoOLs64OroIg+APi6OSk6CIlfpcUWsR4x3EP733vy913gNCoMs3qGgM03TYzqaSYy6+IoVeEEaUJhGVmGbOSlIbv+LpHgO93CZ7lX/fn6FMLFgMCIvEMM0ybeJ14atM2OO8Tx1hZVonPiUdNuiDxI9cVj984l1wWeGbMzGbmiGPEYqmDlQ5mZVMjniSOq5pO+ULOY5XzFmetWmOte/IXRgr68hLXaQ0hhQUsQoIIBTVUUIWNBO06KRYydJ708Q+6folcCrkqYOSYxwY0yK4f/A9+99YqTox7SZEk0P3iOB/DQGgXaNYd5/vYcZonQPAZuNLb/o0GMP1Jer2txY+A6DZwcd3WlD3gcgcYeDJkU3alIC2hWATez+ib8kD/LdC76vWtdY7TByBLvUrfAAeHwEiJstd83t3T2bd/a1r9+wHxcHJzO9FFUgAAAAZiS0dEAAAAAAAA+UO7fwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+YLDw8MKcYh4yUAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAC/0lEQVRYw72XT2hcVRTGf999L9qWQlJNRhGpUVTMyzgpCAVdtCUGcWNdVFHT/DMLcaMIcSuK7goFFRcKQttkWrFFia6qJCbgSlwYx8wMdtGWomgyTW0XASHz7ulCVEKMeX+SfKu7uOd83zn3zzlHpMC+zpG25s7mC3LqNNhrpg4wJ+wGqOrxNTPN1Ovl35L6VJJNpe6hYW+Mgh1I5NVs1jl3slIdP5VLQPGh4Sfk/IcG95INlzw2XKuVv11vQ7AueXHoXbAPgD1kxx6hFzvaS0HjamUmUQYOHXozbCxeOi/scTYTxufz9YlnAPvfDOzetXdK0MtmQ3QVCj3FxUbl7LoCitHQMeAoW4fojkLPjsVGZXrNEUTRwGGHvmAbYE2/v3rh9PcA7t9UuPcS2F5z5h8F/sh1GoH7+O+1A3g4GhwxrDOB7W1ewRFn1pdLhCiVooHD/wgweCVFAl/3Un9eETG8CqCurv57AgWXM/g47szOeGkq419hK/GN1jBUS6/hswQx5iWcWV9GEQpofTL0+AeV/T6NeYmQoLdJPAXcnkqBoxgKSjlf1ViTmJCgL70IuytE7Fr9OeYUoXgGoy1prXAi2wVYE4tYbvqVQgpyQGFosJj7m5e9o1jfmHPnU8puOMGVvOTEmibQJLAjnS2/hJhdTNgY/VcEbxFrlkCTZtaW1trH/OCCW8JPs5LLZycHWLquaTc3d/I6Yna7yQ3OLSxMLP9VCzwfbSc5gMx/sqof6I6GLgh7YAO7303Nlxwt43nIMftpvl4ureoHrLkymsD0Tln4ZS5ywMueX9OSNZbmrxQ69u0GHtvSbki8UauVP1u3K+6OBicFT28NvU7M18ZHNxpM1N01eE7iyKZGbjpVrY+PJBpMGlcrZzvae5zEwc0h5+1qfeK11KNZFPXvF8Fpwf0Z3/p3LcQvz9XOzOUaTqNo4KjQc4KnEkTrneyrOOb92s/lDYtTqiLwyH3Ptv6589Y+GUUz7pZoB8yMJcn9isU/umvu68rCxHJSnzcBcX8ymU2VsdIAAAAASUVORK5CYII=";

/***/ }),
/* 173 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_questionTemplating__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(136);
/* harmony import */ var _answers_Fillable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(174);
/* harmony import */ var _answersLists_ClickableAnswerList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(177);
/* harmony import */ var _QuestionFeedbackWidget__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(167);
/* harmony import */ var _questionText_QuestionText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(138);
/* harmony import */ var _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(122);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};








function FillInManager(props) {
    // const initialState = (props.savedAnswers || []).map((ansId: string, index: number) => {
    //     return {
    //         index,
    //         isCorrect: Object.values(props.question.answers).some((blankOptions: any) => {
    //             const node = blankOptions.find((opt: any) => opt.id === ansId);
    //             return node && node.isCorrect;
    //         }),
    //     };
    // });
    var _a, _b;
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), answers = _c[0], setAnswers = _c[1];
    var _d = (0,_hooks_questionTemplating__WEBPACK_IMPORTED_MODULE_2__.useQuestionTemplating)(props.question.question, function (node, blankIndex) {
        var _a, _b, _c;
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_answers_Fillable__WEBPACK_IMPORTED_MODULE_3__["default"], { isFilled: answers.length > blankIndex || props.isLocked, isActive: blankIndex === answers.length, isCorrect: (_a = answers[blankIndex]) === null || _a === void 0 ? void 0 : _a.isCorrect, text: (_c = (_b = props.question.answers[node.answerId].find(function (item) { return item.isCorrect; })) === null || _b === void 0 ? void 0 : _b.text) !== null && _c !== void 0 ? _c : "" }, node.answerId));
    }), question = _d[0], answersIds = _d[1];
    var handleEnd = function (selectedAnswers, scoreData) {
        setAnswers(selectedAnswers);
        props.handleEnd(props.question.id, selectedAnswers.map(function (item) { return item.answerId; }), scoreData);
    };
    var handleClick = function (selectedAnswers) {
        setAnswers(selectedAnswers);
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"].qcard }, { children: [((_a = props.question) === null || _a === void 0 ? void 0 : _a.isDoubleXp) && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"].doubleXp }), props.header && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"]["card-header"] }, { children: props.header })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"]["card-body"] }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: "question-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_questionText_QuestionText__WEBPACK_IMPORTED_MODULE_5__["default"], __assign({ attachmentURL: props.question.attachmentURL, attachmentType: props.question.attachmentType }, { children: question })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: "answers" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_answersLists_ClickableAnswerList__WEBPACK_IMPORTED_MODULE_6__["default"], { isDoubleXp: !!((_b = props.question) === null || _b === void 0 ? void 0 : _b.isDoubleXp), entries: props.question.answers, answersIds: answersIds, handleEnd: handleEnd, handleClick: handleClick, playFeedbackSound: props.playFeedbackSound }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_QuestionFeedbackWidget__WEBPACK_IMPORTED_MODULE_7__.QuestionFeedbackWidget, { questionId: props.question.id, quizId: props.quizId })] }))] })));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FillInManager);


/***/ }),
/* 174 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Fillable_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(175);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



function Fillable(props) {
    var _a, _b;
    var containerClass = classnames__WEBPACK_IMPORTED_MODULE_1___default()(_Fillable_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"].blank, (_a = {},
        _a[_Fillable_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"].active_spot] = props.isActive,
        _a));
    var contentClass = classnames__WEBPACK_IMPORTED_MODULE_1___default()(_Fillable_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"].filled_answer, (_b = {}, _b[_Fillable_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"].incorrect] = !props.isCorrect, _b));
    var displayedValue = props.text;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", __assign({ className: containerClass }, { children: [!props.isFilled && "____________________", props.isFilled && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", __assign({ className: contentClass }, { children: displayedValue }))] })));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Fillable);


/***/ }),
/* 175 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(123);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(124);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_Fillable_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(176);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_Fillable_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_Fillable_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_Fillable_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_Fillable_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),
/* 176 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Fillable-module__blank {\n  position: relative;\n  color: #dce3eb;\n}\n.Fillable-module__blank > * {\n  -webkit-transform: translateZ(0px);\n}\n.Fillable-module__blank.Fillable-module__active_spot {\n  color: #458dff;\n  background: rgba(73, 109, 219, 0.2);\n  border-radius: 4px;\n}\n\n.Fillable-module__filled_answer {\n  color: #379634;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 23.25px;\n  text-align: center;\n  left: 0;\n  width: 100%;\n  top: -6px;\n}\n.Fillable-module__filled_answer.Fillable-module__incorrect {\n  color: black;\n}\n.Fillable-module__filled_answer .Fillable-module__revelation {\n  display: none;\n}\n.Fillable-module__filled_answer.Fillable-module__crossed_out {\n  text-decoration: line-through;\n  text-decoration-style: solid;\n  text-decoration-color: #1a1919;\n  text-decoration-thickness: 22%;\n}\n.Fillable-module__filled_answer:hover .Fillable-module__revelation {\n  width: 15px;\n  height: 15px;\n  background: url(\"https://storage.googleapis.com/staging.retainit.appspot.com/demo-widget/icon_flip.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  top: 1px;\n  right: 0;\n  display: inline-block;\n}\n.Fillable-module__filled_answer .Fillable-module__revelation-container {\n  width: 15px;\n  height: 15px;\n  display: inline-block;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blank": "Fillable-module__blank",
	"active_spot": "Fillable-module__active_spot",
	"filled_answer": "Fillable-module__filled_answer",
	"incorrect": "Fillable-module__incorrect",
	"revelation": "Fillable-module__revelation",
	"crossed_out": "Fillable-module__crossed_out",
	"revelation-container": "Fillable-module__revelation-container"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 177 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_useXpPopAnimation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(142);
/* harmony import */ var _answers_ClickableAnswer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(161);
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};




function ClickableAnswerList(props) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false /*props.savedAnswers !== undefined*/), lockedAnswer = _a[0], setLockedAnswer = _a[1];
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0 /*props.savedAnswers ? props.savedAnswers.length - 1 : 0*/), currentEntryIndex = _b[0], setCurrentEntryIndex = _b[1];
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), selectedAlternative = _c[0], setSelectedAlternative = _c[1];
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false /*props.savedAnswers !== undefined*/), reveal = _d[0], setReveal = _d[1];
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), addedXp = _e[0], setAddedXp = _e[1];
    var _f = (0,_hooks_useXpPopAnimation__WEBPACK_IMPORTED_MODULE_2__.useXpPopAnimation)(), xpPopComponent = _f.xpPopComponent, play = _f.play;
    var maxScore = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () { return props.answersIds.flatMap(function (entryId) { return props.entries[entryId]; }).filter(function (it) { return it.isCorrect; }).length; }, [props.answersIds, props.entries]);
    var handleAlternativeClick = function (userAnswer, x, y) {
        if (reveal && lockedAnswer) {
            return;
        }
        setReveal(true);
        setLockedAnswer(true);
        var newSelection = __spreadArray(__spreadArray([], selectedAlternative, true), [userAnswer], false);
        setSelectedAlternative(newSelection);
        props.handleClick(newSelection);
        var newXp = !userAnswer.isCorrect ? 0 : props.isDoubleXp ? 10 : 5;
        var totalXp = addedXp + newXp;
        setAddedXp(totalXp);
        if (userAnswer.isCorrect) {
            play(newXp, x, y);
        }
        props.playFeedbackSound(userAnswer.isCorrect);
        setTimeout(function () { return moveToNextBlank(newSelection, totalXp); }, 750);
    };
    var moveToNextBlank = function (selections, addedXp) {
        if (currentEntryIndex + 1 >= props.answersIds.length) {
            var score = selections.filter(function (it) { return it.isCorrect; }).length;
            props.handleEnd(selections, { score: score, maxScore: maxScore, addedXp: addedXp });
            return;
        }
        setCurrentEntryIndex(currentEntryIndex + 1);
        setLockedAnswer(false);
        setReveal(false);
    };
    var listOfEntries = props.answersIds.map(function (entryId) {
        return props.entries[entryId].map(function (alternative, index) {
            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_answers_ClickableAnswer__WEBPACK_IMPORTED_MODULE_3__["default"], { index: index, text: alternative.text, isCorrect: alternative.isCorrect, handleClick: function (x, y) {
                    return handleAlternativeClick({
                        index: index,
                        isCorrect: alternative.isCorrect,
                        answerId: alternative.id,
                    }, x, y);
                }, reveal: reveal, locked: lockedAnswer, allowToggle: false, wasAlreadySelected: false /*props.savedAnswers ? props.savedAnswers.findIndex((item: string) => item === alternative.id) > -1 : false*/ }, "".concat(entryId, "_").concat(index)));
        });
    });
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [xpPopComponent, listOfEntries[currentEntryIndex]] }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ClickableAnswerList);


/***/ }),
/* 178 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _requests__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
/* harmony import */ var _hooks_questionTemplating__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(136);
/* harmony import */ var _answersLists_WritableAnswerList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(179);
/* harmony import */ var _QuestionFeedbackWidget__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(167);
/* harmony import */ var _questionText_QuestionText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(138);
/* harmony import */ var _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(122);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};







function WritableAnswersCard(props) {
    var _a, _b;
    var question = (0,_hooks_questionTemplating__WEBPACK_IMPORTED_MODULE_1__.useQuestionTemplating)(props.question.question, undefined)[0];
    var handleEnd = function (selectedAnswers, scoreData) {
        props.handleEnd(props.question.id, selectedAnswers, scoreData);
    };
    var logRevealAction = function () {
        (0,_requests__WEBPACK_IMPORTED_MODULE_2__.logMetrics)({
            eventName: "showAnswer",
            fullLink: window.location.href,
            hostname: new URL(window.location.href).host,
            value: { questionId: props.question.id, questionType: props.question.type },
        });
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_3__["default"].qcard }, { children: [((_a = props.question) === null || _a === void 0 ? void 0 : _a.isDoubleXp) && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_3__["default"].doubleXp }), props.header && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_3__["default"]["card-header"] }, { children: props.header })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_3__["default"]["card-body"] }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: "question-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_questionText_QuestionText__WEBPACK_IMPORTED_MODULE_4__["default"], __assign({ attachmentURL: props.question.attachmentURL, attachmentType: props.question.attachmentType }, { children: question })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: "answers" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_answersLists_WritableAnswerList__WEBPACK_IMPORTED_MODULE_5__["default"], { entries: props.question.answers, handleEnd: handleEnd, savedAnswers: props.savedAnswers, logRevealAction: logRevealAction, playFeedbackSound: props.playFeedbackSound, isDoubleXp: !!((_b = props.question) === null || _b === void 0 ? void 0 : _b.isDoubleXp) }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_QuestionFeedbackWidget__WEBPACK_IMPORTED_MODULE_6__.QuestionFeedbackWidget, { questionId: props.question.id, quizId: props.quizId })] }))] })));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WritableAnswersCard);


/***/ }),
/* 179 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useXpPopAnimation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(142);
/* harmony import */ var _utils_answerLeniencyMatch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(180);
/* harmony import */ var _answers_Writable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(182);
/* harmony import */ var _Navigation_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(200);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};







function WritableAnswerList(props) {
    var _a;
    var _b, _c, _d;
    var validAnswers = Object.values(props.entries[0]);
    var computedCorrectness = !!((_b = props === null || props === void 0 ? void 0 : props.savedAnswers) === null || _b === void 0 ? void 0 : _b.isCorrect);
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(props.savedAnswers !== undefined), isLocked = _e[0], setIsLocked = _e[1];
    var _f = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(computedCorrectness), isCorrect = _f[0], setIsCorrect = _f[1];
    var _g = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), userAnswer = _g[0], setUserAnswer = _g[1];
    var _h = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), reveal = _h[0], setReveal = _h[1];
    var _j = (0,_hooks_useXpPopAnimation__WEBPACK_IMPORTED_MODULE_3__.useXpPopAnimation)(), xpPopComponent = _j.xpPopComponent, play = _j.play;
    var handleUserAnswer = function (event) {
        setUserAnswer(event.target.value);
    };
    var handleCheck = function (x, y) {
        setIsLocked(true);
        var result = (0,_utils_answerLeniencyMatch__WEBPACK_IMPORTED_MODULE_4__.answerLeniencyMatch)(userAnswer, validAnswers);
        setIsCorrect(result.isCorrect);
        var addedXp = !result.isCorrect ? 0 : props.isDoubleXp ? 10 : 5;
        if (result.isCorrect) {
            play(addedXp, x, y);
        }
        props.playFeedbackSound(result.isCorrect);
        props.handleEnd({ text: userAnswer, isCorrect: result.isCorrect, id: result.id }, { score: result ? 1 : 0, maxScore: 1, addedXp: addedXp });
    };
    var handleShowCorrect = function () {
        if (!reveal) {
            props.logRevealAction();
        }
        setReveal(!reveal);
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [xpPopComponent, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_answers_Writable__WEBPACK_IMPORTED_MODULE_5__["default"], { userAnswer: userAnswer, handleUserAnswer: handleUserAnswer, isCorrect: isCorrect, handleCheck: function () { return handleCheck(100, 100); }, savedAnswers: (_d = (_c = props.savedAnswers) === null || _c === void 0 ? void 0 : _c.text) !== null && _d !== void 0 ? _d : "", isLocked: isLocked, reveal: reveal, correctAnswer: validAnswers[0].text }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _Navigation_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"]["bottom-btn-container"] }, { children: [!isLocked && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"]["check-btn"], (_a = {},
                            _a[_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].disabled] = !userAnswer,
                            _a)), onClick: function (event) { return handleCheck(event.pageX, event.pageY); } }, { children: "Check" }))), isLocked && !isCorrect && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _Navigation_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"]["check-btn"], onClick: handleShowCorrect }, { children: [reveal ? "Show my answer" : "Show correct answer", " "] })))] }))] }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WritableAnswerList);


/***/ }),
/* 180 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "answerLeniencyMatch": () => (/* binding */ answerLeniencyMatch)
/* harmony export */ });
/* harmony import */ var number_to_words__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(181);
/* harmony import */ var number_to_words__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(number_to_words__WEBPACK_IMPORTED_MODULE_0__);

function answerLeniencyMatch(userString, correctStrings) {
    var punctuationRegEx = /[ !-/:-@[-`{-~¡-©«-¬®-±´¶-¸»¿×÷˂-˅˒-˟˥-˫˭˯-˿͵;΄-΅·϶҂՚-՟։-֊־׀׃׆׳-״؆-؏؛؞-؟٪-٭۔۩۽-۾܀-܍߶-߹।-॥॰৲-৳৺૱୰௳-௺౿ೱ-ೲ൹෴฿๏๚-๛༁-༗༚-༟༴༶༸༺-༽྅྾-࿅࿇-࿌࿎-࿔၊-၏႞-႟჻፠-፨᎐-᎙᙭-᙮᚛-᚜᛫-᛭᜵-᜶។-៖៘-៛᠀-᠊᥀᥄-᥅᧞-᧿᨞-᨟᭚-᭪᭴-᭼᰻-᰿᱾-᱿᾽᾿-῁῍-῏῝-῟῭-`´-῾\u2000-\u206e⁺-⁾₊-₎₠-₵℀-℁℃-℆℈-℉℔№-℘℞-℣℥℧℩℮℺-℻⅀-⅄⅊-⅍⅏←-⏧␀-␦⑀-⑊⒜-ⓩ─-⚝⚠-⚼⛀-⛃✁-✄✆-✉✌-✧✩-❋❍❏-❒❖❘-❞❡-❵➔➘-➯➱-➾⟀-⟊⟌⟐-⭌⭐-⭔⳥-⳪⳹-⳼⳾-⳿⸀-\u2e7e⺀-⺙⺛-⻳⼀-⿕⿰-⿻\u3000-〿゛-゜゠・㆐-㆑㆖-㆟㇀-㇣㈀-㈞㈪-㉃㉐㉠-㉿㊊-㊰㋀-㋾㌀-㏿䷀-䷿꒐-꓆꘍-꘏꙳꙾꜀-꜖꜠-꜡꞉-꞊꠨-꠫꡴-꡷꣎-꣏꤮-꤯꥟꩜-꩟﬩﴾-﴿﷼-﷽︐-︙︰-﹒﹔-﹦﹨-﹫！-／：-＠［-｀｛-･￠-￦￨-￮￼-�]|\ud800[\udd00-\udd02\udd37-\udd3f\udd79-\udd89\udd90-\udd9b\uddd0-\uddfc\udf9f\udfd0]|\ud802[\udd1f\udd3f\ude50-\ude58]|\ud809[\udc00-\udc7e]|\ud834[\udc00-\udcf5\udd00-\udd26\udd29-\udd64\udd6a-\udd6c\udd83-\udd84\udd8c-\udda9\uddae-\udddd\ude00-\ude41\ude45\udf00-\udf56]|\ud835[\udec1\udedb\udefb\udf15\udf35\udf4f\udf6f\udf89\udfa9\udfc3]|\ud83c[\udc00-\udc2b\udc30-\udc93]/g;
    var sanitise = function (value) {
        return value
            .trim()
            .toLowerCase()
            .replace(punctuationRegEx, "")
            .replace(/(\s){2,}/g, "$1");
    };
    var enumerateCorrectStrings = function (value) {
        var numberOfValue = Number(value.text);
        if (!isNaN(numberOfValue)) {
            return [
                { text: value.text, id: value.id },
                { text: (0,number_to_words__WEBPACK_IMPORTED_MODULE_0__.toWords)(numberOfValue), id: value.id },
            ];
        }
        else {
            return [value];
        }
    };
    var sanitisedUserString = sanitise(userString);
    var correctStringsExpanded = correctStrings.map(function (cString) {
        return enumerateCorrectStrings({
            text: sanitise(cString.text),
            id: cString.id,
        });
    });
    var result = correctStringsExpanded.find(function (cStringList) { return cStringList.some(function (item) { return item.text === sanitisedUserString; }); });
    return {
        isCorrect: result !== undefined,
        id: result && result[0].id,
    };
}


/***/ }),
/* 181 */
/***/ ((module, exports, __webpack_require__) => {

/*!
 * Number-To-Words util
 * @version v1.2.4
 * @link https://github.com/marlun78/number-to-words
 * @author Martin Eneqvist (https://github.com/marlun78)
 * @contributors Aleksey Pilyugin (https://github.com/pilyugin),Jeremiah Hall (https://github.com/jeremiahrhall),Adriano Melo (https://github.com/adrianomelo),dmrzn (https://github.com/dmrzn)
 * @license MIT
 */
!function(){"use strict";var e="object"==typeof self&&self.self===self&&self||"object"==typeof __webpack_require__.g&&__webpack_require__.g.global===__webpack_require__.g&&__webpack_require__.g||this,t=9007199254740991;function f(e){return!("number"!=typeof e||e!=e||e===1/0||e===-1/0)}function l(e){return"number"==typeof e&&Math.abs(e)<=t}var n=/(hundred|thousand|(m|b|tr|quadr)illion)$/,r=/teen$/,o=/y$/,i=/(zero|one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)$/,s={zero:"zeroth",one:"first",two:"second",three:"third",four:"fourth",five:"fifth",six:"sixth",seven:"seventh",eight:"eighth",nine:"ninth",ten:"tenth",eleven:"eleventh",twelve:"twelfth"};function h(e){return n.test(e)||r.test(e)?e+"th":o.test(e)?e.replace(o,"ieth"):i.test(e)?e.replace(i,a):e}function a(e,t){return s[t]}var u=10,d=100,p=1e3,v=1e6,b=1e9,y=1e12,c=1e15,g=9007199254740992,m=["zero","one","two","three","four","five","six","seven","eight","nine","ten","eleven","twelve","thirteen","fourteen","fifteen","sixteen","seventeen","eighteen","nineteen"],w=["zero","ten","twenty","thirty","forty","fifty","sixty","seventy","eighty","ninety"];function x(e,t){var n,r=parseInt(e,10);if(!f(r))throw new TypeError("Not a finite number: "+e+" ("+typeof e+")");if(!l(r))throw new RangeError("Input is not a safe number, it’s either too large or too small.");return n=function e(t){var n,r,o=arguments[1];if(0===t)return o?o.join(" ").replace(/,$/,""):"zero";o||(o=[]);t<0&&(o.push("minus"),t=Math.abs(t));t<20?(n=0,r=m[t]):t<d?(n=t%u,r=w[Math.floor(t/u)],n&&(r+="-"+m[n],n=0)):t<p?(n=t%d,r=e(Math.floor(t/d))+" hundred"):t<v?(n=t%p,r=e(Math.floor(t/p))+" thousand,"):t<b?(n=t%v,r=e(Math.floor(t/v))+" million,"):t<y?(n=t%b,r=e(Math.floor(t/b))+" billion,"):t<c?(n=t%y,r=e(Math.floor(t/y))+" trillion,"):t<=g&&(n=t%c,r=e(Math.floor(t/c))+" quadrillion,");o.push(r);return e(n,o)}(r),t?h(n):n}var M={toOrdinal:function(e){var t=parseInt(e,10);if(!f(t))throw new TypeError("Not a finite number: "+e+" ("+typeof e+")");if(!l(t))throw new RangeError("Input is not a safe number, it’s either too large or too small.");var n=String(t),r=Math.abs(t%100),o=11<=r&&r<=13,i=n.charAt(n.length-1);return n+(o?"th":"1"===i?"st":"2"===i?"nd":"3"===i?"rd":"th")},toWords:x,toWordsOrdinal:function(e){return h(x(e))}}; true?( true&&module.exports&&(exports=module.exports=M),exports.numberToWords=M):0}();

/***/ }),
/* 182 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(185);
/* harmony import */ var _Writable_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(183);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




function Writable(props) {
    var _a;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_1___default()(_Writable_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"].answer, (_a = {},
        _a[_Writable_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"].success] = props.isLocked && props.isCorrect,
        _a[_Writable_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"].fail] = !props.reveal && props.isLocked && !props.isCorrect,
        _a[_Writable_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"].neutral] = props.reveal && props.isLocked && !props.isCorrect,
        _a));
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [!props.isLocked && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__["default"], { as: "textarea", rows: 7, className: _Writable_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"].writable, placeholder: "Write your answer...", value: props.userAnswer, onChange: props.handleUserAnswer, onKeyUp: function (e) {
                    if (e.key === "Enter") {
                        props.handleCheck();
                    }
                }, autoFocus: true })), props.isLocked && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: classes }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _Writable_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"].word }, { children: props.reveal ? props.correctAnswer : props.savedAnswers ? props.savedAnswers : props.userAnswer })) })))] }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Writable);


/***/ }),
/* 183 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(123);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(124);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_Writable_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(184);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_Writable_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_Writable_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_Writable_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_Writable_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),
/* 184 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Writable-module__writable {\n  caret-color: #356dff;\n  padding: 18px !important;\n  margin-bottom: 18px !important;\n  font-size: 13px !important;\n  line-height: 24px !important;\n  border-radius: 10px !important;\n  font-family: Manrope, sans-serif !important;\n}\n.Writable-module__writable:focus {\n  color: #212529;\n  background-color: #fff;\n  border-color: #f2cf54;\n  outline: 0;\n  box-shadow: unset !important;\n  caret-color: #356dff;\n}\n\n.Writable-module__answer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 18px;\n  min-height: 56px;\n  height: auto;\n  background: rgba(255, 255, 255, 0.6);\n  border: 1px solid rgba(73, 109, 219, 0.1);\n  border-radius: 7.5px;\n  margin-bottom: 24px;\n  position: relative;\n}\n.Writable-module__answer > * {\n  -webkit-transform: translateZ(0px);\n}\n.Writable-module__answer.Writable-module__success {\n  background-color: #bde5c1;\n  border: 1px solid #3caa46;\n}\n.Writable-module__answer.Writable-module__success .Writable-module__word {\n  background: #bde5c1;\n}\n.Writable-module__answer.Writable-module__success .Writable-module__result-text {\n  color: #3caa46;\n}\n.Writable-module__answer.Writable-module__fail {\n  background: #ebeff3;\n  border: 1px solid #d5dce4;\n}\n.Writable-module__answer.Writable-module__fail .Writable-module__word {\n  color: #707682;\n}\n.Writable-module__answer.Writable-module__neutral {\n  background: #fff;\n  border: 1px solid #000;\n}\n\n.Writable-module__result-text {\n  right: 18px;\n  position: absolute;\n}\n\n.Writable-module__word {\n  padding: 4.5px 30px 4.5px 4.5px;\n  min-height: 32.25px;\n  height: auto;\n  margin-left: 9px;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 24px;\n  color: #191c22;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"writable": "Writable-module__writable",
	"answer": "Writable-module__answer",
	"success": "Writable-module__success",
	"word": "Writable-module__word",
	"result-text": "Writable-module__result-text",
	"fail": "Writable-module__fail",
	"neutral": "Writable-module__neutral"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 185 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var warning__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(186);
/* harmony import */ var warning__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(warning__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Feedback__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(189);
/* harmony import */ var _FormContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(187);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(188);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);








const FormControl = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  type,
  size,
  htmlSize,
  id,
  className,
  isValid = false,
  isInvalid = false,
  plaintext,
  readOnly,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'input',
  ...props
}, ref) => {
  const {
    controlId
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_FormContext__WEBPACK_IMPORTED_MODULE_4__["default"]);
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_5__.useBootstrapPrefix)(bsPrefix, 'form-control');
  let classes;

  if (plaintext) {
    classes = {
      [`${bsPrefix}-plaintext`]: true
    };
  } else {
    classes = {
      [bsPrefix]: true,
      [`${bsPrefix}-${size}`]: size
    };
  }

  process.env.NODE_ENV !== "production" ? warning__WEBPACK_IMPORTED_MODULE_2___default()(controlId == null || !id, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Component, { ...props,
    type: type,
    size: htmlSize,
    ref: ref,
    readOnly: readOnly,
    id: id || controlId,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, classes, isValid && `is-valid`, isInvalid && `is-invalid`, type === 'color' && `${bsPrefix}-color`)
  });
});
FormControl.displayName = 'FormControl';
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Object.assign(FormControl, {
  Feedback: _Feedback__WEBPACK_IMPORTED_MODULE_6__["default"]
}));

/***/ }),
/* 186 */
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 187 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // TODO

const FormContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FormContext);

/***/ }),
/* 188 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DEFAULT_BREAKPOINTS": () => (/* binding */ DEFAULT_BREAKPOINTS),
/* harmony export */   "DEFAULT_MIN_BREAKPOINT": () => (/* binding */ DEFAULT_MIN_BREAKPOINT),
/* harmony export */   "ThemeConsumer": () => (/* binding */ Consumer),
/* harmony export */   "createBootstrapComponent": () => (/* binding */ createBootstrapComponent),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "useBootstrapBreakpoints": () => (/* binding */ useBootstrapBreakpoints),
/* harmony export */   "useBootstrapMinBreakpoint": () => (/* binding */ useBootstrapMinBreakpoint),
/* harmony export */   "useBootstrapPrefix": () => (/* binding */ useBootstrapPrefix),
/* harmony export */   "useIsRTL": () => (/* binding */ useIsRTL)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);



const DEFAULT_BREAKPOINTS = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
const DEFAULT_MIN_BREAKPOINT = 'xs';
const ThemeContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  prefixes: {},
  breakpoints: DEFAULT_BREAKPOINTS,
  minBreakpoint: DEFAULT_MIN_BREAKPOINT
});
const {
  Consumer,
  Provider
} = ThemeContext;

function ThemeProvider({
  prefixes = {},
  breakpoints = DEFAULT_BREAKPOINTS,
  minBreakpoint = DEFAULT_MIN_BREAKPOINT,
  dir,
  children
}) {
  const contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({
    prefixes: { ...prefixes
    },
    breakpoints,
    minBreakpoint,
    dir
  }), [prefixes, breakpoints, minBreakpoint, dir]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Provider, {
    value: contextValue,
    children: children
  });
}

function useBootstrapPrefix(prefix, defaultPrefix) {
  const {
    prefixes
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function useBootstrapBreakpoints() {
  const {
    breakpoints
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return breakpoints;
}
function useBootstrapMinBreakpoint() {
  const {
    minBreakpoint
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return minBreakpoint;
}
function useIsRTL() {
  const {
    dir
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return dir === 'rtl';
}

function createBootstrapComponent(Component, opts) {
  if (typeof opts === 'string') opts = {
    prefix: opts
  };
  const isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref

  const {
    prefix,
    forwardRefAs = isClassy ? 'ref' : 'innerRef'
  } = opts;
  const Wrapped = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ ...props
  }, ref) => {
    props[forwardRefAs] = ref;
    const bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Component, { ...props,
      bsPrefix: bsPrefix
    });
  });
  Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
  return Wrapped;
}


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ThemeProvider);

/***/ }),
/* 189 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(190);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);




const propTypes = {
  /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */
  type: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),

  /** Display feedback as a tooltip. */
  tooltip: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
  as: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().elementType)
};
const Feedback = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  as: Component = 'div',
  className,
  type = 'valid',
  tooltip = false,
  ...props
}, ref) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, { ...props,
  ref: ref,
  className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
}));
Feedback.displayName = 'Feedback';
Feedback.propTypes = propTypes;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Feedback);

/***/ }),
/* 190 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = __webpack_require__(191);

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(194)(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(199)();
}


/***/ }),
/* 191 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (process.env.NODE_ENV === 'production') {
  module.exports = __webpack_require__(192);
} else {
  module.exports = __webpack_require__(193);
}


/***/ }),
/* 192 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 193 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (process.env.NODE_ENV !== "production") {
  (function() {
'use strict';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}


/***/ }),
/* 194 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(191);
var assign = __webpack_require__(195);

var ReactPropTypesSecret = __webpack_require__(196);
var has = __webpack_require__(197);
var checkPropTypes = __webpack_require__(198);

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 195 */
/***/ ((module) => {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 196 */
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 197 */
/***/ ((module) => {

module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),
/* 198 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = __webpack_require__(196);
  var loggedTypeFailures = {};
  var has = __webpack_require__(197);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 199 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(196);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 200 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(123);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(124);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(201);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),
/* 201 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Navigation-module__bottom-btn-container {\n  height: 45px;\n}\n.Navigation-module__bottom-btn-container .Navigation-module__check-btn {\n  border-radius: 44px;\n  box-shadow: 0px 4px 14px rgba(73, 109, 219, 0.2);\n  width: fit-content;\n  min-width: 110px;\n  height: 45px;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 15px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 13px 75px;\n  cursor: pointer;\n  margin: 0 20px;\n  left: 0;\n  right: 0;\n  border: 2px solid rgba(53, 109, 255, 0.2);\n  color: #356dff;\n  background-color: #fff;\n  padding: 13px 30px;\n  margin: 0 auto;\n}\n.Navigation-module__bottom-btn-container .Navigation-module__check-btn.Navigation-module__disabled {\n  display: none;\n}\n\n.Navigation-module__continue-btn {\n  border-radius: 44px;\n  box-shadow: 0px 4px 14px rgba(73, 109, 219, 0.2);\n  width: fit-content;\n  min-width: 110px;\n  height: 45px;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 15px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 13px 75px;\n  cursor: pointer;\n  margin: 0 20px;\n  left: 0;\n  right: 0;\n  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2), 0 5px 8px rgba(0, 0, 0, 0.1);\n  border: 2px solid rgba(53, 109, 255, 0.2);\n  background-color: #5ac7a8;\n  color: white;\n  border-radius: 8px;\n  padding: 13px 75px;\n  font-size: 16px;\n  font-weight: 600;\n  font-family: Manrope, serif;\n  margin: 0 auto 5vh;\n}\n.Navigation-module__continue-btn.Navigation-module__disabled {\n  background-color: white;\n  color: #2c2b5e;\n  cursor: not-allowed;\n}\n\n@media only screen and (min-width: 992px) {\n  .Navigation-module__continue-btn {\n    padding: 13px 30px;\n  }\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bottom-btn-container": "Navigation-module__bottom-btn-container",
	"check-btn": "Navigation-module__check-btn",
	"disabled": "Navigation-module__disabled",
	"continue-btn": "Navigation-module__continue-btn"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 202 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _hooks_questionTemplating__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(136);
/* harmony import */ var _answersLists_MatchingAnswersList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(203);
/* harmony import */ var _QuestionFeedbackWidget__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(167);
/* harmony import */ var _questionText_QuestionText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(138);
/* harmony import */ var _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(122);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};






function MatchingQuestionCard(props) {
    var _a, _b;
    var question = (0,_hooks_questionTemplating__WEBPACK_IMPORTED_MODULE_1__.useQuestionTemplating)(props.question.question, undefined)[0];
    var handleEnd = function (selectedAnswers, scoreData) {
        // all answered
        if (scoreData.maxScore === selectedAnswers.filter(function (it) { return it === null || it === void 0 ? void 0 : it.isCorrect; }).length) {
            props.handleEnd(props.question.id, selectedAnswers, scoreData);
        }
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"].qcard }, { children: [((_a = props.question) === null || _a === void 0 ? void 0 : _a.isDoubleXp) && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"].doubleXp }), props.header && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"]["card-header"] }, { children: props.header })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _CardsFull_module_scss__WEBPACK_IMPORTED_MODULE_2__["default"]["card-body"] }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: "question-container" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_questionText_QuestionText__WEBPACK_IMPORTED_MODULE_3__["default"], __assign({ attachmentURL: props.question.attachmentURL, attachmentType: props.question.attachmentType }, { children: question })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: "answers" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_answersLists_MatchingAnswersList__WEBPACK_IMPORTED_MODULE_4__["default"], { isDoubleXp: !!((_b = props.question) === null || _b === void 0 ? void 0 : _b.isDoubleXp), answers: props.question.answers, handleEnd: handleEnd, playFeedbackSound: props.playFeedbackSound }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_QuestionFeedbackWidget__WEBPACK_IMPORTED_MODULE_5__.QuestionFeedbackWidget, { questionId: props.question.id, quizId: props.quizId })] }))] })));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MatchingQuestionCard);


/***/ }),
/* 203 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_sampleSize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(144);
/* harmony import */ var lodash_sampleSize__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_sampleSize__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(208);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(209);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(165);
/* harmony import */ var _providers_LayoutContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(204);
/* harmony import */ var _assets_redx_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(207);
/* harmony import */ var _hooks_useXpPopAnimation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(142);
/* harmony import */ var _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(205);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};










function MatchingAnswersList(props) {
    var _a, _b, _c;
    var isMobile = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_providers_LayoutContext__WEBPACK_IMPORTED_MODULE_4__.LayoutContext).isMobile;
    var allAnswers = (_a = props === null || props === void 0 ? void 0 : props.answers) === null || _a === void 0 ? void 0 : _a[0];
    var refs = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () { return ({
        A: allAnswers.A.map(function () { return react__WEBPACK_IMPORTED_MODULE_3___default().createRef(); }),
        B: allAnswers.A.map(function () { return react__WEBPACK_IMPORTED_MODULE_3___default().createRef(); }),
    }); }, [allAnswers]);
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), userAnswer = _d[0], setUserAnswer = _d[1];
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}), userSelection = _e[0], setUserSelection = _e[1];
    var _f = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), unmatched = _f[0], setUnmatched = _f[1];
    var _g = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), addedXp = _g[0], setAddedXp = _g[1];
    var correctStyles = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
        var colors = [_MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].a, _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].b, _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].c, _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].d, _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].e];
        return lodash_sampleSize__WEBPACK_IMPORTED_MODULE_2___default()(colors, 3);
    }, []);
    var handleScore = function (partialAnswers, addedXp) {
        props.handleEnd(partialAnswers, {
            maxScore: allAnswers.A.length,
            score: partialAnswers
                .filter(function (it) { return it; })
                .map(function (it) { return it.score; })
                .reduce(function (a, b) { return a + b; }, 0),
            addedXp: addedXp,
        });
    };
    var handleAClick = function (answer, index, x, y) {
        var _a;
        if (userSelection.A !== undefined || (userAnswer[index] && userAnswer[index].A !== undefined) || ((_a = unmatched === null || unmatched === void 0 ? void 0 : unmatched.A) === null || _a === void 0 ? void 0 : _a.id) === answer.id) {
            //already cliked an A or it was already macthed in another attempt
            return;
        }
        var newUserSelection = __assign(__assign({}, userSelection), { A: answer });
        setUserSelection(newUserSelection);
        if (userSelection.B === undefined) {
            return;
        }
        var isCorrect = answer.id === userSelection.B.matchingId;
        var newXP = !isCorrect ? 0 : props.isDoubleXp ? 10 : 5;
        var totalXp = addedXp + newXP;
        if (isCorrect) {
            setAddedXp(totalXp);
            play(newXP, x, y);
        }
        props.playFeedbackSound(isCorrect);
        var score = userAnswer[index] ? userAnswer[index].score : isCorrect ? 1 : 0;
        var result = __assign(__assign({}, newUserSelection), { isCorrect: isCorrect, score: score });
        var updatedUserAnswer = __spreadArray([], userAnswer, true);
        updatedUserAnswer[index] = isCorrect ? result : { score: score, isCorrect: isCorrect };
        setUserAnswer(updatedUserAnswer);
        handleScore(updatedUserAnswer, totalXp);
        if (!updatedUserAnswer[index].isCorrect) {
            setUnmatched({ A: answer, B: userSelection.B });
        }
        setUserSelection({});
        setTimeout(function () {
            setUnmatched(null);
        }, 1000);
    };
    var handleBClick = function (answer, x, y) {
        var _a, _b;
        var index = userAnswer.findIndex(function (item) {
            return item && item.B && item.B.id === answer.id;
        });
        if (userSelection.B !== undefined || index > -1 || ((_a = unmatched === null || unmatched === void 0 ? void 0 : unmatched.B) === null || _a === void 0 ? void 0 : _a.id) === answer.id) {
            //already cliked an A or it was already macthed in another attempt
            return;
        }
        var newUserSelection = __assign(__assign({}, userSelection), { B: answer });
        setUserSelection(newUserSelection);
        if (userSelection.A === undefined) {
            return;
        }
        var isCorrect = answer.id === userSelection.A.matchingId;
        props.playFeedbackSound(isCorrect);
        var newXP = !isCorrect ? 0 : props.isDoubleXp ? 10 : 5;
        var totalXp = addedXp + newXP;
        if (isCorrect) {
            setAddedXp(totalXp);
            play(newXP, x, y);
        }
        var indexA = (_b = allAnswers === null || allAnswers === void 0 ? void 0 : allAnswers.A) === null || _b === void 0 ? void 0 : _b.findIndex(function (item) { var _a; return item.id === ((_a = userSelection.A) === null || _a === void 0 ? void 0 : _a.id); });
        var score = userAnswer[indexA] ? userAnswer[indexA].score : isCorrect ? 1 : 0;
        var result = __assign(__assign({}, newUserSelection), { isCorrect: isCorrect, score: score });
        var updatedUserAnswer = __spreadArray([], userAnswer, true);
        updatedUserAnswer[indexA] = isCorrect ? result : { score: score, isCorrect: isCorrect };
        setUserAnswer(updatedUserAnswer);
        handleScore(updatedUserAnswer, totalXp);
        if (!updatedUserAnswer[indexA].isCorrect) {
            setUnmatched({ A: userSelection.A, B: answer });
        }
        setUserSelection({});
        setTimeout(function () {
            setUnmatched(null);
        }, 1000);
    };
    var As = (_b = allAnswers === null || allAnswers === void 0 ? void 0 : allAnswers.A) === null || _b === void 0 ? void 0 : _b.map(function (answer, index) {
        var _a, _b, _c;
        var _d, _e, _f, _g;
        var isCorrect = (_d = userAnswer[index]) === null || _d === void 0 ? void 0 : _d.isCorrect;
        var isWrong = ((_e = unmatched === null || unmatched === void 0 ? void 0 : unmatched.A) === null || _e === void 0 ? void 0 : _e.id) === answer.id;
        var hasLostPoints = ((_f = userAnswer[index]) === null || _f === void 0 ? void 0 : _f.score) === 0 && isCorrect;
        var isSelected = ((_g = userSelection.A) === null || _g === void 0 ? void 0 : _g.id) === answer.id;
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ onClick: function (event) { return handleAClick(answer, index, event.pageX, event.pageY); }, className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["answer-wrapper"], (_a = {}, _a[_MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].selected] = isSelected, _a), (_b = {}, _b[correctStyles[index]] = isCorrect, _b), (_c = {}, _c[_MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].wrong] = isWrong, _c)), ref: refs.A[index] }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["answer-id-box"] }, { children: [isWrong && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["red-x"] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: _assets_redx_png__WEBPACK_IMPORTED_MODULE_6__ }) }))), isCorrect && !hasLostPoints && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["green-tick"] }), hasLostPoints && "-", !isWrong && !isCorrect && String.fromCharCode(65 + index)] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["answer-text"] }, { children: answer.text }))] }), answer.id));
    });
    var Bs = (_c = allAnswers === null || allAnswers === void 0 ? void 0 : allAnswers.B) === null || _c === void 0 ? void 0 : _c.map(function (answer, index) {
        var _a, _b, _c;
        var _d, _e, _f, _g, _h;
        var indexA = (_d = allAnswers === null || allAnswers === void 0 ? void 0 : allAnswers.A) === null || _d === void 0 ? void 0 : _d.findIndex(function (item) { return item.id === answer.matchingId; });
        var isCorrect = (_e = userAnswer[indexA]) === null || _e === void 0 ? void 0 : _e.isCorrect;
        var hasLostPoints = ((_f = userAnswer[indexA]) === null || _f === void 0 ? void 0 : _f.score) === 0 && isCorrect;
        var isWrong = ((_g = unmatched === null || unmatched === void 0 ? void 0 : unmatched.B) === null || _g === void 0 ? void 0 : _g.id) === answer.id;
        var isSelected = ((_h = userSelection.B) === null || _h === void 0 ? void 0 : _h.id) === answer.id;
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ onClick: function (event) { return handleBClick(answer, event.pageX, event.pageY); }, className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["answer-wrapper"], (_a = {}, _a[_MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].selected] = isSelected, _a), (_b = {}, _b[correctStyles[indexA]] = isCorrect, _b), (_c = {}, _c[_MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].wrong] = isWrong, _c)), ref: refs.B[index] }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["answer-id-box"] }, { children: [isWrong && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["red-x"] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: _assets_redx_png__WEBPACK_IMPORTED_MODULE_6__ }) }))), isCorrect && !hasLostPoints && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["green-tick"] }), hasLostPoints && "-", !isWrong && !isCorrect && index + 1] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["answer-text"] }, { children: answer.text }))] }), answer.id));
    });
    var _h = (0,_hooks_useXpPopAnimation__WEBPACK_IMPORTED_MODULE_7__.useXpPopAnimation)(), xpPopComponent = _h.xpPopComponent, play = _h.play;
    (0,_hooks__WEBPACK_IMPORTED_MODULE_8__.useKey)(undefined, function (key) {
        var _a, _b, _c;
        var index = parseInt(key.replace(/^Digit/, "").replace(/^Numpad/, ""));
        if (isNaN(index)) {
            return;
        }
        if (index > ((_a = allAnswers === null || allAnswers === void 0 ? void 0 : allAnswers.A) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        if (userSelection.A === undefined) {
            var answer = (_b = allAnswers === null || allAnswers === void 0 ? void 0 : allAnswers.A) === null || _b === void 0 ? void 0 : _b[index - 1];
            if (answer) {
                var rect = refs.A[index - 1].current.getBoundingClientRect();
                handleAClick(answer, index - 1, rect.left + rect.width / 2, rect.top + rect.height / 2);
            }
        }
        else {
            var answer = (_c = allAnswers === null || allAnswers === void 0 ? void 0 : allAnswers.B) === null || _c === void 0 ? void 0 : _c[index - 1];
            if (answer) {
                var rect = refs.B[index - 1].current.getBoundingClientRect();
                handleBClick(answer, rect.left + rect.width / 2, rect.top + rect.height / 2);
            }
        }
    }, [userSelection, handleAClick, handleBClick, allAnswers]);
    if (isMobile) {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [xpPopComponent, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__["default"], __assign({ className: _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].answers }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__["default"], __assign({ className: _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["answers-list"] }, { children: As })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__["default"], __assign({ className: _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["answers-list"] }, { children: Bs }))] }))] }));
    }
    else {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [xpPopComponent, As.map(function (answer, index) {
                    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__["default"], __assign({ className: _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].answers }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__["default"], __assign({ className: _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["answers-list"] }, { children: As[index] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__["default"], __assign({ className: _MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["answers-list"] }, { children: Bs[index] }))] }), index));
                })] }));
    }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MatchingAnswersList);


/***/ }),
/* 204 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LayoutContext": () => (/* binding */ LayoutContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);


var LayoutContext = react__WEBPACK_IMPORTED_MODULE_0___default().createContext({
    isMobile: window.innerWidth < _config__WEBPACK_IMPORTED_MODULE_1__.MOBILE_BREAKPOINT,
    isMidpoint: false,
});


/***/ }),
/* 205 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(123);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(124);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(206);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_MatchingAnswers_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),
/* 206 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* padding: 4.5px; */\n/* min-height: 32.25px; */\n.MatchingAnswers-module__answers {\n  display: flex;\n  flex-direction: column;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 30px;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper {\n  user-select: none;\n  border: 1px solid rgba(73, 109, 219, 0.1);\n  background: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);\n  border-radius: 10px;\n  cursor: pointer;\n  position: relative;\n  max-width: 370px;\n  padding: 8px;\n  min-height: 55px;\n  margin-bottom: 8px;\n  margin-right: 35px;\n  display: flex;\n  align-items: center;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 18px;\n  color: #2c2b5e;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper > * {\n  -webkit-transform: translateZ(0px);\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper .MatchingAnswers-module__answer-id-box {\n  height: calc(100% - 16px);\n  width: 28px;\n  background: #edf0fb;\n  border-radius: 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 14px;\n  color: #707682;\n  flex-shrink: 0;\n  position: absolute;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper .MatchingAnswers-module__green-tick {\n  width: 9px;\n  height: 18px;\n  border-bottom: 2px solid #379634;\n  border-right: 2px solid #379634;\n  transform: rotate(40deg);\n  margin: 3px auto;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper .MatchingAnswers-module__red-x {\n  width: 15px;\n  height: 15px;\n  margin: 0 auto;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper .MatchingAnswers-module__red-x img {\n  width: 15px;\n  height: 15px;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper .MatchingAnswers-module__answer-text {\n  margin-left: 40px;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper.MatchingAnswers-module__correct {\n  border: 1px solid green;\n  cursor: default;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper.MatchingAnswers-module__correct .MatchingAnswers-module__result_icon {\n  position: absolute;\n  right: 0;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper.MatchingAnswers-module__correct .MatchingAnswers-module__result_icon img {\n  width: 15px;\n  height: auto;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper.MatchingAnswers-module__selected {\n  border: 1px solid #41a5d1;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper.MatchingAnswers-module__a {\n  background: #f15530;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper.MatchingAnswers-module__b {\n  background: #ee742c;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper.MatchingAnswers-module__c {\n  background: #5ac7a8;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper.MatchingAnswers-module__d {\n  background: #e3b275;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper.MatchingAnswers-module__e {\n  background: #41a5d1;\n}\n.MatchingAnswers-module__answers .MatchingAnswers-module__answers-list .MatchingAnswers-module__answer-wrapper.MatchingAnswers-module__wrong {\n  border: 1.5px solid #df2935;\n}\n\n@media only screen and (min-width: 992px) {\n  .MatchingAnswers-module__answers {\n    position: relative;\n    font-family: Manrope, sans-serif;\n    color: #2c2b5e;\n    flex-direction: row;\n  }\n  .MatchingAnswers-module__answers .MatchingAnswers-module__answers-list {\n    margin-bottom: 0px;\n  }\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"answers": "MatchingAnswers-module__answers",
	"answers-list": "MatchingAnswers-module__answers-list",
	"answer-wrapper": "MatchingAnswers-module__answer-wrapper",
	"answer-id-box": "MatchingAnswers-module__answer-id-box",
	"green-tick": "MatchingAnswers-module__green-tick",
	"red-x": "MatchingAnswers-module__red-x",
	"answer-text": "MatchingAnswers-module__answer-text",
	"correct": "MatchingAnswers-module__correct",
	"result_icon": "MatchingAnswers-module__result_icon",
	"selected": "MatchingAnswers-module__selected",
	"a": "MatchingAnswers-module__a",
	"b": "MatchingAnswers-module__b",
	"c": "MatchingAnswers-module__c",
	"d": "MatchingAnswers-module__d",
	"e": "MatchingAnswers-module__e",
	"wrong": "MatchingAnswers-module__wrong"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 207 */
/***/ ((module) => {

"use strict";
module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5gcTEgoXmttsDQAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAABZUlEQVRIx7XXPU7DMBTA8f+zVFBh8RGasZ28ZE+O0JvASXoUuEHYWTKxukfIAKpEBzNErRK1SfyFx8j2T36x3vODwbC70tht2diN0WQadlNpuy0buyvN8LsaouAaoGK9yoLbTaVZ//R7Oka4jFAnQ6zldK6LY9slosOTdgh18fXZygSahE+gI1zhOEygACY07AsogMZxUDye9wjtzF7euAcKSMvped//Y2M0v6sGN7dgPuz+6FNdHD86uS5MwEPR661OwWPQGzgUB00MehcOwi+XLxCdhANwYtBZOA2fRxfhOHwZ9YLDcD90VJ1mR6fB+Ux0gF9alzxpMLywSGbUG5d/QL1wlZTwE6qaSqkyPJzrWFxSq0xsVZMUNKWqSSoai0sONAZXrL/fcqAARdt2nhfuXSHyikzlOX/UGxc6hJfBg54Gh05BF8PeH7B/0I9bmAueht7FB+jtxGvTVuVr2oy527T9AWlycV8b7qHiAAAAAElFTkSuQmCC";

/***/ }),
/* 208 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(188);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);




const Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__.useBootstrapPrefix)(bsPrefix, 'row');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__.useBootstrapBreakpoints)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__.useBootstrapMinBreakpoint)();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;

    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }

    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Row);

/***/ }),
/* 209 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "useCol": () => (/* binding */ useCol)
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(188);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);




function useCol({
  as,
  bsPrefix,
  className,
  ...props
}) {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__.useBootstrapPrefix)(bsPrefix, 'col');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__.useBootstrapBreakpoints)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__.useBootstrapMinBreakpoint)();
  const spans = [];
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;

    if (typeof propValue === 'object' && propValue != null) {
      ({
        span,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }

    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });
  return [{ ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, ...spans, ...classes)
  }, {
    as,
    bsPrefix,
    spans
  }];
}
const Col = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref) => {
  const [{
    className,
    ...colProps
  }, {
    as: Component = 'div',
    bsPrefix,
    spans
  }] = useCol(props);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, { ...colProps,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, !spans.length && bsPrefix)
  });
});
Col.displayName = 'Col';
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Col);

/***/ }),
/* 210 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_throw": () => (/* binding */ _throw),
/* harmony export */   "convertHMS": () => (/* binding */ convertHMS),
/* harmony export */   "sleep": () => (/* binding */ sleep)
/* harmony export */ });
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
function convertHMS(sec) {
    var hours = Math.floor(sec / 3600); // get hours
    var minutes = Math.floor((sec - hours * 3600) / 60); // get minutes
    var seconds = sec - hours * 3600 - minutes * 60; //  get seconds
    // add 0 if value < 10; Example: 2 => 02
    if (hours < 10) {
        hours = "0" + hours;
    }
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    if (seconds < 10) {
        seconds = "0" + seconds;
    }
    if (hours === "00") {
        return minutes + ":" + seconds;
    }
    else {
        return hours + ":" + minutes + ":" + seconds; // Return is HH : MM : SS
    }
}
var sleep = function (ms) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        // from backend code
        return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, ms); })];
    });
}); };
var _throw = function (message) {
    if (typeof message === "string") {
        throw new Error(message);
    }
    else {
        throw message;
    }
};


/***/ }),
/* 211 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(123);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(124);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(212);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_ModalFull_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),
/* 212 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ModalFull-module__modal-content-custom {\n  background-color: transparent !important;\n  border: unset !important;\n  z-index: 4000;\n}\n.ModalFull-module__modal-content-custom .ModalFull-module__modal-header {\n  background-color: transparent;\n  min-height: 40px;\n  border: unset;\n}\n\n.ModalFull-module__article-title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 2;\n  display: -webkit-box;\n  width: 100%;\n  max-height: 100%;\n  -webkit-box-orient: vertical;\n  line-clamp: 2;\n  margin-left: 8px;\n}\n.ModalFull-module__theme-light .ModalFull-module__article-title {\n  color: #000;\n}\n.ModalFull-module__theme-dark .ModalFull-module__article-title {\n  color: #fff;\n}\n\n.ModalFull-module__backdrop {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  top: 0;\n  left: 0;\n  z-index: 300000;\n  width: 100vw;\n  height: 100%;\n  overflow: hidden;\n}\n.ModalFull-module__backdrop.ModalFull-module__fancy {\n  background-image: url(\"https://storage.googleapis.com/staging.retainit.appspot.com/demo-widget/BlackForest.jpg\");\n}\n.ModalFull-module__backdrop .ModalFull-module__body {\n  position: relative;\n  background-color: #364c97;\n  overflow: auto;\n  padding-top: 7px;\n  flex-grow: 1;\n  scroll-behavior: smooth;\n}\n.ModalFull-module__backdrop .ModalFull-module__body.ModalFull-module__noBackground {\n  background-color: transparent;\n}\n@media not all and (min-resolution: 0.001dpcm) {\n  @supports (-webkit-appearance: none) {\n    .ModalFull-module__backdrop .ModalFull-module__body {\n      max-height: calc(100vh - 80px);\n    }\n  }\n}\n.ModalFull-module__backdrop .ModalFull-module__body .ModalFull-module__closeButton {\n  position: fixed;\n  z-index: 1;\n  top: 44px;\n  left: 46px;\n  cursor: pointer;\n}\n.ModalFull-module__backdrop .ModalFull-module__body .ModalFull-module__progress {\n  position: fixed;\n  z-index: 1;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(2px);\n  /* Note: backdrop-filter has minimal browser support */\n  border-radius: 0 10px 10px 0;\n  background-color: #414a7e;\n  padding: 36px 19px 23px 17px;\n  max-width: 190px;\n}\n.ModalFull-module__backdrop .ModalFull-module__body .ModalFull-module__progress .ModalFull-module__closeProgressButton {\n  position: absolute;\n  top: 9px;\n  right: 7px;\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  background: #414a7e;\n  opacity: 0.5;\n}\n.ModalFull-module__backdrop .ModalFull-module__body .ModalFull-module__progress .ModalFull-module__message {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  display: flex;\n  align-items: center;\n  color: #ffffff;\n  top: 50%;\n  right: 10px;\n  transform: rotate(-90deg) translateX(70%);\n  position: absolute;\n  transform-origin: bottom right;\n}\n.ModalFull-module__backdrop .ModalFull-module__body .ModalFull-module__progress .ModalFull-module__title {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 130%;\n  color: #ffffff;\n  padding-bottom: 14px;\n}\n.ModalFull-module__backdrop .ModalFull-module__body .ModalFull-module__progress .ModalFull-module__items {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n.ModalFull-module__backdrop .ModalFull-module__body .ModalFull-module__progress .ModalFull-module__items .ModalFull-module__item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 7px;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 144%;\n  color: #908fac;\n  padding: 3px 7px 2px;\n  cursor: pointer;\n}\n.ModalFull-module__backdrop .ModalFull-module__body .ModalFull-module__progress .ModalFull-module__items .ModalFull-module__item.ModalFull-module__current {\n  color: #ffffff;\n}\n.ModalFull-module__backdrop .ModalFull-module__body .ModalFull-module__progress .ModalFull-module__items .ModalFull-module__item.ModalFull-module__correct {\n  color: #fff597;\n}\n.ModalFull-module__backdrop .ModalFull-module__body .ModalFull-module__progress .ModalFull-module__items .ModalFull-module__item .ModalFull-module__xp {\n  color: #fff597;\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 5px;\n}\n.ModalFull-module__backdrop .ModalFull-module__cards-container .ModalFull-module__bottom-buffer {\n  margin-bottom: 20px;\n}\n.ModalFull-module__backdrop .ModalFull-module__cards-container .ModalFull-module__animationWrapper {\n  position: relative;\n  z-index: 0;\n}\n.ModalFull-module__backdrop .ModalFull-module__footer {\n  position: fixed;\n}\n.ModalFull-module__backdrop .ModalFull-module__quiz-peekaboo {\n  position: relative;\n  bottom: 0;\n  width: 100%;\n  padding: 12px;\n  background: white;\n  scroll-behavior: smooth;\n  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  flex-shrink: 0;\n}\n.ModalFull-module__backdrop .ModalFull-module__quiz-peekaboo .ModalFull-module__action-btns {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-direction: column-reverse;\n}\n.ModalFull-module__backdrop .ModalFull-module__quiz-peekaboo .ModalFull-module__action-btns .ModalFull-module__go-back-btn {\n  box-shadow: 0px 4px 14px rgba(73, 109, 219, 0.2);\n  min-width: 110px;\n  height: 45px;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 15px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border: 2px solid rgba(53, 109, 255, 0.2);\n  color: #fff;\n  background-color: #364c97;\n  border-radius: 8px;\n  width: 80%;\n  margin-bottom: 16px;\n}\n.ModalFull-module__backdrop .ModalFull-module__quiz-peekaboo .ModalFull-module__action-btns .ModalFull-module__restart-btn {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  cursor: pointer;\n  line-height: 18px;\n}\n.ModalFull-module__backdrop .ModalFull-module__quiz-peekaboo .ModalFull-module__action-btns .ModalFull-module__restart-btn img {\n  width: 18px;\n  height: auto;\n}\n\n.ModalFull-module__bottom-navigation {\n  height: 45px;\n  min-height: 45px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  align-content: center;\n  width: 100%;\n  position: fixed;\n  bottom: 0;\n}\n\n.ModalFull-module__powered-by-sm {\n  display: block;\n  width: 150px;\n  height: 20px;\n  z-index: 999999;\n  margin-bottom: 14px;\n}\n.ModalFull-module__powered-by-sm img {\n  width: 100%;\n}\n\n.ModalFull-module__powered-by-lg {\n  display: none;\n}\n\n@media only screen and (min-width: 992px) {\n  .ModalFull-module__powered-by-sm {\n    display: none;\n  }\n  .ModalFull-module__bottom-navigation {\n    height: 61px;\n    min-height: 61px;\n    position: relative;\n    display: block;\n    width: auto;\n  }\n  .ModalFull-module__powered-by-lg {\n    display: block;\n    position: absolute;\n    width: 180px;\n    height: 29px;\n    bottom: 0;\n    right: 0;\n    z-index: 999999;\n    margin: 0 0 0 auto !important;\n  }\n  .ModalFull-module__quiz-header-container {\n    justify-content: center;\n  }\n  .ModalFull-module__quiz-header-container .ModalFull-module__menu-container {\n    position: absolute;\n    left: 30px;\n    top: 20px;\n    width: 13px;\n    height: 11px;\n  }\n  .ModalFull-module__quiz-header-container .ModalFull-module__menu-container img {\n    width: 100%;\n    height: 100%;\n  }\n  .ModalFull-module__quiz-header-container .ModalFull-module__title-wrapper {\n    max-width: 50%;\n  }\n  .ModalFull-module__quiz-header-container .ModalFull-module__title-wrapper .ModalFull-module__article-title {\n    font-family: Manrope, sans-serif;\n    color: #2c2b5e;\n    max-width: 100%;\n    width: auto;\n    margin-left: 16px;\n  }\n  .ModalFull-module__quiz-header-container .ModalFull-module__domain-image {\n    width: 40px;\n    height: 40px;\n  }\n  .ModalFull-module__quiz-header-container .ModalFull-module__domain-image img {\n    height: 100%;\n  }\n  .ModalFull-module__backdrop .ModalFull-module__body {\n    background: linear-gradient(272.03deg, #3c5ae7 -1.1%, #1e1e1e 120.83%);\n    padding-top: 44px;\n  }\n  .ModalFull-module__backdrop .ModalFull-module__body.ModalFull-module__noBackground {\n    background: none;\n  }\n  .ModalFull-module__backdrop .ModalFull-module__quiz-peekaboo .ModalFull-module__action-btns {\n    flex-direction: row;\n  }\n  .ModalFull-module__backdrop .ModalFull-module__quiz-peekaboo .ModalFull-module__action-btns .ModalFull-module__go-back-btn {\n    width: 130px;\n    margin-right: 136px;\n    margin-left: 32px;\n    margin-bottom: 0;\n  }\n}\n.ModalFull-module__endPageContainer {\n  display: flex;\n  flex-direction: column;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content-custom": "ModalFull-module__modal-content-custom",
	"modal-header": "ModalFull-module__modal-header",
	"article-title": "ModalFull-module__article-title",
	"theme-light": "ModalFull-module__theme-light",
	"theme-dark": "ModalFull-module__theme-dark",
	"backdrop": "ModalFull-module__backdrop",
	"fancy": "ModalFull-module__fancy",
	"body": "ModalFull-module__body",
	"noBackground": "ModalFull-module__noBackground",
	"closeButton": "ModalFull-module__closeButton",
	"progress": "ModalFull-module__progress",
	"closeProgressButton": "ModalFull-module__closeProgressButton",
	"message": "ModalFull-module__message",
	"title": "ModalFull-module__title",
	"items": "ModalFull-module__items",
	"item": "ModalFull-module__item",
	"current": "ModalFull-module__current",
	"correct": "ModalFull-module__correct",
	"xp": "ModalFull-module__xp",
	"cards-container": "ModalFull-module__cards-container",
	"bottom-buffer": "ModalFull-module__bottom-buffer",
	"animationWrapper": "ModalFull-module__animationWrapper",
	"footer": "ModalFull-module__footer",
	"quiz-peekaboo": "ModalFull-module__quiz-peekaboo",
	"action-btns": "ModalFull-module__action-btns",
	"go-back-btn": "ModalFull-module__go-back-btn",
	"restart-btn": "ModalFull-module__restart-btn",
	"bottom-navigation": "ModalFull-module__bottom-navigation",
	"powered-by-sm": "ModalFull-module__powered-by-sm",
	"powered-by-lg": "ModalFull-module__powered-by-lg",
	"quiz-header-container": "ModalFull-module__quiz-header-container",
	"menu-container": "ModalFull-module__menu-container",
	"title-wrapper": "ModalFull-module__title-wrapper",
	"domain-image": "ModalFull-module__domain-image",
	"endPageContainer": "ModalFull-module__endPageContainer"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 213 */
/***/ ((module) => {

"use strict";
module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTAgMjMuNzVDMCAzNi44NSAxMC42NSA0Ny41IDIzLjc1IDQ3LjVDMzYuODUgNDcuNSA0Ny41IDM2Ljg1IDQ3LjUgMjMuNzVDNDcuNSAxMC42NSAzNi44NSAwIDIzLjc1IDBDMTAuNjUgMCAwIDEwLjY1IDAgMjMuNzVaTTI4LjU1IDEzLjRDMjguODk5OSAxMy43NDk5IDI5LjA1IDE0LjE1IDI5LjA1IDE0LjZDMjkuMDUgMTUuMDUwMSAyOC44OTk5IDE1LjUwMDEgMjguNTUgMTUuODAwMUwyMC42NSAyMy43NTAxTDI4LjU1IDMxLjY1MDFDMjkuMjAwMSAzMi4zMDAyIDI5LjIwMDEgMzMuNDAwMSAyOC41NSAzNC4wNTAyQzI3Ljg5OTkgMzQuNzAwMiAyNi44IDM0LjcwMDIgMjYuMTQ5OSAzNC4wNTAyTDE2Ljk5OTkgMjQuOTUwMkMxNi4zNDk4IDI0LjMwMDEgMTYuMzQ5OCAyMy4yMDAyIDE2Ljk5OTkgMjIuNTUwMUwyNi4xNDk5IDEzLjQwMDFDMjYuNzk5OCAxMi43NTAyIDI3Ljg5OTkgMTIuNzUwMiAyOC41NDk4IDEzLjQwMDJMMjguNTUgMTMuNFoiCiAgICAgICAgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";

/***/ }),
/* 214 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _react_spring_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(108);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useStarsAnimation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(223);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(210);
/* harmony import */ var _xp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(215);
/* harmony import */ var _assets_empty_head_png__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(228);
/* harmony import */ var _assets_retake_svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(230);
/* harmony import */ var _assets_x_svg__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(233);
/* harmony import */ var _assets_xp_bolt_png__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(232);
/* harmony import */ var _QuizFeedbackWidget__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(229);
/* harmony import */ var _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(226);
/* harmony import */ var _assets_play_quiz__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(231);
/* harmony import */ var _hooks_useColourSample__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(143);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};















function EndPage(_a) {
    var _b, _c;
    var _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var addedXp = _a.addedXp, score = _a.score, props = __rest(_a, ["addedXp", "score"]);
    var scoreGroup = score < 33 ? "low" : score < 67 ? "medium" : score < 100 ? "high" : "perfect";
    var _o = (0,_xp__WEBPACK_IMPORTED_MODULE_4__.getLevel)(props.startingXP), startingLevel = _o[0], nextLevel = _o[1], afterLevel = _o[2];
    var levelAfterXpNeeded = (_d = afterLevel === null || afterLevel === void 0 ? void 0 : afterLevel.neededXP) !== null && _d !== void 0 ? _d : 1;
    var _p = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(startingLevel), currentLevel = _p[0], setCurrentLevel = _p[1];
    var _q = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), hideExistingBar = _q[0], setHideExistingBar = _q[1];
    var itemColours = (0,_hooks_useColourSample__WEBPACK_IMPORTED_MODULE_5__.useColourSample)();
    var nextXPNeeded = (_e = nextLevel === null || nextLevel === void 0 ? void 0 : nextLevel.neededXP) !== null && _e !== void 0 ? _e : (0,_utils__WEBPACK_IMPORTED_MODULE_6__._throw)("Unimplemented");
    var hasLeveledUp = ((_f = nextLevel === null || nextLevel === void 0 ? void 0 : nextLevel.neededXP) !== null && _f !== void 0 ? _f : 0) < props.startingXP + addedXp;
    var scoreDifference = props.lastScore ? score - props.lastScore : undefined;
    var improvementSpring = (0,_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.useSpring)({
        from: { improvement: 0 },
        to: { improvement: scoreDifference ? Math.abs(scoreDifference) : 0 },
    });
    var _r = (0,_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.useSpring)(function () { return ({
        scale: 1,
        glow: 0,
        characterColor: "#ffffff",
        labelColor: "#5ac7a8",
    }); }), progressContainerSpring = _r[0], progressContainerSpringApi = _r[1];
    var _s = (0,_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.useSpring)(function () {
        var _a;
        return ({
            config: _react_spring_web__WEBPACK_IMPORTED_MODULE_1__.config.molasses,
            from: {
                width: "".concat((100 * (props.startingXP - startingLevel.neededXP)) / (nextXPNeeded - startingLevel.neededXP), "%"),
                addedXP: 0,
                goalProgress: (100 * (props.startingXP - startingLevel.neededXP)) / (nextXPNeeded - startingLevel.neededXP),
                done: false,
            },
            to: hasLeveledUp
                ? {
                    width: "100%",
                    addedXP: ((_a = nextLevel === null || nextLevel === void 0 ? void 0 : nextLevel.neededXP) !== null && _a !== void 0 ? _a : 0) - props.startingXP,
                    goalProgress: 100,
                    done: false,
                }
                : {
                    width: "".concat((100 * (props.startingXP + addedXp - startingLevel.neededXP)) / (nextXPNeeded - startingLevel.neededXP), "%"),
                    addedXP: addedXp,
                    goalProgress: (100 * (props.startingXP + addedXp - startingLevel.neededXP)) / (nextXPNeeded - startingLevel.neededXP),
                    done: false,
                },
            onRest: function (result) {
                var _a;
                if (hasLeveledUp && !result.value.done && nextLevel) {
                    setCurrentLevel(nextLevel);
                    progressContainerSpringApi.start({
                        from: {
                            scale: 0.99,
                            glow: 0,
                        },
                        to: {
                            scale: 1,
                            glow: 1,
                            characterColor: "#fff597",
                            labelColor: "#fff597",
                        },
                        config: __assign(__assign({}, _react_spring_web__WEBPACK_IMPORTED_MODULE_1__.config.molasses), { velocity: [0.02, 0] }),
                        onRest: function () {
                            return setTimeout(function () {
                                return progressContainerSpringApi.start({
                                    to: { glow: 0, characterColor: "#ffffff", labelColor: "#5ac7a8" },
                                });
                            }, 500);
                        },
                    });
                    setHideExistingBar(true);
                    starsAnimation.play();
                    progressSpringApi.start({
                        from: {
                            width: "0",
                            addedXP: ((_a = nextLevel === null || nextLevel === void 0 ? void 0 : nextLevel.neededXP) !== null && _a !== void 0 ? _a : 0) - props.startingXP,
                            done: false,
                        },
                        to: {
                            // width: `${100 * (props.startingXP + addedXp - (nextLevel?.neededXP ?? 1 - levelAfterXpNeeded))}%`,
                            width: "".concat((100 * (props.startingXP + addedXp - nextXPNeeded)) / (levelAfterXpNeeded - nextXPNeeded), "%"),
                            addedXP: addedXp,
                            done: true,
                        },
                    });
                }
            },
        });
    }, []), progressSpring = _s[0], progressSpringApi = _s[1];
    var starsAnimation = (0,_hooks_useStarsAnimation__WEBPACK_IMPORTED_MODULE_7__.useStarsAnimation)();
    var levelLabelTransition = (0,_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.useTransition)(currentLevel, {
        from: { opacity: 0, scale: 0.5, y: 50 },
        enter: { opacity: 1, scale: 1, y: 0 },
        leave: { opacity: 0, scale: 0.5, y: -50 },
        config: _react_spring_web__WEBPACK_IMPORTED_MODULE_1__.config.molasses,
        initial: { opacity: 1, scale: 1, y: 0 },
    });
    var characterTransition = (0,_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.useTransition)(currentLevel.characterImage, {
        from: { opacity: 0, scale: 0.5 },
        enter: { opacity: 1, scale: 1 },
        leave: { opacity: 0, scale: 0.5 },
        config: _react_spring_web__WEBPACK_IMPORTED_MODULE_1__.config.molasses,
        initial: { opacity: 1, scale: 1 },
    });
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].endPageContainer }, { children: [characterTransition(function (style, Image) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, __assign({ style: __assign(__assign({}, style), { color: progressContainerSpring.characterColor }), className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].backgroundImage }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {}), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, __assign({ style: { color: progressContainerSpring.characterColor, opacity: progressContainerSpring.glow }, className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].glow }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {}) }))] }))); }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].title }, { children: scoreGroup === "low"
                    ? "Oof... Try again?"
                    : scoreGroup === "medium"
                        ? "Keep going, champ."
                        : scoreGroup === "high"
                            ? "What a quiz whiz!"
                            : "You're killin' it!" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].progressContainer }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].scoreContainer, (_b = {},
                            _b[_EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].low] = scoreGroup === "low",
                            _b[_EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].medium] = scoreGroup === "medium",
                            _b[_EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].high] = scoreGroup === "high",
                            _b[_EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].perfect] = scoreGroup === "perfect",
                            _b)) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].score }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].text }, { children: [score, "%"] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].double }, { children: [score, "%"] }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].stars }, { children: __spreadArray([], Array(3), true).map(function (e, i) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].star }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "30", height: "28", viewBox: "0 0 30 28", xmlns: "http://www.w3.org/2000/svg" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M28.6439 11.0659L28.6454 11.0705C28.7276 11.3214 28.7387 11.5902 28.6777 11.8471C28.6166 12.104 28.4857 12.3389 28.2995 12.5258L28.2979 12.5274L23.3433 17.5255L22.9884 17.8835L23.0652 18.3818L24.1376 25.3395L24.1376 25.3398C24.178 25.6013 24.1456 25.8689 24.0439 26.1132C23.9423 26.3575 23.7753 26.5689 23.5616 26.7243C23.3478 26.8798 23.0954 26.9732 22.8322 26.9944C22.569 27.0157 22.3049 26.9639 22.0691 26.8448L22.0689 26.8447L15.7877 23.6738L15.337 23.4463L14.8864 23.6738L8.60536 26.8447L8.60439 26.8452C8.36866 26.9645 8.10465 27.0164 7.84139 26.9953C7.57812 26.9742 7.32572 26.8808 7.11195 26.7254C6.89817 26.57 6.73128 26.3585 6.62973 26.1141C6.52817 25.8698 6.49591 25.6021 6.53652 25.3406L6.5367 25.3395L7.6091 18.3818L7.6859 17.8835L7.33095 17.5255L2.37653 12.5276C2.37647 12.5276 2.3764 12.5275 2.37634 12.5274C2.19036 12.3397 2.05957 12.1042 1.99841 11.8468C1.93722 11.5894 1.94809 11.32 2.02982 11.0683C2.11154 10.8166 2.26092 10.5924 2.4615 10.4203C2.66201 10.2482 2.90594 10.1347 3.16652 10.0922C3.1666 10.0922 3.16667 10.0922 3.16675 10.0922L10.1106 8.96291L10.6086 8.88191L10.8394 8.4332L14.0584 2.17363C14.1794 1.9384 14.3628 1.74117 14.5884 1.60351C14.8139 1.46586 15.073 1.39307 15.337 1.39307C15.6011 1.39307 15.8602 1.46586 16.0857 1.60351C16.3112 1.74113 16.4946 1.93828 16.6156 2.17343C16.6156 2.1735 16.6157 2.17356 16.6157 2.17363L19.8347 8.4332L20.0655 8.88191L20.5635 8.96291L27.5077 10.0922L27.51 10.0926C27.7702 10.1343 28.0139 10.2472 28.214 10.419C28.4142 10.5907 28.563 10.8146 28.6439 11.0659Z", stroke: "currentColor", strokeWidth: "2" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].double, width: "30", height: "28", viewBox: "0 0 30 28", xmlns: "http://www.w3.org/2000/svg" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M28.6439 11.0659L28.6454 11.0705C28.7276 11.3214 28.7387 11.5902 28.6777 11.8471C28.6166 12.104 28.4857 12.3389 28.2995 12.5258L28.2979 12.5274L23.3433 17.5255L22.9884 17.8835L23.0652 18.3818L24.1376 25.3395L24.1376 25.3398C24.178 25.6013 24.1456 25.8689 24.0439 26.1132C23.9423 26.3575 23.7753 26.5689 23.5616 26.7243C23.3478 26.8798 23.0954 26.9732 22.8322 26.9944C22.569 27.0157 22.3049 26.9639 22.0691 26.8448L22.0689 26.8447L15.7877 23.6738L15.337 23.4463L14.8864 23.6738L8.60536 26.8447L8.60439 26.8452C8.36866 26.9645 8.10465 27.0164 7.84139 26.9953C7.57812 26.9742 7.32572 26.8808 7.11195 26.7254C6.89817 26.57 6.73128 26.3585 6.62973 26.1141C6.52817 25.8698 6.49591 25.6021 6.53652 25.3406L6.5367 25.3395L7.6091 18.3818L7.6859 17.8835L7.33095 17.5255L2.37653 12.5276C2.37647 12.5276 2.3764 12.5275 2.37634 12.5274C2.19036 12.3397 2.05957 12.1042 1.99841 11.8468C1.93722 11.5894 1.94809 11.32 2.02982 11.0683C2.11154 10.8166 2.26092 10.5924 2.4615 10.4203C2.66201 10.2482 2.90594 10.1347 3.16652 10.0922C3.1666 10.0922 3.16667 10.0922 3.16675 10.0922L10.1106 8.96291L10.6086 8.88191L10.8394 8.4332L14.0584 2.17363C14.1794 1.9384 14.3628 1.74117 14.5884 1.60351C14.8139 1.46586 15.073 1.39307 15.337 1.39307C15.6011 1.39307 15.8602 1.46586 16.0857 1.60351C16.3112 1.74113 16.4946 1.93828 16.6156 2.17343C16.6156 2.1735 16.6157 2.17356 16.6157 2.17363L19.8347 8.4332L20.0655 8.88191L20.5635 8.96291L27.5077 10.0922L27.51 10.0926C27.7702 10.1343 28.0139 10.2472 28.214 10.419C28.4142 10.5907 28.563 10.8146 28.6439 11.0659Z", stroke: "currentColor", strokeWidth: "2" }) }))] }), i)); }) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].messageContainer }, { children: props.lastScore !== undefined && scoreDifference !== undefined && scoreDifference !== 0 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].difference, (_c = {},
                                _c[_EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].positive] = scoreDifference > 0,
                                _c[_EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].negative] = scoreDifference < 0,
                                _c)) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].triangle, width: "21", height: "15", viewBox: "0 0 21 15", xmlns: "http://www.w3.org/2000/svg" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M10.5 0L20.4593 15H0.540708L10.5 0Z" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].text }, { children: scoreDifference === 0 ? ("No change") : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.span, { children: improvementSpring.improvement.to(function (x) { return x.toFixed(0); }) }), scoreDifference < 0 ? "% Decline" : "% Improvement"] })) }))] }))) }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].goalContainer, style: progressContainerSpring }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].message }, { children: currentLevel === startingLevel ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: ["You're ", (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.span, { children: progressSpring.goalProgress.to(function (x) { return x.toFixed(0); }) }), "% of the way to leveling up!"] })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: "Amazing! You are now a..." })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].inputContainer }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].levelContainer }, { children: levelLabelTransition(function (style, item) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, __assign({ style: __assign(__assign({}, style), { color: progressContainerSpring.labelColor }), className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].level }, { children: [item.label, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, __assign({ style: { opacity: progressContainerSpring.glow }, className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].glow }, { children: item.label }))] }))); }) })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].progressBarContainer }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].progressBar }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, { className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].glow, style: { opacity: progressContainerSpring.glow, background: progressContainerSpring.characterColor } }), starsAnimation.stars, (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].progressBarInner }, { children: [!hideExistingBar && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].existing, style: {
                                                    width: "".concat((100 * (props.startingXP - startingLevel.neededXP)) / (nextXPNeeded - startingLevel.neededXP), "%"),
                                                } })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"]["new"], style: progressSpring }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].label }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "20", height: "11", viewBox: "0 0 20 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M9.31795 0.636108C9.70208 0.277851 10.2979 0.27785 10.682 0.636107L19.402 8.76869C20.0659 9.38786 19.6277 10.5 18.7199 10.5H1.28006C0.372261 10.5 -0.0658662 9.38786 0.598015 8.76869L9.31795 0.636108Z", fill: "#FFF597" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].amount }, { children: progressSpring.addedXP.to(function (x) { return "+ ".concat(x.toFixed(0), " XP"); }) }))] })) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].background })] }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", __assign({ width: "27", height: "39", viewBox: "0 0 27 39", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M22 12.4286L2 5.14286V20.5714L22 12.4286Z", fill: "#5AC7A8" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M2 39V20.5714M2 0V5.14286M2 5.14286L22 12.4286L2 20.5714M2 5.14286V20.5714", stroke: "#5AC7A8", strokeWidth: "3" })] }))] }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].rightContainer }, { children: [props.nextUp && props.nextUp.length !== 0 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].nextUp }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].header }, { children: "Next Up" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].items }, { children: props.nextUp.slice(0, 3).map(function (item, i) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].item, style: { backgroundColor: itemColours[i] }, onClick: function () { return props.handleNext(item); } }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: item.media.title }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: item.media.image })] }), i)); }) })), props.nextUp.length > 3 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].more }, { children: ["+ ", props.nextUp.length - 3, " more"] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].seeAll }, { children: "See all" }))] }))] }))), props.nextUp && props.nextUp.length === 0 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].nextUp }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].header }, { children: "Next Up" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].emptyHead, src: _assets_empty_head_png__WEBPACK_IMPORTED_MODULE_9__, alt: "empty" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].emptyText }, { children: "Just because your queue\u2019s empty doesn\u2019t mean your head is too." })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].emptyText2 }, { children: "Save another quiz to keep Retaining!" }))] }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_QuizFeedbackWidget__WEBPACK_IMPORTED_MODULE_10__.QuizFeedbackWidget, { quizId: props.quizId })] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].actions }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].retakeButton, onClick: props.handleRestart }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].top }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: _assets_retake_svg__WEBPACK_IMPORTED_MODULE_11__, alt: "retake" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].bottom }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: "Retake" }) }))] })), props.nextUp && props.nextUp.length !== 0 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].nextQuizButton, onClick: function () { var _a; return (((_a = props === null || props === void 0 ? void 0 : props.nextUp) === null || _a === void 0 ? void 0 : _a[0]) ? props.handleNext(props.nextUp[0]) : undefined); } }, { children: [((_j = (_h = (_g = props.nextUp) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.media) === null || _j === void 0 ? void 0 : _j.image) ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].top, src: (_m = (_l = (_k = props.nextUp) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.media) === null || _m === void 0 ? void 0 : _m.image, alt: "img" })) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_play_quiz__WEBPACK_IMPORTED_MODULE_12__.PlayQuiz, { className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].top, style: { color: "white" } })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].bottom }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: "Next Quiz" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].doubleXp }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: _assets_xp_bolt_png__WEBPACK_IMPORTED_MODULE_13__, alt: "lightening" }), "Double XP"] }))] }))] }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].finishButton, onClick: function () { return props.handleClose(); } }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].top }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: _assets_x_svg__WEBPACK_IMPORTED_MODULE_14__, alt: "finish" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _EndPage_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].bottom }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: "Finish" }) }))] }))] }))] })));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EndPage);


/***/ }),
/* 215 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getLevel": () => (/* binding */ getLevel)
/* harmony export */ });
/* harmony import */ var _quiz_assets_character_images_1_novice_1__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(216);
/* harmony import */ var _quiz_assets_character_images_2_apprentice_1__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(217);
/* harmony import */ var _quiz_assets_character_images_3_adventurer_1__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(218);
/* harmony import */ var _quiz_assets_character_images_4_expert_1__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(219);
/* harmony import */ var _quiz_assets_character_images_5_hero_1__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(220);
/* harmony import */ var _quiz_assets_character_images_6_champion_1__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(221);
/* harmony import */ var _quiz_assets_character_images_7_sage_1__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(222);
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};







var levels = [
    { label: "Novice", neededXP: 0, characterImage: _quiz_assets_character_images_1_novice_1__WEBPACK_IMPORTED_MODULE_0__.Novice1 },
    { label: "Apprentice", neededXP: 50, characterImage: _quiz_assets_character_images_2_apprentice_1__WEBPACK_IMPORTED_MODULE_1__.Apprentice1 },
    { label: "Adventurer", neededXP: 250, characterImage: _quiz_assets_character_images_3_adventurer_1__WEBPACK_IMPORTED_MODULE_2__.Adventurer1 },
    { label: "Expert", neededXP: 625, characterImage: _quiz_assets_character_images_4_expert_1__WEBPACK_IMPORTED_MODULE_3__.Expert1 },
    { label: "Hero", neededXP: 2500, characterImage: _quiz_assets_character_images_5_hero_1__WEBPACK_IMPORTED_MODULE_4__.Hero1 },
    { label: "Champion", neededXP: 6250, characterImage: _quiz_assets_character_images_6_champion_1__WEBPACK_IMPORTED_MODULE_5__.Champion1 },
    { label: "Sage", neededXP: 12500, characterImage: _quiz_assets_character_images_7_sage_1__WEBPACK_IMPORTED_MODULE_6__.Sage1 },
];
var getLevel = function (xp) {
    var nextLevelIndex = levels.findIndex(function (it) { return it.neededXP > xp; });
    if (nextLevelIndex === -1) {
        return [levels[levels.length - 1]];
    }
    return __spreadArray([levels[nextLevelIndex - 1]], levels.slice(nextLevelIndex), true);
};


/***/ }),
/* 216 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Novice1": () => (/* binding */ Novice1)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Novice1 = function (props) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "1200pt", height: "1200pt", version: "1.1", viewBox: "0 0 1200 1200", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m80.797 428.54c1.8359 32.059 9.6406 62.043 21.98 84.426 12.457 22.59 28.531 35.574 45.758 37.152h0.003906c-5.5664 16.07-8.6758 32.887-9.2188 49.883v147.28c-10.715 11.008-36.602 43.809-36.602 103.82v57.016c-0.125 17.672 4.1406 35.098 12.422 50.711 6.0391 11.547 14.672 21.539 25.223 29.191-3.5508 2.7383-7.0781 5.5703-10.535 8.5898-3.043 2.6602-4.5625 6.6641-4.0391 10.672 0.51953 4.0078 3.0117 7.4922 6.6328 9.2812l117.43 58.039c3.2695 1.6016 6.0234 4.0938 7.9453 7.1875 1.9258 3.0938 2.9375 6.668 2.9258 10.309v7.4141c0.019532 17.348 6.918 33.984 19.188 46.25 12.27 12.27 28.902 19.172 46.254 19.191h396.25c5.6953-0.003906 10.617-3.9805 11.816-9.5508 7.8242-36.391 2.6172-86.793 1.9922-92.414-0.23828-5.6172-2.9141-51.348-27.176-86.648-5.1875-7.5508-12.953-12.945-21.84-15.176-5.1562-32.594-7.9297-65.52-8.2969-98.516l8.3594-4.6094c12.52 26.117 38.039 74.781 72.395 116.98 15.781 19.539 37.648 33.234 62.117 38.906-1.5273 14.598-1.7227 29.301-0.58984 43.934 0.58203 5.8242 5.2578 10.395 11.094 10.852 11.137 0.86719 22.285 1.25 33.285 1.25v-0.003907c44.594-0.46484 89.012-5.6094 132.53-15.355 3.2266 3.0547 6.832 5.6875 10.723 7.8281-2.2031 29.594-5.8867 59.059-11.039 88.285-0.62109 3.1797 0.058594 6.4766 1.8867 9.1523 1.8281 2.6719 4.6562 4.5 7.8438 5.0742 3.1875 0.57422 6.4727-0.15625 9.1211-2.0273 2.6445-1.8672 4.4297-4.7188 4.9531-7.918 4.8594-27.047 8.5469-56.039 11.012-86.305 0.35156 0 0.70703 0.054688 1.0586 0.054688h34.137v0.003906c2.5-0.023438 4.9922-0.22266 7.4609-0.60156-2.3984 28.98-5.9492 56.699-10.59 82.57-1.1797 6.5742 3.1914 12.859 9.7656 14.039 6.5742 1.1797 12.859-3.1914 14.039-9.7656 5.6992-32.344 9.6641-64.973 11.883-97.738 12.324-9.8555 19.5-24.777 19.504-40.559v-65.793c-0.007812-15.105-6.5898-29.457-18.039-39.316-1-22.645-2.5273-45.559-4.5898-68.176l0.003906 0.003906c-3.2461-34.5-8.4844-68.781-15.695-102.67-3.1758-15.336-5.9258-31.766-8.1172-48.805-2.1562-15.113 2.1367-30.441 11.828-42.234 6.2188-7.6875 14.66-13.262 24.172-15.953 6.1992-1.1641 10.465-6.8945 9.8047-13.168l-6.3516-60h-0.003906c-0.45703-4.3438-3.2266-8.1016-7.2422-9.832-6.8516-2.8945-13.277-6.707-19.102-11.332-12.312-10.191-18.969-25.68-17.895-41.621 2.7617-50.293 8.2031-100.4 16.305-150.11 0.042969-0.24219 0.082032-0.49219 0.10938-0.73828 16.328-141.22-27.75-296.61-29.648-303.18-1.4922-5.1836-6.2305-8.75-11.621-8.75h-66.84c-3.8047-0.007813-7.3906 1.7773-9.6836 4.8125-2.2891 3.0391-3.0156 6.9766-1.9648 10.633 0.44922 1.5547 44.527 157.11 28.891 293.33-0.50391 2.8477-2.5352 14.609-5.0859 32.973l0.003906 0.003907c-3.2539-5.6094-6.9531-10.945-11.066-15.957-12.043-14.621-19.586-32.422-21.715-51.242l-1.6953-14.879c-0.75781-6.6367-6.75-11.406-13.387-10.648s-11.406 6.75-10.648 13.387l1.6992 14.879h-0.003906c2.6562 23.465 12.059 45.656 27.07 63.883 14.934 18.273 22.84 41.289 22.281 64.883-7.6875 81.414-12.352 200.32 9.2617 304.29h-0.003907c6.9219 32.465 11.988 65.301 15.18 98.344 1.8477 20.09 3.2656 40.473 4.2734 60.707v-0.003906c-8.168 4.1055-15.121 10.273-20.168 17.895-57.625 1.9922-123.9 2.2578-165.93-42.309-12.562-13.32-30.207-49.289-42.664-94.992l31.223-23.293v0.003906c7.6562-5.707 12.566-14.363 13.535-23.863 0.97266-9.4961-2.0859-18.969-8.4297-26.102l-111.53-125.51c-0.10938-0.125-0.22266-0.24219-0.33594-0.35156v-0.003907c-9.9727-10.309-21.777-18.668-34.816-24.648 9.5-4.293 17.898-10.699 24.555-18.727 5.4609-6.2031 10.07-13.109 13.703-20.531 29.016-59.293 24.824-109.37 16.199-140.93-6.6797-23.77-24.965-42.527-48.555-49.812 0.46875-6.9141 0.85938-13.973 1.1719-21.176 19.199-13.758 33.496-33.301 40.801-55.766 11.227-32.469 8.5508-68.133-7.3945-98.566-15.672-30.574-46.16-50.762-80.426-53.254-4.875-4.8203-10.094-9.2773-15.617-13.34-22.785-17.203-49.98-27.586-78.43-29.953-28.449-2.3672-56.988 3.3867-82.301 16.586-16.73 8.4453-31.82 19.797-44.574 33.531-31.297-2.4102-85.301 2.1172-117.06 53.926-19.098 31.918-23.082 70.652-10.887 105.79 10.684 32.066 25.594 95.34 5.4297 158.89h-0.003906c-2.3125 7.3086-1.4961 15.25 2.2617 21.934 3.7539 6.6836 10.109 11.512 17.559 13.336-1.4102 8.1172-3.1328 15.883-5.0664 23.293l-27.152-2.1172c-46.887-4.5898-59.074-47.371-62.234-68.438-0.28516-3.6953-0.64844-7.3555-1.0898-10.984v-0.62109l-0.039063 0.18359h-0.003906c-2.5234-23.73-9.4531-46.781-20.426-67.973-3.3047-6.0781-7.207-11.809-11.652-17.109 25.742-1.8828 51.586-1.918 77.332-0.097656 3.2227 0.29297 6.4297-0.71875 8.9023-2.8047 2.4727-2.0898 4.0039-5.082 4.2539-8.3086 0.25-3.2266-0.80469-6.418-2.9258-8.8633-2.125-2.4414-5.1367-3.9336-8.3672-4.1406-40.125-2.7969-80.438-1.3984-120.27 4.1797-18.934 1.6289-35.199 16.742-45.883 42.777-7.0664 18.258-11.148 37.535-12.09 57.09v0.074218c-0.88281 7.3008-1 14.672-0.35156 21.996 0.027344 2.4062 0.0625 4.8008 0.19922 7.2266zm924.38 23.242 0.089844-0.89844c0.03125-0.29297 0.039063-0.58594 0.066406-0.875 5.3594-60.18 12.562-101.37 12.73-102.32 0.042969-0.24219 0.082031-0.49219 0.10938-0.73828 13.555-117.21-14.508-244.19-25.52-287.72h41.859c8.9883 34.773 40.059 166.89 26.543 284.59h0.003906c-8.2188 50.539-13.758 101.48-16.59 152.6 0 0-5.7656 110.82 4.9414 198.59 2.2656 17.668 5.1055 34.711 8.4258 50.656 7.0195 32.984 12.125 66.344 15.285 99.918 1.625 17.949 2.918 36.09 3.8828 54.125-3.043-0.5625-6.1328-0.85547-9.2305-0.86719h-33.48c-1.0117-19.141-2.3789-38.379-4.125-57.359v-0.003906c-3.2734-33.949-8.4766-67.688-15.582-101.05-20.051-96.504-16.41-208.88-9.4102-288.65zm-843 521.02c-11.152-5.4492-20.207-14.418-25.762-25.52-6.3672-12.07-9.6289-25.535-9.5-39.18v-57c0-51.566 21.434-78.422 29.293-86.531l43.52 0.003906c-21.066 45.664-12.07 103.59-3.2891 138.24-12.602 22.211-23.902 45.137-33.852 68.656-0.16406 0.43359-0.30078 0.87891-0.41016 1.3281zm228-8.0312c-1.0586 0.35156-2.1172 0.74609-3.1484 1.2031v0.003907c-9.9258 4.4258-17.469 12.914-20.699 23.293-1.9766 6.3516-3.6523 12.68-5.082 18.785-11.605-22.879-26.074-44.188-43.059-63.414l50.285-68.074c5.0781 9.6562 13.465 17.16 23.621 21.145 0.070312 13-0.066406 39.344-1.9141 67.059zm255.36 136.8c-8.4336 13.766-23.371 25.73-49.812 23.738h-0.003906c-1.0547-0.082031-2.1055-0.21875-3.1445-0.40625-45.613-8.0508-97.008-19.957-143.48-37.387v-0.003907c-4.0273-1.4688-7.6758-3.8203-10.672-6.8828-10.23-10.961-16.59-24.969-18.098-39.883-1.293-10.344 2.8711-20.621 11-27.148 8.1289-6.5234 19.062-8.3672 28.883-4.8672 32.676 11.648 121.38 36.039 167.5 48.535 9.0664 2.4375 16.457 8.9961 19.961 17.707 3.5039 8.7109 2.7109 18.562-2.1406 26.598zm14.469-137.12c-21.281 11.16-43.152 21.164-65.512 29.957-32.363 12.84-68.273 13.555-101.12 2.0117-32.09-11.293-57.418-21.992-75.426-30.273-1.1562-0.53125-2.3398-0.98828-3.5312-1.4102 2.2266-34.359 1.9219-65.582 1.7852-73.914 5.6875-17.172 42.508-130.52 61.824-244.88v0.003906c14.23 21.613 32.293 40.441 53.293 55.555-15.223 32.676-51.176 62.164-51.176 62.164-5.4688 2.0625-8.6836 7.7383-7.6367 13.488 1.0508 5.75 6.0586 9.9258 11.902 9.9258 1.4531 0.003906 2.8984-0.26172 4.2578-0.77734 74.41-28.332 105.04-99.605 112.64-137.21 1.3359-6.7422 2.1875-13.57 2.5508-20.43 67.125 98.352 51.176 223.82 50.984 225.18-0.050781 0.41797-0.074219 0.83594-0.082031 1.2578 0 0.085938-0.027344 0.16406-0.027344 0.25v0.17969 0.003906c-0.050781 35.984 2.7227 71.922 8.293 107.48-1.0117 0.46094-2.0156 0.92578-3.0156 1.4492zm-83.379-383.02c0.95312 67.203-23.758 95.773-23.758 95.773-44.574-20.898-69.801-64.117-69.801-64.117 2.0508-15.047 3.3789-29.98 4.8789-44.488 1.1914-11.543 2.2656-54.141 2.75-88.016l81.363 21.797c-0.93359 30.207 4.2773 58.621 4.5664 79.051zm231.48 316.55v0.003907c12.117 11.234 25.656 20.832 40.27 28.547-11.23 19.664-19.055 41.086-23.137 63.359-18.449-4.7461-34.871-15.32-46.828-30.145-23.238-29.359-43.492-60.965-60.457-94.344l56.383-24.895c8.8633 22.641 20.324 45.406 33.77 57.477zm-8.2578-170.17v0.003907c1.8438 2.0703 2.7383 4.8242 2.457 7.582-0.28516 2.7617-1.7148 5.2773-3.9414 6.9297l-71.207 53.094c14.441-68.191-12.41-163.38-12.41-163.38zm-124.72-97.445v0.003906c30.152 52.629 39.285 114.72 25.559 173.8-0.28906 1.2266-10.551 23.945-20.012 29.812 2.043-46.406-1.9531-152.94-70.234-236.95-5.6211-6.8477-9.2656-15.098-10.539-23.863-0.78516-5.5742-1.5742-11.41-1.9375-14.727 0 0 27.25-3.2969 42.641 17.719 12.574 17.367 24.102 35.469 34.523 54.211zm-242.42-285.67c0.59375-4.2305 1.7734-8.3594 3.4961-12.27 2.6562-5.875 8.1445-9.9688 14.535-10.832 5.668-0.87109 11.383 1.2891 15.055 5.6953 0.82812 0.97266 1.543 2.0273 2.1445 3.1562 2.3359 6.0859 9.0742 9.2266 15.238 7.1016 96.129-33.223 132.28-106.48 144.54-142.09v-0.003907c7.9492 9.6992 14.465 20.484 19.352 32.031 4.2031 9.6094 6.6055 19.91 7.0938 30.387 2.8242 58.879-5.332 120.25-10.434 151.6v0.003906c-1.8594 11.941-6.418 23.301-13.324 33.219-6.3555 8.8945-13.836 16.926-22.262 23.895-4.8359 3.9336-11.234 5.375-17.293 3.9023-25.707-6.0859-50.191-16.5-72.406-30.797-9.332-6.1172-16.594-14.914-20.824-25.238-4.9844-12-8.1172-19.598-8.1172-19.598-3.3047-7.1992-8.0547-6.6406-16.18-6.8594h0.003907c-11.152 1.4375-22.32-2.4922-30.117-10.59-8.4883-8.6211-12.387-20.758-10.5-32.707zm-29.879 78.156h-0.003906c8.7969-8.6797 16.34-18.539 22.422-29.293 0.23438 0.24219 0.44922 0.5 0.68359 0.74219v-0.003906c10.684 11.02 25.207 17.488 40.547 18.062 0.22266 14.723 0.46875 41.066 0.10938 72-24.328 2.1836-48.805 2.0547-73.105-0.39844 4.6133-20.113 7.7383-40.539 9.3477-61.109zm-3.3086 147.97c0.21484-3.8164 1.5469-7.4883 3.8359-10.551 2.2891-3.0664 5.4297-5.3867 9.0312-6.6758 9.5625-3.4922 53.863-20.07 52.266 1.4102 0 0-0.54297 8.1172-0.875 12.211-0.65234 7.0312-1.5039 13.766-2.4102 20.703-1.0781 8.2852-2.1875 16.859-2.9141 26.176-15.176 106.59-50.117 221.76-61.895 258.82-5.9102-4.0586-9.3633-10.832-9.1758-18 3.168-104.27 9.543-233.39 12.148-284.1zm-93.266-26.68c12.383-22.82 21.176-50.879 26.266-83.355v0.003906c15.395-3.6992 30.16-9.6367 43.832-17.621-6.9062 51.637-21.5 85.578-30.297 102.23-1.9609 3.8398-5.5859 6.5547-9.8164 7.3633-8.3789 1.5625-16.934 1.9414-25.414 1.1289-7.0898-0.78516-5.7266-7.6133-4.5664-9.7461zm-28.973 202.36c31.375-43.957 63.145-85.395 90.539-120.35 0 0-3.1758 120.38-3.7969 202.68l-84.934-68.859c-4.0625-3.3125-4.8516-9.207-1.8047-13.473zm-7.4102 85.785 68.297 44.562-41.941 56.824c-34.43 1.6641-68.32 9.2148-100.2 22.32 18.035-37.926 41.508-77.266 73.859-123.71zm-58.328-222.62v0.22656l-2.6016 130.49h-45.43v-116.52zm-96.156-258.33c6.9648-16.941 16.695-27.398 26.023-27.934 0.25391 0 0.51172-0.019531 0.76953-0.019531 9.1523 0 19.66 9.1758 28.266 24.805 10.629 19.281 17.383 45.609 19.012 74.117 1.6289 28.508-2.0742 55.449-10.441 75.82-7.0586 17.211-16.551 27.391-26.023 27.934-9.2578 0.49219-20.18-8.7305-29.031-24.785l0.003906-0.003906c-2.0391-3.7695-3.8789-7.6484-5.5117-11.613 5.0117 2.3516 10.477 3.5742 16.016 3.5859 3.9609-0.007813 7.8984-0.61328 11.68-1.7969 6.5469-1.9961 12.434-5.7109 17.059-10.754 4.6211-5.0469 7.8086-11.234 9.2266-17.93 2.2344-10.934 2.9727-22.117 2.1953-33.25-0.42969-10.082-3.207-19.926-8.1172-28.742-7.4805-13.039-18.113-20.629-30.742-21.957-3.207-0.375-6.4336 0.55469-8.9531 2.5742-2.5234 2.0156-4.1328 4.9609-4.4688 8.1758-0.33984 3.2109 0.62109 6.4258 2.668 8.9258s5.0078 4.0742 8.2227 4.3789c4.6523 0.49219 8.7891 3.832 12.293 9.9375v0.003906c3.0273 5.5703 4.7227 11.766 4.9414 18.105 0.64844 8.9258 0.085938 17.902-1.6758 26.676-0.73047 3.3555-2.625 6.3438-5.3516 8.4297-2.7227 2.0898-6.1016 3.1406-9.5312 2.9727-3.4258-0.16797-6.6836-1.5469-9.1914-3.8945-14.781-13.789-19.059-32.906-20.066-46.32-0.53906-25.371 3.1914-49.078 10.73-67.441z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m580.89 334.85c5.3281 0 10.137-3.2109 12.176-8.1328 2.0391-4.9219 0.91406-10.59-2.8555-14.359-3.7656-3.7695-9.4336-4.8984-14.355-2.8594-4.9258 2.0391-8.1367 6.8438-8.1367 12.176 0 7.2734 5.8984 13.172 13.172 13.176z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m627.13 334.85c5.3281 0 10.133-3.2109 12.172-8.1367 2.0391-4.9219 0.91016-10.59-2.8555-14.355-3.7695-3.7695-9.4375-4.8984-14.359-2.8555-4.9258 2.0391-8.1328 6.8398-8.1328 12.172-0.003906 3.4922 1.3867 6.8438 3.8555 9.3164 2.4727 2.4727 5.8242 3.8594 9.3203 3.8594z", fill: "currentColor" })] }) }))); };


/***/ }),
/* 217 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Apprentice1": () => (/* binding */ Apprentice1)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Apprentice1 = function (props) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "1200pt", height: "1200pt", version: "1.1", viewBox: "0 0 1200 1200", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m84.246 612.35c3.7305 0.84766 7.5664 1.1484 11.383 0.89453 2.3594 16.664 10.992 37.953 32.844 49.434 4.2656 26.062 21.426 124.29 47.719 191.02 1.1875 3.0156 3.5391 5.4336 6.5234 6.7031 3.082 0.64062 6.2617 0.65625 9.3477 0.046875 48.566-20.836 95.391-45.523 140.02-73.82l0.050781-0.023437c10.09-6.4688 19.766-13.023 28.891-19.535l0.35156-0.26562c1.4492-1.0391 2.9219-2.0742 4.3398-3.1094h0.003906c0.63672-0.47266 1.2266-1.0039 1.7617-1.5898l20.707-15.906c2.2344 20.918 10.887 40.637 24.766 56.445 13.883 15.809 32.316 26.938 52.77 31.855 10.543 27.828 17.152 56.992 19.633 86.645 0.75781 9.4219-1.5703 18.84-6.6289 26.824-11.43 18.199-34.59 64.41-42.188 111.23v-0.003906c-15.824 10.227-28.969 24.102-38.32 40.461-1.6016 1.8789-2.6016 4.1992-2.8633 6.6562-0.56641 5.7891 3.0586 11.164 8.6367 12.812 60.758 16.449 122.93 27.109 185.7 31.836 21.176 1.6523 44.277 2.7266 68.598 2.7266 86.824 0 188.92-13.719 271.71-63.883v0.003906c4.3164-2.6875 9.0312-4.6836 13.965-5.918 10.605 0.003906 20.938-3.3438 29.531-9.5547 15.23-11.273 29.125-24.246 41.414-38.672 11.074-12.699 15.188-30.035 10.988-46.352 57.152-68.723 143.34-220.61 106.67-486.63-0.85547-6.1484-6.2188-10.652-12.422-10.438-1.4102 0.054688-33.801 1.7656-49.578 46.234l-147.28 120.88c-5.3008 4.1875-6.3281 11.82-2.3242 17.262 2.0117 2.5469 4.9648 4.1797 8.1914 4.5273 3.2305 0.34766 6.4609-0.61719 8.9727-2.6758l127.52-104.62c-0.90625 56.863-10.59 261.36-100.55 357.48v-0.003906c-4.1289-1.0938-8.375-1.668-12.645-1.707-28.438-32.508-76.629-92.801-105.45-157.62-0.039063-0.085938-0.09375-0.15625-0.13281-0.23828-0.77734-1.7422-1.5352-3.4883-2.2812-5.2383-29.859-70.195-17.168-142.48-9.6758-172.21v0.003906c9.3594-4.3945 16.785-12.07 20.871-21.57 4.0859-9.5 4.5469-20.172 1.293-29.988-9.8867-29.602-27.336-56.105-50.617-76.891-9.3906-8.5312-21.543-13.395-34.227-13.695-12.688-0.30469-25.055 3.9727-34.848 12.043-5.6641 4.6406-11.25 9.625-16.703 14.898l-19.098-19.094h0.003906c-8.0039-8.0039-18.793-12.602-30.109-12.836-11.316-0.23828-22.285 3.9062-30.617 11.566l-1.9453 1.7852-9.2461-86.613v0.003906c-0.45313-4.1055 1.4805-8.1055 4.9844-10.297 21.102-13.617 39.523-30.996 54.352-51.27 3.168 13.023 8.0586 25.566 14.547 37.293 13.043 21.199 31.582 38.465 53.648 49.973 13.145 6.8164 27.723 10.406 42.527 10.465 11.051 0.027343 22-2.0977 32.238-6.2578 27.262-11.137 35.578-30.957 36.438-33.176 2.3359-6.0391-0.5-12.844-6.4336-15.438-27.531-12.043-26.883-50.496-26.875-50.824v-0.38281-128.32c0-46.965-12.48-82.141-37.098-104.55-19.242-17.012-44.34-25.879-69.996-24.734-42.117 0.17969-62.316 24.609-70.914 40.152v0.003906c-7.5273 1.207-14.879 3.3398-21.883 6.3516-9.3398-6.5547-19.297-12.176-29.734-16.789-6.4648-2.8516-13.262-5.4609-20.203-7.7656-29.703-10.176-61.832-10.914-91.977-2.1172-19.895 6.6289-37.18 19.395-49.371 36.457-18.707 5.5039-76.367 29.684-74.359 118.29 0.76953 33.984 12.977 62.078 36.234 83.605 0.12891 8.957 0.70703 17.277 1.4805 24.559l-18.641-17.273h-0.003906c-5.2695-4.8828-12.199-7.5781-19.379-7.5391-7.1836 0.039063-14.082 2.8086-19.301 7.7461l-4.9414 4.6914-30.352-29.035 1.625-34.941c0.55078-11.852-3.3438-23.48-10.918-32.613l-35.52-42.75c-2.0859-2.6172-5.1406-4.2852-8.4727-4.6211-6.1797-0.53125-11.766 3.6914-12.945 9.7812l-8.9883 46.793-27.641 4.7852-17.598-21.211h0.003906c-2.0898-2.6172-5.1406-4.2812-8.4727-4.6172-6.1797-0.53125-11.766 3.6875-12.938 9.7773l-10.453 54.473-55.082 9.5312c-3.332 0.50781-6.3164 2.3516-8.2617 5.1016-3.5273 5.1445-2.5781 12.125 2.1953 16.137l48.312 40.582c9.4648 7.9453 21.426 12.301 33.785 12.301h0.98047l43.191-0.80078 37.672 38.875h0.003907c-2.8398 5.2656-3.9375 11.293-3.1367 17.223 0.96484 6.5117 4.0938 12.512 8.8828 17.031l86.672 84.422 22.152 21.582h0.003906c-6.6641 2.5664-13.004 5.918-18.875 9.9844-9.2734 6.4961-15.371 16.609-16.781 27.844-1.4492 11.41 1.9961 22.898 9.4766 31.633 1.5664 1.8203 3.2695 3.7578 5.1094 5.8086-23.258 18.66-59.117 47.176-87.363 68.543h-0.019531c-6.3203 4.7773-11.953 8.9688-16.898 12.574v0.003907c-12.199-24.402-23.117-49.426-32.719-74.961v-73.227c-0.03125-10.781-4.2227-21.133-11.699-28.902 4.1953-26.551 3.7539-53.629-1.2969-80.027-1.7578-10.52-8.1289-19.699-17.367-25.031-6.5391-3.6445-14.152-4.8711-21.508-3.4688s-13.984 5.3477-18.727 11.141c-5.625 6.8945-8.168 15.801-7.0352 24.625 0.86328 6.6719 1.3555 13.629 1.5898 20.539h0.003906c-9.668-8.332-20.797-14.793-32.824-19.059-6.5391-2.3047-13.645-2.4258-20.258-0.34766-6.6133 2.0781-12.371 6.2461-16.414 11.879-4.2539 5.9805-6.2578 13.277-5.6602 20.594 0.59766 7.3164 3.7617 14.188 8.9297 19.398 2.0391 2.0078 4.3711 3.6914 6.9141 4.9961 7.543 4.1602 14.309 9.5898 20 16.051-9.0078 1.3281-17.703 4.2695-25.668 8.6875-13.227 7.6406-21.535 21.602-21.941 36.871-0.29688 8.6133 0.32031 17.238 1.8438 25.723 1.0781 6.125 3.8828 11.812 8.082 16.398 4.1992 4.582 9.625 7.875 15.629 9.4805zm136.7-280.96-37.121 0.6875c-6.8516 0.125-13.516-2.2305-18.766-6.6328l-28.391-23.832 38.043-6.5898c4.9531-0.85938 8.8594-4.6953 9.8086-9.6367l4.5898-24 32.734 27.48h-0.003906c0.59375 2.543 0.83203 5.1562 0.70703 7.7656zm522.71 606.52c-30.855-42.402-3.4062-132.4 1.6523-138.75h-0.003906c5.0117 9.9102 9.418 20.113 13.199 30.555l0.027344 0.089844v0.003906c5.1016 13.898 9.375 28.09 12.801 42.496 0.097656 0.41797 0.21484 0.82812 0.35156 1.2305 21.301 63.383 68.504 111.39 97.465 136.28-0.15625 5.0742 0.42969 10.145 1.7461 15.047-20.945 11.617-73.805 27.977-73.805 27.977s-15.574-62.938-53.406-114.93zm24.062-199.51c0-0.22266 0.023437-0.44531 0.03125-0.67188 0.67969-20.887-1.2891-41.773-5.8594-62.164 18.969-11.648 31.855-18.957 40.117-23.414-2.5352 40.605 3.75 81.281 18.422 119.23-10.203 5.5977-20.02 11.875-29.383 18.785-8.9531-21.871-17.93-40.82-23.301-51.766zm-355.94-1.2891c-0.77344-21.133 1.5508-42.27 6.9062-62.73 38.324 36.277 81.875 66.602 129.2 89.953 22.941 11.219 49.891 10.66 72.352-1.4961 20.344-10.992 49.457-27.902 87.508-52.816 11.969-7.8398 22.672-14.727 32.293-20.824 2.8477 15.805 4.0312 31.863 3.5312 47.91-0.98438 38.445-29.836 70.773-66.836 75.176-1.9219 0.16016-11.352 0.62109-14.773 0.35156v0.003907c-18.086-1.2695-36.008-4.3086-53.5-9.0703-20.117-5.7656-41.453-5.7656-61.57 0-17.496 4.7617-35.418 7.8008-53.508 9.0703-3.418 0.25391-12.848-0.20703-14.469-0.35156-18.316-2.4609-35.152-11.387-47.457-25.176-12.309-13.785-19.277-31.52-19.648-50zm87.414 223.75v0.003906c7.8594-12.469 11.453-27.156 10.234-41.844-1.4727-16.664-4.1055-33.211-7.8828-49.508l132.23 17.715v-0.003906c6.1836 0.82812 11.777 4.1094 15.523 9.1016 3.7461 4.9922 5.3281 11.277 4.3945 17.449l-2.7188 17.941v-0.003907c-2.6758 18.652 1.5742 37.641 11.945 53.371 13.906 20.684 23.195 44.121 27.227 68.715-100.94 15.793-200.03-7.7422-200.03-7.7422l103.19-84.641c5.168-4.2344 5.918-11.855 1.6836-17.023-4.2383-5.1641-11.859-5.918-17.023-1.6797l-110.59 90.742-0.003907-0.003907c7.6094-25.406 18.305-49.785 31.852-72.586zm-68.742 140.2c17.301-13.852 39.957-19.094 61.578-14.242 165.34 36.559 285.83 5.7539 353.26-22.734 5.9844 10.746 12.82 20.992 20.441 30.645-161.39 64.469-370.9 22.004-435.28 6.332zm659.45-534.4c-0.03125-5.8594 0.82422-11.688 2.5312-17.293 5.0234-15.75 12.227-24 18.148-28.273 24.172 197.98-22.188 327.74-69.062 404.66l-29.371-16.609c72.477-116.11 77.547-302.09 77.754-342.49zm-120.6 393.38c9.5117 7.7383 18.176 15.34 25.766 22.59 5.0039 4.7969 7.9648 11.34 8.2656 18.266s-2.082 13.703-6.6523 18.914c-11.066 13.027-23.582 24.75-37.305 34.941-4.6914 3.2773-10.305 4.9805-16.027 4.8711-5.7227-0.10938-11.262-2.0312-15.824-5.4844-9.6367-7.3242-18.66-15.43-26.973-24.227-4.2148-4.5156-6.7578-10.336-7.2188-16.496-0.45703-6.1602 1.1992-12.293 4.6992-17.387 8.4688-12.375 22.59-29.223 41.707-39.23v0.003906c4.7031-2.4141 10.012-3.3945 15.266-2.8164 5.2578 0.57422 10.227 2.6797 14.297 6.0547zm-57.691-40.625c0.25781 0.070313 0.51562 0.074219 0.77344 0.125 4.9414 6.1055 9.6602 11.812 14.066 16.992l-0.003907 0.003906c-13.297 7.5039-25.191 17.262-35.156 28.832-14.297-11.988-27.586-25.129-39.742-39.285 18.527-9.5117 39.902-11.883 60.062-6.668zm-53.836-76.234c10.941 17.648 22.457 34.234 33.641 49.301l-0.003906 0.003907c-19.184-0.003907-38.051 4.875-54.824 14.184-6.7656-9.6367-12.465-19.98-16.988-30.852 9.2266-14.41 22.508-25.773 38.172-32.66zm-27.449-49.602c4.6797 9.7148 9.75 19.266 15.043 28.637h-0.003907c-12.961 5.9648-24.574 14.5-34.141 25.086-3.125-11.117-6.9219-22.516-11.012-33.652 9.4883-7.4844 19.559-14.207 30.113-20.094zm-210.21-449.46c-3.9648 1.1328-7.5469 3.3281-10.355 6.3516-3.9648 4.2461-6.1719 9.8398-6.168 15.648v9.5312-0.003907c0.046875 8.2188-3.1367 16.129-8.8672 22.02-19.941 20.414-43.84 36.539-70.234 47.387-8.4453 3.4023-18.023 2.4727-25.656-2.4922-32.145-20.715-54.918-53.18-63.453-90.457-0.20703-0.85937-18.055-77.648 12.422-124.75 12.48 30.812 46.008 83.215 131.39 93.883 6.4961 0.76953 12.441-3.7383 13.457-10.199 1.1016-5.5703 3.457-10.816 6.8828-15.34 3.7578-4.793 9.6289-7.4414 15.711-7.0859 5.4219 0.21484 10.383 3.1211 13.215 7.75 4.3281 8.2109 6.3438 17.441 5.8281 26.711 0.058593 1.9023-0.058594 17.074-14.176 21.051zm-3.3711 136.81-63.266 58.16-7.7422-5.707-4.1094-38.77c37.305-13.059 59.527-32.859 71.547-47.117zm87.785-349.06c15.84 24.387 15.965 44.016-0.17188 61.832-7.8516-31.383-24.23-59.98-47.328-82.629 14.938-3.2852 33.32-1.0508 47.512 20.785zm-462 142.8c-1.9883-4.6562-4.6328-8.9961-7.8594-12.895l-5.0625-6.0938 22.199-3.8477h0.003906c4.957-0.85938 8.8633-4.6953 9.8125-9.6367l5.7305-29.855 19.371 23.344c3.7305 4.4883 5.6445 10.211 5.3711 16.043l-1.3555 29.121-31.199 0.57422c-5.6602 0.12891-11.172-1.8203-15.492-5.4766zm2.293 63.949 1.6133-34.73c4.125 1.1406 8.3867 1.7227 12.668 1.7305h0.89062l37.543-0.70703 29.852 28.559-14.719 13.93-26.395-25.863c-4.7695-4.6797-12.426-4.6055-17.105 0.16406-4.6797 4.7656-4.6055 12.426 0.16406 17.102l25.766 25.25-13.367 12.648zm41.125 69.113c0.003906-1.1172 0.46484-2.1836 1.2812-2.9531l79.332-75.074c1.5703-1.4844 4.0234-1.4961 5.6133-0.027344l42.824 39.672c6.0156 19.914 15.688 38.531 28.516 54.91l-92.59 48.527-63.734-62.082c-0.80469-0.77734-1.2539-1.8516-1.2422-2.9727zm82.109 167.74v0.003906c0.51953-4.4609 2.9258-8.4805 6.6094-11.047 5.582-3.8438 11.715-6.8164 18.188-8.8203 24.578 30.445 53.457 57.148 85.73 79.273 5.5039 3.6406 12.914 2.1914 16.645-3.2539 3.7344-5.4453 2.4102-12.875-2.9727-16.699-30.297-20.852-57.434-45.953-80.578-74.539 7.1992-14.141 17.316-26.594 29.68-36.543 3.1719-2.6133 7.1289-4.0938 11.234-4.207 4.1094-0.11328 8.1406 1.1484 11.453 3.582l71.293 52.559-4.168 3.832c-2.8984 2.6719-6.5625 4.3555-10.477 4.8203-3.9141 0.46094-7.8711-0.32422-11.312-2.2422l-8.7188-4.8555v-0.003906c-5.8359-3.2461-13.199-1.1523-16.449 4.6836-3.25 5.8359-1.1523 13.199 4.6836 16.449l8.7188 4.8555h-0.003906c7.8828 4.4023 16.957 6.2031 25.922 5.1445 8.9648-1.0625 17.367-4.9258 24.008-11.047l14.973-13.766 94.699-87.059h-0.003906c3.7344-3.4492 8.6602-5.3164 13.742-5.2109 5.0859 0.10547 9.9297 2.1797 13.516 5.7812l19.68 19.672-118.14 134.7c-4.2773 5.0352-3.7227 12.57 1.2461 16.926 4.9648 4.3555 12.508 3.918 16.941-0.98047l125.39-142.97c7.2461-7.6562 14.965-14.852 23.105-21.551 5.3359-4.3828 12.07-6.7031 18.973-6.5273 6.9062 0.17578 13.516 2.832 18.621 7.4805 20.141 17.965 35.242 40.879 43.805 66.473 1.4102 4.2578 1.1914 8.8867-0.61328 12.996-1.8047 4.1055-5.0625 7.3984-9.1523 9.2422-21.035 9.5938-56.031 28.746-103.32 65.539v-0.003906c-41.605 32.074-85.715 60.766-131.9 85.797-10.902 5.9102-24.035 5.9883-35.004 0.20703-104.12-54.844-158.87-108.65-182.23-135.84-3.0312-3.5508-4.418-8.2188-3.8164-12.844zm-16.234 70.797h-0.003906c9.3398 10.25 15.492 22.992 17.707 36.68 0.023438 0.35156 1.9297 28.824-39.438 65.895h-0.003906c-7.9609-21.406-19.41-41.348-33.879-59.016 18.156-13.91 38.18-29.68 55.629-43.559zm-89.293 68.656c4.1914-2.9805 8.9648-6.457 14.395-10.5v0.003906c14.812 17.832 26.055 38.355 33.113 60.441-21.602 15.141-44.656 28.09-68.824 38.652 18.609-36.172 21.078-75.07 21.312-88.594zm-30.773-15.035c3.0469 6.1445 5.3594 10.609 6.5898 12.953-0.10547 10.027-1.9297 54.129-24.395 89.648v-0.003906c-11.145-21.484-20.75-43.734-28.75-66.578 18.414-7.707 34.473-20.129 46.555-36.02zm-26.117-58.133c4.7422 11.809 9.5664 22.898 14.031 32.703-0.23047 0.31641-0.44141 0.64844-0.63672 0.98828-9.5742 16.535-24.117 29.625-41.566 37.41-4.6641-14.805-9.2383-31.121-13.438-48.887v0.003906c15.598-3.5781 29.961-11.246 41.617-22.207zm-35.879-209.9c1.3672-1.6797 3.375-2.7148 5.5352-2.8516 4.3867-0.30859 8.3125 2.707 9.1484 7.0234 4.3164 21.625 5.2812 43.785 2.8633 65.703-0.32812-0.054687-0.64062-0.14062-0.97266-0.19141-5.7578-0.83594-11.578-1.125-17.391-0.86719 1.6484-20.863 1.3359-41.832-0.93359-62.637-0.30469-2.2148 0.32812-4.4531 1.75-6.1797zm12.996 93.605c4.1133 0.67188 7.8516 2.7852 10.547 5.9648 2.6953 3.1797 4.168 7.2148 4.1602 11.383v71.664c-12.879 17.719-33.512 28.129-55.414 27.957-16.652-7.3633-21.266-23.156-22.492-33.031 7.5312-2.6875 14.043-7.6523 18.629-14.203 4.5859-6.5547 7.0195-14.371 6.9648-22.367v-0.089844c2.6133 0.36719 5.25 0.55469 7.8906 0.5625 1.6484 0 3.3477-0.0625 5.0977-0.1875h-0.003906c3.2305-0.1875 6.2539-1.6602 8.3867-4.0938 2.1367-2.4297 3.207-5.6133 2.9805-8.8438-0.23047-3.2266-1.7461-6.2266-4.207-8.3281-2.457-2.1055-5.6562-3.1328-8.8789-2.8633-8.2188 0.59375-14.047-0.88281-17.332-4.3711l-0.003906 0.003906c-2.4844-3.0312-3.9375-6.7773-4.1445-10.695 16.98-7.8086 33.059-10.676 47.816-8.4609zm-84.875-47.543h-0.003907c-1.6172-0.89062-2.7734-2.4336-3.1758-4.2344-0.44141-1.8906-0.042969-3.8828 1.0898-5.457 2-2.8125 5.6172-3.9609 8.8711-2.8242 16.816 5.8438 31.055 17.398 40.234 32.656-0.15625 2.332-0.32031 4.5508-0.49219 6.6211h0.003906c-4.168 1.1914-8.2695 2.5938-12.293 4.1992-8.8789-12.82-20.594-23.414-34.238-30.961zm-15.027 83.492h-0.003906c0.15625-6.8203 3.8398-13.07 9.7305-16.508 5.7656-3.1523 12.074-5.1875 18.598-6 1.0547 8.0391 4.4609 15.59 9.7852 21.703 0 0.22266-0.0625 0.42969-0.058594 0.65234l0.0625 11.688v0.003906c0.027344 3.418-1.1602 6.7344-3.3516 9.3594s-5.2383 4.3906-8.6094 4.9805l-3.9961 0.70703 0.003906-0.003907c-3.8125 0.67578-7.6719 1.0469-11.543 1.1133-4.4688 0.16016-8.3828-2.9688-9.2109-7.3594-1.1758-6.7109-1.6484-13.527-1.4141-20.336z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m875.34 698.7-4.8008 3.9375v0.003906c-2.4805 2.0312-4.0508 4.9688-4.3672 8.1641-0.3125 3.1914 0.65234 6.3789 2.6875 8.8594 4.2383 5.168 11.859 5.918 17.027 1.6797l4.8008-3.9414h-0.003906c5.168-4.2383 5.918-11.859 1.6836-17.027-4.2383-5.1641-11.863-5.918-17.027-1.6797z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m463.97 315.95c-2.2852-0.27344-4.5273-0.82422-6.6797-1.6406-6.1836-2.3711-13.125 0.67188-15.57 6.8281-2.4453 6.1523 0.51562 13.129 6.6367 15.648 4.3672 1.6914 8.9375 2.7891 13.594 3.2656 0.35156 0.027343 0.68359 0.042968 1.0234 0.042968 6.4961 0.015625 11.844-5.1055 12.109-11.594 0.26953-6.4883-4.6367-12.031-11.113-12.551z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m510.75 314.36c-2.1523 0.82031-4.3945 1.3711-6.6836 1.6445-6.4727 0.51953-11.379 6.0586-11.113 12.547s5.6094 11.609 12.105 11.598c0.33984 0 0.67578-0.015626 1.0156-0.042969 4.6602-0.47656 9.2344-1.5742 13.602-3.2617 6.1406-2.5078 9.1172-9.4961 6.668-15.66-2.4453-6.1641-9.4023-9.2109-15.594-6.8242z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m527.79 666.35 2.5078 0.95703c0.94141 0.34766 1.8828 0.67578 2.8242 0.98438 6.3516 2.0625 13.176-1.4141 15.238-7.7656 2.0625-6.3555-1.418-13.176-7.7695-15.238-0.60156-0.19922-1.2031-0.40234-1.8086-0.62891l-2.2695-0.86719c-6.2109-2.3398-13.145 0.76562-15.539 6.957-2.3945 6.1875 0.64453 13.152 6.8125 15.602z", fill: "currentColor" })] }) }))); };


/***/ }),
/* 218 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Adventurer1": () => (/* binding */ Adventurer1)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Adventurer1 = function (props) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "1200pt", height: "1200pt", version: "1.1", viewBox: "0 0 1200 1200", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m518.82 295.53c2.332 0.4375 6.7422 1.3125 10.023 2.2812 3.0781 0.90625 6.3906 0.55469 9.207-0.98047 2.8164-1.5391 4.9062-4.1328 5.8086-7.2109 1.8828-6.4102-1.7852-13.133-8.1953-15.016-4.0859-1.2031-8.9922-2.2148-12.391-2.8516-6.5664-1.2305-12.887 3.0977-14.117 9.6602-1.2266 6.5664 3.0977 12.887 9.6641 14.117z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m1066.6 633.43c4.8555-0.039062 9.4609 2.1367 12.516 5.9141 7.6367 9.6992 19.309 15.352 31.656 15.32h13.355c10.828 0 21.211-4.3008 28.867-11.957 7.6602-7.6562 11.961-18.039 11.961-28.867v-29.695c0.035157-15.805-6.0391-31.008-16.953-42.43-10.918-11.426-25.828-18.191-41.613-18.875l-74.793-3.9961c-17.965-6.3516-160.57-55.332-280.29-56.352v0.003907c-3.5586-0.03125-6.9531 1.5078-9.2773 4.207-2.3203 2.6992-3.3359 6.2852-2.7695 9.8047 1.8164 9.7891 4.3984 19.418 7.7266 28.801-11.473-0.57031-24.199-1.2812-38.082-2.1172-30.129-1.8438-59.898-3.9727-79.566-5.4375h-0.003906c-12.352-0.875-24.395-4.2773-35.379-10-22.438-11.344-46.309-19.586-70.965-24.504-2.0391-1.5781-4.1289-3.1406-6.2422-4.6953 0.09375-9.1758 0.25781-18.641 0.50781-28.387 4.1328 1.3359 8.1172 2.4414 11.793 3.3164 3.582 0.85547 7.2539 1.2852 10.941 1.2852 12.129-0.027344 23.809-4.6172 32.711-12.855 15.789-14.406 26.602-33.449 30.879-54.391 6.7734-33.129 11.156-70.965 12.469-83.035 29.359-33.531 33.633-74.699 33.457-96.688h0.003906c-0.12109-10.094-1.543-20.129-4.2344-29.859-8.9297-32.742-24.242-54.395-45.531-64.363-13.848-6.25-29.43-7.5352-44.117-3.6406-8.2383-8.8242-24.785-23.449-47.062-27.938-52.941-10.664-94.941-1.8789-124.87 26.117-5.4961 5.1562-10.652 10.664-15.434 16.496-29.887 37.23-44.613 84.375-41.23 132 1.0703 25.281 7.9062 49.984 19.992 72.219-24.312 4.8633-46.984 15.844-65.875 31.902-14.047-4.3984-45.09-10.559-75.434 7.2383h-0.003906c-15.641-14.242-34.52-24.453-54.996-29.758-3.4414-23.504-13.34-45.59-28.59-63.805 27.141-35.875 19.039-77.91 8.543-100.32 7.0586-17.594 23.617-71.141-15.684-111.02l-0.003906 0.003907c-3.5469-3.6055-8.9688-4.6172-13.578-2.5391-0.94141 0.42188-93.531 43.957-58.195 181.44-21.512 48.121 5.4375 97.789 14.754 112.61 0.13672 0.21875 0.33203 0.375 0.48047 0.58203 4.3711 70.492 66.84 79.594 85.629 80.715v-0.003907c14.316 16.887 35.074 26.973 57.195 27.797 1.6094 0.070312 3.2031 0.10547 4.7773 0.10547 17.352 0.46484 34.398-4.6133 48.664-14.5 8.3359 1.5508 16.793 2.3398 25.27 2.3594 20.641 0 46.789-5.0312 63.605-26.57h0.003906c5.5391 1.6055 11.191 2.8047 16.906 3.5859 12.613 1.5469 25.414 0.25391 37.469-3.7852v31.602c-14.93 9.5586-39.473 21.148-75.207 26.066-12.531-0.93359-63.754 3.0664-122.8 116.65-0.019531 0.035157-0.023438 0.070313-0.042969 0.10547-2.6523 5.1016-5.25 10.285-7.7344 15.414-40.762 84.262-53.613 138.19-57.484 167.13-24.426-4.0469-49.211-5.5156-73.941-4.3789-5.2891 0.36719-9.7227 4.1328-10.941 9.2891-0.5 2.3789-0.29297 4.8555 0.59375 7.1172 33.664 93.176 121.56 159.85 194.89 201.39l-19.059 19.691c-42.426 42.562-76.109 93.016-99.152 148.52-1.0039 2.2578-1.3047 4.7656-0.87109 7.1953 1.0898 5.7188 6.0859 9.8555 11.906 9.8633h608.2c2.4805 0.046875 4.9219-0.64844 7.0039-2.0039 4.8594-3.2383 6.7227-9.4805 4.4258-14.852-1.9141-4.4766-41.855-95.625-137.71-168.79 0 0 145.82-0.70703 222.12 124.54 2.0586 3.4336 5.7617 5.5469 9.7656 5.5703h0.10156c5.2891-0.046876 9.9336-3.5234 11.473-8.582l28.645-94.379v-0.003906c1.6641-5.5273 1.5352-11.441-0.36719-16.895-1.9023-5.4531-5.4805-10.164-10.223-13.457-85.957-60.164-185.82-90.555-308.87-53.438l0.003907-135.09c-0.007813-10.969 3.5547-21.641 10.152-30.406 6.7383-9.0742 14.215-17.578 22.344-25.43 20.566-19.566 30.535-47.785 26.824-75.926-7.4336-56.223-31.555-108.93-69.25-151.3 6.8203 2.6797 13.496 5.7148 20 9.0898 13.906 7.25 29.148 11.566 44.789 12.68 16.801 1.2539 40.941 2.9844 66.426 4.6211h0.003906c-3.5352 26.574 2.0195 53.566 15.762 76.586h-49.766c-5.8047-0.078125-10.871 3.9141-12.156 9.5781-0.75391 3.5703 0.14062 7.2891 2.4375 10.129 2.3008 2.8359 5.7539 4.4844 9.4062 4.4844h189.03c11.965 4.1094 24.527 6.1992 37.18 6.1836zm-28.07-90 66.676 3.5664c9.5781 0.39844 18.625 4.4883 25.254 11.414 6.6289 6.9219 10.32 16.141 10.301 25.727v29.695c-0.003906 4.4102-1.7578 8.6406-4.8789 11.758-3.1211 3.1211-7.3477 4.875-11.762 4.8789h-13.348c-4.9219 0.015625-9.5781-2.2227-12.637-6.0781-7.6484-9.6016-19.262-15.184-31.535-15.152h-28.977c-6.7773-22.777-2.2227-51.398 0.91016-65.801zm-577.68-235.2c0.64844-20.309 11.75-38.844 29.348-49 34.121-19.891 52.004-44.715 61.371-65.293h0.003906c5.5312 9.832 11.66 19.312 18.352 28.391 4.3633 6.1602 8.4688 11.977 11.785 17.59 5.582 9.8359 9.0508 20.723 10.188 31.973-2.8242 0.55078-9.1758 1.8633-13.41 3.1094h-0.003907c-5.7695 1.6953-9.418 7.375-8.5625 13.328 0.85938 5.9531 5.957 10.375 11.973 10.375 1.1289 0 6.4688-1.3086 8.3125-1.7305-2.1172 17.004-5.668 42.812-10.348 65.695-3.2734 15.953-11.523 30.461-23.559 41.43-5.8125 5.4375-13.949 7.6289-21.707 5.8438-23.672-5.5273-45.234-17.801-62.074-35.332-4.1133-4.3945-6.8516-9.8984-7.8711-15.832-3.0664-16.664-4.3398-33.609-3.7969-50.547zm-38.703 104.03c17.688 22.891 42.43 39.32 70.391 46.738-0.41016 40.168 0.47266 73.934 1.2266 94.055-37.406-19.344-63.824-54.832-71.617-96.219zm-79.574 71.426c19.594-3.8867 38.535-10.531 56.258-19.742 3.5664 18.707 21.457 84.801 98.824 117.71 6.9336 16.137 30.734 79 5.6055 130.23l-0.003906 0.003906c-2.8945 5.7148-6.4023 11.105-10.453 16.074-12.129 15.293-39.605 53.109-45.566 88.445-21.648-0.15234-44.652-0.74219-69.012-1.7656v-47.492c0-12.543-4.3828-24.695-12.391-34.352l-31.512-37.996c-8.0391-9.6992-10.531-22.844-6.6016-34.809l4.0508-12.289c16.559-34.941 21.133-81.531 21.133-81.531 6.3828-27.855 2.7266-57.07-10.332-82.496zm97.492 421.16h0.23047c27.387-0.51172 74.035 2.7852 108.18-5.3164v39.371c-19.547 1.082-62.309 2.8242-108.8 0.90625-5.1484-15.129-15.387-28.004-28.973-36.422l-2.6406-1.6445-0.22656-4.9414h0.003907c-0.33984-8.9062-3.3438-17.504-8.6211-24.684s-12.59-12.605-20.988-15.586v-15.48c20.766 1.4922 46.902 2.7773 75.57 2.7773v0.003907c31.641 0.13672 63.262-1.6797 94.676-5.4375v36.203c-33.25 8.7344-80.914 5.543-108.64 6.0586h0.003906c-6.6797 0.0625-12.043 5.5234-11.98 12.203 0.058594 6.6758 5.5234 12.043 12.203 11.98zm-112.59-0.99219 0.003906 0.003906c0.52734-0.57031 1-1.1914 1.4102-1.8516 5.9766-9.7227 14.715-17.441 25.098-22.176 6.3281-2.9297 13.703-2.5117 19.66 1.1094 5.9609 3.625 9.7227 9.9766 10.039 16.945l0.51562 11.293c0.17969 3.9766 2.3086 7.6094 5.6836 9.7148l8.0352 5.0039h0.003907c9.3203 5.6367 16.211 14.543 19.328 24.98 3.1133 10.441 2.2344 21.664-2.4727 31.488-0.54297 1.1016-1.1016 2.1602-1.6797 3.1758v0.003906c-5.2695 8.9062-13.512 15.668-23.277 19.094-9.7617 3.4258-20.422 3.2969-30.102-0.36328-23.785-9.0469-46.621-20.406-68.184-33.918 7.8906-23.535 20.078-45.406 35.941-64.5zm-10.141-34.52 0.003906 0.003906c-17.254-26.316-39.953-48.625-66.562-65.422 6.8281-29.355 15.555-58.238 26.117-86.469l37.191 50.367c4.1211 5.6094 6.3516 12.387 6.3711 19.344v36.922zm-0.61719-382.27c14.027 21.957 18.547 48.664 12.527 74.012-3.625 16.125-10.684 31.277-20.691 44.434-4.0039 5.3164-7.9414 10.992-11.797 16.941-19.844-23.039-47.363-36.809-68.594-44.586 42.25-75.977 76.59-88.746 88.555-90.801zm-102.77 118.2c0.94141-1.9336 1.8945-3.8711 2.8555-5.8125 20.707 7.1992 49.527 20.953 66.707 45.141-4.793 8.6836-9.2227 17.543-13.387 26.469-23.09-24.742-53.398-33.953-69.438-37.23 4.0234-9.082 8.4336-18.578 13.262-28.559zm-23.059 51.363c10.914 1.6797 47.012 9.3633 68.391 39.281-4.957 12.215-9.3828 24.289-13.277 35.906-24.223-18.707-55.621-25.465-72.637-27.84 4.4961-13.871 10.238-29.625 17.523-47.34zm-24.488 70.859c14.492 1.7188 50.352 8.0234 71.688 29.5-3.7148 12.66-6.7812 24.32-9.2227 34.434h0.003907c-22.363-11.156-46.004-19.543-70.398-24.969 1.7656-13.148 4.4141-26.164 7.9336-38.957zm74.539 181.95c-101.12-35.082-152.96-117.84-158.5-127.06-0.17188-0.30078-0.35156-0.58203-0.52344-0.88281 44.688 1.2539 154.98 13.391 213.09 98.23h0.003906c-8.4648 5.5703-15.973 12.473-22.238 20.438-3.6914 4.6445-8.7383 8.0352-14.438 9.6953-5.6992 1.6641-11.773 1.5195-17.387-0.41406zm180.38 165.31c-6.3086 17.941-18.012 33.496-33.508 44.523-15.496 11.031-34.023 16.996-53.043 17.078h-118.01c13.789-39.535 37.609-74.809 69.133-102.37l24.707 11.293s82.887 31.477 123.55-49.766c0.8125-1.4414 1.6016-2.9375 2.3594-4.4805 4.0977-8.3867 6.3906-17.539 6.7344-26.867 13.738 0.50391 27.109 0.70703 39.609 0.70703 2.8047 0 5.5625-0.007813 8.2773-0.027344-35.73 30.84-57.32 74.629-69.805 109.91zm305.72 61.602h-113.21c-9.375-0.058594-18.531-2.8516-26.34-8.043s-13.934-12.551-17.613-21.172c-15.16-34.551-36.492-66.043-62.953-92.938v-0.03125c18.23-43.371 50.824-51.594 50.824-51.594 96.918 54.945 150.02 138.35 169.29 173.79zm-119.02-481.63c2.6562 20.457-4.6289 40.949-19.594 55.145-9.0977 8.7734-17.453 18.277-24.988 28.422-9.7266 12.934-14.977 28.684-14.957 44.867v30.211c-23.375 1.7656-48.816 2.793-76.547 3.0312 6.6055-29.648 31.648-63.09 39.828-73.41h0.003906c5.1289-6.3203 9.5586-13.176 13.219-20.449 31.488-64.188 0.25-138.9-6.2969-153.18-0.42578-8.3164-1.8477-38.699-2.0508-80.184 50.258 41.672 82.902 100.8 91.383 165.54zm153.13-115.44c-3.7617 21.059-4.2969 42.566-1.5742 63.785h-20.223c-17.496-20.844-25.219-48.184-21.219-75.098 14.336 0.84375 27.312 1.5195 38.793 2.0352 1.3477 2.9141 2.7969 5.8828 4.3398 8.9102-0.03125 0.13281-0.085937 0.24219-0.11719 0.37109zm22.812 63.785c-1.3125-10.059-1.9414-20.195-1.8867-30.336 7.2344 9.9141 15.234 19.246 23.926 27.91 0.83203 0.83203 1.7031 1.625 2.5586 2.4258zm-17.293-115.96c85.172 3.6797 181.08 30.426 228.53 45.266 0 0.054688 9.4062 38.336-38.645 43.934l-79.098-0.003906c-75.258 0.003906-110.79-89.195-110.79-89.195z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m807.11 794.41c-28.449-14.121-61.621-15.211-90.934-2.9844-45.27 19.047-84.238 50.5-112.41 90.727-1.1562 1.6328-1.1758 3.8125-0.054688 5.4688 1.1211 1.6562 3.1523 2.4453 5.0977 1.9805 27.316-6.3516 55.516-7.9648 83.375-4.7656 6.9648 0.83203 14.012-0.59375 20.102-4.0703 19.434-11.164 69.992-33.914 143.51-21.742 3.25 0.55078 6.5234-0.82422 8.4062-3.5312 1.8828-2.7031 2.0312-6.2539 0.38672-9.1094-8.3203-14.379-25.223-35.793-57.473-51.973z", fill: "currentColor" })] }) }))); };


/***/ }),
/* 219 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Expert1": () => (/* binding */ Expert1)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Expert1 = function (props) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "1200pt", height: "1200pt", version: "1.1", viewBox: "0 0 1200 1200", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m715.04 557.57c2.1133 0 4.1875-0.55469 6.0156-1.6133 2.4609-1.4102 5-2.8477 7.6133-4.3008 5.8398-3.2461 7.9414-10.609 4.6953-16.445-3.2422-5.8398-10.605-7.9414-16.445-4.6992-2.7188 1.5117-5.3594 3.0039-7.9219 4.4805-4.7578 2.7305-7.0859 8.3203-5.668 13.617 1.418 5.3008 6.2227 8.9844 11.711 8.9727z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m595.41 328.45c3.418 0.4375 6.793 1.1211 10.109 2.0469 1.1016 0.32031 2.2383 0.48437 3.3867 0.48437 6.0195 0 11.121-4.4297 11.969-10.391 0.84766-5.9609-2.8164-11.641-8.6016-13.32-4.625-1.3086-9.3438-2.2656-14.117-2.8516-6.6367-0.75391-12.625 4.0117-13.383 10.648-0.75391 6.6367 4.0117 12.629 10.648 13.383z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m663.77 330.98c1.1445 0 2.2852-0.16406 3.3828-0.48437 3.3164-0.92578 6.6914-1.6055 10.105-2.043 6.5898-0.80469 11.297-6.7734 10.547-13.367-0.74609-6.5977-6.6719-11.355-13.273-10.668-4.7734 0.58594-9.4922 1.5391-14.117 2.8516-5.7852 1.6797-9.4492 7.3594-8.6016 13.32 0.84766 5.9609 5.9492 10.391 11.973 10.391z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m1052.5 514.48c-2.2891-4.4492-7.0117-7.1055-12-6.7461-3.2422 0.30469-6.2227 1.8984-8.2734 4.4258-2.0508 2.5234-3 5.7695-2.6328 9.0039 0.26953 2.3242 25.309 234.65-86.871 430.27-0.070312 0.125-0.11328 0.25781-0.17969 0.38281l-0.027343-0.019531h-0.003907c-6.4492 9.7969-13.539 19.152-21.223 28.016l-1.8555-4.1523c-2.2422-12.949-19.012-114.61-11.836-217.77v-0.75391c0-0.125 0.03125-0.23828 0.027344-0.35156-1.7422-77.043-10.457-137.69-25.91-180.61l1.7656-3.2461c13.082-3.5781 23.348-13.723 27.074-26.762 3.7305-13.039 0.38281-27.078-8.8281-37.031-13.461-14.016-30.883-23.59-49.934-27.438-10.504-28.988-61.059-31.371-85.059-30.797v-0.003906c-9.2617 0.21484-18.203-3.3867-24.727-9.957-4.9727-4.7891-9.2422-10.254-12.684-16.238-4.4883-8.4961-4.6211-18.633-0.35156-27.242 9.7656-19.969 16.332-41.348 19.465-63.352 0.16406-1.1602 2.4219-17.176 4.4531-38.871v-0.003907c5.9922-4.2578 10.078-10.695 11.375-17.93 3.832-20.078 5.2148-40.547 4.1172-60.957 9.0742-6.707 54.84-31.828 54.84-31.828 3.3164-1.7109 7.3047-1.4766 10.395 0.61719 3.0898 2.0938 4.7891 5.7109 4.4297 9.4258-0.25 2.2148-1.1875 4.2969-2.6836 5.9492l-24.902 28.648c-4.8984 5.5977-6.6758 13.273-4.7305 20.453 21.512 78.414 75.332 188.29 209.07 209.95 0.64453 0.10547 1.293 0.15625 1.9414 0.15625 5.4609-0.003906 10.238-3.6641 11.664-8.9336 1.4258-5.2695-0.85156-10.84-5.5586-13.598-0.60938-0.35156-60.801-37.141-57.223-168.97 0.19141-5.9609 3.8828-146.6-63.387-199.89l-0.003907-0.003906c-15.305-12.301-35.234-17.273-54.523-13.602-19.293 3.6758-36 15.625-45.711 32.691-7.3359 12.688-11.629 26.898-12.547 41.52-14.723 6.8711-30.637 10.828-46.863 11.648-11.637-15.43-26.684-27.957-43.965-36.602-25.359-12.961-54.082-17.836-82.297-13.969-28.215 3.8672-54.566 16.289-75.504 35.594-49.297 45.84-46.941 110.56-41.168 145.06 1.5195 8.9805 7.4688 16.59 15.82 20.227 2.1758 0.95312 4.4648 1.625 6.8125 1.9922 0.86328 18.035 3.0781 35.984 6.6289 53.688 2.3047 15.516 6.6797 30.652 13.004 45.008 0 0-3.8164 12.027-6.543 13.469 0 0-147.09-292.65-450.93-363.92-3.4609-0.85547-7.1211-0.16797-10.039 1.8828-2.8906 2.0703-4.7266 5.3125-5.0117 8.8594-0.23438 3.0156-5.0781 74.773 52.543 153.93 15.523 21.16 37.625 36.586 62.844 43.859 62.199 18.656 121.04 47.102 174.29 84.262-30.781 1.4102-60.906 9.3789-88.359 23.375-25.203 12.805-54.551 14.719-81.199 5.293-17.141-6.2188-29.742-14.969-37.465-26.004-2.6562-3.8281-7.2422-5.8359-11.859-5.1836-5.9062 0.92188-10.258 6.0234-10.234 12 1.3008 29.965 10.605 59.031 26.941 84.18 18.707 28.09 50.25 44.934 84 44.855 16.586-0.015624 32.926-4.0547 47.609-11.77 13.418-7.0195 26.309-15 38.578-23.875 24.863-17.734 55.422-25.625 85.766-22.148 40.113 4.1133 74.711 27.176 78.496 31.641 0 0-15.973 18.172-90.223 50.395-15.031 6.5234-16.359 28.918-6.9922 44.594 3.25 5.2148 7.8945 9.4102 13.414 12.113 1.1953 0.60938 2.4414 1.2539 3.6953 1.8984-15.375 31.441-32.117 90.805-34.629 201.45v0.20312 0.35156c2.4961 102.8-10.094 204.47-11.922 218.58l-0.20703 0.47266c-7.9336-5.1055-15.023-11.418-21.016-18.703h-0.023438c-0.066406-0.10156-0.11328-0.21484-0.18359-0.31641-130.71-187.19-123.63-425.09-123.53-427.47v-0.003907c0.21094-5.793-3.7188-10.926-9.3711-12.227s-11.434 1.5898-13.777 6.8945c-69.484 157.24-64.07 274.26-47.32 344.74 18.414 77.395 53.594 116.92 55.078 118.56l0.003906 0.003907c1.793 1.9766 4.1914 3.3086 6.8203 3.7812 41.617 7.5039 93.637 34.164 112.74 75.426h0.003906c-4.6367 10.871-5.9531 22.871-3.7891 34.488 2.1641 11.617 7.7148 22.336 15.949 30.809 26.93 26.902 97.105 26.824 97.117 26.824h427.34c0.35156 0.03125 0.6875 0.082031 1.0586 0.082031h0.16406c42.75-0.55469 67.766-8.3477 86.379-26.902 7.7227-7.9258 13.094-17.84 15.516-28.637 2.4219-10.797 1.793-22.055-1.8086-32.52 15.727-32.199 47.84-73.562 111.99-90.352 2.582-0.67578 4.8711-2.1875 6.5039-4.3047 1.3555-1.7656 33.375-43.883 45.734-122.47 11.246-71.492 7.5977-188.4-73.574-339.57zm-832.6 454.18c-7.918-10.109-33.355-46.055-47.461-106.59-13.59-58.34-18.793-150.68 24.656-273.57 0 0-39.234 267.09 90.508 387.68-20.805 1.5742-58.09-3.3594-67.703-7.5234zm661.98-177.71c-20.977-10.949-44.516-16.031-68.141-14.707-0.027344-9.9297 0.039063-18.055 0.11328-23.797 29.391-4.082 56.953 6.2773 69.109 11.836-0.52734 8.9414-0.86719 17.844-1.082 26.668zm0.38281 55.793h-0.003906c-22.449 1.3594-44.684 5.1953-66.289 11.445-1.1055-21.09-1.6953-40.785-1.9844-57.738 23.684-1.6133 47.223 4.7539 66.863 18.086 0.25781 0.17578 0.53125 0.30859 0.79688 0.46094 0.074219 9.4375 0.28516 18.707 0.61328 27.719zm0.58203-108.75-0.003906-0.003906c-21.988-8.6836-45.715-12.07-69.258-9.8789-0.27344-5.6836-0.16016-26.285-3.0742-50.824 0 0 3.2266-46.34 58.461-57.594 6.3438 28.051 11.781 66.359 13.871 118.28zm-136.43 115.43c-37.387 27.844-77.832 51.324-120.55 69.992-32.188-16.668-63.172-35.574-92.715-56.578 1.2656-13.484 3.9453-43.645 4.4062-61.836 0.375-16.5-5.2891-32.566-15.934-45.176-39.27-46.762-28.031-101.04-15.219-133.49 31.168 23.207 66.625 50.719 96.637 76.895h-0.003906c11.965 10.398 27.234 16.211 43.086 16.398 15.852 0.1875 31.254-5.2578 43.461-15.371 27.906-23.102 57.512-44.07 88.566-62.734 6.8516 28.188 10.266 75.215-19.684 118.3-9.3906 13.516-16.234 28.625-15.934 45.113l-0.003906 0.003906c0.29687 16.227 1.5938 32.418 3.8867 48.484zm-251.82-89.262c2.6094 3.7656 5.3945 7.5156 8.5078 11.219v0.003906c6.8516 8.0977 10.504 18.422 10.277 29.027-0.48438 19.234-3.7109 53.965-4.6758 64.047-8.1562 12.918-14.664 24.777-19.207 33.613 4.5469-56.27 5.1758-109.27 5.0977-137.91zm282.39 11.223h0.003906c4.6289-5.5117 8.8477-11.355 12.617-17.488-0.22266 25.152 0 77.258 4.2812 134.12-6.1406-10.922-14.652-25.477-22.941-37.828-2.5391-16.445-3.9531-33.043-4.2344-49.68-0.21094-10.629 3.4414-20.977 10.277-29.121zm-185.29-543.68c38.289 56.27 102.35 67.109 136.41 68.641-1.2578 12.32-2.5039 22.164-3.1523 27.055-7.207 8.0664-35.383 35.105-89.059 35.105-51.824 0-77.039-18.297-83.965-24.352-3.2734-17.387-5.1562-35.008-5.6289-52.695 21.465-15.555 36.414-37.492 45.387-53.754zm-146.67 140.39 0.14453 0.19531c-100.62-93.59-207.22-132.44-253.67-145.85-20.059-5.7695-37.637-18.027-49.988-34.848-37.301-51.223-45.809-99.426-47.621-122.9 221.93 62.359 346.45 221.21 401.65 312.12-8.4258 3.2383-17.566 4.1367-26.461 2.6055-8.8945-1.5312-17.207-5.4414-24.059-11.312zm-28.445 143.21c8.9961-7.5078 18.848-13.926 29.348-19.129 21.195-10.59 46.281-9.8594 66.828 1.9375 7.1328 4.1914 13.832 9.0781 20 14.586 0.17969 0.16016 0.35156 0.3125 0.55469 0.46094 2.6836 2.1172 66.375 51.785 128.5 75.297v0.003907c3.1484 1.1914 6.6484 1.0156 9.6641-0.48047 3.0156-1.5 5.2656-4.1875 6.2188-7.4141 1.6289-6.3086-1.8398-12.816-7.9844-14.98-56.496-21.559-116.73-67.766-121.21-71.25-10.914-9.8008-23.324-17.797-36.762-23.68-1.6055-0.68359-2.6875-2.2148-2.7891-3.957-0.10156-1.7422 0.79297-3.3906 2.3086-4.2539 18.535-11.863 33.664-28.344 43.91-47.82 30.938 41.812 68.117 48.262 69.121 48.645 61.469 23.914 126.65 13.41 133.64 12.172 35.406-3.5742 54.465 3.3633 64.379 10.133v0.003906c-18.594 5.4844-36.828 12.113-54.605 19.844-5.7812 2.3984-8.8828 8.7109-7.25 14.754 0.98438 3.3164 3.3438 6.0508 6.4805 7.5078 3.1367 1.4609 6.7461 1.5117 9.918 0.13281 21.699-9.5078 44.148-17.211 67.113-23.031 17.031 3.5312 30.508 10.5 39.988 20.762v-0.003906c3.4922 3.6836 4.7812 8.9375 3.3789 13.816-1.3438 4.9766-5.2188 8.8711-10.191 10.234-80.766 23.387-166.23 77.504-209.98 107.68-5.6328 3.8789-12.324 5.9297-19.164 5.8672-6.8398-0.0625-13.492-2.2383-19.051-6.2227-72.238-52.039-162.79-100.64-210.32-124.98-3.0664-1.5547-5.1328-4.5625-5.4922-7.9805-0.39453-3.2852 0.90234-6.543 3.4453-8.6602zm5 619.72c-35.418-0.66406-54.891-6.3203-68.402-19.805v0.003907c-4.9727-5.1914-8.2617-11.762-9.4375-18.852s-0.17969-14.371 2.8516-20.887l1.6094-3.6016 29.648-66.273v0.003906c14.672 20.078 34.828 35.496 58.051 44.398-7.3125 27.852-12.105 56.305-14.32 85.016zm33.414-149.96c-3.5859 10.414-8.6484 25.945-12.707 41.508-23.191-9.4258-42.172-26.953-53.406-49.328 0.70703-5.4648 2.0703-16.844 3.6602-32.531 13.234 2.5664 25.883 7.543 37.316 14.68 2.6758 1.8281 5.9727 2.5078 9.1562 1.8828 3.1797-0.62109 5.9766-2.4961 7.7617-5.2031 1.7891-2.707 2.4141-6.0156 1.7383-9.1836-0.67578-3.1719-2.5938-5.9375-5.3281-7.6797-14.762-9.2969-31.18-15.648-48.355-18.707 0.68359-7.8359 1.3672-16.281 2.0156-25.195 22.621-6.2656 46.086-8.9219 69.531-7.8672-2.1602 32.715-5.957 65.301-11.383 97.637zm12.887-121.77v0.003906c-23.328-1.1875-46.699 1.0352-69.387 6.5859 0.96484-16.566 1.7422-34.27 2.1875-52.59 12.352-0.51562 43.637-0.20312 68.637 13.738-0.35938 10.305-0.82812 21.117-1.4375 32.273zm2.1719-58.738c-26.648-11.219-55.211-11.938-68.988-11.469 0.0625-9.4883 0.023437-19.059-0.14063-28.684 12-5.5195 39.789-16.109 69.414-12 0.10938 10.562 0.17969 29.02-0.28906 52.172zm0.60938-76.484c-23.551-2.1992-47.289 1.1875-69.285 9.8828 2.707-67.012 11.016-111.58 19.738-140.75 0.042969 0 54.312 14.469 51.969 57.617-3.5703 18.371-3.8086 37.234-0.70312 55.688 0 0-1.4766 13.234-1.7188 17.582zm30.785 203.61 52.609 31.41c-4.7344 1.2422-10.387 2.3945-16.48 3.4219l-0.32422-0.16406-5.2148 1.0586h-0.007813c-15.516 2.3711-31.176 3.6836-46.871 3.9336 4.4258-13.605 9.8711-26.859 16.285-39.645zm3.0195 109.22v-0.003907c39.812-4.8867 79.094-13.398 117.36-25.434 53.66 23.898 108.66 44.66 164.73 62.188-137.93 3.2773-231.45-19.359-282.09-36.734zm224.82-71.109v-0.003906c20.648-11.352 40.508-24.086 59.438-38.117 12.309 21.488 23.094 43.812 32.281 66.812-31.086-7.832-61.699-17.406-91.707-28.68zm126.83 52.902c-2.1172-6.0586-3.832-10.09-4.4844-11.574l-0.003906-0.003907c-8.0039-22.68-17.449-44.824-28.281-66.301v-0.76953c-2.5664-20.391-4.4609-41.094-5.8594-61.09 21.43-6.5859 43.559-10.641 65.934-12.082 1.1367 18.969 2.6914 36.352 4.3203 51.477-14.219-4.9922-29.164-7.6172-44.234-7.7695-6.6172 0.16016-11.879 5.6055-11.805 12.223 0.070313 6.6172 5.4453 11.949 12.062 11.965h0.1875c15.977 0.25781 31.707 3.9453 46.133 10.805 0.31641 0.16016 0.65234 0.22656 0.97266 0.35156 1.7969 13.359 3.375 23.059 4.2148 27.973-9.3047 22.43-19.609 31.195-39.145 44.809zm74.918 92.535c-12.184 12.156-28.773 17.914-57.293 19.445-0.30859-16.828-1.6875-33.621-4.125-50.273-1.207-12.555-3.3125-25.004-6.2969-37.258 19.059-13.121 32.719-22.59 43.844-39.699l30.457 68.047c3.0312 6.5156 4.0273 13.797 2.8516 20.887-1.1758 7.0898-4.4648 13.66-9.4375 18.852zm171.39-266.52c-9.375 61.441-31.953 99.25-39.051 109.93h0.003906c-18.754 4.5859-37.984 6.9297-57.289 6.9883 104.05-139.53 50.562-387.75 50.562-387.75 52.855 119.17 54.812 211.61 45.777 270.84z", fill: "currentColor" })] }) }))); };


/***/ }),
/* 220 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hero1": () => (/* binding */ Hero1)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Hero1 = function (props) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "1200pt", height: "1200pt", version: "1.1", viewBox: "0 0 1200 1200", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m230.02 1138.7c21.27 8.5625 45.027 8.5625 66.301 0 20.855-8.4492 40.605-19.406 58.816-32.629 32.234 19.539 67.988 32.562 105.23 38.34 4.4219 4.4609 10.074 7.5 16.238 8.7227 11.637 2.1641 23.457 3.2109 35.293 3.1211 16.336 0.054687 32.633-1.6445 48.605-5.0703 6.6406-1.5117 12.605-5.1602 16.977-10.383 33.129-8.2578 63.285-25.605 87.078-50.09 5.9688-6.3203 9.7891-14.359 10.926-22.977 1.1367-8.6172-0.47266-17.371-4.5977-25.023l-6.9219-12.945c-2.9375-5.4961-7.5156-9.9453-13.094-12.727-5.582-2.7852-11.887-3.7617-18.047-2.8008-2.4297-23.84-3.4141-47.801-2.9492-71.754 1.7344-1.7852 3.4062-3.5312 4.957-5.2031h0.003906c9.5625-10.23 15.316-23.441 16.297-37.41 0.52344-7.9102 1.2109-16.008 2.0039-24.094v-0.003906c8.0547 13.723 17.207 26.77 27.363 39.016-4.3555 14.895-7.3945 30.141-9.0859 45.566-1.0039 8.7422 0.73047 17.582 4.9648 25.297 4.2383 7.7109 10.766 13.922 18.68 17.762 35.59 17.098 110.21 45.469 214.3 46.293h0.003906c1.1172 3.1719 3.4414 5.7773 6.4648 7.2461l-7.0117 41.438c-1.2539 7.4336 0.39844 15.062 4.6172 21.312 4.2148 6.2461 10.676 10.633 18.039 12.246l20.883 4.5898c2.0938 0.46484 4.2305 0.69922 6.375 0.70312 6.8008-0.023437 13.387-2.4023 18.633-6.7383 5.2461-4.332 8.8242-10.352 10.129-17.031l8.5391-43.887c13.09-4.4336 22.918-15.379 25.922-28.867l13.676-61.992 45.285 7.7656 0.003906-0.003906c3.1953 0.54688 6.4766-0.21094 9.1055-2.1016 2.6328-1.8945 4.3945-4.7656 4.8906-7.9688l5.1562-33.312v0.003906c1.0742-7.0625-0.023437-14.285-3.1445-20.711-3.125-6.4258-8.125-11.754-14.344-15.273l-36.027-20.254c20.871-85.766 82.879-348.64 109.53-549.07 0.85938-5.8125 20.934-143.52-2.2188-245.7-0.92969-4.0977-3.9141-7.418-7.8906-8.7734-3.9766-1.3594-8.3672-0.55469-11.605 2.1211-2.7812 2.2969-68.445 58.133-102 220.77-2.0156 8.5234-64.113 273.26-85.789 559.41l-41.496 4.2852c-7.3086 0.75391-14.195 3.7812-19.688 8.6562-5.4961 4.8789-9.3203 11.355-10.938 18.52l-3.0312 13.363c-14.258-6.8281-30.141-16.48-30.141-16.48-48.227-33.406-112.52-46.941-91.445-269.07 12.012-3.625 24.398-5.8594 36.922-6.6562 10.789-0.51953 21.082-4.707 29.168-11.871 8.0859-7.1641 13.484-16.875 15.301-27.523 12.98-77.598-11.738-129.2-67.82-141.58-1.9844-0.4375-3.9727-0.82422-5.9688-1.1523v-0.003906c0.80469-10.363-0.12891-20.793-2.7578-30.852-7.3203-22.891-19.5-43.93-35.711-61.676-17.957-19.242-25.965-45.73-21.68-71.699 5.6016-32.402 7.2656-81.531-16.664-131.65-1.4648-2.9844-36.617-73.352-102.43-91.973-34.395-9.7422-70.332-3.5117-106.91 18.473h0.003906c-28.633-3.6758-57.547 4.293-80.25 22.125-41.523 32.57-62.859 95.691-63.426 187.57-0.089843 19.055-8.7266 37.062-23.527 49.059-28.281 23.008-56.148 68.766-44.512 118.81-32.879 9.7422-79.059 35.426-91.148 103.15h0.003907c-1.7773 14.273-0.36719 28.762 4.1289 42.422 2.0156 6.3672 8.8086 9.8984 15.176 7.8828 3.0586-0.96875 5.6055-3.1094 7.082-5.957 1.4805-2.8477 1.7656-6.1641 0.80078-9.2188-3.2773-9.9609-4.4258-20.496-3.3672-30.926 9.6289-53.945 44.672-75.848 75.395-84.531 4.0234 8.3164 8.9062 16.188 14.574 23.484 11.605 15.078 37.434 36 69.449 36h-0.003906c3.6992-0.015625 7.3945-0.30469 11.047-0.875 3.4609 22.035 0.67188 44.598-8.0547 65.125l-0.039062 0.089844h0.003906c-2.7812 6.2148-6.1719 12.133-10.133 17.672-2.0352 2.832-4.4453 5.375-7.1719 7.5547-12.5-7.2812-25.91-14.551-40.344-21.723-21.32-10.52-46.32-10.52-67.641 0-107.96 53.641-160.18 112.7-181.7 143.12-7.9102 11.207-12.27 24.531-12.504 38.246-5.125 254.97 134.58 338.7 194.88 362.86zm286.72-815.18c1.6211 2.7695 4.2773 4.7773 7.3828 5.5859 3.1055 0.80859 6.4062 0.34766 9.1719-1.2812 5.457-3.082 11.242-5.5469 17.246-7.3438 12.145 7.8164 23.195 17.211 32.863 27.938-10.652 51.883-46.418 80.867-67.117 93.602h-0.003907c-6.1953 3.7383-13.891 3.9766-20.305 0.63281-20.488-10.988-38.391-26.227-52.516-44.695-2.3867-19.297-8.6836-42.863-17.969-73.766-7.7383-25.73-5.1719-94.883 40.805-130.99 5.4648 24.289 20.824 67.336 63.73 109.19v0.003907c-3.0742 1.3633-6.0742 2.8945-8.9844 4.5859-5.7539 3.3828-7.6836 10.785-4.3047 16.543zm-41.543 168.16c39.66-7.8047 62.789-17.648 73.988-23.492v35.348c0.09375 9.8711-3.7578 19.375-10.707 26.391s-16.414 10.965-26.289 10.965c-9.8711 0-19.336-3.9492-26.285-10.965-6.9492-7.0156-10.805-16.52-10.707-26.391zm-78.969 117.32c20.938-42.801 17.41-99.176 17.41-99.176l37.371-11.578v5.2969c-0.12109 16.305 6.2695 31.984 17.754 43.562 11.488 11.574 27.121 18.082 43.426 18.082 16.309 0 31.941-6.5078 43.43-18.082 11.484-11.578 17.875-27.258 17.754-43.562v-8.6484c19.574 2.9922 38.137 6.3789 56.219 10.234 0 0-19.836 52.211-1.6094 101.61-24.438 27.719-49.336 51.555-67.766 64.57-14.324 10.789-32.883 14.223-50.117 9.2734-42.105-10.191-87.746-47.461-113.87-71.578zm158.86 518.61c-24.273 5.1914-49.309 5.8008-73.809 1.793-3.1172-0.57422-5.4805-3.1406-5.7969-6.293-0.97266-11.969-0.91406-24 0.17578-35.957 0.40625-3.7305 3.5781-6.543 7.3281-6.5078h0.09375c21.953 0.09375 43.898-1.0234 65.727-3.3555 3.8867-0.42188 7.4141 2.3008 7.9961 6.168 1.8906 12.184 3.1641 24.453 3.8164 36.77 0.21094 3.4805-2.1289 6.6016-5.5312 7.3828zm-9.0273-74.352c-20.816 2.2188-41.738 3.2891-62.676 3.2031h-0.39844c-6.2031 0.003906-12.266 1.8477-17.426 5.293-8.9414-2.4609-17.711-5.5078-26.254-9.1133 10.957-21.141 19.957-43.242 26.887-66.023 14.676 7.7344 27.09 13.332 35.887 16.977 17.273 7.2148 36.898 6.1016 53.238-3.0234 17.918-10.082 34.785-21.926 50.352-35.359 0.32422 20.977 1.7891 41.918 4.3906 62.734-12.875 12.211-27.578 22.332-43.582 30-6.0625-3.8633-13.273-5.5195-20.418-4.6875zm80.922-154.98c-0.61328 8.418-4.1016 16.367-9.8789 22.516-21.426 23.141-46.215 42.914-73.539 58.66-0.46484 0.25781-0.95312 0.45312-1.4102 0.6875v0.003906c0.09375-14.715 1.5352-29.391 4.3047-43.844 1.1211-6.5039-3.1797-12.707-9.6641-13.938-6.4844-1.2305-12.758 2.9648-14.098 9.4297-3.2578 16.965-4.8398 34.203-4.7266 51.477-2.2617-0.46094-4.4766-1.1328-6.6133-2-13.137-5.5039-25.984-11.676-38.492-18.492 6.1797-24.785 10.449-50.004 12.781-75.441 11.965 6.4102 24.336 12.035 37.027 16.844 6.3438 2.375 13.062 3.5977 19.832 3.6016 11.023 0.035157 21.797-3.2969 30.875-9.5508 22.184-16.137 42.113-35.164 59.27-56.57-2.3242 18.246-4.418 37.914-5.668 56.617zm-63.336-22.871c12.492-61.59 8.4883-107.41 2.4531-135.84-1.5859-6.3125-7.8789-10.238-14.246-8.8867-6.3672 1.3516-10.523 7.5-9.4023 13.91 5.9453 28.008 9.6953 74.578-5.2266 138.53-2.0703-0.33203-4.1016-0.85938-6.0703-1.5781-15.215-5.7812-29.93-12.801-43.996-20.988 3.3633-28.105 4.7227-56.41 4.0625-84.707 0-0.054687 0.63281-42.758-30.992-89.492 13.914 7.7773 28.766 13.742 44.191 17.75 7.2305 1.7969 14.645 2.7266 22.094 2.7656 17.16-0.070313 33.855-5.5977 47.668-15.785 18.523-13.078 41.961-35.047 65.648-61.23l-0.003906-0.003906c3.1484 4.6914 6.6602 9.1211 10.504 13.258 8.4062 10.863 20.848 17.863 34.492 19.41 0.039062 3.6328 0.10547 7.2891 0.027343 10.824h0.003907c-0.78516 33.262-10.598 65.68-28.387 93.793-21.762 34.496-55.234 80.648-92.82 108.27zm99.855-31.539h-0.003906c-4.1211-8.5586-5.1953-18.273-3.0469-27.527 0 0 14.359-43.578 62.625-79.262 1.8359 28.746 6.3281 57.262 13.41 85.184-20.098 18.211-35.914 40.648-46.309 65.695-10.277-13.812-19.215-28.578-26.688-44.09zm300.27 264.98v0.003907c-0.26953 1.3711-1.0781 2.5742-2.2461 3.3398-1.168 0.76953-2.5938 1.0312-3.9609 0.73047l-20.879-4.5898v0.003906c-2.6992-0.59766-4.457-3.1992-4.0039-5.9258l6.2383-37.059 32.348 4.9414zm170.93-988.07m-78.742 190.87c0.027344-0.125 0.054687-0.24219 0.082031-0.35156 21.918-106.39 58.258-164.64 78.66-190.5l-135.07 740.18c-1.4062-0.375-2.8711-0.49609-4.3203-0.35156l-24.273 2.5078c22.074-285.76 84.281-548.82 84.914-551.48zm-157.89 590.77c1.0312-4.5703 4.8672-7.9688 9.5273-8.4453l86.391-8.918 76.766 43.152c3.9609 2.2383 6.125 6.6953 5.4336 11.191l-3.2734 21.176-36.066-6.1758c-1.7578-8.082-5.7852-15.5-11.613-21.375-5.8242-5.875-13.203-9.9688-21.273-11.801-16.023-3.582-32.422-5.2031-48.84-4.832-13.195 0.29297-25.352 7.2344-32.309 18.453l-30.895-5.293zm-139.86-441.51c54.395 12 56.762 68.602 49.176 113.97h-0.003907c-0.9375 5.2305-3.6367 9.9883-7.6445 13.48-4.0078 3.4922-9.0859 5.5156-14.398 5.7305-26.957 1.9141-53.254 9.2344-77.32 21.527-4.293 2.207-9.1719 3.0078-13.945 2.2852-4.7773-0.72266-9.2031-2.9297-12.652-6.3086-31.434-32.141-31.082-78.84-31.078-79.277v-0.63672c-0.78906-24.5 11.395-44.371 36.227-59.066l0.003907 0.003906c15.312-9.1211 32.801-13.953 50.625-13.992 7.0664 0 14.109 0.76562 21.012 2.2852zm-438.85-116.61c20.43-16.547 32.348-41.398 32.469-67.688 0.51172-82.652 19.117-140.89 53.801-168.41h0.003907c18.352-14.742 42.137-20.922 65.344-16.973 3.168 0.75391 6.5078 0.19531 9.2578-1.543 31.859-20.117 62.574-26.227 91.281-18.145 55.375 15.59 87.109 78.758 87.363 79.266 21.129 44.258 19.602 88.043 14.598 116.98v0.003907c-5.5781 33.316 4.6211 67.336 27.617 92.086 22.961 29.223-10.668 41.648-10.668 41.648-46.57 17.914-67.84-31.875-67.84-31.875v0.046876-0.003907c-7.9609-23.117-22.902-43.191-42.766-57.445-87.59-61.488-92.176-136.63-92.324-139.77-0.003906-0.066406-0.011719-0.13281-0.019531-0.19922v-0.10156c-0.25781-8.2344 0.85156-16.453 3.2852-24.32 1.8945-6.3086-1.6055-12.977-7.8789-14.996-6.2695-2.0195-13.004 1.3516-15.145 7.582-2.5938 8.2617-4.082 16.832-4.4297 25.484-65.227 39.625-72.293 127.59-60.961 165.24 10.445 34.75 16.875 59.371 17.859 77.926 0 0 2.5781 66.895-74.664 43.438-63.625-19.32-61.586-58.41-50.074-80.582 6.3945-10.465 14.465-19.809 23.891-27.656zm-251.95 407.27c20.203-28.57 69.504-84.152 172.71-135.43h0.003906c14.535-7.1719 31.578-7.1719 46.113 0 103.21 51.281 152.52 106.86 172.71 135.43 1.5977 2.2773 2.9727 4.6992 4.1094 7.2383-8.5234 7.5312-17.926 14.008-28.004 19.289-38.586-55.125-91.137-99-152.26-127.14-4.3125-1.9258-9.3086-1.5352-13.273 1.0391-3.9609 2.5742-6.3477 6.9805-6.3398 11.707v28.484c-10.406-0.003906-20.664 2.4883-29.91 7.2695-68.469 35.441-99.715 74.031-110.82 90.652-21.902-5.668-42.137-16.465-59.039-31.504 1.1133-2.4609 2.4531-4.8164 4-7.0352zm48.41 61.797c-0.75781 26.711 1.5 53.418 6.7266 79.621 1.2617 6.4609 7.3203 10.836 13.852 10.004 3.2695-0.52344 6.1875-2.3633 8.0664-5.0898 1.875-2.7305 2.5508-6.1133 1.8672-9.3555-4.3594-21.434-6.5156-43.258-6.4453-65.133 0.015625-11.516 4.0781-22.66 11.477-31.488 14.383-17.324 42.816-44.992 93.02-70.984 11.785-6.0898 25.793-6.0898 37.578 0 51.758 26.797 80.379 55.375 94.309 72.551 6.5781 8.0938 10.176 18.199 10.191 28.629 0 1.1133-0.046876 2.168-0.054688 3.2656-27.828-30.227-68.152-47.082-96.781-55.82-6.2266-1.8789-12.969-0.69531-18.184 3.1875-5.2109 3.8789-8.2773 10-8.2656 16.5v236.09c-4.9062-0.007813-9.7656-0.96875-14.305-2.8242-20.145-8.3477-38.344-20.762-53.465-36.473-4.4727-4.7539-11.848-5.2695-16.941-1.1875-2.5195 2.1641-4.0391 5.2695-4.2031 8.5898-0.16016 3.3164 1.0508 6.5547 3.3477 8.9531 17.617 18.398 38.887 32.914 62.445 42.609 14.816 6.0469 31.414 6.0469 46.234 0 41.078-17.207 74.715-48.441 94.914-88.137-12.234 80.945-65.891 109.41-99.008 119.35-5.5117 1.6641-10.34 5.0664-13.766 9.6914-3.4297 4.6289-5.2695 10.238-5.2539 15.996v18.453c-8.2266-0.027344-16.387-1.418-24.156-4.1094-54.855-21.977-180.91-97.883-179.8-329.94 17.008 12.477 36.203 21.656 56.598 27.055z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m474.03 306.91c-6.2969-2.2852-12.785-4.0078-19.391-5.1406-6.5352-0.94141-12.617 3.5391-13.66 10.059-1.0469 6.5234 3.3359 12.676 9.8398 13.824 5.0078 0.87891 9.9336 2.1875 14.723 3.9062 6.2539 2.3438 13.227-0.82422 15.57-7.082 2.3438-6.2539-0.82812-13.223-7.082-15.566z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m163.46 941.54c0-4.9297-2.9688-9.3711-7.5195-11.258-4.5547-1.8867-9.793-0.84375-13.277 2.6406s-4.5273 8.7266-2.6445 13.277c1.8867 4.5547 6.3281 7.5234 11.258 7.5234 6.7305 0 12.184-5.457 12.184-12.184z", fill: "currentColor" })] }) }))); };


/***/ }),
/* 221 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Champion1": () => (/* binding */ Champion1)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Champion1 = function (props) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "1200pt", height: "1200pt", version: "1.1", viewBox: "0 0 1200 1200", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m609.4 306.24 11.051 2.2422v-0.003907c6.5156 1.2578 12.828-2.9688 14.145-9.4727 1.3203-6.5039-2.8477-12.852-9.3359-14.234l-11.047-2.2422v0.003906c-6.5312-1.2891-12.871 2.9375-14.195 9.4609-1.3242 6.5195 2.8711 12.887 9.3828 14.246z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m502.32 846.2c-5.2383 0-9.957 3.1523-11.961 7.9883-2.0039 4.8398-0.89453 10.406 2.8047 14.109 3.7031 3.7031 9.2734 4.8125 14.109 2.8086 4.8398-2.0039 7.9922-6.7266 7.9922-11.961 0-3.4336-1.3633-6.7266-3.793-9.1562-2.4258-2.4258-5.7188-3.7891-9.1523-3.7891z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m483.78 963.31c0 5.2383 3.1523 9.957 7.9922 11.961 4.8359 2.0039 10.402 0.89844 14.105-2.8047s4.8125-9.2695 2.8086-14.109c-2.0039-4.8359-6.7266-7.9922-11.961-7.9922-3.4336 0-6.7266 1.3633-9.1562 3.793-2.4258 2.4258-3.7891 5.7188-3.7891 9.1523z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m344.82 665.04c-5.2383 0-9.957 3.1562-11.961 7.9922-2.0039 4.8398-0.89453 10.406 2.8047 14.109 3.7031 3.7031 9.2734 4.8086 14.109 2.8047 4.8398-2.0039 7.9922-6.7227 7.9922-11.961 0-3.4297-1.3633-6.7227-3.793-9.1523-2.4258-2.4258-5.7188-3.793-9.1523-3.793z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m424.42 543.68c5.2383 0 9.957-3.1523 11.961-7.9922 2.0039-4.8359 0.89453-10.402-2.8047-14.105-3.7031-3.7031-9.2734-4.8125-14.109-2.8086-4.8398 2.0039-7.9922 6.7266-7.9922 11.961 0 3.4336 1.3633 6.7266 3.793 9.1562 2.4258 2.4258 5.7188 3.7891 9.1523 3.7891z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m393.2 604.3c0 7.1523-5.7969 12.949-12.945 12.949-7.1523 0-12.949-5.7969-12.949-12.949 0-7.1484 5.7969-12.945 12.949-12.945 7.1484 0 12.945 5.7969 12.945 12.945", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m1133.7 668.91c-4.0469-0.125-7.9023 1.7188-10.348 4.9414-234.44 297.46-593.36 327.61-685.43 330.31v-25.703h0.003906c-0.003906-8.793-3.2227-17.281-9.043-23.871-5.8242-6.5859-13.852-10.82-22.578-11.902l3.8828-21.844c13.125 1.2344 28.094 2.0312 45.074 2.0312v0.003906c28.652-0.125 57.27-2.0977 85.672-5.9062-0.92578 13.363-1.4102 27.715-1.2188 43.012 0.097657 6.5938 5.4961 11.875 12.09 11.824h0.15625c3.207-0.039063 6.2695-1.3516 8.5078-3.6523 2.2383-2.2969 3.4727-5.3906 3.4297-8.6016-0.67969-38.977 3.5312-77.883 12.535-115.81 0.63281-2.6367 0.99609-5.332 1.0781-8.0391 11.98-0.082031 23.562-4.3164 32.77-11.98l11.512 15.094h0.003906c2.9609 3.8555 4.1406 8.7812 3.25 13.559-2.7188 13.953-8.4922 27.133-16.898 38.594-10.758 15.086-15.148 33.797-12.215 52.094l0.90625 5.8047c0.49219 3.1719 2.2266 6.0156 4.8164 7.9062 2.5898 1.8945 5.8281 2.6758 8.9961 2.1836 0 0 52.117-8.7969 82.941-23.332v-0.003906c3.1797-0.41406 6.0664-2.0781 8.0195-4.6211 1.9531-2.543 2.8164-5.7617 2.3984-8.9414-4.6094-35.133-17.793-80.168-23.676-104.12h0.003906c28.027-23.625 60.332-41.645 95.16-53.074 3.4453-1.1094 6.3008-3.5586 7.9219-6.793 1.625-3.2344 1.875-6.9883 0.70312-10.41l-14.449-41.691c-1.168-3.375-3.6289-6.1484-6.8398-7.7031-3.2148-1.5586-6.9141-1.7773-10.285-0.60156-23.137 8.0234-72.352 26.824-102.71 50.887 1.75-13.293-0.20312-26.809-5.6484-39.062-14.227-32.43-28.664-80.09-40.312-123.02 22.766-27.66 47.57-53.574 74.207-77.527 6.1172-5.5391 10.094-13.051 11.242-21.223 1.1484-8.168-0.60938-16.484-4.9609-23.496-10.66-17.223-22.953-33.383-36.703-48.258 9.7344-3.0664 17.859-9.8672 22.586-18.914 42.184-80.617 41.473-189.31 41.426-193.89v-0.03125c-0.042968-3.8828-2.6641-126.68-120.9-132.45-7.6328-0.57812-101.29-5.6484-135.07 84.133-13.078-6.3516-30.707-15.176-48.148-24.621 1.668-26.238-8.8008-51.797-28.402-69.324-33.398-30.816-84.586-31.059-116.54-0.55469-22.859 21.824-36.91 55.719-41.762 100.74v0.003907c-3.9062 36.18-15.992 70.996-35.344 101.81-49.938 79.105-49.016 151.77-39.453 198.76 10.379 51.02 32.566 83.148 33.504 84.492 2.2617 3.2422 5.9648 5.1719 9.9141 5.1719 2.6289-0.003907 5.1836-0.85547 7.2852-2.4258 3.5-2.7695 5.2734-7.1836 4.668-11.605-7.75-71.027 39.402-117.02 39.855-117.45 0.12891-0.125 0.25391-0.24609 0.37891-0.375 76.836-79.328 118.05-152.82 139.09-200.5l10.363-24.465c20.398 11.355 39.613 24.715 57.355 39.883 4.7812 19.648 15.133 37.5 29.816 51.402 1.3164 5.8984 3.5977 11.539 6.7539 16.691 3.2344 5.3164 7.6484 9.8125 12.906 13.141l-13.699 40.18c-5.0234-2.2656-8.168-3.457-8.7539-3.6758-3.2109-1.1914-6.7812-0.96484-9.8164 0.625-3.0352 1.5898-5.2578 4.3945-6.1055 7.7148l-8.668 33.883c-21.992 11.906-42.711 26.027-61.836 42.141-3.8086-4.6133-7.3789-9.418-10.703-14.391-6.3828-9.6758-17.062-15.656-28.648-16.043-11.691-0.44922-22.898 4.707-30.168 13.875-55.301 70.168-96.539 153-111.71 185.36-6.1875 12.973-5.2969 28.215 2.3633 40.379 8.0664 12.785 17.785 24.449 28.91 34.688-7.9961 16.527-14.57 33.707-19.652 51.348-10.039-4.0352-20.363-7.3125-30.887-9.8086-3.5859-0.76562-7.3281 0.13672-10.172 2.4531-2.8438 2.3125-4.4805 5.7969-4.4531 9.4648 0.92188 128.37 63.07 229.41 76.629 249.94l-0.70703 8.8242c-51.465-4.7188-102.63-12.305-153.25-22.715-9.1328-1.8516-18.621 0.19141-26.191 5.6289-7.5664 5.4375-12.527 13.777-13.691 23.023l-1.7227 13.613h0.003906c-0.97656 7.7148 0.75781 15.527 4.9062 22.102 4.1484 6.5781 10.453 11.504 17.836 13.945 45.805 15.012 116.37 25.059 168.32 30.895 2.8398 10.152 8.7734 19.172 16.973 25.801 17.395 14.031 46.941 29.953 91.348 29.953h0.42188c1.9023 7.8633 6.3906 14.855 12.742 19.863 6.3516 5.0078 14.199 7.7344 22.285 7.75h12c9.5664 0 18.742-3.8008 25.508-10.566 6.7656-6.7617 10.566-15.938 10.566-25.504v-27.363c177.77-3.2734 351.71-52.113 505.2-141.85 117.43-68.945 179.74-136.51 182.34-139.35 0.85547-0.9375 1.5547-2 2.082-3.1484 19.297-42.438 17.754-130.16 17.68-133.87h-0.003906c-0.13672-6.3633-5.1758-11.535-11.531-11.84zm-688.04-467.91c-22.406-16.164-46.113-30.449-70.875-42.707-5.8906-2.8047-10.891-7.1914-14.441-12.664-3.3867-5.3008-4.9141-11.578-4.3398-17.84 27.055 17.949 66.352 37.812 92.781 50.531-1.6289 7.4648-2.6758 15.051-3.125 22.68zm-30.035 775.94v101.16c-29.617 1.8633-37.664-11.293-39.836-18.707-0.69531-27.113 0.72266-54.238 4.2344-81.129 0.89844-7.0547 6.8359-12.379 13.945-12.508h7.5391c7.793 0.007812 14.117 6.6836 14.117 11.18zm-125.65-290.64c-7.1602-4.0234-13.188-9.7891-17.52-16.766-4.1406-7.2617-4.168-16.164-0.070312-23.449l15.828-28.773c23.754 22.305 59.566 41.543 112.53 41.543h0.3125l-21.934 38.152h0.003906c-1.75 3.0039-4.3125 5.4492-7.3945 7.0508-3.082 1.6055-6.5586 2.3008-10.02 2.0078-24.949-1.9688-49.289-8.6758-71.727-19.762zm43.793-66.223c-9.1367-4.9453-16.586-12.516-21.383-21.734-4.3125-8.9219-3.7227-19.434 1.5625-27.816l18.18-29.465c29.285 29.004 68.52 45.758 109.72 46.855l-26.547 46.172c-34.383 2.4219-60.988-3.8359-81.527-14.008zm-51.668 110.75c13.898 4.7422 28.371 7.6055 43.031 8.5156-9 14.043-17.09 28.652-24.223 43.734-13.562-13.098-28.691-24.469-45.043-33.855 11.266-19.965 26.234-18.395 26.234-18.395zm66.438 16.867c5.7344 8.6133 20.469 31.121 21.73 32.805 3.5156 4.6836 5.5742 10.301 5.918 16.148-12.125 2.6484-22.254 10.93-27.258 22.285-6.0469 13.832-11.16 28.055-15.309 42.566-1.4102-9.043-2.5547-17.328-3.4609-24.328-1.543-11.863-5.6133-23.262-11.934-33.426 8.3789-19.566 18.523-38.328 30.312-56.051zm204.41 90.301h-0.003906c-4.3242 17.883-7.5586 36.008-9.6914 54.281-31.445 4.4727-63.18 6.5703-94.941 6.2734-31.41-1.9688-30.754-19.445-30.754-19.445l11.293-59.168 110.06 0.003906c4.4297-0.015625 8.6211 2.0195 11.348 5.5156 2.7852 3.5391 3.7773 8.168 2.6836 12.539zm69.078-118.77h-0.003906c4.0039 8.8867 5.2344 18.77 3.5312 28.363-3.6406 21.52-13.992 41.336-29.582 56.609-5.1875 4.8125-12.023 7.4492-19.102 7.3633h-6.8633c-0.24609-0.35156-0.45703-0.70703-0.70703-1.0312-7.2969-9.3555-18.512-14.812-30.375-14.773h-97.059c-0.5-18.059-4.9648-35.789-13.082-51.926-5.7891-11.715-5.8047-25.453-0.042969-37.184l55.059-112.79c25.535-45.613 11.91-77.168 11.91-77.168-3.7656-10.238-11.891-18.273-22.172-21.922-15.895-5.6406-31.016-13.254-45.016-22.656 16.262-16.293 34.875-30.059 55.215-40.836 26.234 18.762 50.52 40.113 72.484 63.73 5.0273 22.527 35.227 154.53 65.801 224.22zm-45.711-260.82-9.7266 12.312-0.003906 0.003906c-20.754-21.414-43.383-40.938-67.609-58.332l4.5898-18.746-0.003906 0.003906c27.949 17.027 52.594 38.961 72.754 64.746zm-70.297-91.543 15.098-44.289c1.5977 0.085937 3.1758 0.10938 4.7031 0.070312l1.0586 11.809c0.84766 9.9688 4.0117 19.598 9.2461 28.125 9.6445 15.102 21.793 28.445 35.926 39.457-1.5938 2.7891-3.4531 6.1211-5.3281 9.6445-18.32-17.371-38.707-32.422-60.703-44.816zm-2.9805-108.2v-0.003906c1.582-5.4766 5.8086-9.793 11.246-11.5 5.0977-1.6914 10.703-0.71875 14.934 2.5898 6.1953 4.8867 10.652 11.645 12.707 19.262 1.4766 5.082 6.0898 8.6133 11.379 8.7109 5.2773 0.050781 9.9883-3.2812 11.707-8.2695 4.4297-13.879 9.7539-27.453 15.938-40.648 3.207-6.7031 8.2227-12.379 14.477-16.395 6.2539-4.0195 13.504-6.2109 20.934-6.3398 31.516-0.55078 56.219 1.4531 71.027 5.6719-0.73828 23.969-3.0469 47.867-6.9102 71.535l-13.293 1.8867h0.003907c-6.2852 0.89062-10.812 6.4883-10.367 12.82 0.44531 6.332 5.707 11.242 12.055 11.25 0.56641 0 6.7969-0.84375 6.7969-0.84375-5.5391 26.879-14.562 52.922-26.844 77.465-1.2148 2.3477-3.0508 4.3164-5.3047 5.6914-2.2578 1.375-4.8477 2.1055-7.4922 2.1094h-25.375c-5.8164 0.015625-11.5-1.7617-16.266-5.0938-15.02-10.309-27.848-23.488-37.75-38.777-3.2266-5.3047-5.168-11.289-5.6719-17.48l-2.2031-24.527 0.003907 0.003907c-0.32812-3.6289-2.2773-6.918-5.3008-8.9531-3.0234-2.0352-6.8047-2.5977-10.289-1.5312-0.19141 0.054687-19.367 5.7578-27.562-7.5273-6.6055-10.719-5.0547-22.832-2.5781-31.109zm-37.664 258.88-0.003907-0.003906c3.5312 1.2461 6.3281 3.9961 7.6289 7.5078 1.2656 3.3711 0.94141 7.1289-0.875 10.234l-16.414 28.551h-0.003906c-26.246 1.3672-52.379-4.3633-75.648-16.59-18.93-12.934-23.594-26.863-24.215-36.156v0.003907c-0.30469-5.5664 1.2539-11.07 4.4336-15.652l21.195-31.223-0.003906 0.003906c23.477 24.016 52.191 42.266 83.902 53.32zm-386.36 497.61 1.7188-13.609c0.32031-2.5742 1.6992-4.8984 3.8047-6.4141 2.1055-1.5156 4.7461-2.082 7.2891-1.5703 27.07 5.4648 73.922 14.176 122.47 19.801l-16.195 35.246c-40.062-5.7148-82.414-13.445-112.81-23.406v-0.003906c-4.2266-1.4102-6.8594-5.625-6.2734-10.043zm119.59-265.26c21.395 7.1211 61.344 23.941 92.117 57.348 8.4609 9.1406 13.867 20.691 15.461 33.047 3.8633 29.84 11.98 81.605 25.738 123.65-17.484-2.8711-42.305-4.7266-64.059 1.8477-15.816-25.379-63.922-110.66-69.258-215.89zm155.18 360.73c-37.059-0.15625-61.336-13.133-75.531-24.586-6.875-5.5625-10.547-14.168-9.8125-22.977l5.9805-74.027c23.648-7.4453 54.59-1.4922 67.219 1.5312l5.9688 16.691h-0.003906c4.0977 11.438 6.1914 23.496 6.1836 35.645zm752.51-307.77c-9.5312 9.9961-70.77 72.113-176.25 133.9v0.003907c-149.58 87.25-319 134.77-492.13 138.04v-26.707c56.141-0.25391 390.78-12 631.98-249.86v-0.003907c5.5039-5.3906 8.6172-12.762 8.6406-20.469v-16.941c14.262-14.328 28.227-29.426 41.891-45.285-1.2148 27.43-4.6562 64.953-14.133 87.336z", fill: "currentColor" })] }) }))); };


/***/ }),
/* 222 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sage1": () => (/* binding */ Sage1)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Sage1 = function (props) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "1200pt", height: "1200pt", version: "1.1", viewBox: "0 0 1200 1200", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m87.605 1165c0.53906 0 1.0781-0.035156 1.6094-0.10547 6.6211-0.88672 11.273-6.9688 10.391-13.59-11.777-88.395-6.2734-183.75 2.9219-260.21v0.003907c3.4414 5.9375 7.6172 11.418 12.43 16.316 8.7773 8.9141 20.359 20.391 33.379 32.543-8.4492 109.94 12.102 211.11 12.988 215.39v0.003906c1.1602 5.6094 6.0977 9.6367 11.828 9.6445h59.367c5.7031-0.007812 10.633-4 11.816-9.582 20.648-97.227 74-175.98 93.883-202.81v-0.003906c28.75 23.453 60.426 43.062 94.238 58.344 9.7656 4.4688 20.559 6.2305 31.238 5.1016 10.684-1.1289 20.867-5.1055 29.488-11.52 28.105-20.781 52.93-45.672 73.641-73.832 105.53 84.117 136.83 223.33 137.14 224.77 1.207 5.5586 6.1211 9.5234 11.809 9.5312h110.93-0.003906c6.2109-0.011719 11.406-4.7227 12.02-10.902 7.1289-71.938-0.47266-144.57-22.332-213.47h78.043c27.914 119.85 18 209.87 17.883 210.87-0.76953 6.625 3.9648 12.625 10.59 13.414 0.47266 0.054687 0.95312 0.082031 1.4297 0.082031 6.125-0.003906 11.281-4.5898 12-10.676 0.55469-4.6914 12.73-113.8-27.75-255.66h51.223-0.003906c5.1211 12.875 15.051 23.254 27.688 28.941v224.62c-0.13672 6.6016 4.8672 12.18 11.445 12.762 3.3125 0.17969 6.5586-1.0117 8.9688-3.2969 2.4062-2.2852 3.7734-5.4609 3.7695-8.7812v-176.86l27.48 15.922v160.26c-0.13281 6.6016 4.8711 12.18 11.449 12.762 3.3125 0.17969 6.5547-1.0117 8.9648-3.2969 2.4102-2.2852 3.7734-5.4609 3.7734-8.7812v-226.88c8.4922-4.5312 15.594-11.285 20.547-19.535 4.9531-8.2539 7.5742-17.695 7.582-27.316v-65.648c-0.007812-9.625-2.6289-19.066-7.582-27.316s-12.055-15.004-20.547-19.535v-312.22c12.238-10.184 21.301-23.656 26.117-38.824 2.2695-7.4961 2.8711-15.395 1.7656-23.148l34.082-86.254h0.003906c3.9336-9.8086 5.9219-20.285 5.8516-30.855-0.089843-8.625-0.39453-32.355-15.883-50.215l11.707-15.883v0.003906c2.75-3.7344 4.2422-8.25 4.2578-12.891 0.015625-4.6367-1.4453-9.1641-4.1719-12.918l-94.367-129.93c-3.6367-5.0117-9.4766-7.9492-15.664-7.8789-6.1914 0.070313-11.965 3.1406-15.484 8.2305l-90.117 130.55c-2.3867 3.457-3.75 7.5195-3.9336 11.719-0.18359 4.1992 0.82031 8.3633 2.9023 12.016l11.066 19.465c-13.035 9.168-22.547 22.508-26.973 37.816-3.4141 12.242-3.3906 25.184 0.0625 37.414 3.457 12.227 10.211 23.27 19.523 31.914l39.348 37.488c-13.004 45.176 8.8242 81.098 23.293 98.75h0.003906c6.9727 8.5156 10.777 19.191 10.762 30.199v263.87c-11.539 5.1992-20.855 14.332-26.289 25.766l-93.934-3.3711c-32.48-69.945-75.785-134.33-128.31-190.8 41.551-9.8828 66.594-37.445 70.488-79.457 0.035156-0.35156 0.054687-0.74219 0.054687-1.1172 0-1.5117-0.27344-37.285-24.141-63.852h-0.003906c-12.266-13.656-18.227-31.844-16.426-50.117 2.5664-28.648-7.6367-71.242-70.82-111.47h-0.003906c-23.039-14.574-37.926-39.098-40.227-66.266-5.4336-70.707-34.41-189.32-167.57-189.32-2.7812 0.046876-65.035 1.5781-98.922 44.055-20.332-5.293-70.418-11.531-122.39 34.062-40.027 35.105-45.629 101.48-43.281 150.98 1.4922 25.848-8.832 50.977-28.066 68.305-34.387 29.676-53.074 73.613-50.598 118.96 0.67188 24 7.543 47.418 19.941 67.977-8.6914 7.2227-14.695 17.156-17.047 28.203-2.8984 13.789-5.0039 27.734-6.2969 41.766-10.094-1.2266-20.297 1.0938-28.863 6.5664-10.586 6.7344-17.734 17.727-19.598 30.137-4.168 27.309-5.5547 54.977-4.1289 82.566 0.64844 12.07 4.9102 23.668 12.238 33.285-8.5078 37.441-50.953 237.82-27.672 412.55 0.80078 6.0039 5.918 10.492 11.98 10.496zm1015.2-867.65-19.691 49.828-33.711-39.617 50.574-62.656c5.8398 9.2266 6.8789 20.863 6.9844 30.742l0.003906-0.003906c0.035157 7.4375-1.375 14.809-4.1602 21.707zm-94.379-210.84 9.6914 94.59c0.63281 6.1602 5.8086 10.848 12 10.863 0.41797 0 0.83203-0.019531 1.2461-0.0625 6.6445-0.68359 11.48-6.6211 10.801-13.27l-8.4688-82.52 68.312 94.051-70.727 23.84-93.801-24.707zm9.832 149.07-7.6875 55.926-63.176-67.207-4.9414-8.6875zm-87.496 81.684c-6.0469-5.6367-10.453-12.809-12.75-20.75-2.293-7.9414-2.3906-16.359-0.28125-24.352 2.9297-10.156 9.2539-19 17.918-25.059l123.16 131.05c7.7344 8.082 10.594 19.668 7.5078 30.418-2.8711 9.0312-7.9297 17.215-14.723 23.82zm80.91 193.01 27.48 26.324v223.85c-0.27344 0-0.53516-0.042969-0.80859-0.042969h-26.672zm-31.441 303.25h0.003906c0.003906-7.6758 3.0547-15.031 8.4844-20.457 5.4258-5.4258 12.781-8.4766 20.457-8.4844h29.164c7.6758 0.007813 15.031 3.0586 20.457 8.4844 5.4258 5.4258 8.4805 12.781 8.4844 20.457v65.648c-0.007813 7.6719-3.0586 15.027-8.4844 20.453-5.4258 5.4258-12.781 8.4805-20.457 8.4844h-29.176c-7.6758-0.003906-15.031-3.0586-20.457-8.4844s-8.4766-12.781-8.4844-20.453zm-732.42 250.23c-4.6133-3.6445-8.125-8.4961-10.141-14.02-2.0195-5.5234-2.4609-11.496-1.2852-17.258l7.9492-38.055c1.0469-5.0156-1.1758-10.145-5.5547-12.809-36.457-22.156-82.438-66.641-106.59-91.18h0.003906c-11.328-11.496-17.316-27.215-16.504-43.336 0.99219-18.766 2.5859-36.145 4.4141-51.75 27.328 5.6836 55.332 7.4023 83.148 5.1016l-12.75 45.082c-0.94531 3.3359-0.41406 6.918 1.4609 9.832 22.059 34.312 75.609 88.234 104.03 115.89l-0.003906 0.003906c-18.707 29.379-34.824 60.332-48.176 92.504zm427.99-469.71c-0.54688 7.8242-3.8867 15.191-9.4141 20.754-5.5312 5.5625-12.875 8.9531-20.695 9.5469l-13.184 1.0586c0.90625-4.9297 1.2188-9.9492 0.93359-14.953-0.82031-14.812-3.6328-29.445-8.3594-43.504-3.5195-10.328-9.7578-19.516-18.055-26.598 15.773-11.465 30.504-24.293 44.02-38.344 1.6836-1.7812 4.1797-2.5508 6.5742-2.0273 2.3047 0.45312 4.1953 2.1016 4.957 4.3242 10.324 28.738 14.82 59.246 13.223 89.742zm-210.82-132.13h-0.003906c-6.7227 4.1211-15.117 4.4258-22.121 0.80078-20.969-11.145-39.309-26.645-53.793-45.461-13.219-16.941-21.465-37.227-23.82-58.586-1.2773-11.254-2.0273-23.684-2.2539-37.078 12.461-21.629 34.715-56.664 55.266-70.672v-0.003906c11.961 21.668 28.23 40.652 47.809 55.793 19.574 15.137 42.047 26.109 66.023 32.23-0.49219 9.4609-1.1406 18.832-2.0391 27.883-2.0703 21.988-10.59 42.875-24.488 60.039-11.5 13.844-25.211 25.688-40.582 35.055zm27.34 10.609-0.003906 71.406c-24.969-2.4531-49.723-6.75-74.062-12.852v-54.672c4.457 2.8242 8.9844 5.4844 13.633 7.8477l0.003907 0.003907c14.527 7.3516 31.82 6.6836 45.742-1.7656 4.3164-2.6172 9.3438-5.9766 14.684-9.9688zm-242.91 26.523c1.4844-3.918 4.5508-7.0312 8.4414-8.5781 3.8906-1.5508 8.2539-1.3984 12.027 0.42578 10.438 8.2383 91.574 68.645 237.21 78.59v-0.003906c-1.0117 3.3672-1.7344 6.8086-2.1562 10.297-0.35156 3.1055-0.59766 6.1953-0.76172 9.2695-140.12-2.0781-236.19-56.371-259.99-71.312h-0.003906c1.1445-6.3828 2.8945-12.641 5.2305-18.688zm279.53 83.57-0.003907-0.003906c1.1211-9.1523 5.5664-17.574 12.492-23.664 6.9219-6.0938 15.844-9.4258 25.066-9.3711h0.23828-0.003907c7.7891-0.007812 15.383 2.4141 21.734 6.9219 6.3477 4.5078 11.137 10.879 13.703 18.234 4.0273 12 6.4219 24.488 7.1133 37.129 0.54688 8.5898-1.8594 17.109-6.8203 24.145-4.9609 7.0352-12.18 12.164-20.453 14.535l-3.0391 0.875c-9.6523 2.8086-20.023 1.6602-28.828-3.1953-8.8008-4.8555-15.305-13.016-18.078-22.676-3.8711-13.965-4.9258-28.559-3.1055-42.934zm427.09 232.26v59.609l-191.52-0.003906c-16.352-0.023438-32.34-4.8164-46.004-13.793-33.922-22.477-66.312-47.176-96.965-73.938 24.352-30.801 28.941-77.02 29.523-102 31.93 38.973 69.387 79.102 92.195 102.89 12.445 13.039 29.504 20.68 47.52 21.285zm-115.99-28.367-48.406-1.7383h-0.003906c-11.723-0.39453-22.824-5.3711-30.922-13.855-14.508-15.129-35.027-36.969-56.16-60.805-0.49609-0.78125-31.137-49.227 30.816-81.238v-0.003906c41.781 47.633 76.988 100.65 104.69 157.64zm-626.33-435.94c24.715-22.176 38.016-54.375 36.16-87.527-2.0938-44.191 2.2891-102.91 35.066-131.65 54.293-47.648 104.36-27.785 106.4-26.941v0.003906c5.4258 2.3125 11.727 0.37109 14.914-4.5859 25.043-38.949 83.887-40.59 84.258-40.59 107.79 0 137.39 90.812 143.25 166.99 2.8984 34.75 21.906 66.141 51.355 84.816 41.895 26.672 62.543 57.414 59.727 88.906-2.2891 24.949 5.8672 49.727 22.523 68.441 5.0703 5.7695 9.0859 12.387 11.867 19.547-3.9297 16.738-32.898 20.254-32.898 20.254-51.285 3.25-63.531-38.895-63.531-38.895v0.058594c-17.828-54.641-54.02-115.02-127.91-146.47-119.29-50.777-109.82-117.67-109.41-120.27v0.003906c0.88672-4.9414-1.3711-9.918-5.6719-12.504-4.3047-2.5859-9.7578-2.2461-13.703 0.85547-36.602 28.008-66.523 63.801-87.598 104.79v-0.050781l-0.27344 0.56641c-0.30859 0.60547-0.60938 1.2109-0.91016 1.8164-8.6562 16.965-64.898 119.15-163.48 119.55h0.003906c5.7266-26.078 19.707-49.617 39.859-67.129zm-94.609 279.12c0.80078-5.5039 3.9766-10.375 8.6875-13.328 4.7852-3.0547 10.66-3.8906 16.109-2.2891l6.3945 1.8828c12.121 5.9805 120 57.355 247.71 57.355 3.2422 0.054688 6.3711-1.1914 8.6875-3.4688 2.3125-2.2734 3.6133-5.3789 3.6133-8.625 0-3.2422-1.3008-6.3516-3.6133-8.625-2.3164-2.2734-5.4453-3.5234-8.6875-3.4688-108.42 0-204.49-40-230.73-51.934v0.003906c1.1328-14.965 3.2461-29.836 6.3242-44.523 1.4141-6.5352 5.2461-12.293 10.73-16.121 5.4805-3.8281 12.207-5.4414 18.832-4.5195l23.688 3.3477c17.375 11.688 120 75.883 278.12 77.875 0.80078 6.3945 2.0859 12.719 3.8438 18.922 3.707 12.934 11.516 24.316 22.254 32.426s23.82 12.512 37.277 12.539c5.875-0.003906 11.719-0.83594 17.359-2.4727l2.5742-0.74219c10.836 55.262-8.5117 91.887-21.559 109.26v0.003907c-9.6133 13.035-14.766 28.82-14.699 45.016v81.531c-20.105 28.984-44.855 54.445-73.258 75.363-5.1406 3.8242-11.215 6.2031-17.59 6.8789-6.3711 0.67578-12.809-0.375-18.637-3.0352-33.93-15.277-65.547-35.242-93.922-59.316v-87.395c0.12891-18.746-6.8125-36.852-19.441-50.711 96.785-13.629 181.12-92.117 181.12-92.117 5.8359-3.2461 7.9414-10.605 4.6953-16.445-3.2461-5.8359-10.605-7.9414-16.445-4.6953-78.379 43.559-203.33 89.797-353.57 62.695-7.3164-1.3086-14.051-4.8438-19.289-10.113-0.24219-0.28125-0.50781-0.54297-0.77734-0.80469-5.8008-6.1953-9.2344-14.234-9.6914-22.711-1.3359-25.945-0.027344-51.961 3.8984-77.641z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m425.34 336.75c-5.957-1.4922-12.02-2.5117-18.133-3.0586-6.6016-0.47656-12.359 4.4336-12.926 11.023-0.57031 6.5938 4.2617 12.418 10.844 13.074 4.8398 0.43359 9.6367 1.2422 14.348 2.4258 0.96484 0.23828 1.9531 0.35547 2.9453 0.35547 6.1094-0.003906 11.254-4.5625 11.996-10.625 0.74609-6.0625-3.1484-11.727-9.0742-13.207z", fill: "currentColor" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m504.98 344.7c-0.26562-3.1992-1.8008-6.1602-4.2578-8.2227-2.457-2.0664-5.6328-3.0703-8.832-2.7852-6.1133 0.54297-12.18 1.5625-18.133 3.0547-5.9297 1.4766-9.8203 7.1445-9.0781 13.207 0.74609 6.0625 5.8945 10.621 12.004 10.621 0.98828 0.003906 1.9766-0.11719 2.9375-0.35156 4.7148-1.1836 9.5117-1.9922 14.348-2.4258 3.1992-0.27344 6.1562-1.8086 8.2227-4.2656 2.0625-2.457 3.0664-5.6328 2.7891-8.832z", fill: "currentColor" })] }) }))); };


/***/ }),
/* 223 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useStarsAnimation": () => (/* binding */ useStarsAnimation)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _react_spring_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(108);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _useColourSample__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(143);
/* harmony import */ var _useStarsAnimation_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(224);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





var useStarsAnimation = function (numberOfStars) {
    if (numberOfStars === void 0) { numberOfStars = 7; }
    var colours = (0,_useColourSample__WEBPACK_IMPORTED_MODULE_3__.useColourSample)();
    var stars = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () { return Array(numberOfStars).map(function (_, i) { return i; }); }, [numberOfStars]);
    var _a = (0,_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.useSprings)(stars.length, function () { return ({
        opacity: 0,
        x: 0,
        y: 0,
        rotateZ: 0,
    }); }), starSprings = _a[0], starSpringsApi = _a[1];
    var _b = (0,_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.useSpring)(function () { return ({
        opacity: 0,
    }); }), starsOpacity = _b[0], starsOpacityApi = _b[1];
    var component = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _useStarsAnimation_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"].levelUpStars }, { children: starSprings.map(function (item, index) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, __assign({ className: _useStarsAnimation_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"].star, style: __assign(__assign({}, item), { opacity: starsOpacity.opacity }) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ className: _useStarsAnimation_module_scss__WEBPACK_IMPORTED_MODULE_4__["default"].glow, width: "30", height: "28", viewBox: "0 0 30 28", xmlns: "http://www.w3.org/2000/svg", color: colours[index % colours.length], fill: colours[index % colours.length] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M28.6439 11.0659L28.6454 11.0705C28.7276 11.3214 28.7387 11.5902 28.6777 11.8471C28.6166 12.104 28.4857 12.3389 28.2995 12.5258L28.2979 12.5274L23.3433 17.5255L22.9884 17.8835L23.0652 18.3818L24.1376 25.3395L24.1376 25.3398C24.178 25.6013 24.1456 25.8689 24.0439 26.1132C23.9423 26.3575 23.7753 26.5689 23.5616 26.7243C23.3478 26.8798 23.0954 26.9732 22.8322 26.9944C22.569 27.0157 22.3049 26.9639 22.0691 26.8448L22.0689 26.8447L15.7877 23.6738L15.337 23.4463L14.8864 23.6738L8.60536 26.8447L8.60439 26.8452C8.36866 26.9645 8.10465 27.0164 7.84139 26.9953C7.57812 26.9742 7.32572 26.8808 7.11195 26.7254C6.89817 26.57 6.73128 26.3585 6.62973 26.1141C6.52817 25.8698 6.49591 25.6021 6.53652 25.3406L6.5367 25.3395L7.6091 18.3818L7.6859 17.8835L7.33095 17.5255L2.37653 12.5276C2.37647 12.5276 2.3764 12.5275 2.37634 12.5274C2.19036 12.3397 2.05957 12.1042 1.99841 11.8468C1.93722 11.5894 1.94809 11.32 2.02982 11.0683C2.11154 10.8166 2.26092 10.5924 2.4615 10.4203C2.66201 10.2482 2.90594 10.1347 3.16652 10.0922C3.1666 10.0922 3.16667 10.0922 3.16675 10.0922L10.1106 8.96291L10.6086 8.88191L10.8394 8.4332L14.0584 2.17363C14.1794 1.9384 14.3628 1.74117 14.5884 1.60351C14.8139 1.46586 15.073 1.39307 15.337 1.39307C15.6011 1.39307 15.8602 1.46586 16.0857 1.60351C16.3112 1.74113 16.4946 1.93828 16.6156 2.17343C16.6156 2.1735 16.6157 2.17356 16.6157 2.17363L19.8347 8.4332L20.0655 8.88191L20.5635 8.96291L27.5077 10.0922L27.51 10.0926C27.7702 10.1343 28.0139 10.2472 28.214 10.419C28.4142 10.5907 28.563 10.8146 28.6439 11.0659Z", stroke: "currentColor", fill: "currentColor", strokeWidth: "2" }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "30", height: "28", viewBox: "0 0 30 28", xmlns: "http://www.w3.org/2000/svg", color: colours[index % colours.length], fill: colours[index % colours.length] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M28.6439 11.0659L28.6454 11.0705C28.7276 11.3214 28.7387 11.5902 28.6777 11.8471C28.6166 12.104 28.4857 12.3389 28.2995 12.5258L28.2979 12.5274L23.3433 17.5255L22.9884 17.8835L23.0652 18.3818L24.1376 25.3395L24.1376 25.3398C24.178 25.6013 24.1456 25.8689 24.0439 26.1132C23.9423 26.3575 23.7753 26.5689 23.5616 26.7243C23.3478 26.8798 23.0954 26.9732 22.8322 26.9944C22.569 27.0157 22.3049 26.9639 22.0691 26.8448L22.0689 26.8447L15.7877 23.6738L15.337 23.4463L14.8864 23.6738L8.60536 26.8447L8.60439 26.8452C8.36866 26.9645 8.10465 27.0164 7.84139 26.9953C7.57812 26.9742 7.32572 26.8808 7.11195 26.7254C6.89817 26.57 6.73128 26.3585 6.62973 26.1141C6.52817 25.8698 6.49591 25.6021 6.53652 25.3406L6.5367 25.3395L7.6091 18.3818L7.6859 17.8835L7.33095 17.5255L2.37653 12.5276C2.37647 12.5276 2.3764 12.5275 2.37634 12.5274C2.19036 12.3397 2.05957 12.1042 1.99841 11.8468C1.93722 11.5894 1.94809 11.32 2.02982 11.0683C2.11154 10.8166 2.26092 10.5924 2.4615 10.4203C2.66201 10.2482 2.90594 10.1347 3.16652 10.0922C3.1666 10.0922 3.16667 10.0922 3.16675 10.0922L10.1106 8.96291L10.6086 8.88191L10.8394 8.4332L14.0584 2.17363C14.1794 1.9384 14.3628 1.74117 14.5884 1.60351C14.8139 1.46586 15.073 1.39307 15.337 1.39307C15.6011 1.39307 15.8602 1.46586 16.0857 1.60351C16.3112 1.74113 16.4946 1.93828 16.6156 2.17343C16.6156 2.1735 16.6157 2.17356 16.6157 2.17363L19.8347 8.4332L20.0655 8.88191L20.5635 8.96291L27.5077 10.0922L27.51 10.0926C27.7702 10.1343 28.0139 10.2472 28.214 10.419C28.4142 10.5907 28.563 10.8146 28.6439 11.0659Z", stroke: "currentColor", fill: "currentColor", strokeWidth: "2" }) }))] }), index)); }) })));
    var play = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function () {
        starsOpacityApi.start({
            from: { opacity: 0 },
            to: [{ opacity: 1 }, { opacity: 0 }],
            config: _react_spring_web__WEBPACK_IMPORTED_MODULE_1__.config["default"],
        });
        starSpringsApi.start(function (i) {
            var rand = (Math.random() * Math.PI) / 4;
            return {
                from: {
                    scale: 1.5,
                    x: Math.cos(rand + (2 * Math.PI * i) / numberOfStars) * 50,
                    y: Math.sin(rand + (2 * Math.PI * i) / numberOfStars) * 50 * 0.6 - 30,
                    rotateZ: 0,
                },
                to: {
                    scale: 2.5,
                    x: Math.cos(rand + (2 * Math.PI * i) / numberOfStars) * 400,
                    y: Math.sin(rand + (2 * Math.PI * i) / numberOfStars) * 400 * 0.6 - 30,
                    rotateZ: (Math.random() * Math.PI) / 2,
                },
                config: __assign(__assign({}, _react_spring_web__WEBPACK_IMPORTED_MODULE_1__.config.slow), { velocity: [0, 1, 1], easing: _react_spring_web__WEBPACK_IMPORTED_MODULE_1__.easings.easeInQuad }),
            };
        });
    }, [numberOfStars, starSpringsApi, starsOpacityApi]);
    return { stars: component, play: play };
};


/***/ }),
/* 224 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(123);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(124);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_useStarsAnimation_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(225);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_useStarsAnimation_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_useStarsAnimation_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_useStarsAnimation_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_useStarsAnimation_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),
/* 225 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".useStarsAnimation-module__levelUpStars {\n  position: absolute;\n  z-index: -1;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n.useStarsAnimation-module__levelUpStars .useStarsAnimation-module__star svg {\n  position: absolute;\n}\n.useStarsAnimation-module__levelUpStars .useStarsAnimation-module__star .useStarsAnimation-module__glow {\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  filter: blur(10px);\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"levelUpStars": "useStarsAnimation-module__levelUpStars",
	"star": "useStarsAnimation-module__star",
	"glow": "useStarsAnimation-module__glow"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 226 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(123);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(124);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_EndPage_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(227);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_EndPage_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_EndPage_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_EndPage_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_EndPage_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),
/* 227 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EndPage-module__endPageContainer {\n  background: linear-gradient(272.03deg, #3c5ae7 -1.1%, #1e1e1e 120.83%);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  align-items: center;\n  justify-content: space-around;\n  padding-top: 66px;\n  padding-bottom: 63px;\n  position: relative;\n  z-index: -1;\n}\n.EndPage-module__endPageContainer .EndPage-module__backgroundImage {\n  position: absolute;\n  z-index: -1;\n  left: -25px;\n  bottom: -50px;\n  transform-origin: bottom left;\n}\n.EndPage-module__endPageContainer .EndPage-module__backgroundImage svg {\n  height: 512px;\n  width: 512px;\n}\n.EndPage-module__endPageContainer .EndPage-module__backgroundImage .EndPage-module__glow {\n  position: absolute;\n  top: 0;\n  left: 0;\n  filter: blur(10px);\n}\n.EndPage-module__endPageContainer .EndPage-module__title {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 50px;\n  line-height: 68px;\n  text-align: center;\n  color: #ffffff;\n  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n  margin-bottom: 4px;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 20px;\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n  margin-bottom: 65px;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer .EndPage-module__score {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 60px;\n  line-height: 82px;\n  text-align: center;\n  color: #ffffff;\n  position: relative;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer .EndPage-module__score .EndPage-module__double {\n  filter: blur(5px);\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer.EndPage-module__low .EndPage-module__double {\n  display: none;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer.EndPage-module__low .EndPage-module__stars .EndPage-module__star:nth-child(1) {\n  fill: #f15530;\n  color: transparent;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer.EndPage-module__low .EndPage-module__stars .EndPage-module__star:nth-child(2),\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer.EndPage-module__low .EndPage-module__stars .EndPage-module__star:nth-child(3) {\n  fill: transparent;\n  color: white;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer.EndPage-module__medium .EndPage-module__double {\n  display: none;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer.EndPage-module__medium .EndPage-module__stars .EndPage-module__star:nth-child(1),\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer.EndPage-module__medium .EndPage-module__stars .EndPage-module__star:nth-child(2) {\n  fill: #e3b275;\n  color: transparent;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer.EndPage-module__medium .EndPage-module__stars .EndPage-module__star:nth-child(3) {\n  fill: transparent;\n  color: white;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer.EndPage-module__high .EndPage-module__double {\n  display: none;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer.EndPage-module__high .EndPage-module__stars .EndPage-module__star {\n  fill: #5ac7a8;\n  color: transparent;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer.EndPage-module__perfect .EndPage-module__double {\n  display: block;\n  opacity: 0.8;\n  filter: blur(2px);\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer.EndPage-module__perfect .EndPage-module__stars .EndPage-module__star {\n  fill: #fff;\n  color: transparent;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer .EndPage-module__stars {\n  display: flex;\n  flex-direction: row;\n  gap: 9.2px;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__scoreContainer .EndPage-module__stars .EndPage-module__star {\n  position: relative;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__messageContainer {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 27px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 5px;\n  margin-bottom: 12px;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__messageContainer .EndPage-module__difference {\n  padding-left: 6px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: #e3b275;\n  fill: #e3b275;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__messageContainer .EndPage-module__difference.EndPage-module__positive {\n  color: #5ac7a8;\n  fill: #5ac7a8;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__messageContainer .EndPage-module__difference.EndPage-module__positive .EndPage-module__triangle {\n  transform: rotateZ(0deg);\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__messageContainer .EndPage-module__difference.EndPage-module__negative {\n  color: #f15530;\n  fill: #f15530;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__messageContainer .EndPage-module__difference.EndPage-module__negative .EndPage-module__triangle {\n  transform: rotateZ(180deg);\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__messageContainer .EndPage-module__difference .EndPage-module__triangle {\n  transform: rotateZ(90deg);\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__messageContainer .EndPage-module__difference .EndPage-module__text {\n  flex-direction: row;\n  margin-left: 6px;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__messageContainer .EndPage-module__badge {\n  color: white;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.EndPage-module__endPageContainer .EndPage-module__progressContainer .EndPage-module__messageContainer .EndPage-module__badge img {\n  width: 32px;\n  height: 32px;\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__message {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 30px;\n  line-height: 41px;\n  /* identical to box height */\n  color: #ffffff;\n  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__message span {\n  font-weight: 700;\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__inputContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__inputContainer input,\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__inputContainer .EndPage-module__levelContainer {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 50px;\n  line-height: 68px;\n  height: 68px;\n  color: #5ac7a8;\n  text-align: center;\n  margin-right: 10px;\n  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n  background: transparent;\n  border-color: transparent;\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__inputContainer input .EndPage-module__level,\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__inputContainer .EndPage-module__levelContainer .EndPage-module__level {\n  position: absolute;\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__inputContainer input .EndPage-module__level .EndPage-module__glow,\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__inputContainer .EndPage-module__levelContainer .EndPage-module__level .EndPage-module__glow {\n  position: absolute;\n  top: 0;\n  left: 0;\n  filter: blur(10px);\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__inputContainer svg {\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__progressBarContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 20px;\n  margin-top: 15px;\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__progressBarContainer .EndPage-module__progressBar {\n  width: 413px;\n  height: 27.2px;\n  border: 6px solid #2e3453;\n  border-radius: 30px;\n  margin-bottom: 42px;\n  margin-top: 6px;\n  position: relative;\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__progressBarContainer .EndPage-module__progressBar .EndPage-module__glow {\n  position: absolute;\n  top: -6px;\n  left: -6px;\n  right: -6px;\n  bottom: -6px;\n  filter: blur(10px);\n  z-index: -1;\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__progressBarContainer .EndPage-module__progressBar .EndPage-module__progressBarInner {\n  z-index: -1;\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__progressBarContainer .EndPage-module__progressBar .EndPage-module__progressBarInner .EndPage-module__background {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: #2e3453;\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__progressBarContainer .EndPage-module__progressBar .EndPage-module__progressBarInner .EndPage-module__existing,\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__progressBarContainer .EndPage-module__progressBar .EndPage-module__progressBarInner .EndPage-module__new {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__progressBarContainer .EndPage-module__progressBar .EndPage-module__progressBarInner .EndPage-module__existing {\n  z-index: 2;\n  background: #5ac7a8;\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__progressBarContainer .EndPage-module__progressBar .EndPage-module__progressBarInner .EndPage-module__new {\n  z-index: 1;\n  background: #fff597;\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__progressBarContainer .EndPage-module__progressBar .EndPage-module__progressBarInner .EndPage-module__new .EndPage-module__label {\n  position: relative;\n  left: 100%;\n  transform: translateX(-50%);\n  top: calc(100% + 6px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 27px;\n  color: #fff597;\n}\n.EndPage-module__endPageContainer .EndPage-module__goalContainer .EndPage-module__progressBarContainer .EndPage-module__progressBar .EndPage-module__progressBarInner .EndPage-module__new .EndPage-module__label .EndPage-module__amount {\n  width: max-content;\n}\n.EndPage-module__endPageContainer .EndPage-module__actions {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  gap: 55px;\n  margin-top: 48px;\n}\n.EndPage-module__endPageContainer .EndPage-module__actions span {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 27px;\n  text-align: center;\n  color: #ffffff;\n}\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__doubleXp {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20px;\n  text-align: center;\n  color: #fff597;\n  margin-top: 3px;\n}\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__doubleXp img {\n  height: 28px;\n}\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__retakeButton,\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__nextQuizButton,\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__finishButton {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  cursor: pointer;\n}\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__retakeButton .EndPage-module__top,\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__nextQuizButton .EndPage-module__top,\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__finishButton .EndPage-module__top {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__retakeButton .EndPage-module__bottom,\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__nextQuizButton .EndPage-module__bottom,\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__finishButton .EndPage-module__bottom {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__retakeButton .EndPage-module__top {\n  background: #e3b275;\n  border-radius: 100%;\n  width: 72px;\n  height: 72px;\n}\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__retakeButton .EndPage-module__top img {\n  width: 55px;\n  height: 55px;\n}\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__nextQuizButton {\n  margin-bottom: -31px;\n}\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__nextQuizButton .EndPage-module__top {\n  width: 87px;\n  height: 87px;\n  border: 5.5px solid #5ac7a8;\n  border-radius: 100%;\n  object-fit: cover;\n}\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__nextQuizButton .EndPage-module__top:not(img) {\n  border-color: transparent;\n  padding: 2px;\n  background-color: #5ac7a8;\n}\n.EndPage-module__endPageContainer .EndPage-module__actions .EndPage-module__finishButton .EndPage-module__top {\n  background: #41a5d1;\n  border-radius: 100%;\n  width: 72px;\n  height: 72px;\n}\n.EndPage-module__endPageContainer .EndPage-module__rightContainer {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 57px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.EndPage-module__endPageContainer .EndPage-module__rightContainer .EndPage-module__nextUp {\n  filter: drop-shadow(0px 12px 10px rgba(44, 43, 94, 0.4));\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  background-color: white;\n  border-radius: 40px;\n  padding: 22px 22px 18px;\n  margin-bottom: 22px;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: -0.1px;\n  color: #2c2b5e;\n}\n@media only screen and (max-width: 1280px) {\n  .EndPage-module__endPageContainer .EndPage-module__rightContainer .EndPage-module__nextUp {\n    display: none;\n  }\n}\n.EndPage-module__endPageContainer .EndPage-module__rightContainer .EndPage-module__nextUp .EndPage-module__header {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 30px;\n  line-height: 41px;\n  letter-spacing: -0.1px;\n  color: #2c2b5e;\n  width: 100%;\n  text-align: center;\n}\n.EndPage-module__endPageContainer .EndPage-module__rightContainer .EndPage-module__nextUp .EndPage-module__items {\n  width: 300px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n}\n.EndPage-module__endPageContainer .EndPage-module__rightContainer .EndPage-module__nextUp .EndPage-module__items .EndPage-module__item {\n  border-radius: 15px;\n  filter: drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.25));\n  cursor: pointer;\n  height: 62px;\n  display: flex;\n  flex-direction: row;\n  padding: 8.4px 6.5px 5.6px 12px;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: -0.1px;\n  color: white;\n  gap: 8px;\n}\n.EndPage-module__endPageContainer .EndPage-module__rightContainer .EndPage-module__nextUp .EndPage-module__items .EndPage-module__item div {\n  height: 38px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.EndPage-module__endPageContainer .EndPage-module__rightContainer .EndPage-module__nextUp .EndPage-module__items .EndPage-module__item img {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  object-fit: cover;\n}\n.EndPage-module__endPageContainer .EndPage-module__rightContainer .EndPage-module__nextUp .EndPage-module__more {\n  margin-top: 8px;\n}\n.EndPage-module__endPageContainer .EndPage-module__rightContainer .EndPage-module__nextUp .EndPage-module__seeAll {\n  width: 100%;\n  text-align: center;\n  margin-top: 16px;\n}\n.EndPage-module__endPageContainer .EndPage-module__rightContainer .EndPage-module__nextUp .EndPage-module__emptyHead {\n  margin: 10px auto;\n}\n.EndPage-module__endPageContainer .EndPage-module__rightContainer .EndPage-module__nextUp .EndPage-module__emptyText {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  max-width: 270px;\n  text-align: center;\n}\n.EndPage-module__endPageContainer .EndPage-module__rightContainer .EndPage-module__nextUp .EndPage-module__emptyText2 {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 22px;\n  max-width: 280px;\n  text-align: center;\n  margin-top: 17px;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"endPageContainer": "EndPage-module__endPageContainer",
	"backgroundImage": "EndPage-module__backgroundImage",
	"glow": "EndPage-module__glow",
	"title": "EndPage-module__title",
	"progressContainer": "EndPage-module__progressContainer",
	"scoreContainer": "EndPage-module__scoreContainer",
	"score": "EndPage-module__score",
	"double": "EndPage-module__double",
	"low": "EndPage-module__low",
	"stars": "EndPage-module__stars",
	"star": "EndPage-module__star",
	"medium": "EndPage-module__medium",
	"high": "EndPage-module__high",
	"perfect": "EndPage-module__perfect",
	"messageContainer": "EndPage-module__messageContainer",
	"difference": "EndPage-module__difference",
	"positive": "EndPage-module__positive",
	"triangle": "EndPage-module__triangle",
	"negative": "EndPage-module__negative",
	"text": "EndPage-module__text",
	"badge": "EndPage-module__badge",
	"goalContainer": "EndPage-module__goalContainer",
	"message": "EndPage-module__message",
	"inputContainer": "EndPage-module__inputContainer",
	"levelContainer": "EndPage-module__levelContainer",
	"level": "EndPage-module__level",
	"progressBarContainer": "EndPage-module__progressBarContainer",
	"progressBar": "EndPage-module__progressBar",
	"progressBarInner": "EndPage-module__progressBarInner",
	"background": "EndPage-module__background",
	"existing": "EndPage-module__existing",
	"new": "EndPage-module__new",
	"label": "EndPage-module__label",
	"amount": "EndPage-module__amount",
	"actions": "EndPage-module__actions",
	"doubleXp": "EndPage-module__doubleXp",
	"retakeButton": "EndPage-module__retakeButton",
	"nextQuizButton": "EndPage-module__nextQuizButton",
	"finishButton": "EndPage-module__finishButton",
	"top": "EndPage-module__top",
	"bottom": "EndPage-module__bottom",
	"rightContainer": "EndPage-module__rightContainer",
	"nextUp": "EndPage-module__nextUp",
	"header": "EndPage-module__header",
	"items": "EndPage-module__items",
	"item": "EndPage-module__item",
	"more": "EndPage-module__more",
	"seeAll": "EndPage-module__seeAll",
	"emptyHead": "EndPage-module__emptyHead",
	"emptyText": "EndPage-module__emptyText",
	"emptyText2": "EndPage-module__emptyText2"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 228 */
/***/ ((module) => {

"use strict";
module.exports = "data:image/png;base64,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";

/***/ }),
/* 229 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QuizFeedbackWidget": () => (/* binding */ QuizFeedbackWidget)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var immutability_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(117);
/* harmony import */ var immutability_helper__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(immutability_helper__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useKey__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(165);
/* harmony import */ var _providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(105);
/* harmony import */ var _requests__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7);
/* harmony import */ var _assets_black_x_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(171);
/* harmony import */ var _assets_continue_png__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(172);
/* harmony import */ var _assets_thumb__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(170);
/* harmony import */ var _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(168);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};











var QuizFeedbackWidget = function (_a) {
    var _b, _c;
    var quizId = _a.quizId;
    var user = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_4__.AppConfigContext).user;
    var _d = useQuizFeedback(quizId), feedback = _d.feedback, setFeedback = _d.setFeedback;
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), menuState = _e[0], setMenuState = _e[1];
    if (user.id === "") {
        return null;
    }
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].outer }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].label }, { children: "How was this quiz?" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].inner }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_thumb__WEBPACK_IMPORTED_MODULE_6__.Thumb, { onClick: function () { return setMenuState("positive"); }, className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option, _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].positive, (_b = {}, _b[_FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].active] = (feedback === null || feedback === void 0 ? void 0 : feedback.result) === "positive", _b)) }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_thumb__WEBPACK_IMPORTED_MODULE_6__.Thumb, { onClick: function () { return setMenuState("negative"); }, className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option, _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].negative, (_c = {}, _c[_FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].active] = (feedback === null || feedback === void 0 ? void 0 : feedback.result) === "negative", _c)) })] })), menuState !== null && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuizFeedbackModal, { type: menuState, setFeedback: function (feedback) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                setMenuState(null);
                                if (!feedback) return [3 /*break*/, 2];
                                return [4 /*yield*/, setFeedback(feedback)];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); } }))] })));
};
var QuizFeedbackModal = function (_a) {
    var _b, _c;
    var type = _a.type, setFeedback = _a.setFeedback;
    var _d = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        page: 0,
        choices: {
            difficulty: false,
            numberofQuestions: false,
            content: false,
            other: false,
        },
        feedback: {
            result: type,
            length: undefined,
            difficulty: undefined,
            information: undefined,
        },
    }), menuState = _d[0], setMenuState = _d[1];
    var mutateMenuState = function (spec) { return setMenuState(function (menuState) { return immutability_helper__WEBPACK_IMPORTED_MODULE_2___default()(menuState, spec); }); };
    (0,_hooks_useKey__WEBPACK_IMPORTED_MODULE_7__.useKey)("Escape", function () { return setFeedback(); }, [setFeedback]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].modalOuter, onClick: function () {
            setFeedback(menuState.feedback);
        } }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].modalInner, onClick: function (e) {
                e.stopPropagation();
            } }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].close, src: _assets_black_x_svg__WEBPACK_IMPORTED_MODULE_8__, onClick: function () {
                        setFeedback(menuState.feedback);
                    }, alt: "Close" }), menuState.page === 0 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].title }, { children: ["What parts of the quiz were you ", type === "positive" ? "satisfied" : "unsatisfied", " by?"] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].options }, { children: [type === "negative" && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "dif", checked: menuState.choices.difficulty, onChange: function (e) {
                                                        return mutateMenuState({
                                                            choices: {
                                                                difficulty: { $set: e.target.checked },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "dif" }, { children: "Difficulty level" }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "length", checked: menuState.choices.numberofQuestions, onChange: function (e) {
                                                        return mutateMenuState({
                                                            choices: {
                                                                numberofQuestions: { $set: e.target.checked },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "length" }, { children: "Number of Questions" }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "content", checked: menuState.choices.content, onChange: function (e) {
                                                        return mutateMenuState({
                                                            choices: {
                                                                content: { $set: e.target.checked },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "content" }, { children: "Content" }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "other", checked: menuState.choices.other, onChange: function (e) {
                                                        return mutateMenuState({
                                                            choices: {
                                                                other: { $set: e.target.checked },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "other" }, { children: "Other" }))] }))] })), type === "positive" && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "difficulty", checked: menuState.feedback.difficulty === "just-right", onChange: function (e) {
                                                        return mutateMenuState({
                                                            feedback: {
                                                                difficulty: { $set: e.target.checked ? "just-right" : undefined },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "difficulty" }, { children: "This quiz was not too hard or too easy." }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "length", checked: menuState.feedback.length === "just-right", onChange: function (e) {
                                                        return mutateMenuState({
                                                            feedback: {
                                                                length: { $set: e.target.checked ? "just-right" : undefined },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "length" }, { children: "This quiz was not too long or too short." }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "info", checked: menuState.feedback.information === "correct", onChange: function (e) {
                                                        return mutateMenuState({
                                                            feedback: {
                                                                information: { $set: e.target.checked ? "correct" : undefined },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "info" }, { children: "This quiz evaluated the right kind of information." }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "other", checked: menuState.choices.other, onChange: function (e) {
                                                        return mutateMenuState({
                                                            choices: {
                                                                other: { $set: e.target.checked },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "other" }, { children: "Other" }))] })), menuState.choices.other && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].subsubtitle }, { children: "Please explain why you chose \u201COther\u201D:" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", { value: (_b = menuState.feedback.other) !== null && _b !== void 0 ? _b : "", onChange: function (e) { return mutateMenuState({ feedback: { other: { $set: e.target.value } } }); } })] }))] }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].continueContainer }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["continue"] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: _assets_continue_png__WEBPACK_IMPORTED_MODULE_9__, alt: "continue", onClick: function () {
                                        if (type === "negative") {
                                            if (menuState.choices.difficulty ||
                                                menuState.choices.numberofQuestions ||
                                                menuState.choices.content ||
                                                menuState.choices.other) {
                                                mutateMenuState({ page: { $set: 1 } });
                                            }
                                            else {
                                                setFeedback(undefined);
                                            }
                                        }
                                        else {
                                            if (menuState.feedback.difficulty ||
                                                menuState.feedback.length ||
                                                menuState.feedback.information ||
                                                menuState.choices.other) {
                                                mutateMenuState({ page: { $set: 2 } });
                                            }
                                        }
                                    } }) })) }))] })), menuState.page === 1 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [menuState.choices.difficulty && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].subtitle }, { children: "Difficulty level" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].options }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "hard", checked: menuState.feedback.difficulty === "too-hard", onChange: function (e) {
                                                        return mutateMenuState({
                                                            feedback: {
                                                                difficulty: {
                                                                    $set: e.target.checked ? "too-hard" : undefined,
                                                                },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "hard" }, { children: "This quiz was too hard." }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "easy", checked: menuState.feedback.difficulty === "too-easy", onChange: function (e) {
                                                        return mutateMenuState({
                                                            feedback: {
                                                                difficulty: {
                                                                    $set: e.target.checked ? "too-easy" : undefined,
                                                                },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "easy" }, { children: "This quiz was too easy." }))] }))] }))] })), menuState.choices.numberofQuestions && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].subtitle }, { children: "Number of Questions" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].options }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "short", checked: menuState.feedback.length === "too-short", onChange: function (e) {
                                                        return mutateMenuState({
                                                            feedback: {
                                                                length: {
                                                                    $set: e.target.checked ? "too-short" : undefined,
                                                                },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "short" }, { children: "There were too few questions." }))] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "long", checked: menuState.feedback.length === "too-long", onChange: function (e) {
                                                        return mutateMenuState({
                                                            feedback: {
                                                                length: {
                                                                    $set: e.target.checked ? "too-long" : undefined,
                                                                },
                                                            },
                                                        });
                                                    } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "long" }, { children: "There were too many questions." }))] }))] }))] })), menuState.choices.content && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].subtitle }, { children: "Content" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].options }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "missing", checked: menuState.feedback.information === "missing", onChange: function (e) {
                                                    return mutateMenuState({
                                                        feedback: {
                                                            information: {
                                                                $set: e.target.checked ? "missing" : undefined,
                                                            },
                                                        },
                                                    });
                                                } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "missing" }, { children: "This quiz was missing facts I was wanting to retain." }))] })) }))] })), menuState.choices.content && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].subtitle }, { children: "Content" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].options }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].option }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", { type: "checkbox", id: "missing", checked: menuState.feedback.information === "missing", onChange: function (e) {
                                                    return mutateMenuState({
                                                        feedback: {
                                                            information: {
                                                                $set: e.target.checked ? "missing" : undefined,
                                                            },
                                                        },
                                                    });
                                                } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", __assign({ htmlFor: "missing" }, { children: "This quiz was missing facts I was wanting to retain." }))] })) }))] })), menuState.choices.other && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].subsubtitle }, { children: "Please explain why you chose \u201COther\u201D:" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", { value: (_c = menuState.feedback.other) !== null && _c !== void 0 ? _c : "", onChange: function (e) { return mutateMenuState({ feedback: { other: { $set: e.target.value } } }); } })] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].continueContainer }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["continue"] }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: _assets_continue_png__WEBPACK_IMPORTED_MODULE_9__, alt: "continue", onClick: function () {
                                        mutateMenuState({
                                            page: { $set: 2 },
                                        });
                                    } }) })) }))] })), menuState.page === 2 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].title }, { children: "Thank you for your feedback!" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].endCard, width: "229", height: "143", viewBox: "0 0 229 143", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M113.651 72.6546C116.81 68.2308 137.336 37.9768 122.922 17.6895C115.088 6.66256 98.328 0.720174 73.1049 0.031336C72.3258 0.0103032 71.5248 0.000149113 70.7002 0.000149113C54.4721 0.000149113 22.9703 4.589 7.84909 21.7895C-1.76121 32.7218 -2.55051 46.4791 5.50311 62.6854C17.9759 87.7806 40.5236 88.416 57.0542 88.416C73.3764 88.416 94.3924 84.8095 99.5106 80.5548L123.267 93.8975C123.46 93.9679 123.659 94.0002 123.864 94.0002C124.235 94.0002 124.601 93.8866 124.873 93.6738C125.294 93.3474 125.411 92.8495 125.166 92.4249L113.651 72.6546ZM99.7209 78.1784C99.1061 77.959 98.3829 78.1069 97.978 78.5272C94.8115 81.8349 74.3743 86.1898 57.0573 86.1898C41.419 86.1898 20.0591 85.8034 8.17256 61.8832C0.48065 46.4011 1.1657 33.3364 10.2096 23.0493C22.7872 8.7415 50.3848 2.22817 70.7041 2.22817C71.492 2.22817 72.2595 2.23724 73.0046 2.25827C97.1507 2.92009 113.102 8.47248 120.416 18.7635C134.889 39.1223 111.05 71.7158 110.81 72.0426C110.578 72.3534 110.551 72.7323 110.746 73.0609L120.977 90.63L99.7209 78.1784Z", fill: "#2C2A5D" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M28.2702 31L25.7742 22.36H26.6922L28.7142 29.494L30.7242 22.366L31.6482 22.36L33.6702 29.494L35.6802 22.36H36.6042L34.1142 31H33.2262L31.1862 23.914L29.1582 31H28.2702ZM39.6699 31.18C39.0379 31.18 38.4899 31.04 38.0259 30.76C37.5659 30.48 37.2079 30.086 36.9519 29.578C36.6959 29.07 36.5679 28.474 36.5679 27.79C36.5679 27.082 36.6939 26.47 36.9459 25.954C37.1979 25.438 37.5519 25.04 38.0079 24.76C38.4679 24.48 39.0099 24.34 39.6339 24.34C40.2739 24.34 40.8199 24.488 41.2719 24.784C41.7239 25.076 42.0659 25.496 42.2979 26.044C42.5299 26.592 42.6359 27.246 42.6159 28.006H41.7159V27.694C41.6999 26.854 41.5179 26.22 41.1699 25.792C40.8259 25.364 40.3219 25.15 39.6579 25.15C38.9619 25.15 38.4279 25.376 38.0559 25.828C37.6879 26.28 37.5039 26.924 37.5039 27.76C37.5039 28.576 37.6879 29.21 38.0559 29.662C38.4279 30.11 38.9539 30.334 39.6339 30.334C40.0979 30.334 40.5019 30.228 40.8459 30.016C41.1939 29.8 41.4679 29.49 41.6679 29.086L42.4899 29.404C42.2339 29.968 41.8559 30.406 41.3559 30.718C40.8599 31.026 40.2979 31.18 39.6699 31.18ZM37.1919 28.006V27.268H42.1419V28.006H37.1919ZM43.9474 24.88L44.0014 24.442C44.1614 24.454 44.2774 24.422 44.3494 24.346C44.4214 24.27 44.4654 24.168 44.4814 24.04C44.4974 23.912 44.5014 23.774 44.4934 23.626H43.9474V22.36H44.9734V23.866C44.9734 24.234 44.8794 24.51 44.6914 24.694C44.5074 24.878 44.2594 24.94 43.9474 24.88ZM47.0909 31V22.18H47.9729V31H47.0909ZM49.8916 31V22.18H50.7736V31H49.8916ZM57.4528 31.162C57.0648 31.162 56.7248 31.102 56.4328 30.982C56.1448 30.862 55.8988 30.7 55.6948 30.496C55.4948 30.292 55.3328 30.06 55.2088 29.8C55.0848 29.536 54.9948 29.258 54.9388 28.966C54.8828 28.67 54.8548 28.376 54.8548 28.084V24.52H55.7428V27.826C55.7428 28.182 55.7768 28.512 55.8448 28.816C55.9128 29.12 56.0208 29.386 56.1688 29.614C56.3208 29.838 56.5148 30.012 56.7508 30.136C56.9908 30.26 57.2808 30.322 57.6208 30.322C57.9328 30.322 58.2068 30.268 58.4428 30.16C58.6828 30.052 58.8828 29.898 59.0428 29.698C59.2068 29.494 59.3308 29.248 59.4148 28.96C59.4988 28.668 59.5408 28.34 59.5408 27.976L60.1648 28.114C60.1648 28.778 60.0488 29.336 59.8168 29.788C59.5848 30.24 59.2648 30.582 58.8568 30.814C58.4488 31.046 57.9808 31.162 57.4528 31.162ZM59.6308 31V29.404H59.5408V24.52H60.4228V31H59.6308ZM64.5178 31.174C63.7578 31.174 63.1318 31.01 62.6398 30.682C62.1518 30.354 61.8518 29.898 61.7398 29.314L62.6398 29.164C62.7358 29.532 62.9538 29.826 63.2938 30.046C63.6378 30.262 64.0618 30.37 64.5658 30.37C65.0578 30.37 65.4458 30.268 65.7298 30.064C66.0138 29.856 66.1558 29.574 66.1558 29.218C66.1558 29.018 66.1098 28.856 66.0178 28.732C65.9298 28.604 65.7478 28.486 65.4718 28.378C65.1958 28.27 64.7838 28.142 64.2358 27.994C63.6478 27.834 63.1878 27.674 62.8558 27.514C62.5238 27.354 62.2878 27.17 62.1478 26.962C62.0078 26.75 61.9378 26.492 61.9378 26.188C61.9378 25.82 62.0418 25.498 62.2498 25.222C62.4578 24.942 62.7458 24.726 63.1138 24.574C63.4818 24.418 63.9098 24.34 64.3978 24.34C64.8858 24.34 65.3218 24.42 65.7058 24.58C66.0938 24.736 66.4058 24.956 66.6418 25.24C66.8778 25.524 67.0178 25.854 67.0618 26.23L66.1618 26.392C66.1018 26.012 65.9118 25.712 65.5918 25.492C65.2758 25.268 64.8738 25.152 64.3858 25.144C63.9258 25.132 63.5518 25.22 63.2638 25.408C62.9758 25.592 62.8318 25.838 62.8318 26.146C62.8318 26.318 62.8838 26.466 62.9878 26.59C63.0918 26.71 63.2798 26.824 63.5518 26.932C63.8278 27.04 64.2198 27.158 64.7278 27.286C65.3238 27.438 65.7918 27.598 66.1318 27.766C66.4718 27.934 66.7138 28.132 66.8578 28.36C67.0018 28.588 67.0738 28.87 67.0738 29.206C67.0738 29.818 66.8458 30.3 66.3898 30.652C65.9378 31 65.3138 31.174 64.5178 31.174ZM71.1465 31.18C70.5145 31.18 69.9665 31.04 69.5025 30.76C69.0425 30.48 68.6845 30.086 68.4285 29.578C68.1725 29.07 68.0445 28.474 68.0445 27.79C68.0445 27.082 68.1705 26.47 68.4225 25.954C68.6745 25.438 69.0285 25.04 69.4845 24.76C69.9445 24.48 70.4865 24.34 71.1105 24.34C71.7505 24.34 72.2965 24.488 72.7485 24.784C73.2005 25.076 73.5425 25.496 73.7745 26.044C74.0065 26.592 74.1125 27.246 74.0925 28.006H73.1925V27.694C73.1765 26.854 72.9945 26.22 72.6465 25.792C72.3025 25.364 71.7985 25.15 71.1345 25.15C70.4385 25.15 69.9045 25.376 69.5325 25.828C69.1645 26.28 68.9805 26.924 68.9805 27.76C68.9805 28.576 69.1645 29.21 69.5325 29.662C69.9045 30.11 70.4305 30.334 71.1105 30.334C71.5745 30.334 71.9785 30.228 72.3225 30.016C72.6705 29.8 72.9445 29.49 73.1445 29.086L73.9665 29.404C73.7105 29.968 73.3325 30.406 72.8325 30.718C72.3365 31.026 71.7745 31.18 71.1465 31.18ZM68.6685 28.006V27.268H73.6185V28.006H68.6685ZM81.3543 31C80.9903 31.076 80.6303 31.106 80.2743 31.09C79.9223 31.074 79.6063 30.998 79.3263 30.862C79.0503 30.726 78.8403 30.514 78.6963 30.226C78.5803 29.986 78.5163 29.744 78.5043 29.5C78.4963 29.252 78.4923 28.97 78.4923 28.654V22.72H79.3683V28.618C79.3683 28.89 79.3703 29.118 79.3743 29.302C79.3823 29.482 79.4243 29.642 79.5003 29.782C79.6443 30.05 79.8723 30.21 80.1843 30.262C80.5003 30.314 80.8903 30.302 81.3543 30.226V31ZM77.1063 25.276V24.52H81.3543V25.276H77.1063ZM87.311 31V27.694C87.311 27.334 87.277 27.004 87.209 26.704C87.141 26.4 87.031 26.136 86.879 25.912C86.731 25.684 86.537 25.508 86.297 25.384C86.061 25.26 85.773 25.198 85.433 25.198C85.121 25.198 84.845 25.252 84.605 25.36C84.369 25.468 84.169 25.624 84.005 25.828C83.845 26.028 83.723 26.272 83.639 26.56C83.555 26.848 83.513 27.176 83.513 27.544L82.889 27.406C82.889 26.742 83.005 26.184 83.237 25.732C83.469 25.28 83.789 24.938 84.197 24.706C84.605 24.474 85.073 24.358 85.601 24.358C85.989 24.358 86.327 24.418 86.615 24.538C86.907 24.658 87.153 24.82 87.353 25.024C87.557 25.228 87.721 25.462 87.845 25.726C87.969 25.986 88.059 26.264 88.115 26.56C88.171 26.852 88.199 27.144 88.199 27.436V31H87.311ZM82.625 31V22.36H83.423V27.238H83.513V31H82.625ZM89.876 23.29V22.3H90.758V23.29H89.876ZM89.876 31V24.52H90.758V31H89.876ZM94.9748 31.174C94.2148 31.174 93.5888 31.01 93.0968 30.682C92.6088 30.354 92.3088 29.898 92.1968 29.314L93.0968 29.164C93.1928 29.532 93.4108 29.826 93.7508 30.046C94.0948 30.262 94.5188 30.37 95.0228 30.37C95.5148 30.37 95.9028 30.268 96.1868 30.064C96.4708 29.856 96.6128 29.574 96.6128 29.218C96.6128 29.018 96.5668 28.856 96.4748 28.732C96.3868 28.604 96.2048 28.486 95.9288 28.378C95.6528 28.27 95.2408 28.142 94.6928 27.994C94.1048 27.834 93.6448 27.674 93.3128 27.514C92.9808 27.354 92.7448 27.17 92.6048 26.962C92.4648 26.75 92.3948 26.492 92.3948 26.188C92.3948 25.82 92.4988 25.498 92.7068 25.222C92.9148 24.942 93.2028 24.726 93.5708 24.574C93.9388 24.418 94.3668 24.34 94.8548 24.34C95.3428 24.34 95.7788 24.42 96.1628 24.58C96.5508 24.736 96.8628 24.956 97.0988 25.24C97.3348 25.524 97.4748 25.854 97.5188 26.23L96.6188 26.392C96.5588 26.012 96.3688 25.712 96.0488 25.492C95.7328 25.268 95.3308 25.152 94.8428 25.144C94.3828 25.132 94.0088 25.22 93.7208 25.408C93.4328 25.592 93.2888 25.838 93.2888 26.146C93.2888 26.318 93.3408 26.466 93.4448 26.59C93.5488 26.71 93.7368 26.824 94.0088 26.932C94.2848 27.04 94.6768 27.158 95.1848 27.286C95.7808 27.438 96.2488 27.598 96.5888 27.766C96.9288 27.934 97.1708 28.132 97.3148 28.36C97.4588 28.588 97.5308 28.87 97.5308 29.206C97.5308 29.818 97.3028 30.3 96.8468 30.652C96.3948 31 95.7708 31.174 94.9748 31.174ZM30.7586 47C30.3946 47.076 30.0346 47.106 29.6786 47.09C29.3266 47.074 29.0106 46.998 28.7306 46.862C28.4546 46.726 28.2446 46.514 28.1006 46.226C27.9846 45.986 27.9206 45.744 27.9086 45.5C27.9006 45.252 27.8966 44.97 27.8966 44.654V38.72H28.7726V44.618C28.7726 44.89 28.7746 45.118 28.7786 45.302C28.7866 45.482 28.8286 45.642 28.9046 45.782C29.0486 46.05 29.2766 46.21 29.5886 46.262C29.9046 46.314 30.2946 46.302 30.7586 46.226V47ZM26.5106 41.276V40.52H30.7586V41.276H26.5106ZM34.5069 47.18C33.8629 47.18 33.3129 47.034 32.8569 46.742C32.4009 46.45 32.0509 46.046 31.8069 45.53C31.5629 45.014 31.4409 44.422 31.4409 43.754C31.4409 43.074 31.5649 42.478 31.8129 41.966C32.0609 41.454 32.4129 41.056 32.8689 40.772C33.3289 40.484 33.8749 40.34 34.5069 40.34C35.1549 40.34 35.7069 40.486 36.1629 40.778C36.6229 41.066 36.9729 41.468 37.2129 41.984C37.4569 42.496 37.5789 43.086 37.5789 43.754C37.5789 44.434 37.4569 45.032 37.2129 45.548C36.9689 46.06 36.6169 46.46 36.1569 46.748C35.6969 47.036 35.1469 47.18 34.5069 47.18ZM34.5069 46.334C35.2269 46.334 35.7629 46.096 36.1149 45.62C36.4669 45.14 36.6429 44.518 36.6429 43.754C36.6429 42.97 36.4649 42.346 36.1089 41.882C35.7569 41.418 35.2229 41.186 34.5069 41.186C34.0229 41.186 33.6229 41.296 33.3069 41.516C32.9949 41.732 32.7609 42.034 32.6049 42.422C32.4529 42.806 32.3769 43.25 32.3769 43.754C32.3769 44.534 32.5569 45.16 32.9169 45.632C33.2769 46.1 33.8069 46.334 34.5069 46.334ZM49.0328 47L49.0388 42.746C49.0388 42.246 48.8988 41.854 48.6188 41.57C48.3428 41.282 47.9908 41.138 47.5628 41.138C47.3188 41.138 47.0808 41.194 46.8488 41.306C46.6168 41.418 46.4248 41.598 46.2728 41.846C46.1248 42.094 46.0508 42.418 46.0508 42.818L45.5288 42.668C45.5168 42.204 45.6068 41.798 45.7988 41.45C45.9948 41.102 46.2628 40.832 46.6028 40.64C46.9468 40.444 47.3348 40.346 47.7668 40.346C48.4188 40.346 48.9408 40.548 49.3328 40.952C49.7248 41.352 49.9208 41.894 49.9208 42.578L49.9148 47H49.0328ZM41.2988 47V40.52H42.0908V42.116H42.1868V47H41.2988ZM45.1748 47L45.1808 42.806C45.1808 42.29 45.0428 41.884 44.7668 41.588C44.4948 41.288 44.1348 41.138 43.6868 41.138C43.2388 41.138 42.8768 41.292 42.6008 41.6C42.3248 41.904 42.1868 42.31 42.1868 42.818L41.6588 42.53C41.6588 42.114 41.7568 41.742 41.9528 41.414C42.1488 41.082 42.4168 40.822 42.7568 40.634C43.0968 40.442 43.4828 40.346 43.9148 40.346C44.3268 40.346 44.6928 40.434 45.0128 40.61C45.3368 40.786 45.5908 41.042 45.7748 41.378C45.9588 41.714 46.0508 42.122 46.0508 42.602L46.0448 47H45.1748ZM53.3307 47.18C52.8427 47.18 52.4327 47.092 52.1007 46.916C51.7727 46.74 51.5267 46.506 51.3627 46.214C51.1987 45.922 51.1167 45.604 51.1167 45.26C51.1167 44.908 51.1867 44.608 51.3267 44.36C51.4707 44.108 51.6647 43.902 51.9087 43.742C52.1567 43.582 52.4427 43.46 52.7667 43.376C53.0947 43.296 53.4567 43.226 53.8527 43.166C54.2527 43.102 54.6427 43.048 55.0227 43.004C55.4067 42.956 55.7427 42.91 56.0307 42.866L55.7187 43.058C55.7307 42.418 55.6067 41.944 55.3467 41.636C55.0867 41.328 54.6347 41.174 53.9907 41.174C53.5467 41.174 53.1707 41.274 52.8627 41.474C52.5587 41.674 52.3447 41.99 52.2207 42.422L51.3627 42.17C51.5107 41.59 51.8087 41.14 52.2567 40.82C52.7047 40.5 53.2867 40.34 54.0027 40.34C54.5947 40.34 55.0967 40.452 55.5087 40.676C55.9247 40.896 56.2187 41.216 56.3907 41.636C56.4707 41.824 56.5227 42.034 56.5467 42.266C56.5707 42.498 56.5827 42.734 56.5827 42.974V47H55.7967V45.374L56.0247 45.47C55.8047 46.026 55.4627 46.45 54.9987 46.742C54.5347 47.034 53.9787 47.18 53.3307 47.18ZM53.4327 46.418C53.8447 46.418 54.2047 46.344 54.5127 46.196C54.8207 46.048 55.0687 45.846 55.2567 45.59C55.4447 45.33 55.5667 45.038 55.6227 44.714C55.6707 44.506 55.6967 44.278 55.7007 44.03C55.7047 43.778 55.7067 43.59 55.7067 43.466L56.0427 43.64C55.7427 43.68 55.4167 43.72 55.0647 43.76C54.7167 43.8 54.3727 43.846 54.0327 43.898C53.6967 43.95 53.3927 44.012 53.1207 44.084C52.9367 44.136 52.7587 44.21 52.5867 44.306C52.4147 44.398 52.2727 44.522 52.1607 44.678C52.0527 44.834 51.9987 45.028 51.9987 45.26C51.9987 45.448 52.0447 45.63 52.1367 45.806C52.2327 45.982 52.3847 46.128 52.5927 46.244C52.8047 46.36 53.0847 46.418 53.4327 46.418ZM58.1387 47L58.1447 38.36H59.0327V43.64L61.9247 40.52H63.1007L60.0647 43.76L63.4967 47H62.2127L59.0327 43.88V47H58.1387ZM66.7226 47.18C66.0906 47.18 65.5426 47.04 65.0786 46.76C64.6186 46.48 64.2606 46.086 64.0046 45.578C63.7486 45.07 63.6206 44.474 63.6206 43.79C63.6206 43.082 63.7466 42.47 63.9986 41.954C64.2506 41.438 64.6046 41.04 65.0606 40.76C65.5206 40.48 66.0626 40.34 66.6866 40.34C67.3266 40.34 67.8726 40.488 68.3246 40.784C68.7766 41.076 69.1186 41.496 69.3506 42.044C69.5826 42.592 69.6886 43.246 69.6686 44.006H68.7686V43.694C68.7526 42.854 68.5706 42.22 68.2226 41.792C67.8786 41.364 67.3746 41.15 66.7106 41.15C66.0146 41.15 65.4806 41.376 65.1086 41.828C64.7406 42.28 64.5566 42.924 64.5566 43.76C64.5566 44.576 64.7406 45.21 65.1086 45.662C65.4806 46.11 66.0066 46.334 66.6866 46.334C67.1506 46.334 67.5546 46.228 67.8986 46.016C68.2466 45.8 68.5206 45.49 68.7206 45.086L69.5426 45.404C69.2866 45.968 68.9086 46.406 68.4086 46.718C67.9126 47.026 67.3506 47.18 66.7226 47.18ZM64.2446 44.006V43.268H69.1946V44.006H64.2446ZM74.3265 49.88L75.5805 46.478L75.5985 47.486L72.7605 40.52H73.6965L76.0245 46.346H75.6405L77.7885 40.52H78.6885L75.2085 49.88H74.3265ZM82.2023 47.18C81.5583 47.18 81.0083 47.034 80.5523 46.742C80.0963 46.45 79.7463 46.046 79.5023 45.53C79.2583 45.014 79.1363 44.422 79.1363 43.754C79.1363 43.074 79.2603 42.478 79.5083 41.966C79.7563 41.454 80.1083 41.056 80.5643 40.772C81.0243 40.484 81.5703 40.34 82.2023 40.34C82.8503 40.34 83.4023 40.486 83.8583 40.778C84.3183 41.066 84.6683 41.468 84.9083 41.984C85.1523 42.496 85.2743 43.086 85.2743 43.754C85.2743 44.434 85.1523 45.032 84.9083 45.548C84.6643 46.06 84.3123 46.46 83.8523 46.748C83.3923 47.036 82.8423 47.18 82.2023 47.18ZM82.2023 46.334C82.9223 46.334 83.4583 46.096 83.8103 45.62C84.1623 45.14 84.3383 44.518 84.3383 43.754C84.3383 42.97 84.1603 42.346 83.8043 41.882C83.4523 41.418 82.9183 41.186 82.2023 41.186C81.7183 41.186 81.3183 41.296 81.0023 41.516C80.6903 41.732 80.4563 42.034 80.3003 42.422C80.1483 42.806 80.0723 43.25 80.0723 43.754C80.0723 44.534 80.2523 45.16 80.6123 45.632C80.9723 46.1 81.5023 46.334 82.2023 46.334ZM89.0758 47.162C88.6878 47.162 88.3478 47.102 88.0558 46.982C87.7678 46.862 87.5218 46.7 87.3178 46.496C87.1178 46.292 86.9558 46.06 86.8318 45.8C86.7078 45.536 86.6178 45.258 86.5618 44.966C86.5058 44.67 86.4778 44.376 86.4778 44.084V40.52H87.3658V43.826C87.3658 44.182 87.3998 44.512 87.4678 44.816C87.5358 45.12 87.6438 45.386 87.7918 45.614C87.9438 45.838 88.1378 46.012 88.3738 46.136C88.6138 46.26 88.9038 46.322 89.2438 46.322C89.5558 46.322 89.8298 46.268 90.0658 46.16C90.3058 46.052 90.5058 45.898 90.6658 45.698C90.8298 45.494 90.9538 45.248 91.0378 44.96C91.1218 44.668 91.1638 44.34 91.1638 43.976L91.7878 44.114C91.7878 44.778 91.6718 45.336 91.4398 45.788C91.2078 46.24 90.8878 46.582 90.4798 46.814C90.0718 47.046 89.6038 47.162 89.0758 47.162ZM91.2538 47V45.404H91.1638V40.52H92.0458V47H91.2538ZM93.7228 47V40.52H94.5148V42.08L94.3588 41.876C94.4308 41.684 94.5248 41.508 94.6408 41.348C94.7568 41.184 94.8828 41.05 95.0188 40.946C95.1868 40.798 95.3828 40.686 95.6068 40.61C95.8308 40.53 96.0568 40.484 96.2848 40.472C96.5128 40.456 96.7208 40.472 96.9088 40.52V41.348C96.6728 41.288 96.4148 41.274 96.1348 41.306C95.8548 41.338 95.5968 41.45 95.3608 41.642C95.1448 41.81 94.9828 42.012 94.8748 42.248C94.7668 42.48 94.6948 42.728 94.6588 42.992C94.6228 43.252 94.6048 43.51 94.6048 43.766V47H93.7228ZM24.7993 63.18C24.1953 63.18 23.6793 63.03 23.2513 62.73C22.8233 62.426 22.4953 62.016 22.2673 61.5C22.0393 60.984 21.9253 60.402 21.9253 59.754C21.9253 59.11 22.0373 58.53 22.2613 58.014C22.4893 57.498 22.8153 57.09 23.2393 56.79C23.6633 56.49 24.1713 56.34 24.7633 56.34C25.3713 56.34 25.8833 56.488 26.2993 56.784C26.7153 57.08 27.0293 57.486 27.2413 58.002C27.4573 58.514 27.5653 59.098 27.5653 59.754C27.5653 60.398 27.4593 60.98 27.2473 61.5C27.0353 62.016 26.7233 62.426 26.3113 62.73C25.8993 63.03 25.3953 63.18 24.7993 63.18ZM24.8893 62.358C25.3493 62.358 25.7293 62.246 26.0293 62.022C26.3293 61.798 26.5533 61.49 26.7013 61.098C26.8493 60.702 26.9233 60.254 26.9233 59.754C26.9233 59.246 26.8493 58.798 26.7013 58.41C26.5533 58.018 26.3293 57.712 26.0293 57.492C25.7333 57.272 25.3593 57.162 24.9073 57.162C24.4433 57.162 24.0593 57.276 23.7553 57.504C23.4513 57.732 23.2253 58.042 23.0773 58.434C22.9333 58.826 22.8613 59.266 22.8613 59.754C22.8613 60.246 22.9353 60.69 23.0833 61.086C23.2353 61.478 23.4613 61.788 23.7613 62.016C24.0613 62.244 24.4373 62.358 24.8893 62.358ZM26.8273 65.88V61.398H26.9233V56.52H27.7153V65.88H26.8273ZM31.8766 63.162C31.4886 63.162 31.1486 63.102 30.8566 62.982C30.5686 62.862 30.3226 62.7 30.1186 62.496C29.9186 62.292 29.7566 62.06 29.6326 61.8C29.5086 61.536 29.4186 61.258 29.3626 60.966C29.3066 60.67 29.2786 60.376 29.2786 60.084V56.52H30.1666V59.826C30.1666 60.182 30.2006 60.512 30.2686 60.816C30.3366 61.12 30.4446 61.386 30.5926 61.614C30.7446 61.838 30.9386 62.012 31.1746 62.136C31.4146 62.26 31.7046 62.322 32.0446 62.322C32.3566 62.322 32.6306 62.268 32.8666 62.16C33.1066 62.052 33.3066 61.898 33.4666 61.698C33.6306 61.494 33.7546 61.248 33.8386 60.96C33.9226 60.668 33.9646 60.34 33.9646 59.976L34.5886 60.114C34.5886 60.778 34.4726 61.336 34.2406 61.788C34.0086 62.24 33.6886 62.582 33.2806 62.814C32.8726 63.046 32.4046 63.162 31.8766 63.162ZM34.0546 63V61.404H33.9646V56.52H34.8466V63H34.0546ZM36.6436 55.29V54.3H37.5256V55.29H36.6436ZM36.6436 63V56.52H37.5256V63H36.6436ZM38.7244 63V62.814L42.9064 57.342H39.0364V56.52H44.3584V56.724L40.1824 62.178H44.1304V63H38.7244ZM45.0759 63V62.814L49.2579 57.342H45.3879V56.52H50.7099V56.724L46.5339 62.178H50.4819V63H45.0759ZM54.289 63.18C53.657 63.18 53.109 63.04 52.645 62.76C52.185 62.48 51.827 62.086 51.571 61.578C51.315 61.07 51.187 60.474 51.187 59.79C51.187 59.082 51.313 58.47 51.565 57.954C51.817 57.438 52.171 57.04 52.627 56.76C53.087 56.48 53.629 56.34 54.253 56.34C54.893 56.34 55.439 56.488 55.891 56.784C56.343 57.076 56.685 57.496 56.917 58.044C57.149 58.592 57.255 59.246 57.235 60.006H56.335V59.694C56.319 58.854 56.137 58.22 55.789 57.792C55.445 57.364 54.941 57.15 54.277 57.15C53.581 57.15 53.047 57.376 52.675 57.828C52.307 58.28 52.123 58.924 52.123 59.76C52.123 60.576 52.307 61.21 52.675 61.662C53.047 62.11 53.573 62.334 54.253 62.334C54.717 62.334 55.121 62.228 55.465 62.016C55.813 61.8 56.087 61.49 56.287 61.086L57.109 61.404C56.853 61.968 56.475 62.406 55.975 62.718C55.479 63.026 54.917 63.18 54.289 63.18ZM51.811 60.006V59.268H56.761V60.006H51.811ZM60.9846 63.174C60.2246 63.174 59.5986 63.01 59.1066 62.682C58.6186 62.354 58.3186 61.898 58.2066 61.314L59.1066 61.164C59.2026 61.532 59.4206 61.826 59.7606 62.046C60.1046 62.262 60.5286 62.37 61.0326 62.37C61.5246 62.37 61.9126 62.268 62.1966 62.064C62.4806 61.856 62.6226 61.574 62.6226 61.218C62.6226 61.018 62.5766 60.856 62.4846 60.732C62.3966 60.604 62.2146 60.486 61.9386 60.378C61.6626 60.27 61.2506 60.142 60.7026 59.994C60.1146 59.834 59.6546 59.674 59.3226 59.514C58.9906 59.354 58.7546 59.17 58.6146 58.962C58.4746 58.75 58.4046 58.492 58.4046 58.188C58.4046 57.82 58.5086 57.498 58.7166 57.222C58.9246 56.942 59.2126 56.726 59.5806 56.574C59.9486 56.418 60.3766 56.34 60.8646 56.34C61.3526 56.34 61.7886 56.42 62.1726 56.58C62.5606 56.736 62.8726 56.956 63.1086 57.24C63.3446 57.524 63.4846 57.854 63.5286 58.23L62.6286 58.392C62.5686 58.012 62.3786 57.712 62.0586 57.492C61.7426 57.268 61.3406 57.152 60.8526 57.144C60.3926 57.132 60.0186 57.22 59.7306 57.408C59.4426 57.592 59.2986 57.838 59.2986 58.146C59.2986 58.318 59.3506 58.466 59.4546 58.59C59.5586 58.71 59.7466 58.824 60.0186 58.932C60.2946 59.04 60.6866 59.158 61.1946 59.286C61.7906 59.438 62.2586 59.598 62.5986 59.766C62.9386 59.934 63.1806 60.132 63.3246 60.36C63.4686 60.588 63.5406 60.87 63.5406 61.206C63.5406 61.818 63.3126 62.3 62.8566 62.652C62.4046 63 61.7806 63.174 60.9846 63.174ZM70.1836 63.18C69.5876 63.18 69.0836 63.03 68.6716 62.73C68.2596 62.426 67.9476 62.016 67.7356 61.5C67.5236 60.98 67.4176 60.398 67.4176 59.754C67.4176 59.098 67.5236 58.514 67.7356 58.002C67.9516 57.486 68.2676 57.08 68.6836 56.784C69.0996 56.488 69.6116 56.34 70.2196 56.34C70.8116 56.34 71.3196 56.49 71.7436 56.79C72.1676 57.09 72.4916 57.498 72.7156 58.014C72.9436 58.53 73.0576 59.11 73.0576 59.754C73.0576 60.402 72.9436 60.984 72.7156 61.5C72.4876 62.016 72.1596 62.426 71.7316 62.73C71.3036 63.03 70.7876 63.18 70.1836 63.18ZM67.2676 63V54.36H68.1556V58.122H68.0596V63H67.2676ZM70.0936 62.358C70.5456 62.358 70.9216 62.244 71.2216 62.016C71.5216 61.788 71.7456 61.478 71.8936 61.086C72.0456 60.69 72.1216 60.246 72.1216 59.754C72.1216 59.266 72.0476 58.826 71.8996 58.434C71.7516 58.042 71.5256 57.732 71.2216 57.504C70.9216 57.276 70.5396 57.162 70.0756 57.162C69.6236 57.162 69.2476 57.272 68.9476 57.492C68.6516 57.712 68.4296 58.018 68.2816 58.41C68.1336 58.798 68.0596 59.246 68.0596 59.754C68.0596 60.254 68.1336 60.702 68.2816 61.098C68.4296 61.49 68.6536 61.798 68.9536 62.022C69.2536 62.246 69.6336 62.358 70.0936 62.358ZM77.1172 63.18C76.4852 63.18 75.9372 63.04 75.4732 62.76C75.0132 62.48 74.6552 62.086 74.3992 61.578C74.1432 61.07 74.0152 60.474 74.0152 59.79C74.0152 59.082 74.1412 58.47 74.3932 57.954C74.6452 57.438 74.9992 57.04 75.4552 56.76C75.9152 56.48 76.4572 56.34 77.0812 56.34C77.7212 56.34 78.2672 56.488 78.7192 56.784C79.1712 57.076 79.5132 57.496 79.7452 58.044C79.9772 58.592 80.0832 59.246 80.0632 60.006H79.1632V59.694C79.1472 58.854 78.9652 58.22 78.6172 57.792C78.2732 57.364 77.7692 57.15 77.1052 57.15C76.4092 57.15 75.8752 57.376 75.5032 57.828C75.1352 58.28 74.9512 58.924 74.9512 59.76C74.9512 60.576 75.1352 61.21 75.5032 61.662C75.8752 62.11 76.4012 62.334 77.0812 62.334C77.5452 62.334 77.9492 62.228 78.2932 62.016C78.6412 61.8 78.9152 61.49 79.1152 61.086L79.9372 61.404C79.6812 61.968 79.3032 62.406 78.8032 62.718C78.3072 63.026 77.7452 63.18 77.1172 63.18ZM74.6392 60.006V59.268H79.5892V60.006H74.6392ZM84.9227 63C84.5587 63.076 84.1987 63.106 83.8427 63.09C83.4907 63.074 83.1747 62.998 82.8947 62.862C82.6187 62.726 82.4087 62.514 82.2647 62.226C82.1487 61.986 82.0847 61.744 82.0727 61.5C82.0647 61.252 82.0607 60.97 82.0607 60.654V54.72H82.9367V60.618C82.9367 60.89 82.9387 61.118 82.9427 61.302C82.9507 61.482 82.9927 61.642 83.0687 61.782C83.2127 62.05 83.4407 62.21 83.7527 62.262C84.0687 62.314 84.4587 62.302 84.9227 62.226V63ZM80.6747 57.276V56.52H84.9227V57.276H80.6747ZM89.0087 63C88.6447 63.076 88.2847 63.106 87.9287 63.09C87.5767 63.074 87.2607 62.998 86.9807 62.862C86.7047 62.726 86.4947 62.514 86.3507 62.226C86.2347 61.986 86.1707 61.744 86.1587 61.5C86.1507 61.252 86.1467 60.97 86.1467 60.654V54.72H87.0227V60.618C87.0227 60.89 87.0247 61.118 87.0287 61.302C87.0367 61.482 87.0787 61.642 87.1547 61.782C87.2987 62.05 87.5267 62.21 87.8387 62.262C88.1547 62.314 88.5447 62.302 89.0087 62.226V63ZM84.7607 57.276V56.52H89.0087V57.276H84.7607ZM93.0312 63.18C92.3992 63.18 91.8512 63.04 91.3872 62.76C90.9272 62.48 90.5692 62.086 90.3132 61.578C90.0572 61.07 89.9292 60.474 89.9292 59.79C89.9292 59.082 90.0552 58.47 90.3072 57.954C90.5592 57.438 90.9132 57.04 91.3692 56.76C91.8292 56.48 92.3712 56.34 92.9952 56.34C93.6352 56.34 94.1812 56.488 94.6332 56.784C95.0852 57.076 95.4272 57.496 95.6592 58.044C95.8912 58.592 95.9972 59.246 95.9772 60.006H95.0772V59.694C95.0612 58.854 94.8792 58.22 94.5312 57.792C94.1872 57.364 93.6832 57.15 93.0192 57.15C92.3232 57.15 91.7892 57.376 91.4172 57.828C91.0492 58.28 90.8652 58.924 90.8652 59.76C90.8652 60.576 91.0492 61.21 91.4172 61.662C91.7892 62.11 92.3152 62.334 92.9952 62.334C93.4592 62.334 93.8632 62.228 94.2072 62.016C94.5552 61.8 94.8292 61.49 95.0292 61.086L95.8512 61.404C95.5952 61.968 95.2172 62.406 94.7172 62.718C94.2212 63.026 93.6592 63.18 93.0312 63.18ZM90.5532 60.006V59.268H95.5032V60.006H90.5532ZM97.3088 63V56.52H98.1008V58.08L97.9448 57.876C98.0168 57.684 98.1108 57.508 98.2268 57.348C98.3428 57.184 98.4688 57.05 98.6048 56.946C98.7728 56.798 98.9688 56.686 99.1928 56.61C99.4168 56.53 99.6428 56.484 99.8708 56.472C100.099 56.456 100.307 56.472 100.495 56.52V57.348C100.259 57.288 100.001 57.274 99.7208 57.306C99.4408 57.338 99.1828 57.45 98.9468 57.642C98.7308 57.81 98.5688 58.012 98.4608 58.248C98.3528 58.48 98.2808 58.728 98.2448 58.992C98.2088 59.252 98.1908 59.51 98.1908 59.766V63H97.3088ZM102.233 63V62.01H103.115V63H102.233ZM102.233 60.84V54.36H103.115V60.84H102.233Z", fill: "#2C2B5E" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M219.317 137.16C219.317 140.362 207.483 142.957 192.883 142.957C178.285 142.957 166.45 140.362 166.45 137.16C166.45 133.961 178.283 131.363 192.883 131.363C207.482 131.362 219.317 133.959 219.317 137.16ZM226.87 118.186C225.595 119.86 221.048 116.035 219.672 115.695C214.907 114.521 213.105 118.637 209.474 120.89C203.776 124.428 201.186 119.791 196.761 116.727C191.9 113.361 189.983 117.271 185.292 117.603C180.86 117.918 179.483 112.735 175.693 111.614C171.555 110.391 167.703 113.24 165.108 115.241C163.431 116.531 159.62 118.768 157.774 116.896C157.509 116.628 158.659 97.256 159.872 79.8979C159.903 76.4991 157.495 70.7047 151.186 67.2882C146.192 64.583 147.284 59.9546 152.96 59.7179C158.637 59.4812 161.207 61.964 161.207 61.964C161.207 61.964 161.213 62.6944 161.399 60.8926C161.828 56.7099 162.258 52.5084 163.012 48.3668C164.615 39.5477 167.025 30.2635 174.528 24.5963C186.129 15.8253 204.707 17.5184 213.742 28.593C222.892 39.8109 224.561 57.1694 225.805 71.0717C227.931 94.8307 228.996 115.402 226.87 118.186L226.87 118.186ZM178.798 50.9722C178.798 45.4392 176.486 43.4778 174.507 43.4778C172.527 43.4778 170.214 45.4392 170.214 50.9722C170.214 51.4259 170.584 51.7974 171.039 51.7974C171.494 51.7974 171.864 51.4259 171.864 50.9722C171.864 46.9342 173.19 45.1269 174.505 45.1269C175.82 45.1269 177.146 46.9342 177.146 50.9722C177.146 51.4259 177.516 51.7974 177.972 51.7974C178.427 51.7974 178.798 51.4259 178.798 50.9722H178.798ZM193.389 51.8715C193.682 47.8609 195.239 46.1305 196.543 46.2351C198.062 46.3479 198.911 48.766 198.657 52.2524C198.624 52.7088 198.967 53.1036 199.42 53.1369C199.441 53.1396 199.462 53.1396 199.481 53.1396C199.91 53.1396 200.272 52.8094 200.304 52.3737C200.707 46.8612 198.687 44.736 196.664 44.5892C194.637 44.445 192.148 46.2302 191.742 51.7506C191.709 52.2043 192.05 52.5992 192.505 52.6351C192.968 52.6719 193.355 52.3251 193.389 51.8714L193.389 51.8715ZM211.437 66.4006C211.437 66.4006 211.118 65.9729 210.422 65.3373C210.082 65.0125 209.648 64.6414 209.105 64.2659C208.592 63.8463 207.926 63.5081 207.217 63.0939C206.477 62.7638 205.668 62.3581 204.752 62.1187C204.29 62.0059 203.816 61.8905 203.33 61.7692C202.846 61.625 202.325 61.6731 201.806 61.6165C201.276 61.6084 200.774 61.5037 200.193 61.5765C199.933 61.6012 199.696 61.6039 199.414 61.6492L198.538 61.8348C197.434 62.1564 196.246 62.7193 195.494 63.8468C194.736 64.9595 194.674 66.5138 195.229 67.6265C195.74 68.7707 196.614 69.5824 197.485 70.2001C197.905 70.4795 198.452 70.7917 198.761 70.9786C199.171 71.2234 199.571 71.4656 199.962 71.6978C200.787 72.1353 201.362 72.6811 201.981 73.1379C202.61 73.5755 203.085 74.1132 203.544 74.5503C203.773 74.7731 203.987 74.9793 204.185 75.1733C204.368 75.3768 204.52 75.5817 204.668 75.7591C205.263 76.4716 205.603 76.8786 205.603 76.8786C205.603 76.8786 205.361 76.4029 204.938 75.5704C204.826 75.367 204.712 75.1302 204.567 74.8854C204.401 74.6545 204.222 74.407 204.029 74.1415C203.634 73.6145 203.233 72.9807 202.612 72.4277C202.027 71.8554 201.402 71.1488 200.646 70.6714C200.279 70.4032 199.902 70.1269 199.516 69.8434C199.135 69.578 198.745 69.3057 198.349 69.0263C197.631 68.476 197.034 67.7609 196.697 66.995C196.342 66.2232 196.437 65.4078 196.868 64.7628C197.276 64.0863 198.113 63.6294 198.975 63.3626L199.615 63.2071C199.838 63.1537 200.115 63.1344 200.36 63.0971C200.792 63.0117 201.302 63.0805 201.76 63.0625C202.704 63.0117 203.601 63.1725 204.461 63.31C204.9 63.3446 205.293 63.5135 205.694 63.6141C206.087 63.735 206.485 63.8149 206.841 63.9578C207.542 64.27 208.231 64.4847 208.78 64.8009C209.349 65.0831 209.84 65.3454 210.225 65.5961C211.015 66.0678 211.437 66.4006 211.437 66.4006V66.4006Z", fill: "#2C2B5E" })] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].continueContainer }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _FeedbackWidget_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"]["continue"], onClick: function () {
                                    setFeedback(menuState.feedback);
                                } }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: _assets_continue_png__WEBPACK_IMPORTED_MODULE_9__, alt: "continue" }), "Return"] })) }))] }))] })) })));
};
var useQuizFeedback = function (quizId) {
    var user = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_4__.AppConfigContext).user;
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), feedback = _a[0], setFeed = _a[1];
    var set = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function (feedback) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setFeed(feedback);
                    return [4 /*yield*/, (0,_requests__WEBPACK_IMPORTED_MODULE_10__.setQuizFeedback)(quizId, feedback)];
                case 1:
                    result = _b.sent();
                    setFeed((_a = result === null || result === void 0 ? void 0 : result.content) !== null && _a !== void 0 ? _a : null);
                    return [2 /*return*/];
            }
        });
    }); }, [quizId]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
        if (user.id !== "") {
            (0,_requests__WEBPACK_IMPORTED_MODULE_10__.getQuizFeedback)(quizId).then(function (feedback) {
                var _a;
                setFeed((_a = feedback === null || feedback === void 0 ? void 0 : feedback.content) !== null && _a !== void 0 ? _a : null);
            });
        }
    }, [quizId, user.id]);
    return {
        feedback: feedback,
        setFeedback: set,
    };
};


/***/ }),
/* 230 */
/***/ ((module) => {

"use strict";
module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTciIGhlaWdodD0iNTciIHZpZXdCb3g9IjAgMCA1NyA1NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIgogICAgICAgICAgZD0iTTQ5LjM1MjcgMjIuNTY0NlYxMC4zNkM0OS4zNTI3IDkuMzIxNzcgNDguMTA2OSA4LjgxNDIgNDcuMzkxNiA5LjU1MjQ4TDQzLjI4NSAxMy42NTkxQzM5LjEwOTEgOS40ODMyNiAzMy4xNTY3IDcuMDgzODYgMjYuNjUwNyA3LjY2MDY0QzE2Ljk4MzkgOC41MzczNSA5LjAyNDMgMTYuMzEyMyA3Ljk2MzAzIDI1Ljk3OTFDNi41Nzg3NiAzOC40ODM3IDE2LjMzNzkgNDkuMDk2NCAyOC41ODg2IDQ5LjA5NjRDMzkuMTc4MyA0OS4wOTY0IDQ3LjkyMjMgNDEuMTYgNDkuMTkxMiAzMC45MTY0QzQ5LjM1MjcgMjkuNTMyMSA0OC4yNjgzIDI4LjMzMjQgNDYuODg0MSAyOC4zMzI0QzQ1LjczMDUgMjguMzMyNCA0NC43NjE1IDI5LjE4NiA0NC42MjMxIDMwLjMxNjVDNDMuNjMxIDM4LjM2ODQgMzYuNjg2NiA0NC41OTc2IDI4LjM1NzkgNDQuNDgyMkMxOS43OTg1IDQ0LjM2NjkgMTIuNTc3MyAzNy4xNDU2IDEyLjQzODggMjguNTYzMUMxMi4zMDA0IDE5LjU2NTQgMTkuNjE0IDEyLjE4MjYgMjguNTg4NiAxMi4xODI2QzMzLjA0MTQgMTIuMTgyNiAzNy4wNzg4IDE0LjAwNTIgNDAuMDA4OSAxNi45MTIyTDM1LjE4NyAyMS43MzQxQzM0LjQ0ODcgMjIuNDcyMyAzNC45NTYzIDIzLjcxODIgMzUuOTk0NSAyMy43MTgySDQ4LjE5OTFDNDguODQ1MSAyMy43MTgyIDQ5LjM1MjcgMjMuMjEwNiA0OS4zNTI3IDIyLjU2NDZaIgogICAgICAgICAgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";

/***/ }),
/* 231 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PlayQuiz": () => (/* binding */ PlayQuiz)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var PlayQuiz = function (props) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "88", height: "38", viewBox: "0 0 39 19", color: "#2C2B5E", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M36.4839 3.16667H28.9355V2.53333C28.9355 1.13615 27.8071 0 26.4194 0H12.5807C11.193 0 10.0645 1.13615 10.0645 2.53333V3.16667H2.51613C1.12843 3.16667 0 4.30281 0 5.7V13.3C0 14.6972 1.12843 15.8333 2.51613 15.8333H3.43756L4.50891 17.4515C4.61334 17.6092 4.78309 17.7119 4.97003 17.7302C4.99133 17.7321 5.0116 17.7333 5.03228 17.7333C5.19835 17.7333 5.35868 17.6675 5.47703 17.5478L7.17982 15.8333H10.0645V16.4667C10.0645 17.8639 11.1929 19 12.5806 19H26.4194C27.8071 19 28.9355 17.8639 28.9355 16.4667V15.8333H31.8202L33.523 17.5478C33.6413 17.6675 33.8017 17.7333 33.9677 17.7333C33.9878 17.7333 34.0087 17.7321 34.03 17.7302C34.2173 17.7119 34.3867 17.6092 34.4911 17.4515L35.5624 15.8333H36.4839C37.8716 15.8333 39 14.6972 39 13.3V5.7C39 4.30281 37.8716 3.16667 36.4839 3.16667H36.4839ZM10.0645 14.5667H6.91936C6.75268 14.5667 6.59235 14.6333 6.47461 14.7522L5.12974 16.1063L4.29758 14.8491C4.18066 14.6724 3.98429 14.5667 3.77421 14.5667H2.51614C1.82242 14.5667 1.25808 13.9985 1.25808 13.3V5.7C1.25808 5.00154 1.82242 4.43333 2.51614 4.43333H10.0645L10.0645 14.5667ZM27.6774 16.4667C27.6774 17.1651 27.1131 17.7333 26.4194 17.7333H12.5807C11.8869 17.7333 11.3226 17.1651 11.3226 16.4667V2.53333C11.3226 1.83487 11.8869 1.26667 12.5807 1.26667H26.4194C27.1131 1.26667 27.6774 1.83487 27.6774 2.53333V16.4667ZM37.742 13.3C37.742 13.9985 37.1776 14.5667 36.4839 14.5667H35.2258C35.0157 14.5667 34.8194 14.6724 34.7025 14.8485L33.8703 16.1056L32.5254 14.7516C32.4077 14.6332 32.248 14.5667 32.0807 14.5667H28.9355V4.43333H36.4839C37.1776 4.43333 37.742 5.00153 37.742 5.69999L37.742 13.3ZM3.32968 11.8579C3.45233 11.9814 3.61328 12.0434 3.77443 12.0434C3.93537 12.0434 4.09652 11.9814 4.21917 11.8579L5.66154 10.4057L7.10392 11.8579C7.22657 11.9814 7.38752 12.0434 7.54866 12.0434C7.70961 12.0434 7.87075 11.9814 7.99341 11.8579C8.23933 11.6103 8.23933 11.2099 7.99341 10.9623L6.55104 9.51007L7.99341 8.05784C8.23933 7.81024 8.23933 7.40989 7.99341 7.16226C7.74749 6.91466 7.34986 6.91466 7.10391 7.16226L5.66153 8.61449L4.21916 7.16226C3.97324 6.91466 3.57561 6.91466 3.32966 7.16226C3.08374 7.40986 3.08374 7.81021 3.32966 8.05784L4.77203 9.51007L3.32966 10.9623C3.08374 11.2093 3.08374 11.6103 3.32966 11.8579H3.32968ZM35.3716 7.19529L32.6666 10.4708L31.2671 9.06168C31.0211 8.81408 30.6235 8.81408 30.3776 9.06168C30.1316 9.30928 30.1316 9.70963 30.3776 9.95726L32.2647 11.8521C32.383 11.9719 32.5433 12.0333 32.71 12.0333H32.7389C32.9156 12.0333 33.0804 11.9465 33.1937 11.8104L36.3388 8.00221C36.5614 7.73296 36.5243 7.33468 36.2577 7.11116C35.9885 6.88748 35.5929 6.92747 35.3715 7.19528L35.3716 7.19529ZM24.2204 8.95285L16.672 4.51952C16.477 4.40551 16.2373 4.40427 16.0417 4.51766C15.8462 4.63084 15.726 4.83989 15.726 5.06665V13.9333C15.726 14.1601 15.8462 14.3691 16.0417 14.4823C16.1386 14.5388 16.2469 14.5666 16.355 14.5666C16.4646 14.5666 16.5739 14.5376 16.672 14.4805L24.2204 10.0471C24.4141 9.93374 24.5325 9.72489 24.5325 9.49998C24.5325 9.27507 24.4141 9.06621 24.2204 8.95284L24.2204 8.95285ZM16.9839 12.8308V6.16919L22.6551 9.49994L16.9839 12.8308Z", fill: "currentColor" }) }))); };


/***/ }),
/* 232 */
/***/ ((module) => {

"use strict";
module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAA2CAYAAABJN/BMAAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV8/xKqVDnYQcchQnSyIijhqFYpQIdQKrTqYXPoFTRqSFBdHwbXg4Mdi1cHFWVcHV0EQ/ABxdHJSdJES/5cUWsR4cNyPd/ced+8Af6PCVDM4DqiaZaSTCSGbWxW6X9GHECLoQVBipj4niil4jq97+Ph6F+dZ3uf+HP1K3mSATyCeZbphEW8QT29aOud94igrSQrxOfGYQRckfuS67PIb56LDfp4ZNTLpeeIosVDsYLmDWclQiaeIY4qqUb4/67LCeYuzWqmx1j35C8N5bWWZ6zSHkcQiliBCgIwayqjAQpxWjRQTadpPePiHHL9ILplcZTByLKAKFZLjB/+D392ahckJNymcALpebPtjBOjeBZp12/4+tu3mCRB4Bq60tr/aAGY+Sa+3tdgRENkGLq7bmrwHXO4Ag0+6ZEiOFKDpLxSA9zP6phwwcAv0rrm9tfZx+gBkqKvUDXBwCIwWKXvd492hzt7+PdPq7wfk53Juca5wywAAAAZiS0dEAAAAAAAA+UO7fwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAAd0SU1FB+YLCA8JLrjlunoAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAACzElEQVRYw+2X3WvTUBjGnzft1rWlxTlFEd3EjwrC3MD6caEM/ANEBQWvBBG2liEWYYoiBRG8mDD8nK0UYSjIJoh444WICN4o6iZDESnMqUyYo2Vu7Zoueb3wg3Rrm6Q9iTd9bhKSk5Nfnveck+cANdVUU3GRqI44G+8Az++He/4U0fGcmWclIQDTsWVgZQBMByt5XggEHMotMJoBHjPrghAI/nmjC6B9f6o7bLsTnOpfCwnnNCPsg60QzFEJ9bgM0CrN5Zf2OpFZ2Qlgr5YLqe+jtk1RzlxfA5ZGADRqLo+SN9RqoxPS4AIAQEWyUlMl8y70R8DYWaSnV7ZAcDaxDqyZDYUj9Y3lEMxRCSzfW1SGfwtW/XvrnZhZcQaMbSUI0+Q+9tlSCE7H1oOop0yLYVQhSb8MsTo41TgIvtKN6Hk1EE79RUk9DcKe8p8ifeO5awGdVzFcwTGiYN7UYsWZ2C6w+gSAS1DqGCBv+IjhcvDUFT/ACXEAACT6Ym5MuOvOgjkgMMUlkWw6b/jfwfLNNuT5NQCHqPQHwm7yhF4YcoL5jh8y3xcIABD1lQIoXo7Z6SgIG4QBMMYhqxcM/8p5JtYKUt8JzvMHyBN6YHydUDEBB0YAajLwiasNIDzUA6g81GTjHVCVZzplSEHOtdPSE+PWhBpW9BMUc9QIQBUQ2KwD8Jh84atWB92tZe7JcDq6rY13POgA0ZYyLkWpoTNpKQTmfrSAuaEEwFt4n/Zan7bZub3EPMtD5cNEQ4oNEMrGEnW6SP7wR7v2HW1FeklCzvXZtu8AoWXRSMgph6gxkrZn3zGZ8EHFpgVQvbSku+I9h3knPLlAQeAlfILiulR14DKZC5oLysB0knxHJ+2GaNec3yVv1yMh0dNUa0X9G3amMJvtEZZ/TTqx4/eRQ7Q8MvF/IMB+gG6TJzwkMnw5zTkhB+FOfUVNNdVkk34BrWjm2HQo1VAAAAAASUVORK5CYII=";

/***/ }),
/* 233 */
/***/ ((module) => {

"use strict";
module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzciIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNyAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxsaW5lIHgxPSI1LjE2OTQ3IiB5MT0iMy43MzQzOCIgeDI9IjMyLjcyNTIiIHkyPSIzMS4yOTAxIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogICAgPGxpbmUgeDE9IjMuODcxNTgiIHkxPSIzMS42NzA5IiB4Mj0iMzEuNDI3MyIgeTI9IjQuMTE1MSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSI3IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";

/***/ }),
/* 234 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useButtonBopAnimation": () => (/* reexport safe */ _useButtonBopAnimation__WEBPACK_IMPORTED_MODULE_0__.useButtonBopAnimation),
/* harmony export */   "useColourSample": () => (/* reexport safe */ _useColourSample__WEBPACK_IMPORTED_MODULE_2__.useColourSample),
/* harmony export */   "useKey": () => (/* reexport safe */ _useKey__WEBPACK_IMPORTED_MODULE_3__.useKey),
/* harmony export */   "useStarsAnimation": () => (/* reexport safe */ _useStarsAnimation__WEBPACK_IMPORTED_MODULE_1__.useStarsAnimation),
/* harmony export */   "useTitle": () => (/* reexport safe */ _useTitle__WEBPACK_IMPORTED_MODULE_4__.useTitle)
/* harmony export */ });
/* harmony import */ var _useButtonBopAnimation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(164);
/* harmony import */ var _useStarsAnimation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(223);
/* harmony import */ var _useColourSample__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(143);
/* harmony import */ var _useKey__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(165);
/* harmony import */ var _useTitle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(235);







/***/ }),
/* 235 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useTitle": () => (/* binding */ useTitle)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var useTitle = function (title) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (title) {
            var originalTitle_1 = document.title;
            document.title = process.env.NODE_ENV === "development" ? "DEV ".concat(title) : title;
            return function () {
                document.title = originalTitle_1;
            };
        }
        else {
            return function () { };
        }
    }, [title]);
};


/***/ }),
/* 236 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_throw": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_2__._throw),
/* harmony export */   "convertHMS": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_2__.convertHMS),
/* harmony export */   "sleep": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_2__.sleep),
/* harmony export */   "stripNullish": () => (/* reexport safe */ _strip_nullish__WEBPACK_IMPORTED_MODULE_0__.stripNullish),
/* harmony export */   "stripUndefined": () => (/* reexport safe */ _strip_undefined__WEBPACK_IMPORTED_MODULE_1__.stripUndefined)
/* harmony export */ });
/* harmony import */ var _strip_nullish__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(237);
/* harmony import */ var _strip_undefined__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(210);





/***/ }),
/* 237 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "stripNullish": () => (/* binding */ stripNullish)
/* harmony export */ });
function notNullish(t) {
    return t !== undefined && t !== null;
}
// Return a new object with properties == undefined/null filtered out
function stripNullish(object) {
    return Object.fromEntries(Object.entries(object).filter(function (_a) {
        var val = _a[1];
        return notNullish(val);
    }));
}


/***/ }),
/* 238 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ErrorBoundary": () => (/* reexport safe */ _ErrorBoundary__WEBPACK_IMPORTED_MODULE_3__.ErrorBoundary),
/* harmony export */   "GamificationPanel": () => (/* reexport safe */ _GamificationPanel__WEBPACK_IMPORTED_MODULE_0__.GamificationPanel),
/* harmony export */   "QuizProgressGraph": () => (/* reexport safe */ _QuizProgressGraph__WEBPACK_IMPORTED_MODULE_1__.QuizProgressGraph),
/* harmony export */   "UserLevelIndicator": () => (/* reexport safe */ _UserLevelIndicator__WEBPACK_IMPORTED_MODULE_2__.UserLevelIndicator)
/* harmony export */ });
/* harmony import */ var _GamificationPanel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(239);
/* harmony import */ var _QuizProgressGraph__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(250);
/* harmony import */ var _UserLevelIndicator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(245);
/* harmony import */ var _ErrorBoundary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(106);






/***/ }),
/* 239 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GamificationPanel": () => (/* binding */ GamificationPanel)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(105);
/* harmony import */ var _requests__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(240);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(241);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(242);
/* harmony import */ var _assets_fire2_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(248);
/* harmony import */ var _assets_tag_svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(249);
/* harmony import */ var _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(243);
/* harmony import */ var _QuizProgressGraph__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(250);
/* harmony import */ var _UserLevelIndicator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(245);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};











var GamificationPanel = function (props) {
    var _a, _b;
    var _c, _d, _e, _f, _g, _h, _j;
    var userActivity = (0,_requests__WEBPACK_IMPORTED_MODULE_3__.useUserActivity)();
    var _k = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_4__.AppConfigContext), user = _k.user, stats = _k.stats;
    var _l = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), calendarIsOpen = _l[0], setCalendarIsOpen = _l[1];
    // the first day of the current week, written as iife
    var _m = (function () {
        var now = new Date();
        return [
            new Date(now.getFullYear(), now.getMonth(), now.getDate()),
            new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() + 1),
        ];
    })(), today = _m[0], firstDayOfWeek = _m[1];
    var getColorFromActivity = function (activity) {
        if (activity === 0) {
            return "#ffffff";
        }
        var green = Math.min(255, Math.round(90 * (activity / 5) + 166));
        return "rgb(90, ".concat(green, ", 168)");
    };
    var badges = (0,_requests__WEBPACK_IMPORTED_MODULE_3__.useUserAchievements)();
    var badgeIconMap = {
        wand: _assets__WEBPACK_IMPORTED_MODULE_5__.Wand,
        shiled: _assets__WEBPACK_IMPORTED_MODULE_6__.Shield,
        trendsetter: _assets__WEBPACK_IMPORTED_MODULE_7__.Trendsetter,
        // marathoner: marathoner,
    };
    var streak = (function () {
        if (!stats.streak) {
            return 0;
        }
        var lastAdded = new Date(stats.streak.lastAdded);
        var lastAddedDaysAgo = Math.floor((today.getTime() - lastAdded.getTime()) / 1000 / 60 / 60 / 24);
        if (lastAddedDaysAgo > 1) {
            return 0;
        }
        return stats.streak.current;
    })();
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].panel }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UserLevelIndicator__WEBPACK_IMPORTED_MODULE_9__.UserLevelIndicator, {}), streak !== 0 && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].streak }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].top }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: _assets_fire2_svg__WEBPACK_IMPORTED_MODULE_10__, alt: "fire" }), streak, " day streak!"] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].bottom }, { children: [(_d = (_c = stats === null || stats === void 0 ? void 0 : stats.streak) === null || _c === void 0 ? void 0 : _c.best) !== null && _d !== void 0 ? _d : 0, " Longest streak"] }))] }))), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].calendar, (_a = {}, _a[_GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].open] = calendarIsOpen, _a)) }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].top }, { children: ["M", "T", "W", "Th", "F", "S", "Su"].map(function (day) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].headerCell }, { children: day }), day)); }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].bottom }, { children: Array.from({ length: 7 * 4 }, function (_, i) {
                            var day = new Date(firstDayOfWeek);
                            day.setDate(day.getDate() + i - 21);
                            return day;
                        }).map(function (currentDay, i) {
                            var _a;
                            var _b, _c, _d;
                            var daysAgo = Math.floor((today.getTime() - currentDay.getTime()) / 1000 / 60 / 60 / 24);
                            var isToday = daysAgo === 0;
                            var isFuture = daysAgo < 0;
                            var activityCount = (_d = (_c = (_b = userActivity.result) === null || _b === void 0 ? void 0 : _b.activity) === null || _c === void 0 ? void 0 : _c[currentDay.toISOString().split("T")[0]]) !== null && _d !== void 0 ? _d : 0;
                            var isPartOfStreak = (function () {
                                if (!(stats === null || stats === void 0 ? void 0 : stats.streak)) {
                                    return false;
                                }
                                var lastAdded = new Date(stats.streak.lastAdded);
                                var lastAddedDaysAgo = Math.floor((today.getTime() - lastAdded.getTime()) / 1000 / 60 / 60 / 24);
                                if (lastAddedDaysAgo > 1) {
                                    return false;
                                }
                                var updatedDaysAgo = Math.floor((lastAdded.getTime() - currentDay.getTime()) / 1000 / 60 / 60 / 24);
                                return updatedDaysAgo >= 0 && stats.streak.current > updatedDaysAgo;
                            })();
                            return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].cell, (_a = {},
                                    _a[_GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].isStreak] = isPartOfStreak,
                                    // [styles.emptyOutline]: isFuture || (activityCount === 0 && !isToday),
                                    _a[_GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].isToday] = isToday,
                                    _a)), style: {
                                    backgroundColor: daysAgo < 0 ? undefined : getColorFromActivity(activityCount),
                                } }, { children: isPartOfStreak && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { src: _assets_fire2_svg__WEBPACK_IMPORTED_MODULE_10__, className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].streakIcon }) }), i));
                        }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DownArrow, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].expand, (_b = {}, _b[_GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].open] = calendarIsOpen, _b)), onClick: function () { return setCalendarIsOpen(!calendarIsOpen); }, color: "#ffffff" })] })), badges.status === "success" && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].badges }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].subtitle }, { children: "My Progress" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].list }, { children: (_h = (_g = (_f = (_e = badges === null || badges === void 0 ? void 0 : badges.result) === null || _e === void 0 ? void 0 : _e.sort(function (a, b) {
                            var aProgress = a.progress / a.outOf;
                            var bProgress = b.progress / b.outOf;
                            return Math.sign(bProgress - aProgress);
                        })) === null || _f === void 0 ? void 0 : _f.sort(function (a, b) { return -a.type.localeCompare(b.type); })) === null || _g === void 0 ? void 0 : _g.slice(0, 3)) === null || _h === void 0 ? void 0 : _h.map(function (badge, i) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].badge }, { children: [badge.icon.type === "generic" ? ((function () {
                                    var BadgeImage = badgeIconMap[badge.icon.name];
                                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BadgeImage, { className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].icon, color: badge.color });
                                })()) : ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", { className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].icon, src: badge.icon.type === "tag" && badge.icon.url === undefined ? _assets_tag_svg__WEBPACK_IMPORTED_MODULE_11__ : badge.icon.url, alt: "" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].content }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].name }, { children: [badge.name, " ", (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", { children: ["Lv.", badge.level + 1] })] })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].subtext }, { children: badge.description })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].progressBarOuter }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].progressBar, style: {
                                                        borderColor: badge.color,
                                                    } }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].progressBarInner, style: {
                                                            width: "".concat((badge.progress / badge.outOf) * 100, "%"),
                                                            backgroundColor: badge.color,
                                                        } }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].text }, { children: [badge.progress, "/", (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: badge.outOf })] }))] }))] }))] }), i)); }) })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].seeAll, onClick: function () { return props.openBadges(); } }, { children: "See all" }))] }))), props.showProgress, props.showProgress && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].progress }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__["default"].subtitle }, { children: "Quiz Progress" })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_QuizProgressGraph__WEBPACK_IMPORTED_MODULE_12__.QuizProgressGraph, { emptyMessage: "Take the quiz to start retaining.", mediaId: (_j = props.context) === null || _j === void 0 ? void 0 : _j.media.id })] })))] })));
};
var DownArrow = function (props) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "20", height: "8", viewBox: "0 0 20 8", color: "#2C2B5E", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "M9.52628 7.5L19.0526 0H0L9.52628 7.5Z", fill: "currentColor" }) }))); };


/***/ }),
/* 240 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wand": () => (/* binding */ Wand)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Wand = function (props) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "1200pt", height: "1200pt", version: "1.1", viewBox: "0 0 1200 1200", xmlns: "http://www.w3.org/2000/svg", color: "#2c2a5d" }, props, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { transform: "scale(2.3438)", d: "m256 6c-138.1 0-250 111.9-250 250s111.9 250 250 250 250-111.9 250-250-111.9-250-250-250zm69.4 92 7.6 1.5-6.8 34.2-7.6-1.5zm-37.9 0 7.3 34.1-7.6 1.6-7.3-34.1zm-150 292.3c-5.1 5.1-13.5 4.9-18.4-0.6-4.5-5-3.9-12.8 0.9-17.6l10.6-10.7 17.9 17.9zm168.4-138.7-30.8 60.4-8.1-51.2-111.8 111.7-17.8-17.8 112-112.1-51.9-8.2 60.4-30.8-10.6-67 48 48 60.4-30.8-30.8 60.5 48 47.9zm108.5-70.7 1.5 7.6-34.2 6.8-1.5-7.6zm0 53.2-34.1-7.3 1.6-7.6 34.1 7.3z", fill: "currentColor", stroke: "currentColor", strokeMiterlimit: "10" }) }))); };


/***/ }),
/* 241 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Shield": () => (/* binding */ Shield)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Shield = function (props) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "1200pt", height: "1200pt", version: "1.1", viewBox: "0 0 1200 1200", xmlns: "http://www.w3.org/2000/svg", fill: "#2c2a5d" }, props, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", __assign({ fill: "currentColor" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m800 950c6.6797 0 13.078-2.6719 17.777-7.4219 4.6953-4.7461 7.2969-11.176 7.2227-17.855-0.074219-6.6758-2.8164-13.047-7.6172-17.691l-767.38-742.63v-114.4h114.4l742.63 767.38c6.2109 6.418 15.375 9.0391 24.039 6.8711 8.6641-2.168 15.512-8.7969 17.969-17.383 2.4531-8.5898 0.14063-17.836-6.0703-24.254l-750-775c-4.7109-4.8711-11.195-7.6172-17.969-7.6172h-150c-6.6289 0-12.988 2.6328-17.676 7.3242-4.6914 4.6875-7.3242 11.047-7.3242 17.676v150c0 6.7734 2.7461 13.258 7.6172 17.969l775 750c4.6562 4.5195 10.895 7.043 17.383 7.0312z" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m842.68 807.32-700-700c-6.3359-6.2188-15.492-8.6133-24.059-6.2891-8.5664 2.3242-15.258 9.0156-17.582 17.582-2.3242 8.5664 0.070313 17.723 6.2891 24.059l700 700c6.3359 6.2188 15.492 8.6133 24.059 6.2891 8.5664-2.3242 15.258-9.0156 17.582-17.582 2.3242-8.5664-0.070313-17.723-6.2891-24.059z" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m757.32 1042.7c4.6875 4.6875 11.047 7.3242 17.676 7.3242 6.6328 0 12.988-2.6367 17.676-7.3242l250-250c4.7383-4.6797 7.4141-11.051 7.4336-17.707 0.019531-6.6602-2.6133-13.051-7.3203-17.758-4.7109-4.707-11.098-7.3398-17.758-7.3203-6.6562 0.023437-13.027 2.6992-17.707 7.4336l-250 250c-4.6875 4.6875-7.3242 11.047-7.3242 17.676s2.6367 12.988 7.3242 17.676z" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m1192.7 1082.3-200-200c-6.3359-6.2188-15.492-8.6133-24.059-6.2891-8.5664 2.3242-15.258 9.0156-17.582 17.582-2.3242 8.5664 0.070313 17.723 6.2891 24.059l32.324 32.324-39.648 39.648-32.324-32.324c-6.3281-6.25-15.5-8.6641-24.086-6.3438-8.5859 2.3164-15.293 9.0234-17.609 17.609-2.3203 8.5859 0.09375 17.758 6.3438 24.086l200 200c4.6875 4.6875 11.047 7.3242 17.676 7.3242 6.6328 0 12.988-2.6367 17.676-7.3242l75-75c4.6914-4.6875 7.3242-11.047 7.3242-17.676s-2.6367-12.988-7.3242-17.676zm-167.68-96.973 39.648 39.648-39.648 39.648-39.648-39.648zm75 154.3-39.648-39.648 39.648-39.648 39.648 39.648z" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m458.97 148.34c52.199-20.34 100.04-50.438 140.98-88.684 85.352 79.051 175.66 116.88 266.57 112.2 77.117-5.9219 150.25-36.629 208.47-87.539v590.69c0.0625 50.512-7.9492 100.71-23.73 148.7-2.0742 6.293-1.5664 13.152 1.418 19.07 2.9805 5.918 8.1953 10.41 14.488 12.484s13.152 1.5664 19.07-1.418c5.918-2.9844 10.41-8.1953 12.484-14.488 17.465-53.031 26.332-108.51 26.27-164.34v-650c-0.007812-6.9062-2.875-13.504-7.918-18.223-5.043-4.7227-11.812-7.1445-18.707-6.6992-6.8906 0.44531-13.293 3.7227-17.688 9.0508-0.87891 1.0742-89.332 106.66-217.09 112.8-83.691 4.25-165.89-34.582-245.92-114.61-4.6875-4.6875-11.047-7.3242-17.676-7.3242-6.6328 0-12.988 2.6367-17.676 7.3242-39.84 41.152-88.016 73.316-141.3 94.336-8.3164 3.2227-14.285 10.629-15.664 19.438-1.3828 8.8086 2.0273 17.688 8.957 23.305 6.9258 5.6133 16.32 7.1133 24.652 3.9375z" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m884.98 1055c-94.574 70.906-212.19 104-329.87 92.828-117.68-11.176-226.96-65.824-306.49-153.27-79.539-87.445-123.62-201.4-123.62-319.61v-275c0-8.9297-4.7656-17.184-12.5-21.652-7.7344-4.4648-17.266-4.4648-25 0-7.7344 4.4688-12.5 12.723-12.5 21.652v275c0.011719 130.65 48.734 256.61 136.65 353.25 87.914 96.648 208.7 157.05 338.77 169.39 130.07 12.352 260.07-24.238 364.6-102.62 7.125-5.3711 10.848-14.129 9.7695-22.988-1.0781-8.8555-6.7969-16.469-15-19.973-8.2031-3.5039-17.656-2.3711-24.801 2.9727z" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m200 425c-6.6289 0-12.988 2.6328-17.676 7.3242-4.6914 4.6875-7.3242 11.047-7.3242 17.676v200c0.125 112.68 44.941 220.71 124.62 300.38 79.676 79.676 187.7 124.49 300.38 124.62 8.9297 0 17.184-4.7656 21.652-12.5 4.4648-7.7344 4.4648-17.266 0-25-4.4688-7.7344-12.723-12.5-21.652-12.5-99.422-0.11328-194.74-39.656-265.04-109.96-70.305-70.301-109.85-165.62-109.96-265.04v-200c0-6.6289-2.6328-12.988-7.3242-17.676-4.6875-4.6914-11.047-7.3242-17.676-7.3242z" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m1e3 650c6.6328 0 12.992-2.6328 17.68-7.3203s7.3203-11.047 7.3203-17.68v-400c-0.003906-5.8789-2.0781-11.57-5.8594-16.074-3.7812-4.5-9.0312-7.5234-14.82-8.543-5.793-1.0156-11.758 0.042969-16.844 2.9883-2.1953 1.2812-222.63 126.15-369.8-21.047-4.6875-4.6914-11.047-7.3242-17.676-7.3242-6.6328 0-12.988 2.6328-17.676 7.3242-19.734 19.926-42.746 36.309-68.031 48.438-8.0703 3.8242-13.492 11.664-14.215 20.57-0.72266 8.9023 3.3555 17.516 10.707 22.594 7.3477 5.0781 16.848 5.8516 24.918 2.0273 23.199-11.055 44.82-25.145 64.297-41.906 36.418 30.176 79.254 51.629 125.23 62.723 45.977 11.094 93.879 11.535 140.05 1.2891 37.711-6.8398 74.523-17.957 109.71-33.141v360.08c0 6.6328 2.6328 12.992 7.3203 17.68s11.047 7.3203 17.68 7.3203z" })] })) }))); };


/***/ }),
/* 242 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Trendsetter": () => (/* binding */ Trendsetter)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Trendsetter = function (props) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "1200pt", height: "1200pt", version: "1.1", viewBox: "0 0 1200 1200", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { fill: "currentColor", d: "m948.75 455.62v-204.38h-204.38l-144.38-144.38-144.38 144.38h-204.38v204.38l-144.38 144.38 144.38 144.38v54.75h75v-85.875l-113.62-113.25 113.62-113.25v-160.5h160.5l113.25-113.62 113.25 113.62h160.5v160.5l113.62 113.25-113.62 113.25v160.5h-160.5l-113.25 113.62-113.25-113.62h-235.5v75h204.38l144.38 144.38 144.38-144.38h204.38v-204.38l144.38-144.38zm-311.25 291h-75v-230.25l-34.875 19.125-36-65.625 145.88-79.875z" }) }))); };


/***/ }),
/* 243 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(123);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(124);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(244);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_GamificationPanel_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),
/* 244 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GamificationPanel-module__panel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 35px;\n  padding-bottom: 35px;\n  height: 100%;\n  max-height: 100vh;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__title {\n  font-family: \"Manrope\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 38px;\n  display: flex;\n  align-items: center;\n  /* RetainIt Blue */\n  color: #ffffff;\n  margin-bottom: 12px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__streak {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__streak .GamificationPanel-module__top {\n  font-family: \"Manrope\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 22px;\n  /* identical to box height */\n  display: flex;\n  align-items: center;\n  color: #ffffff;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__streak .GamificationPanel-module__top img {\n  margin-right: 8px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__streak .GamificationPanel-module__bottom {\n  font-family: \"Manrope\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 14px;\n  /* identical to box height */\n  display: flex;\n  align-items: center;\n  color: #c2c2c2;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__calendar {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  margin-top: 10px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__calendar .GamificationPanel-module__top {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  padding: 0 10px;\n  justify-content: space-around;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__calendar .GamificationPanel-module__top .GamificationPanel-module__headerCell {\n  font-family: \"Manrope\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  display: flex;\n  align-items: center;\n  color: #ffffff;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__calendar.GamificationPanel-module__open .GamificationPanel-module__bottom {\n  height: 164px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__calendar .GamificationPanel-module__bottom {\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n  align-content: flex-end;\n  transition: height 0.5s;\n  overflow: hidden;\n  height: 48px;\n  background: #2c2b5e;\n  border-radius: 25px;\n  flex-wrap: wrap;\n  max-width: 278px;\n  display: flex;\n  flex-direction: row;\n  padding: 10px;\n  gap: 8px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__calendar .GamificationPanel-module__bottom .GamificationPanel-module__cell {\n  gap: 10px;\n  width: 30px;\n  height: 30px;\n  border-radius: 100%;\n  background: #212039;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: content-box;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__calendar .GamificationPanel-module__bottom .GamificationPanel-module__cell.GamificationPanel-module__isToday {\n  margin: -4px;\n  border: 4px solid #5ac7a8;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__calendar .GamificationPanel-module__bottom .GamificationPanel-module__cell.GamificationPanel-module__emptyOutline {\n  background-color: white;\n  box-sizing: border-box;\n  border: 1px solid #9695c7;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__subtitle {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 33px;\n  /* identical to box height */\n  text-align: center;\n  color: #ffffff;\n  margin-bottom: 14px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__badges {\n  margin-top: 32px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding-left: 24px;\n  padding-right: 16px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__badges .GamificationPanel-module__list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__badges .GamificationPanel-module__list .GamificationPanel-module__badge {\n  display: flex;\n  flex-direction: row;\n  gap: 14px;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #ffffff;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__badges .GamificationPanel-module__list .GamificationPanel-module__badge .GamificationPanel-module__icon {\n  width: 45px;\n  height: 45px;\n  border-radius: 6px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__badges .GamificationPanel-module__list .GamificationPanel-module__badge .GamificationPanel-module__content {\n  flex-grow: 1;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__badges .GamificationPanel-module__list .GamificationPanel-module__badge .GamificationPanel-module__content .GamificationPanel-module__name {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  font-weight: 700;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__badges .GamificationPanel-module__list .GamificationPanel-module__badge .GamificationPanel-module__content .GamificationPanel-module__name span {\n  font-size: 14px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__badges .GamificationPanel-module__list .GamificationPanel-module__badge .GamificationPanel-module__content .GamificationPanel-module__progressBarOuter {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__badges .GamificationPanel-module__list .GamificationPanel-module__badge .GamificationPanel-module__content .GamificationPanel-module__progressBarOuter .GamificationPanel-module__progressBar {\n  flex-grow: 1;\n  border: 2px solid;\n  padding: 2px;\n  border-radius: 10px;\n  position: relative;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__badges .GamificationPanel-module__list .GamificationPanel-module__badge .GamificationPanel-module__content .GamificationPanel-module__progressBarOuter .GamificationPanel-module__progressBar .GamificationPanel-module__progressBarInner {\n  position: relative;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  height: 5px;\n  border-radius: 3px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__badges .GamificationPanel-module__list .GamificationPanel-module__badge .GamificationPanel-module__content .GamificationPanel-module__progressBarOuter .GamificationPanel-module__text {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 25px;\n  min-width: 42px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__badges .GamificationPanel-module__list .GamificationPanel-module__badge .GamificationPanel-module__content .GamificationPanel-module__progressBarOuter .GamificationPanel-module__text span {\n  font-size: 12px;\n  line-height: 16px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__badges .GamificationPanel-module__seeAll {\n  cursor: pointer;\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  text-align: center;\n  color: #ffffff;\n  margin-top: 16px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__recent {\n  margin-top: 28px;\n}\n.GamificationPanel-module__panel .GamificationPanel-module__progress {\n  margin-top: 32px;\n  width: 100%;\n}\n\n.GamificationPanel-module__expand {\n  margin-top: 8px;\n  margin-left: auto;\n  margin-right: auto;\n  cursor: pointer;\n}\n.GamificationPanel-module__expand .GamificationPanel-module__open {\n  transform: rotateZ(180deg);\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": "GamificationPanel-module__panel",
	"title": "GamificationPanel-module__title",
	"streak": "GamificationPanel-module__streak",
	"top": "GamificationPanel-module__top",
	"bottom": "GamificationPanel-module__bottom",
	"calendar": "GamificationPanel-module__calendar",
	"headerCell": "GamificationPanel-module__headerCell",
	"open": "GamificationPanel-module__open",
	"cell": "GamificationPanel-module__cell",
	"isToday": "GamificationPanel-module__isToday",
	"emptyOutline": "GamificationPanel-module__emptyOutline",
	"subtitle": "GamificationPanel-module__subtitle",
	"badges": "GamificationPanel-module__badges",
	"list": "GamificationPanel-module__list",
	"badge": "GamificationPanel-module__badge",
	"icon": "GamificationPanel-module__icon",
	"content": "GamificationPanel-module__content",
	"name": "GamificationPanel-module__name",
	"progressBarOuter": "GamificationPanel-module__progressBarOuter",
	"progressBar": "GamificationPanel-module__progressBar",
	"progressBarInner": "GamificationPanel-module__progressBarInner",
	"text": "GamificationPanel-module__text",
	"seeAll": "GamificationPanel-module__seeAll",
	"recent": "GamificationPanel-module__recent",
	"progress": "GamificationPanel-module__progress",
	"expand": "GamificationPanel-module__expand"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 245 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UserLevelIndicator": () => (/* binding */ UserLevelIndicator)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(105);
/* harmony import */ var _xp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(215);
/* harmony import */ var _UserLevelIndicator_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(246);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};






var UserLevelIndicator = function (props) {
    // a component which shows the user level and xp, the user image is show in the middle of a circlar progress bar which shows the progress to the
    // next level
    var _a;
    var _b, _c, _d, _e;
    var stats = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_3__.AppConfigContext).stats;
    var currentXp = (_b = stats === null || stats === void 0 ? void 0 : stats.xp) !== null && _b !== void 0 ? _b : 0;
    var _f = (0,_xp__WEBPACK_IMPORTED_MODULE_4__.getLevel)(currentXp), currentLevel = _f[0], nextLevel = _f[1];
    var progress = (currentXp - currentLevel.neededXP) / (((_c = nextLevel === null || nextLevel === void 0 ? void 0 : nextLevel.neededXP) !== null && _c !== void 0 ? _c : 0) - currentLevel.neededXP);
    var CharacterImage = currentLevel.characterImage;
    var radius = props.small ? 16 : 48;
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_UserLevelIndicator_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].outer, (_a = {},
            _a[_UserLevelIndicator_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].small] = props.small,
            _a[(_d = props === null || props === void 0 ? void 0 : props.className) !== null && _d !== void 0 ? _d : ""] = !!(props === null || props === void 0 ? void 0 : props.className),
            _a)), onClick: props.onClick }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _UserLevelIndicator_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].progress }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CharacterImage, { className: _UserLevelIndicator_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].character }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", __assign({ className: _UserLevelIndicator_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].progressCircle }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", { cx: "50%", cy: "50%", r: radius, fill: "transparent", stroke: "#2C2B5E", strokeWidth: props.small ? 2 : 9 }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", { cx: "50%", cy: "50%", r: radius, fill: "transparent", strokeDasharray: 2 * Math.PI * radius, strokeDashoffset: 2 * Math.PI * radius * (1 - progress), stroke: "#6DE9C5", strokeWidth: props.small ? 2 : 7, style: { transform: "rotateZ(-90deg)", transformOrigin: "center" } }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m 19.4384,7.65764 7e-4,0.00222 c 0.0704,0.22402 0.08,0.46462 0.0276,0.69442 -0.0524,0.22974 -0.1643,0.43746 -0.3208,0.60108 l -7e-4,8.3e-4 -3.4459,3.62091 -0.1681,0.1766 0.0357,0.2412 0.7458,5.0406 10e-5,10e-5 c 0.0346,0.234 0.0067,0.4731 -0.0802,0.6904 -0.0867,0.2172 -0.2281,0.4025 -0.4061,0.5373 -0.1778,0.1346 -0.3855,0.2141 -0.6003,0.2321 -0.2147,0.0181 -0.431,-0.0257 -0.6255,-0.1281 h -10e-5 l -4.3685,-2.2972 -0.2327,-0.1223 -0.23272,0.1223 -4.36833,2.2972 -4.9e-4,2e-4 C 5.20337,19.4701 4.9871,19.514 4.77234,19.4961 4.55752,19.4781 4.34968,19.3987 4.1719,19.264 3.99392,19.1292 3.85252,18.9439 3.76582,18.7266 3.67907,18.5092 3.65122,18.27 3.6861,18.036 l 8e-5,-5e-4 L 4.43202,12.9949 4.46771,12.7537 4.2996,12.5771 0.853859,8.95628 C 0.697649,8.79205 0.585945,8.584 0.533484,8.35405 0.481008,8.12404 0.490395,7.88325 0.560351,7.65883 0.63028,7.4345 0.757335,7.23723 0.925005,7.08731 1.09246,6.93759 1.29402,6.84068 1.50691,6.80454 c 5e-5,-1e-5 9e-5,-2e-5 1.3e-4,-2e-5 L 6.33637,5.9864 6.58815,5.94375 6.7012,5.71477 8.93998,1.17992 C 9.04298,0.971401 9.19767,0.799347 9.38465,0.680479 9.57142,0.561744 9.78406,0.5 9.9994,0.5 c 0.2153,0 0.428,0.061744 0.6147,0.180479 0.187,0.118848 0.3417,0.290866 0.4447,0.499341 v 10e-5 l 2.2388,4.53485 0.113,0.22898 0.2518,0.04265 4.8296,0.81814 0.0012,2e-4 c 0.2127,0.0355 0.4143,0.13203 0.5816,0.2816 0.1675,0.14973 0.2942,0.34699 0.3636,0.5713 z", fill: "#FFF597", stroke: "#2C2B5E", style: {
                                    transform: props.small
                                        ? "rotateZ(".concat(progress * 360, "deg) translate(-10px,-10px) translate(13px,-1px) scale(0.4)")
                                        : "rotateZ(".concat(progress * 360, "deg) translate(-10px,-10px) translate(50%, 10.5px)"),
                                    transformOrigin: "center",
                                } })] }))] })), !props.small && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _UserLevelIndicator_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].status }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _UserLevelIndicator_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].level }, { children: currentLevel.label })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _UserLevelIndicator_module_scss__WEBPACK_IMPORTED_MODULE_5__["default"].needed }, { children: [((_e = nextLevel === null || nextLevel === void 0 ? void 0 : nextLevel.neededXP) !== null && _e !== void 0 ? _e : 0) - currentXp, " XP until next level"] }))] })))] })));
};


/***/ }),
/* 246 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(123);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(124);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_UserLevelIndicator_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(247);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_UserLevelIndicator_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_UserLevelIndicator_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_UserLevelIndicator_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_UserLevelIndicator_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),
/* 247 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UserLevelIndicator-module__outer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n.UserLevelIndicator-module__outer.UserLevelIndicator-module__small {\n  width: 40px;\n  height: 40px;\n}\n.UserLevelIndicator-module__outer.UserLevelIndicator-module__small .UserLevelIndicator-module__progress {\n  width: 34px;\n  height: 34px;\n}\n.UserLevelIndicator-module__outer.UserLevelIndicator-module__small .UserLevelIndicator-module__progress .UserLevelIndicator-module__character {\n  width: 30px;\n  height: 30px;\n  padding: 2px;\n  background-color: white;\n  color: black;\n}\n.UserLevelIndicator-module__outer .UserLevelIndicator-module__progress {\n  position: relative;\n  width: 122px;\n  height: 122px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.UserLevelIndicator-module__outer .UserLevelIndicator-module__progress .UserLevelIndicator-module__character {\n  width: 88px;\n  height: 88px;\n  border-radius: 100%;\n  position: relative;\n  color: white;\n}\n.UserLevelIndicator-module__outer .UserLevelIndicator-module__progress .UserLevelIndicator-module__progressCircle {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.UserLevelIndicator-module__outer .UserLevelIndicator-module__status {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.UserLevelIndicator-module__outer .UserLevelIndicator-module__status .UserLevelIndicator-module__level {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 38px;\n  display: flex;\n  align-items: center;\n  /* Retro/Retro D */\n  color: #5ac7a8;\n}\n.UserLevelIndicator-module__outer .UserLevelIndicator-module__status .UserLevelIndicator-module__needed {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 19px;\n  display: flex;\n  align-items: center;\n  color: #ffffff;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outer": "UserLevelIndicator-module__outer",
	"small": "UserLevelIndicator-module__small",
	"progress": "UserLevelIndicator-module__progress",
	"character": "UserLevelIndicator-module__character",
	"progressCircle": "UserLevelIndicator-module__progressCircle",
	"status": "UserLevelIndicator-module__status",
	"level": "UserLevelIndicator-module__level",
	"needed": "UserLevelIndicator-module__needed"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 248 */
/***/ ((module) => {

"use strict";
module.exports = "data:image/svg+xml;base64,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";

/***/ }),
/* 249 */
/***/ ((module) => {

"use strict";
module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAzNCAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxlbGxpcHNlIGN4PSIxNi44NTU0IiBjeT0iMTcuNjM2NSIgcng9IjE2LjgwNzIiIHJ5PSIxNi45NDgxIiBmaWxsPSIjRTNCMjc1IiAvPgogICAgPHBhdGgKICAgICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgY2xpcC1ydWxlPSJldmVub2RkIgogICAgICAgIGQ9Ik0xMy43NSAyOC4wNDg0TDUuNjQ1ODEgMTkuODc2NkwxNi43Mzc5IDguNTkyMjlMMjQuOTM4MiA4LjU5NTE0TDI0Ljk0MSAxNi44NjM5TDEzLjc1IDI4LjA0ODRaTTIzLjk3NTQgOS41NjU1SDE3LjIyMDFMNy4wODcwMyAxOS43ODM1TDEzLjg0MjMgMjYuNTk1NEwyMy45NzU0IDE2LjM3NzRWOS41NjU1Wk0yMS42MjEyIDExLjkyNDJDMjIuMTg2NiAxMi40OTUzIDIyLjE4NjYgMTMuNDIwOSAyMS42MTkzIDEzLjk5M0MyMS4wNTE5IDE0LjU2NDEgMjAuMTM0MSAxNC41NjUxIDE5LjU2ODQgMTMuOTk0OUMxOS4wMDExIDEzLjQyMzggMTkuMDAzIDEyLjQ5NzMgMTkuNTY5NCAxMS45MjYxQzIwLjEzNiAxMS4zNTM4IDIxLjA1NDkgMTEuMzUzOCAyMS42MjEyIDExLjkyNDJIMjEuNjIxMloiCiAgICAgICAgZmlsbD0iIzJDMkI1RSIKICAgIC8+Cjwvc3ZnPgo=";

/***/ }),
/* 250 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QuizProgressGraph": () => (/* binding */ QuizProgressGraph)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(253);
/* harmony import */ var _requests__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
/* harmony import */ var _QuizProgressGraph_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(251);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};



// import { Area, AreaChart, CartesianGrid, XAxis, YAxis } from "recharts";


var QuizProgressGraph = function (_a) {
    var mediaId = _a.mediaId, emptyMessage = _a.emptyMessage, props = __rest(_a, ["mediaId", "emptyMessage"]);
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), scoresProgerss = _b[0], setScoresProgress = _b[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
        if (mediaId) {
            setScoresProgress("loading");
            (0,_requests__WEBPACK_IMPORTED_MODULE_2__.getMediaReview)(mediaId).then(function (res) {
                if (res) {
                    if (res.score.length === 0) {
                        setScoresProgress([]);
                    }
                    else {
                        setScoresProgress(__spreadArray([{ score: 0, createdAt: "" }], res.score, true).map(function (it, index) { return (__assign(__assign({}, it), { index: index })); }));
                    }
                }
                else {
                    setScoresProgress([]);
                }
            });
        }
    }, [mediaId]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", __assign({ className: _QuizProgressGraph_module_scss__WEBPACK_IMPORTED_MODULE_3__["default"].chart }, { children: [!mediaId && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _QuizProgressGraph_module_scss__WEBPACK_IMPORTED_MODULE_3__["default"].overlay }, { children: "Select a quizz to see your progress." })), mediaId && scoresProgerss === "loading" && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _QuizProgressGraph_module_scss__WEBPACK_IMPORTED_MODULE_3__["default"].overlay }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__["default"], { animation: "border", variant: "primary" }) }))), mediaId && scoresProgerss !== "loading" && scoresProgerss.length === 0 && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", __assign({ className: _QuizProgressGraph_module_scss__WEBPACK_IMPORTED_MODULE_3__["default"].overlay }, { children: emptyMessage }))] })));
};


/***/ }),
/* 251 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(123);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(124);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(127);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_QuizProgressGraph_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(252);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_QuizProgressGraph_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_QuizProgressGraph_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_QuizProgressGraph_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_1_use_1_node_modules_postcss_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_QuizProgressGraph_module_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),
/* 252 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(131);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuizProgressGraph-module__chart {\n  position: relative;\n}\n\n.QuizProgressGraph-module__overlay {\n  font-family: Manrope, sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  text-align: center;\n  line-height: 16px;\n  color: #2c2b5e;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding-bottom: 24px;\n  padding-left: 24px;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chart": "QuizProgressGraph-module__chart",
	"overlay": "QuizProgressGraph-module__overlay"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 253 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(188);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);




const Spinner = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  variant,
  animation,
  size,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__.useBootstrapPrefix)(bsPrefix, 'spinner');
  const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
  });
});
Spinner.displayName = 'Spinner';
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Spinner);

/***/ }),
/* 254 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Marathoner": () => (/* reexport safe */ _badges__WEBPACK_IMPORTED_MODULE_0__.Marathoner),
/* harmony export */   "Shield": () => (/* reexport safe */ _badges__WEBPACK_IMPORTED_MODULE_0__.Shield),
/* harmony export */   "Trendsetter": () => (/* reexport safe */ _badges__WEBPACK_IMPORTED_MODULE_0__.Trendsetter),
/* harmony export */   "Wand": () => (/* reexport safe */ _badges__WEBPACK_IMPORTED_MODULE_0__.Wand)
/* harmony export */ });
/* harmony import */ var _badges__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(255);





/***/ }),
/* 255 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Marathoner": () => (/* reexport safe */ _marathoner__WEBPACK_IMPORTED_MODULE_0__.Marathoner),
/* harmony export */   "Shield": () => (/* reexport safe */ _shield__WEBPACK_IMPORTED_MODULE_1__.Shield),
/* harmony export */   "Trendsetter": () => (/* reexport safe */ _trendsetter__WEBPACK_IMPORTED_MODULE_2__.Trendsetter),
/* harmony export */   "Wand": () => (/* reexport safe */ _wand__WEBPACK_IMPORTED_MODULE_3__.Wand)
/* harmony export */ });
/* harmony import */ var _marathoner__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(256);
/* harmony import */ var _shield__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(241);
/* harmony import */ var _trendsetter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(242);
/* harmony import */ var _wand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(240);






/***/ }),
/* 256 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Marathoner": () => (/* binding */ Marathoner)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Marathoner = function (props) { return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", __assign({ width: "1200pt", height: "1200pt", version: "1.1", viewBox: "0 0 1200 1200", xmlns: "http://www.w3.org/2000/svg", fill: "#2c2a5d" }, props, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", __assign({ fill: "currentColor" }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m601.08 367.57c-129.73 0-233.51 103.79-233.51 231.35 0 129.73 103.79 233.51 233.51 233.51 127.57 0 231.35-103.79 231.35-233.51 0-127.57-103.79-231.35-231.35-231.35zm43.242 192.43 58.379 30.27c8.6484 4.3242 8.6484 15.137 2.1641 17.297l-64.863 36.758-30.27 58.379c-4.3242 6.4883-15.137 6.4883-17.297 0l-36.758-62.703-58.379-32.434c-6.4883-2.1641-6.4883-12.973 0-17.297l62.703-34.594 32.434-58.379c2.1641-8.6484 12.973-8.6484 17.297-2.1641l34.594 64.863z" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m845.41 657.3c-4.3242 25.945-15.137 47.566-25.945 69.188h181.62c19.461 0 34.594-15.137 34.594-34.594v-34.594z" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m849.73 564.32c4.3242 23.785 4.3242 47.566 0 69.188h233.51c19.461 0 34.594-15.137 34.594-34.594v-34.594h-268.11z" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m819.46 473.51c10.812 19.461 21.621 43.242 25.945 69.188h320c19.461 0 34.594-15.137 34.594-34.594v-34.594z" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m354.59 542.7c6.4883-25.945 15.137-49.73 28.109-69.188h-382.7v34.594c0 19.461 15.137 34.594 34.594 34.594z" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m350.27 633.51c-4.3242-21.621-4.3242-45.406 0-69.188h-268.11v34.594c0 19.461 15.137 34.594 34.594 34.594z" }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", { d: "m382.7 726.49c-12.973-21.621-21.621-43.242-28.109-69.188h-190.27v34.594c0 19.461 15.137 34.594 34.594 34.594z" })] })) }))); };


/***/ }),
/* 257 */
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 *  howler.js v2.2.3
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */

(function() {

  'use strict';

  /** Global Methods **/
  /***************************************************************************/

  /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */
  var HowlerGlobal = function() {
    this.init();
  };
  HowlerGlobal.prototype = {
    /**
     * Initialize the global Howler object.
     * @return {Howler}
     */
    init: function() {
      var self = this || Howler;

      // Create a global ID counter.
      self._counter = 1000;

      // Pool of unlocked HTML5 Audio objects.
      self._html5AudioPool = [];
      self.html5PoolSize = 10;

      // Internal properties.
      self._codecs = {};
      self._howls = [];
      self._muted = false;
      self._volume = 1;
      self._canPlayEvent = 'canplaythrough';
      self._navigator = (typeof window !== 'undefined' && window.navigator) ? window.navigator : null;

      // Public properties.
      self.masterGain = null;
      self.noAudio = false;
      self.usingWebAudio = true;
      self.autoSuspend = true;
      self.ctx = null;

      // Set to false to disable the auto audio unlocker.
      self.autoUnlock = true;

      // Setup the various state values for global tracking.
      self._setup();

      return self;
    },

    /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */
    volume: function(vol) {
      var self = this || Howler;
      vol = parseFloat(vol);

      // If we don't have an AudioContext created yet, run the setup.
      if (!self.ctx) {
        setupAudioContext();
      }

      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
        self._volume = vol;

        // Don't update any of the nodes if we are muted.
        if (self._muted) {
          return self;
        }

        // When using Web Audio, we just need to adjust the master gain.
        if (self.usingWebAudio) {
          self.masterGain.gain.setValueAtTime(vol, Howler.ctx.currentTime);
        }

        // Loop through and change volume for all HTML5 audio nodes.
        for (var i=0; i<self._howls.length; i++) {
          if (!self._howls[i]._webAudio) {
            // Get all of the sounds in this Howl group.
            var ids = self._howls[i]._getSoundIds();

            // Loop through all sounds and change the volumes.
            for (var j=0; j<ids.length; j++) {
              var sound = self._howls[i]._soundById(ids[j]);

              if (sound && sound._node) {
                sound._node.volume = sound._volume * vol;
              }
            }
          }
        }

        return self;
      }

      return self._volume;
    },

    /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */
    mute: function(muted) {
      var self = this || Howler;

      // If we don't have an AudioContext created yet, run the setup.
      if (!self.ctx) {
        setupAudioContext();
      }

      self._muted = muted;

      // With Web Audio, we just need to mute the master gain.
      if (self.usingWebAudio) {
        self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler.ctx.currentTime);
      }

      // Loop through and mute all HTML5 Audio nodes.
      for (var i=0; i<self._howls.length; i++) {
        if (!self._howls[i]._webAudio) {
          // Get all of the sounds in this Howl group.
          var ids = self._howls[i]._getSoundIds();

          // Loop through all sounds and mark the audio node as muted.
          for (var j=0; j<ids.length; j++) {
            var sound = self._howls[i]._soundById(ids[j]);

            if (sound && sound._node) {
              sound._node.muted = (muted) ? true : sound._muted;
            }
          }
        }
      }

      return self;
    },

    /**
     * Handle stopping all sounds globally.
     */
    stop: function() {
      var self = this || Howler;

      // Loop through all Howls and stop them.
      for (var i=0; i<self._howls.length; i++) {
        self._howls[i].stop();
      }

      return self;
    },

    /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */
    unload: function() {
      var self = this || Howler;

      for (var i=self._howls.length-1; i>=0; i--) {
        self._howls[i].unload();
      }

      // Create a new AudioContext to make sure it is fully reset.
      if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== 'undefined') {
        self.ctx.close();
        self.ctx = null;
        setupAudioContext();
      }

      return self;
    },

    /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */
    codecs: function(ext) {
      return (this || Howler)._codecs[ext.replace(/^x-/, '')];
    },

    /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */
    _setup: function() {
      var self = this || Howler;

      // Keeps track of the suspend/resume state of the AudioContext.
      self.state = self.ctx ? self.ctx.state || 'suspended' : 'suspended';

      // Automatically begin the 30-second suspend process
      self._autoSuspend();

      // Check if audio is available.
      if (!self.usingWebAudio) {
        // No audio is available on this system if noAudio is set to true.
        if (typeof Audio !== 'undefined') {
          try {
            var test = new Audio();

            // Check if the canplaythrough event is available.
            if (typeof test.oncanplaythrough === 'undefined') {
              self._canPlayEvent = 'canplay';
            }
          } catch(e) {
            self.noAudio = true;
          }
        } else {
          self.noAudio = true;
        }
      }

      // Test to make sure audio isn't disabled in Internet Explorer.
      try {
        var test = new Audio();
        if (test.muted) {
          self.noAudio = true;
        }
      } catch (e) {}

      // Check for supported codecs.
      if (!self.noAudio) {
        self._setupCodecs();
      }

      return self;
    },

    /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */
    _setupCodecs: function() {
      var self = this || Howler;
      var audioTest = null;

      // Must wrap in a try/catch because IE11 in server mode throws an error.
      try {
        audioTest = (typeof Audio !== 'undefined') ? new Audio() : null;
      } catch (err) {
        return self;
      }

      if (!audioTest || typeof audioTest.canPlayType !== 'function') {
        return self;
      }

      var mpegTest = audioTest.canPlayType('audio/mpeg;').replace(/^no$/, '');

      // Opera version <33 has mixed MP3 support, so we need to check for and block it.
      var ua = self._navigator ? self._navigator.userAgent : '';
      var checkOpera = ua.match(/OPR\/([0-6].)/g);
      var isOldOpera = (checkOpera && parseInt(checkOpera[0].split('/')[1], 10) < 33);
      var checkSafari = ua.indexOf('Safari') !== -1 && ua.indexOf('Chrome') === -1;
      var safariVersion = ua.match(/Version\/(.*?) /);
      var isOldSafari = (checkSafari && safariVersion && parseInt(safariVersion[1], 10) < 15);

      self._codecs = {
        mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType('audio/mp3;').replace(/^no$/, ''))),
        mpeg: !!mpegTest,
        opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ''),
        ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
        oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
        wav: !!(audioTest.canPlayType('audio/wav; codecs="1"') || audioTest.canPlayType('audio/wav')).replace(/^no$/, ''),
        aac: !!audioTest.canPlayType('audio/aac;').replace(/^no$/, ''),
        caf: !!audioTest.canPlayType('audio/x-caf;').replace(/^no$/, ''),
        m4a: !!(audioTest.canPlayType('audio/x-m4a;') || audioTest.canPlayType('audio/m4a;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        m4b: !!(audioTest.canPlayType('audio/x-m4b;') || audioTest.canPlayType('audio/m4b;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        mp4: !!(audioTest.canPlayType('audio/x-mp4;') || audioTest.canPlayType('audio/mp4;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        weba: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, '')),
        webm: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, '')),
        dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ''),
        flac: !!(audioTest.canPlayType('audio/x-flac;') || audioTest.canPlayType('audio/flac;')).replace(/^no$/, '')
      };

      return self;
    },

    /**
     * Some browsers/devices will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */
    _unlockAudio: function() {
      var self = this || Howler;

      // Only run this if Web Audio is supported and it hasn't already been unlocked.
      if (self._audioUnlocked || !self.ctx) {
        return;
      }

      self._audioUnlocked = false;
      self.autoUnlock = false;

      // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
      // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
      // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
      if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
        self._mobileUnloaded = true;
        self.unload();
      }

      // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
      // http://stackoverflow.com/questions/24119684
      self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);

      // Call this method on touch start to create and play a buffer,
      // then check if the audio actually played to determine if
      // audio has now been unlocked on iOS, Android, etc.
      var unlock = function(e) {
        // Create a pool of unlocked HTML5 Audio objects that can
        // be used for playing sounds without user interaction. HTML5
        // Audio objects must be individually unlocked, as opposed
        // to the WebAudio API which only needs a single activation.
        // This must occur before WebAudio setup or the source.onended
        // event will not fire.
        while (self._html5AudioPool.length < self.html5PoolSize) {
          try {
            var audioNode = new Audio();

            // Mark this Audio object as unlocked to ensure it can get returned
            // to the unlocked pool when released.
            audioNode._unlocked = true;

            // Add the audio node to the pool.
            self._releaseHtml5Audio(audioNode);
          } catch (e) {
            self.noAudio = true;
            break;
          }
        }

        // Loop through any assigned audio nodes and unlock them.
        for (var i=0; i<self._howls.length; i++) {
          if (!self._howls[i]._webAudio) {
            // Get all of the sounds in this Howl group.
            var ids = self._howls[i]._getSoundIds();

            // Loop through all sounds and unlock the audio nodes.
            for (var j=0; j<ids.length; j++) {
              var sound = self._howls[i]._soundById(ids[j]);

              if (sound && sound._node && !sound._node._unlocked) {
                sound._node._unlocked = true;
                sound._node.load();
              }
            }
          }
        }

        // Fix Android can not play in suspend state.
        self._autoResume();

        // Create an empty buffer.
        var source = self.ctx.createBufferSource();
        source.buffer = self._scratchBuffer;
        source.connect(self.ctx.destination);

        // Play the empty buffer.
        if (typeof source.start === 'undefined') {
          source.noteOn(0);
        } else {
          source.start(0);
        }

        // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
        if (typeof self.ctx.resume === 'function') {
          self.ctx.resume();
        }

        // Setup a timeout to check that we are unlocked on the next event loop.
        source.onended = function() {
          source.disconnect(0);

          // Update the unlocked state and prevent this check from happening again.
          self._audioUnlocked = true;

          // Remove the touch start listener.
          document.removeEventListener('touchstart', unlock, true);
          document.removeEventListener('touchend', unlock, true);
          document.removeEventListener('click', unlock, true);
          document.removeEventListener('keydown', unlock, true);

          // Let all sounds know that audio has been unlocked.
          for (var i=0; i<self._howls.length; i++) {
            self._howls[i]._emit('unlock');
          }
        };
      };

      // Setup a touch start listener to attempt an unlock in.
      document.addEventListener('touchstart', unlock, true);
      document.addEventListener('touchend', unlock, true);
      document.addEventListener('click', unlock, true);
      document.addEventListener('keydown', unlock, true);

      return self;
    },

    /**
     * Get an unlocked HTML5 Audio object from the pool. If none are left,
     * return a new Audio object and throw a warning.
     * @return {Audio} HTML5 Audio object.
     */
    _obtainHtml5Audio: function() {
      var self = this || Howler;

      // Return the next object from the pool if one exists.
      if (self._html5AudioPool.length) {
        return self._html5AudioPool.pop();
      }

      //.Check if the audio is locked and throw a warning.
      var testPlay = new Audio().play();
      if (testPlay && typeof Promise !== 'undefined' && (testPlay instanceof Promise || typeof testPlay.then === 'function')) {
        testPlay.catch(function() {
          console.warn('HTML5 Audio pool exhausted, returning potentially locked audio object.');
        });
      }

      return new Audio();
    },

    /**
     * Return an activated HTML5 Audio object to the pool.
     * @return {Howler}
     */
    _releaseHtml5Audio: function(audio) {
      var self = this || Howler;

      // Don't add audio to the pool if we don't know if it has been unlocked.
      if (audio._unlocked) {
        self._html5AudioPool.push(audio);
      }

      return self;
    },

    /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */
    _autoSuspend: function() {
      var self = this;

      if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === 'undefined' || !Howler.usingWebAudio) {
        return;
      }

      // Check if any sounds are playing.
      for (var i=0; i<self._howls.length; i++) {
        if (self._howls[i]._webAudio) {
          for (var j=0; j<self._howls[i]._sounds.length; j++) {
            if (!self._howls[i]._sounds[j]._paused) {
              return self;
            }
          }
        }
      }

      if (self._suspendTimer) {
        clearTimeout(self._suspendTimer);
      }

      // If no sound has played after 30 seconds, suspend the context.
      self._suspendTimer = setTimeout(function() {
        if (!self.autoSuspend) {
          return;
        }

        self._suspendTimer = null;
        self.state = 'suspending';

        // Handle updating the state of the audio context after suspending.
        var handleSuspension = function() {
          self.state = 'suspended';

          if (self._resumeAfterSuspend) {
            delete self._resumeAfterSuspend;
            self._autoResume();
          }
        };

        // Either the state gets suspended or it is interrupted.
        // Either way, we need to update the state to suspended.
        self.ctx.suspend().then(handleSuspension, handleSuspension);
      }, 30000);

      return self;
    },

    /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */
    _autoResume: function() {
      var self = this;

      if (!self.ctx || typeof self.ctx.resume === 'undefined' || !Howler.usingWebAudio) {
        return;
      }

      if (self.state === 'running' && self.ctx.state !== 'interrupted' && self._suspendTimer) {
        clearTimeout(self._suspendTimer);
        self._suspendTimer = null;
      } else if (self.state === 'suspended' || self.state === 'running' && self.ctx.state === 'interrupted') {
        self.ctx.resume().then(function() {
          self.state = 'running';

          // Emit to all Howls that the audio has resumed.
          for (var i=0; i<self._howls.length; i++) {
            self._howls[i]._emit('resume');
          }
        });

        if (self._suspendTimer) {
          clearTimeout(self._suspendTimer);
          self._suspendTimer = null;
        }
      } else if (self.state === 'suspending') {
        self._resumeAfterSuspend = true;
      }

      return self;
    }
  };

  // Setup the global audio controller.
  var Howler = new HowlerGlobal();

  /** Group Methods **/
  /***************************************************************************/

  /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */
  var Howl = function(o) {
    var self = this;

    // Throw an error if no source is provided.
    if (!o.src || o.src.length === 0) {
      console.error('An array of source files must be passed with any new Howl.');
      return;
    }

    self.init(o);
  };
  Howl.prototype = {
    /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */
    init: function(o) {
      var self = this;

      // If we don't have an AudioContext created yet, run the setup.
      if (!Howler.ctx) {
        setupAudioContext();
      }

      // Setup user-defined default properties.
      self._autoplay = o.autoplay || false;
      self._format = (typeof o.format !== 'string') ? o.format : [o.format];
      self._html5 = o.html5 || false;
      self._muted = o.mute || false;
      self._loop = o.loop || false;
      self._pool = o.pool || 5;
      self._preload = (typeof o.preload === 'boolean' || o.preload === 'metadata') ? o.preload : true;
      self._rate = o.rate || 1;
      self._sprite = o.sprite || {};
      self._src = (typeof o.src !== 'string') ? o.src : [o.src];
      self._volume = o.volume !== undefined ? o.volume : 1;
      self._xhr = {
        method: o.xhr && o.xhr.method ? o.xhr.method : 'GET',
        headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
        withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : false,
      };

      // Setup all other default properties.
      self._duration = 0;
      self._state = 'unloaded';
      self._sounds = [];
      self._endTimers = {};
      self._queue = [];
      self._playLock = false;

      // Setup event listeners.
      self._onend = o.onend ? [{fn: o.onend}] : [];
      self._onfade = o.onfade ? [{fn: o.onfade}] : [];
      self._onload = o.onload ? [{fn: o.onload}] : [];
      self._onloaderror = o.onloaderror ? [{fn: o.onloaderror}] : [];
      self._onplayerror = o.onplayerror ? [{fn: o.onplayerror}] : [];
      self._onpause = o.onpause ? [{fn: o.onpause}] : [];
      self._onplay = o.onplay ? [{fn: o.onplay}] : [];
      self._onstop = o.onstop ? [{fn: o.onstop}] : [];
      self._onmute = o.onmute ? [{fn: o.onmute}] : [];
      self._onvolume = o.onvolume ? [{fn: o.onvolume}] : [];
      self._onrate = o.onrate ? [{fn: o.onrate}] : [];
      self._onseek = o.onseek ? [{fn: o.onseek}] : [];
      self._onunlock = o.onunlock ? [{fn: o.onunlock}] : [];
      self._onresume = [];

      // Web Audio or HTML5 Audio?
      self._webAudio = Howler.usingWebAudio && !self._html5;

      // Automatically try to enable audio.
      if (typeof Howler.ctx !== 'undefined' && Howler.ctx && Howler.autoUnlock) {
        Howler._unlockAudio();
      }

      // Keep track of this Howl group in the global controller.
      Howler._howls.push(self);

      // If they selected autoplay, add a play event to the load queue.
      if (self._autoplay) {
        self._queue.push({
          event: 'play',
          action: function() {
            self.play();
          }
        });
      }

      // Load the source file unless otherwise specified.
      if (self._preload && self._preload !== 'none') {
        self.load();
      }

      return self;
    },

    /**
     * Load the audio file.
     * @return {Howler}
     */
    load: function() {
      var self = this;
      var url = null;

      // If no audio is available, quit immediately.
      if (Howler.noAudio) {
        self._emit('loaderror', null, 'No audio support.');
        return;
      }

      // Make sure our source is in an array.
      if (typeof self._src === 'string') {
        self._src = [self._src];
      }

      // Loop through the sources and pick the first one that is compatible.
      for (var i=0; i<self._src.length; i++) {
        var ext, str;

        if (self._format && self._format[i]) {
          // If an extension was specified, use that instead.
          ext = self._format[i];
        } else {
          // Make sure the source is a string.
          str = self._src[i];
          if (typeof str !== 'string') {
            self._emit('loaderror', null, 'Non-string found in selected audio sources - ignoring.');
            continue;
          }

          // Extract the file extension from the URL or base64 data URI.
          ext = /^data:audio\/([^;,]+);/i.exec(str);
          if (!ext) {
            ext = /\.([^.]+)$/.exec(str.split('?', 1)[0]);
          }

          if (ext) {
            ext = ext[1].toLowerCase();
          }
        }

        // Log a warning if no extension was found.
        if (!ext) {
          console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
        }

        // Check if this extension is available.
        if (ext && Howler.codecs(ext)) {
          url = self._src[i];
          break;
        }
      }

      if (!url) {
        self._emit('loaderror', null, 'No codec support for selected audio sources.');
        return;
      }

      self._src = url;
      self._state = 'loading';

      // If the hosting page is HTTPS and the source isn't,
      // drop down to HTML5 Audio to avoid Mixed Content errors.
      if (window.location.protocol === 'https:' && url.slice(0, 5) === 'http:') {
        self._html5 = true;
        self._webAudio = false;
      }

      // Create a new sound object and add it to the pool.
      new Sound(self);

      // Load and decode the audio data for playback.
      if (self._webAudio) {
        loadBuffer(self);
      }

      return self;
    },

    /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */
    play: function(sprite, internal) {
      var self = this;
      var id = null;

      // Determine if a sprite, sound id or nothing was passed
      if (typeof sprite === 'number') {
        id = sprite;
        sprite = null;
      } else if (typeof sprite === 'string' && self._state === 'loaded' && !self._sprite[sprite]) {
        // If the passed sprite doesn't exist, do nothing.
        return null;
      } else if (typeof sprite === 'undefined') {
        // Use the default sound sprite (plays the full audio length).
        sprite = '__default';

        // Check if there is a single paused sound that isn't ended.
        // If there is, play that sound. If not, continue as usual.
        if (!self._playLock) {
          var num = 0;
          for (var i=0; i<self._sounds.length; i++) {
            if (self._sounds[i]._paused && !self._sounds[i]._ended) {
              num++;
              id = self._sounds[i]._id;
            }
          }

          if (num === 1) {
            sprite = null;
          } else {
            id = null;
          }
        }
      }

      // Get the selected node, or get one from the pool.
      var sound = id ? self._soundById(id) : self._inactiveSound();

      // If the sound doesn't exist, do nothing.
      if (!sound) {
        return null;
      }

      // Select the sprite definition.
      if (id && !sprite) {
        sprite = sound._sprite || '__default';
      }

      // If the sound hasn't loaded, we must wait to get the audio's duration.
      // We also need to wait to make sure we don't run into race conditions with
      // the order of function calls.
      if (self._state !== 'loaded') {
        // Set the sprite value on this sound.
        sound._sprite = sprite;

        // Mark this sound as not ended in case another sound is played before this one loads.
        sound._ended = false;

        // Add the sound to the queue to be played on load.
        var soundId = sound._id;
        self._queue.push({
          event: 'play',
          action: function() {
            self.play(soundId);
          }
        });

        return soundId;
      }

      // Don't play the sound if an id was passed and it is already playing.
      if (id && !sound._paused) {
        // Trigger the play event, in order to keep iterating through queue.
        if (!internal) {
          self._loadQueue('play');
        }

        return sound._id;
      }

      // Make sure the AudioContext isn't suspended, and resume it if it is.
      if (self._webAudio) {
        Howler._autoResume();
      }

      // Determine how long to play for and where to start playing.
      var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
      var duration = Math.max(0, ((self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000) - seek);
      var timeout = (duration * 1000) / Math.abs(sound._rate);
      var start = self._sprite[sprite][0] / 1000;
      var stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
      sound._sprite = sprite;

      // Mark the sound as ended instantly so that this async playback
      // doesn't get grabbed by another call to play while this one waits to start.
      sound._ended = false;

      // Update the parameters of the sound.
      var setParams = function() {
        sound._paused = false;
        sound._seek = seek;
        sound._start = start;
        sound._stop = stop;
        sound._loop = !!(sound._loop || self._sprite[sprite][2]);
      };

      // End the sound instantly if seek is at the end.
      if (seek >= stop) {
        self._ended(sound);
        return;
      }

      // Begin the actual playback.
      var node = sound._node;
      if (self._webAudio) {
        // Fire this when the sound is ready to play to begin Web Audio playback.
        var playWebAudio = function() {
          self._playLock = false;
          setParams();
          self._refreshBuffer(sound);

          // Setup the playback params.
          var vol = (sound._muted || self._muted) ? 0 : sound._volume;
          node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
          sound._playStart = Howler.ctx.currentTime;

          // Play the sound using the supported method.
          if (typeof node.bufferSource.start === 'undefined') {
            sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
          } else {
            sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
          }

          // Start a new timer if none is present.
          if (timeout !== Infinity) {
            self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
          }

          if (!internal) {
            setTimeout(function() {
              self._emit('play', sound._id);
              self._loadQueue();
            }, 0);
          }
        };

        if (Howler.state === 'running' && Howler.ctx.state !== 'interrupted') {
          playWebAudio();
        } else {
          self._playLock = true;

          // Wait for the audio context to resume before playing.
          self.once('resume', playWebAudio);

          // Cancel the end timer.
          self._clearTimer(sound._id);
        }
      } else {
        // Fire this when the sound is ready to play to begin HTML5 Audio playback.
        var playHtml5 = function() {
          node.currentTime = seek;
          node.muted = sound._muted || self._muted || Howler._muted || node.muted;
          node.volume = sound._volume * Howler.volume();
          node.playbackRate = sound._rate;

          // Some browsers will throw an error if this is called without user interaction.
          try {
            var play = node.play();

            // Support older browsers that don't support promises, and thus don't have this issue.
            if (play && typeof Promise !== 'undefined' && (play instanceof Promise || typeof play.then === 'function')) {
              // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
              self._playLock = true;

              // Set param values immediately.
              setParams();

              // Releases the lock and executes queued actions.
              play
                .then(function() {
                  self._playLock = false;
                  node._unlocked = true;
                  if (!internal) {
                    self._emit('play', sound._id);
                  } else {
                    self._loadQueue();
                  }
                })
                .catch(function() {
                  self._playLock = false;
                  self._emit('playerror', sound._id, 'Playback was unable to start. This is most commonly an issue ' +
                    'on mobile devices and Chrome where playback was not within a user interaction.');

                  // Reset the ended and paused values.
                  sound._ended = true;
                  sound._paused = true;
                });
            } else if (!internal) {
              self._playLock = false;
              setParams();
              self._emit('play', sound._id);
            }

            // Setting rate before playing won't work in IE, so we set it again here.
            node.playbackRate = sound._rate;

            // If the node is still paused, then we can assume there was a playback issue.
            if (node.paused) {
              self._emit('playerror', sound._id, 'Playback was unable to start. This is most commonly an issue ' +
                'on mobile devices and Chrome where playback was not within a user interaction.');
              return;
            }

            // Setup the end timer on sprites or listen for the ended event.
            if (sprite !== '__default' || sound._loop) {
              self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            } else {
              self._endTimers[sound._id] = function() {
                // Fire ended on this audio node.
                self._ended(sound);

                // Clear this listener.
                node.removeEventListener('ended', self._endTimers[sound._id], false);
              };
              node.addEventListener('ended', self._endTimers[sound._id], false);
            }
          } catch (err) {
            self._emit('playerror', sound._id, err);
          }
        };

        // If this is streaming audio, make sure the src is set and load again.
        if (node.src === 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA') {
          node.src = self._src;
          node.load();
        }

        // Play immediately if ready, or wait for the 'canplaythrough'e vent.
        var loadedNoReadyState = (window && window.ejecta) || (!node.readyState && Howler._navigator.isCocoonJS);
        if (node.readyState >= 3 || loadedNoReadyState) {
          playHtml5();
        } else {
          self._playLock = true;
          self._state = 'loading';

          var listener = function() {
            self._state = 'loaded';
            
            // Begin playback.
            playHtml5();

            // Clear this listener.
            node.removeEventListener(Howler._canPlayEvent, listener, false);
          };
          node.addEventListener(Howler._canPlayEvent, listener, false);

          // Cancel the end timer.
          self._clearTimer(sound._id);
        }
      }

      return sound._id;
    },

    /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */
    pause: function(id) {
      var self = this;

      // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
      if (self._state !== 'loaded' || self._playLock) {
        self._queue.push({
          event: 'pause',
          action: function() {
            self.pause(id);
          }
        });

        return self;
      }

      // If no id is passed, get all ID's to be paused.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Clear the end timer.
        self._clearTimer(ids[i]);

        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound && !sound._paused) {
          // Reset the seek position.
          sound._seek = self.seek(ids[i]);
          sound._rateSeek = 0;
          sound._paused = true;

          // Stop currently running fades.
          self._stopFade(ids[i]);

          if (sound._node) {
            if (self._webAudio) {
              // Make sure the sound has been created.
              if (!sound._node.bufferSource) {
                continue;
              }

              if (typeof sound._node.bufferSource.stop === 'undefined') {
                sound._node.bufferSource.noteOff(0);
              } else {
                sound._node.bufferSource.stop(0);
              }

              // Clean up the buffer source.
              self._cleanBuffer(sound._node);
            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
              sound._node.pause();
            }
          }
        }

        // Fire the pause event, unless `true` is passed as the 2nd argument.
        if (!arguments[1]) {
          self._emit('pause', sound ? sound._id : null);
        }
      }

      return self;
    },

    /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */
    stop: function(id, internal) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to stop when capable.
      if (self._state !== 'loaded' || self._playLock) {
        self._queue.push({
          event: 'stop',
          action: function() {
            self.stop(id);
          }
        });

        return self;
      }

      // If no id is passed, get all ID's to be stopped.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Clear the end timer.
        self._clearTimer(ids[i]);

        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound) {
          // Reset the seek position.
          sound._seek = sound._start || 0;
          sound._rateSeek = 0;
          sound._paused = true;
          sound._ended = true;

          // Stop currently running fades.
          self._stopFade(ids[i]);

          if (sound._node) {
            if (self._webAudio) {
              // Make sure the sound's AudioBufferSourceNode has been created.
              if (sound._node.bufferSource) {
                if (typeof sound._node.bufferSource.stop === 'undefined') {
                  sound._node.bufferSource.noteOff(0);
                } else {
                  sound._node.bufferSource.stop(0);
                }

                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
              }
            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
              sound._node.currentTime = sound._start || 0;
              sound._node.pause();

              // If this is a live stream, stop download once the audio is stopped.
              if (sound._node.duration === Infinity) {
                self._clearSound(sound._node);
              }
            }
          }

          if (!internal) {
            self._emit('stop', sound._id);
          }
        }
      }

      return self;
    },

    /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */
    mute: function(muted, id) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to mute when capable.
      if (self._state !== 'loaded'|| self._playLock) {
        self._queue.push({
          event: 'mute',
          action: function() {
            self.mute(muted, id);
          }
        });

        return self;
      }

      // If applying mute/unmute to all sounds, update the group's value.
      if (typeof id === 'undefined') {
        if (typeof muted === 'boolean') {
          self._muted = muted;
        } else {
          return self._muted;
        }
      }

      // If no id is passed, get all ID's to be muted.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound) {
          sound._muted = muted;

          // Cancel active fade and set the volume to the end value.
          if (sound._interval) {
            self._stopFade(sound._id);
          }

          if (self._webAudio && sound._node) {
            sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler.ctx.currentTime);
          } else if (sound._node) {
            sound._node.muted = Howler._muted ? true : muted;
          }

          self._emit('mute', sound._id);
        }
      }

      return self;
    },

    /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */
    volume: function() {
      var self = this;
      var args = arguments;
      var vol, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // Return the value of the groups' volume.
        return self._volume;
      } else if (args.length === 1 || args.length === 2 && typeof args[1] === 'undefined') {
        // First check if this is an ID, and if not, assume it is a new volume.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          vol = parseFloat(args[0]);
        }
      } else if (args.length >= 2) {
        vol = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // Update the volume or return the current volume.
      var sound;
      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
        // If the sound hasn't loaded, add it to the load queue to change volume when capable.
        if (self._state !== 'loaded'|| self._playLock) {
          self._queue.push({
            event: 'volume',
            action: function() {
              self.volume.apply(self, args);
            }
          });

          return self;
        }

        // Set the group volume.
        if (typeof id === 'undefined') {
          self._volume = vol;
        }

        // Update one or all volumes.
        id = self._getSoundIds(id);
        for (var i=0; i<id.length; i++) {
          // Get the sound.
          sound = self._soundById(id[i]);

          if (sound) {
            sound._volume = vol;

            // Stop currently running fades.
            if (!args[2]) {
              self._stopFade(id[i]);
            }

            if (self._webAudio && sound._node && !sound._muted) {
              sound._node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
            } else if (sound._node && !sound._muted) {
              sound._node.volume = vol * Howler.volume();
            }

            self._emit('volume', sound._id);
          }
        }
      } else {
        sound = id ? self._soundById(id) : self._sounds[0];
        return sound ? sound._volume : 0;
      }

      return self;
    },

    /**
     * Fade a currently playing sound between two volumes (if no id is passed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */
    fade: function(from, to, len, id) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to fade when capable.
      if (self._state !== 'loaded' || self._playLock) {
        self._queue.push({
          event: 'fade',
          action: function() {
            self.fade(from, to, len, id);
          }
        });

        return self;
      }

      // Make sure the to/from/len values are numbers.
      from = Math.min(Math.max(0, parseFloat(from)), 1);
      to = Math.min(Math.max(0, parseFloat(to)), 1);
      len = parseFloat(len);

      // Set the volume to the start position.
      self.volume(from, id);

      // Fade the volume of one or all sounds.
      var ids = self._getSoundIds(id);
      for (var i=0; i<ids.length; i++) {
        // Get the sound.
        var sound = self._soundById(ids[i]);

        // Create a linear fade or fall back to timeouts with HTML5 Audio.
        if (sound) {
          // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
          if (!id) {
            self._stopFade(ids[i]);
          }

          // If we are using Web Audio, let the native methods do the actual fade.
          if (self._webAudio && !sound._muted) {
            var currentTime = Howler.ctx.currentTime;
            var end = currentTime + (len / 1000);
            sound._volume = from;
            sound._node.gain.setValueAtTime(from, currentTime);
            sound._node.gain.linearRampToValueAtTime(to, end);
          }

          self._startFadeInterval(sound, from, to, len, ids[i], typeof id === 'undefined');
        }
      }

      return self;
    },

    /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */
    _startFadeInterval: function(sound, from, to, len, id, isGroup) {
      var self = this;
      var vol = from;
      var diff = to - from;
      var steps = Math.abs(diff / 0.01);
      var stepLen = Math.max(4, (steps > 0) ? len / steps : len);
      var lastTick = Date.now();

      // Store the value being faded to.
      sound._fadeTo = to;

      // Update the volume value on each interval tick.
      sound._interval = setInterval(function() {
        // Update the volume based on the time since the last tick.
        var tick = (Date.now() - lastTick) / len;
        lastTick = Date.now();
        vol += diff * tick;

        // Round to within 2 decimal points.
        vol = Math.round(vol * 100) / 100;

        // Make sure the volume is in the right bounds.
        if (diff < 0) {
          vol = Math.max(to, vol);
        } else {
          vol = Math.min(to, vol);
        }

        // Change the volume.
        if (self._webAudio) {
          sound._volume = vol;
        } else {
          self.volume(vol, sound._id, true);
        }

        // Set the group's volume.
        if (isGroup) {
          self._volume = vol;
        }

        // When the fade is complete, stop it and fire event.
        if ((to < from && vol <= to) || (to > from && vol >= to)) {
          clearInterval(sound._interval);
          sound._interval = null;
          sound._fadeTo = null;
          self.volume(to, sound._id);
          self._emit('fade', sound._id);
        }
      }, stepLen);
    },

    /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */
    _stopFade: function(id) {
      var self = this;
      var sound = self._soundById(id);

      if (sound && sound._interval) {
        if (self._webAudio) {
          sound._node.gain.cancelScheduledValues(Howler.ctx.currentTime);
        }

        clearInterval(sound._interval);
        sound._interval = null;
        self.volume(sound._fadeTo, id);
        sound._fadeTo = null;
        self._emit('fade', id);
      }

      return self;
    },

    /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */
    loop: function() {
      var self = this;
      var args = arguments;
      var loop, id, sound;

      // Determine the values for loop and id.
      if (args.length === 0) {
        // Return the grou's loop value.
        return self._loop;
      } else if (args.length === 1) {
        if (typeof args[0] === 'boolean') {
          loop = args[0];
          self._loop = loop;
        } else {
          // Return this sound's loop value.
          sound = self._soundById(parseInt(args[0], 10));
          return sound ? sound._loop : false;
        }
      } else if (args.length === 2) {
        loop = args[0];
        id = parseInt(args[1], 10);
      }

      // If no id is passed, get all ID's to be looped.
      var ids = self._getSoundIds(id);
      for (var i=0; i<ids.length; i++) {
        sound = self._soundById(ids[i]);

        if (sound) {
          sound._loop = loop;
          if (self._webAudio && sound._node && sound._node.bufferSource) {
            sound._node.bufferSource.loop = loop;
            if (loop) {
              sound._node.bufferSource.loopStart = sound._start || 0;
              sound._node.bufferSource.loopEnd = sound._stop;

              // If playing, restart playback to ensure looping updates.
              if (self.playing(ids[i])) {
                self.pause(ids[i], true);
                self.play(ids[i], true);
              }
            }
          }
        }
      }

      return self;
    },

    /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */
    rate: function() {
      var self = this;
      var args = arguments;
      var rate, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // We will simply return the current rate of the first node.
        id = self._sounds[0]._id;
      } else if (args.length === 1) {
        // First check if this is an ID, and if not, assume it is a new rate value.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          rate = parseFloat(args[0]);
        }
      } else if (args.length === 2) {
        rate = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // Update the playback rate or return the current value.
      var sound;
      if (typeof rate === 'number') {
        // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
        if (self._state !== 'loaded' || self._playLock) {
          self._queue.push({
            event: 'rate',
            action: function() {
              self.rate.apply(self, args);
            }
          });

          return self;
        }

        // Set the group rate.
        if (typeof id === 'undefined') {
          self._rate = rate;
        }

        // Update one or all volumes.
        id = self._getSoundIds(id);
        for (var i=0; i<id.length; i++) {
          // Get the sound.
          sound = self._soundById(id[i]);

          if (sound) {
            // Keep track of our position when the rate changed and update the playback
            // start position so we can properly adjust the seek position for time elapsed.
            if (self.playing(id[i])) {
              sound._rateSeek = self.seek(id[i]);
              sound._playStart = self._webAudio ? Howler.ctx.currentTime : sound._playStart;
            }
            sound._rate = rate;

            // Change the playback rate.
            if (self._webAudio && sound._node && sound._node.bufferSource) {
              sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler.ctx.currentTime);
            } else if (sound._node) {
              sound._node.playbackRate = rate;
            }

            // Reset the timers.
            var seek = self.seek(id[i]);
            var duration = ((self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000) - seek;
            var timeout = (duration * 1000) / Math.abs(sound._rate);

            // Start a new end timer if sound is already playing.
            if (self._endTimers[id[i]] || !sound._paused) {
              self._clearTimer(id[i]);
              self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
            }

            self._emit('rate', sound._id);
          }
        }
      } else {
        sound = self._soundById(id);
        return sound ? sound._rate : self._rate;
      }

      return self;
    },

    /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */
    seek: function() {
      var self = this;
      var args = arguments;
      var seek, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // We will simply return the current position of the first node.
        if (self._sounds.length) {
          id = self._sounds[0]._id;
        }
      } else if (args.length === 1) {
        // First check if this is an ID, and if not, assume it is a new seek position.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else if (self._sounds.length) {
          id = self._sounds[0]._id;
          seek = parseFloat(args[0]);
        }
      } else if (args.length === 2) {
        seek = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // If there is no ID, bail out.
      if (typeof id === 'undefined') {
        return 0;
      }

      // If the sound hasn't loaded, add it to the load queue to seek when capable.
      if (typeof seek === 'number' && (self._state !== 'loaded' || self._playLock)) {
        self._queue.push({
          event: 'seek',
          action: function() {
            self.seek.apply(self, args);
          }
        });

        return self;
      }

      // Get the sound.
      var sound = self._soundById(id);

      if (sound) {
        if (typeof seek === 'number' && seek >= 0) {
          // Pause the sound and update position for restarting playback.
          var playing = self.playing(id);
          if (playing) {
            self.pause(id, true);
          }

          // Move the position of the track and cancel timer.
          sound._seek = seek;
          sound._ended = false;
          self._clearTimer(id);

          // Update the seek position for HTML5 Audio.
          if (!self._webAudio && sound._node && !isNaN(sound._node.duration)) {
            sound._node.currentTime = seek;
          }

          // Seek and emit when ready.
          var seekAndEmit = function() {
            // Restart the playback if the sound was playing.
            if (playing) {
              self.play(id, true);
            }

            self._emit('seek', id);
          };

          // Wait for the play lock to be unset before emitting (HTML5 Audio).
          if (playing && !self._webAudio) {
            var emitSeek = function() {
              if (!self._playLock) {
                seekAndEmit();
              } else {
                setTimeout(emitSeek, 0);
              }
            };
            setTimeout(emitSeek, 0);
          } else {
            seekAndEmit();
          }
        } else {
          if (self._webAudio) {
            var realTime = self.playing(id) ? Howler.ctx.currentTime - sound._playStart : 0;
            var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
            return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
          } else {
            return sound._node.currentTime;
          }
        }
      }

      return self;
    },

    /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */
    playing: function(id) {
      var self = this;

      // Check the passed sound ID (if any).
      if (typeof id === 'number') {
        var sound = self._soundById(id);
        return sound ? !sound._paused : false;
      }

      // Otherwise, loop through all sounds and check if any are playing.
      for (var i=0; i<self._sounds.length; i++) {
        if (!self._sounds[i]._paused) {
          return true;
        }
      }

      return false;
    },

    /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */
    duration: function(id) {
      var self = this;
      var duration = self._duration;

      // If we pass an ID, get the sound and return the sprite length.
      var sound = self._soundById(id);
      if (sound) {
        duration = self._sprite[sound._sprite][1] / 1000;
      }

      return duration;
    },

    /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */
    state: function() {
      return this._state;
    },

    /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */
    unload: function() {
      var self = this;

      // Stop playing any active sounds.
      var sounds = self._sounds;
      for (var i=0; i<sounds.length; i++) {
        // Stop the sound if it is currently playing.
        if (!sounds[i]._paused) {
          self.stop(sounds[i]._id);
        }

        // Remove the source or disconnect.
        if (!self._webAudio) {
          // Set the source to 0-second silence to stop any downloading (except in IE).
          self._clearSound(sounds[i]._node);

          // Remove any event listeners.
          sounds[i]._node.removeEventListener('error', sounds[i]._errorFn, false);
          sounds[i]._node.removeEventListener(Howler._canPlayEvent, sounds[i]._loadFn, false);
          sounds[i]._node.removeEventListener('ended', sounds[i]._endFn, false);

          // Release the Audio object back to the pool.
          Howler._releaseHtml5Audio(sounds[i]._node);
        }

        // Empty out all of the nodes.
        delete sounds[i]._node;

        // Make sure all timers are cleared out.
        self._clearTimer(sounds[i]._id);
      }

      // Remove the references in the global Howler object.
      var index = Howler._howls.indexOf(self);
      if (index >= 0) {
        Howler._howls.splice(index, 1);
      }

      // Delete this sound from the cache (if no other Howl is using it).
      var remCache = true;
      for (i=0; i<Howler._howls.length; i++) {
        if (Howler._howls[i]._src === self._src || self._src.indexOf(Howler._howls[i]._src) >= 0) {
          remCache = false;
          break;
        }
      }

      if (cache && remCache) {
        delete cache[self._src];
      }

      // Clear global errors.
      Howler.noAudio = false;

      // Clear out `self`.
      self._state = 'unloaded';
      self._sounds = [];
      self = null;

      return null;
    },

    /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */
    on: function(event, fn, id, once) {
      var self = this;
      var events = self['_on' + event];

      if (typeof fn === 'function') {
        events.push(once ? {id: id, fn: fn, once: once} : {id: id, fn: fn});
      }

      return self;
    },

    /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */
    off: function(event, fn, id) {
      var self = this;
      var events = self['_on' + event];
      var i = 0;

      // Allow passing just an event and ID.
      if (typeof fn === 'number') {
        id = fn;
        fn = null;
      }

      if (fn || id) {
        // Loop through event store and remove the passed function.
        for (i=0; i<events.length; i++) {
          var isId = (id === events[i].id);
          if (fn === events[i].fn && isId || !fn && isId) {
            events.splice(i, 1);
            break;
          }
        }
      } else if (event) {
        // Clear out all events of this type.
        self['_on' + event] = [];
      } else {
        // Clear out all events of every type.
        var keys = Object.keys(self);
        for (i=0; i<keys.length; i++) {
          if ((keys[i].indexOf('_on') === 0) && Array.isArray(self[keys[i]])) {
            self[keys[i]] = [];
          }
        }
      }

      return self;
    },

    /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */
    once: function(event, fn, id) {
      var self = this;

      // Setup the event listener.
      self.on(event, fn, id, 1);

      return self;
    },

    /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */
    _emit: function(event, id, msg) {
      var self = this;
      var events = self['_on' + event];

      // Loop through event store and fire all functions.
      for (var i=events.length-1; i>=0; i--) {
        // Only fire the listener if the correct ID is used.
        if (!events[i].id || events[i].id === id || event === 'load') {
          setTimeout(function(fn) {
            fn.call(this, id, msg);
          }.bind(self, events[i].fn), 0);

          // If this event was setup with `once`, remove it.
          if (events[i].once) {
            self.off(event, events[i].fn, events[i].id);
          }
        }
      }

      // Pass the event type into load queue so that it can continue stepping.
      self._loadQueue(event);

      return self;
    },

    /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */
    _loadQueue: function(event) {
      var self = this;

      if (self._queue.length > 0) {
        var task = self._queue[0];

        // Remove this task if a matching event was passed.
        if (task.event === event) {
          self._queue.shift();
          self._loadQueue();
        }

        // Run the task if no event type is passed.
        if (!event) {
          task.action();
        }
      }

      return self;
    },

    /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */
    _ended: function(sound) {
      var self = this;
      var sprite = sound._sprite;

      // If we are using IE and there was network latency we may be clipping
      // audio before it completes playing. Lets check the node to make sure it
      // believes it has completed, before ending the playback.
      if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
        setTimeout(self._ended.bind(self, sound), 100);
        return self;
      }

      // Should this sound loop?
      var loop = !!(sound._loop || self._sprite[sprite][2]);

      // Fire the ended event.
      self._emit('end', sound._id);

      // Restart the playback for HTML5 Audio loop.
      if (!self._webAudio && loop) {
        self.stop(sound._id, true).play(sound._id);
      }

      // Restart this timer if on a Web Audio loop.
      if (self._webAudio && loop) {
        self._emit('play', sound._id);
        sound._seek = sound._start || 0;
        sound._rateSeek = 0;
        sound._playStart = Howler.ctx.currentTime;

        var timeout = ((sound._stop - sound._start) * 1000) / Math.abs(sound._rate);
        self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
      }

      // Mark the node as paused.
      if (self._webAudio && !loop) {
        sound._paused = true;
        sound._ended = true;
        sound._seek = sound._start || 0;
        sound._rateSeek = 0;
        self._clearTimer(sound._id);

        // Clean up the buffer source.
        self._cleanBuffer(sound._node);

        // Attempt to auto-suspend AudioContext if no sounds are still playing.
        Howler._autoSuspend();
      }

      // When using a sprite, end the track.
      if (!self._webAudio && !loop) {
        self.stop(sound._id, true);
      }

      return self;
    },

    /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */
    _clearTimer: function(id) {
      var self = this;

      if (self._endTimers[id]) {
        // Clear the timeout or remove the ended listener.
        if (typeof self._endTimers[id] !== 'function') {
          clearTimeout(self._endTimers[id]);
        } else {
          var sound = self._soundById(id);
          if (sound && sound._node) {
            sound._node.removeEventListener('ended', self._endTimers[id], false);
          }
        }

        delete self._endTimers[id];
      }

      return self;
    },

    /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */
    _soundById: function(id) {
      var self = this;

      // Loop through all sounds and find the one with this ID.
      for (var i=0; i<self._sounds.length; i++) {
        if (id === self._sounds[i]._id) {
          return self._sounds[i];
        }
      }

      return null;
    },

    /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */
    _inactiveSound: function() {
      var self = this;

      self._drain();

      // Find the first inactive node to recycle.
      for (var i=0; i<self._sounds.length; i++) {
        if (self._sounds[i]._ended) {
          return self._sounds[i].reset();
        }
      }

      // If no inactive node was found, create a new one.
      return new Sound(self);
    },

    /**
     * Drain excess inactive sounds from the pool.
     */
    _drain: function() {
      var self = this;
      var limit = self._pool;
      var cnt = 0;
      var i = 0;

      // If there are less sounds than the max pool size, we are done.
      if (self._sounds.length < limit) {
        return;
      }

      // Count the number of inactive sounds.
      for (i=0; i<self._sounds.length; i++) {
        if (self._sounds[i]._ended) {
          cnt++;
        }
      }

      // Remove excess inactive sounds, going in reverse order.
      for (i=self._sounds.length - 1; i>=0; i--) {
        if (cnt <= limit) {
          return;
        }

        if (self._sounds[i]._ended) {
          // Disconnect the audio source when using Web Audio.
          if (self._webAudio && self._sounds[i]._node) {
            self._sounds[i]._node.disconnect(0);
          }

          // Remove sounds until we have the pool size.
          self._sounds.splice(i, 1);
          cnt--;
        }
      }
    },

    /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */
    _getSoundIds: function(id) {
      var self = this;

      if (typeof id === 'undefined') {
        var ids = [];
        for (var i=0; i<self._sounds.length; i++) {
          ids.push(self._sounds[i]._id);
        }

        return ids;
      } else {
        return [id];
      }
    },

    /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */
    _refreshBuffer: function(sound) {
      var self = this;

      // Setup the buffer source for playback.
      sound._node.bufferSource = Howler.ctx.createBufferSource();
      sound._node.bufferSource.buffer = cache[self._src];

      // Connect to the correct node.
      if (sound._panner) {
        sound._node.bufferSource.connect(sound._panner);
      } else {
        sound._node.bufferSource.connect(sound._node);
      }

      // Setup looping and playback rate.
      sound._node.bufferSource.loop = sound._loop;
      if (sound._loop) {
        sound._node.bufferSource.loopStart = sound._start || 0;
        sound._node.bufferSource.loopEnd = sound._stop || 0;
      }
      sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler.ctx.currentTime);

      return self;
    },

    /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */
    _cleanBuffer: function(node) {
      var self = this;
      var isIOS = Howler._navigator && Howler._navigator.vendor.indexOf('Apple') >= 0;

      if (Howler._scratchBuffer && node.bufferSource) {
        node.bufferSource.onended = null;
        node.bufferSource.disconnect(0);
        if (isIOS) {
          try { node.bufferSource.buffer = Howler._scratchBuffer; } catch(e) {}
        }
      }
      node.bufferSource = null;

      return self;
    },

    /**
     * Set the source to a 0-second silence to stop any downloading (except in IE).
     * @param  {Object} node Audio node to clear.
     */
    _clearSound: function(node) {
      var checkIE = /MSIE |Trident\//.test(Howler._navigator && Howler._navigator.userAgent);
      if (!checkIE) {
        node.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
      }
    }
  };

  /** Single Sound Methods **/
  /***************************************************************************/

  /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */
  var Sound = function(howl) {
    this._parent = howl;
    this.init();
  };
  Sound.prototype = {
    /**
     * Initialize a new Sound object.
     * @return {Sound}
     */
    init: function() {
      var self = this;
      var parent = self._parent;

      // Setup the default parameters.
      self._muted = parent._muted;
      self._loop = parent._loop;
      self._volume = parent._volume;
      self._rate = parent._rate;
      self._seek = 0;
      self._paused = true;
      self._ended = true;
      self._sprite = '__default';

      // Generate a unique ID for this sound.
      self._id = ++Howler._counter;

      // Add itself to the parent's pool.
      parent._sounds.push(self);

      // Create the new node.
      self.create();

      return self;
    },

    /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */
    create: function() {
      var self = this;
      var parent = self._parent;
      var volume = (Howler._muted || self._muted || self._parent._muted) ? 0 : self._volume;

      if (parent._webAudio) {
        // Create the gain node for controlling volume (the source will connect to this).
        self._node = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
        self._node.gain.setValueAtTime(volume, Howler.ctx.currentTime);
        self._node.paused = true;
        self._node.connect(Howler.masterGain);
      } else if (!Howler.noAudio) {
        // Get an unlocked Audio object from the pool.
        self._node = Howler._obtainHtml5Audio();

        // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
        self._errorFn = self._errorListener.bind(self);
        self._node.addEventListener('error', self._errorFn, false);

        // Listen for 'canplaythrough' event to let us know the sound is ready.
        self._loadFn = self._loadListener.bind(self);
        self._node.addEventListener(Howler._canPlayEvent, self._loadFn, false);

        // Listen for the 'ended' event on the sound to account for edge-case where
        // a finite sound has a duration of Infinity.
        self._endFn = self._endListener.bind(self);
        self._node.addEventListener('ended', self._endFn, false);

        // Setup the new audio node.
        self._node.src = parent._src;
        self._node.preload = parent._preload === true ? 'auto' : parent._preload;
        self._node.volume = volume * Howler.volume();

        // Begin loading the source.
        self._node.load();
      }

      return self;
    },

    /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */
    reset: function() {
      var self = this;
      var parent = self._parent;

      // Reset all of the parameters of this sound.
      self._muted = parent._muted;
      self._loop = parent._loop;
      self._volume = parent._volume;
      self._rate = parent._rate;
      self._seek = 0;
      self._rateSeek = 0;
      self._paused = true;
      self._ended = true;
      self._sprite = '__default';

      // Generate a new ID so that it isn't confused with the previous sound.
      self._id = ++Howler._counter;

      return self;
    },

    /**
     * HTML5 Audio error listener callback.
     */
    _errorListener: function() {
      var self = this;

      // Fire an error event and pass back the code.
      self._parent._emit('loaderror', self._id, self._node.error ? self._node.error.code : 0);

      // Clear the event listener.
      self._node.removeEventListener('error', self._errorFn, false);
    },

    /**
     * HTML5 Audio canplaythrough listener callback.
     */
    _loadListener: function() {
      var self = this;
      var parent = self._parent;

      // Round up the duration to account for the lower precision in HTML5 Audio.
      parent._duration = Math.ceil(self._node.duration * 10) / 10;

      // Setup a sprite if none is defined.
      if (Object.keys(parent._sprite).length === 0) {
        parent._sprite = {__default: [0, parent._duration * 1000]};
      }

      if (parent._state !== 'loaded') {
        parent._state = 'loaded';
        parent._emit('load');
        parent._loadQueue();
      }

      // Clear the event listener.
      self._node.removeEventListener(Howler._canPlayEvent, self._loadFn, false);
    },

    /**
     * HTML5 Audio ended listener callback.
     */
    _endListener: function() {
      var self = this;
      var parent = self._parent;

      // Only handle the `ended`` event if the duration is Infinity.
      if (parent._duration === Infinity) {
        // Update the parent duration to match the real audio duration.
        // Round up the duration to account for the lower precision in HTML5 Audio.
        parent._duration = Math.ceil(self._node.duration * 10) / 10;

        // Update the sprite that corresponds to the real duration.
        if (parent._sprite.__default[1] === Infinity) {
          parent._sprite.__default[1] = parent._duration * 1000;
        }

        // Run the regular ended method.
        parent._ended(self);
      }

      // Clear the event listener since the duration is now correct.
      self._node.removeEventListener('ended', self._endFn, false);
    }
  };

  /** Helper Methods **/
  /***************************************************************************/

  var cache = {};

  /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */
  var loadBuffer = function(self) {
    var url = self._src;

    // Check if the buffer has already been cached and use it instead.
    if (cache[url]) {
      // Set the duration from the cache.
      self._duration = cache[url].duration;

      // Load the sound into this Howl.
      loadSound(self);

      return;
    }

    if (/^data:[^;]+;base64,/.test(url)) {
      // Decode the base64 data URI without XHR, since some browsers don't support it.
      var data = atob(url.split(',')[1]);
      var dataView = new Uint8Array(data.length);
      for (var i=0; i<data.length; ++i) {
        dataView[i] = data.charCodeAt(i);
      }

      decodeAudioData(dataView.buffer, self);
    } else {
      // Load the buffer from the URL.
      var xhr = new XMLHttpRequest();
      xhr.open(self._xhr.method, url, true);
      xhr.withCredentials = self._xhr.withCredentials;
      xhr.responseType = 'arraybuffer';

      // Apply any custom headers to the request.
      if (self._xhr.headers) {
        Object.keys(self._xhr.headers).forEach(function(key) {
          xhr.setRequestHeader(key, self._xhr.headers[key]);
        });
      }

      xhr.onload = function() {
        // Make sure we get a successful response back.
        var code = (xhr.status + '')[0];
        if (code !== '0' && code !== '2' && code !== '3') {
          self._emit('loaderror', null, 'Failed loading audio file with status: ' + xhr.status + '.');
          return;
        }

        decodeAudioData(xhr.response, self);
      };
      xhr.onerror = function() {
        // If there is an error, switch to HTML5 Audio.
        if (self._webAudio) {
          self._html5 = true;
          self._webAudio = false;
          self._sounds = [];
          delete cache[url];
          self.load();
        }
      };
      safeXhrSend(xhr);
    }
  };

  /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */
  var safeXhrSend = function(xhr) {
    try {
      xhr.send();
    } catch (e) {
      xhr.onerror();
    }
  };

  /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */
  var decodeAudioData = function(arraybuffer, self) {
    // Fire a load error if something broke.
    var error = function() {
      self._emit('loaderror', null, 'Decoding audio data failed.');
    };

    // Load the sound on success.
    var success = function(buffer) {
      if (buffer && self._sounds.length > 0) {
        cache[self._src] = buffer;
        loadSound(self, buffer);
      } else {
        error();
      }
    };

    // Decode the buffer into an audio source.
    if (typeof Promise !== 'undefined' && Howler.ctx.decodeAudioData.length === 1) {
      Howler.ctx.decodeAudioData(arraybuffer).then(success).catch(error);
    } else {
      Howler.ctx.decodeAudioData(arraybuffer, success, error);
    }
  }

  /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */
  var loadSound = function(self, buffer) {
    // Set the duration.
    if (buffer && !self._duration) {
      self._duration = buffer.duration;
    }

    // Setup a sprite if none is defined.
    if (Object.keys(self._sprite).length === 0) {
      self._sprite = {__default: [0, self._duration * 1000]};
    }

    // Fire the loaded event.
    if (self._state !== 'loaded') {
      self._state = 'loaded';
      self._emit('load');
      self._loadQueue();
    }
  };

  /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */
  var setupAudioContext = function() {
    // If we have already detected that Web Audio isn't supported, don't run this step again.
    if (!Howler.usingWebAudio) {
      return;
    }

    // Check if we are using Web Audio and setup the AudioContext if we are.
    try {
      if (typeof AudioContext !== 'undefined') {
        Howler.ctx = new AudioContext();
      } else if (typeof webkitAudioContext !== 'undefined') {
        Howler.ctx = new webkitAudioContext();
      } else {
        Howler.usingWebAudio = false;
      }
    } catch(e) {
      Howler.usingWebAudio = false;
    }

    // If the audio context creation still failed, set using web audio to false.
    if (!Howler.ctx) {
      Howler.usingWebAudio = false;
    }

    // Check if a webview is being used on iOS8 or earlier (rather than the browser).
    // If it is, disable Web Audio as it causes crashing.
    var iOS = (/iP(hone|od|ad)/.test(Howler._navigator && Howler._navigator.platform));
    var appVersion = Howler._navigator && Howler._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    var version = appVersion ? parseInt(appVersion[1], 10) : null;
    if (iOS && version && version < 9) {
      var safari = /safari/.test(Howler._navigator && Howler._navigator.userAgent.toLowerCase());
      if (Howler._navigator && !safari) {
        Howler.usingWebAudio = false;
      }
    }

    // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
    if (Howler.usingWebAudio) {
      Howler.masterGain = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
      Howler.masterGain.gain.setValueAtTime(Howler._muted ? 0 : Howler._volume, Howler.ctx.currentTime);
      Howler.masterGain.connect(Howler.ctx.destination);
    }

    // Re-run the setup on Howler.
    Howler._setup();
  };

  // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return {
        Howler: Howler,
        Howl: Howl
      };
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }

  // Add support for CommonJS libraries such as browserify.
  if (true) {
    exports.Howler = Howler;
    exports.Howl = Howl;
  }

  // Add to global in Node.js (for testing, etc).
  if (typeof __webpack_require__.g !== 'undefined') {
    __webpack_require__.g.HowlerGlobal = HowlerGlobal;
    __webpack_require__.g.Howler = Howler;
    __webpack_require__.g.Howl = Howl;
    __webpack_require__.g.Sound = Sound;
  } else if (typeof window !== 'undefined') {  // Define globally in case AMD is not available or unused.
    window.HowlerGlobal = HowlerGlobal;
    window.Howler = Howler;
    window.Howl = Howl;
    window.Sound = Sound;
  }
})();


/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.2.3
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */

(function() {

  'use strict';

  // Setup default properties.
  HowlerGlobal.prototype._pos = [0, 0, 0];
  HowlerGlobal.prototype._orientation = [0, 0, -1, 0, 1, 0];

  /** Global Methods **/
  /***************************************************************************/

  /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */
  HowlerGlobal.prototype.stereo = function(pan) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Loop through all Howls and update their stereo panning.
    for (var i=self._howls.length-1; i>=0; i--) {
      self._howls[i].stereo(pan);
    }

    return self;
  };

  /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */
  HowlerGlobal.prototype.pos = function(x, y, z) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? self._pos[1] : y;
    z = (typeof z !== 'number') ? self._pos[2] : z;

    if (typeof x === 'number') {
      self._pos = [x, y, z];

      if (typeof self.ctx.listener.positionX !== 'undefined') {
        self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
        self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
        self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
      } else {
        self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
      }
    } else {
      return self._pos;
    }

    return self;
  };

  /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */
  HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    var or = self._orientation;
    y = (typeof y !== 'number') ? or[1] : y;
    z = (typeof z !== 'number') ? or[2] : z;
    xUp = (typeof xUp !== 'number') ? or[3] : xUp;
    yUp = (typeof yUp !== 'number') ? or[4] : yUp;
    zUp = (typeof zUp !== 'number') ? or[5] : zUp;

    if (typeof x === 'number') {
      self._orientation = [x, y, z, xUp, yUp, zUp];

      if (typeof self.ctx.listener.forwardX !== 'undefined') {
        self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.upX.setTargetAtTime(xUp, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.upY.setTargetAtTime(yUp, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.upZ.setTargetAtTime(zUp, Howler.ctx.currentTime, 0.1);
      } else {
        self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
      }
    } else {
      return or;
    }

    return self;
  };

  /** Group Methods **/
  /***************************************************************************/

  /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */
  Howl.prototype.init = (function(_super) {
    return function(o) {
      var self = this;

      // Setup user-defined default properties.
      self._orientation = o.orientation || [1, 0, 0];
      self._stereo = o.stereo || null;
      self._pos = o.pos || null;
      self._pannerAttr = {
        coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : 360,
        coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : 360,
        coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : 0,
        distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : 'inverse',
        maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : 10000,
        panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : 'HRTF',
        refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : 1,
        rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : 1
      };

      // Setup event listeners.
      self._onstereo = o.onstereo ? [{fn: o.onstereo}] : [];
      self._onpos = o.onpos ? [{fn: o.onpos}] : [];
      self._onorientation = o.onorientation ? [{fn: o.onorientation}] : [];

      // Complete initilization with howler.js core's init function.
      return _super.call(this, o);
    };
  })(Howl.prototype.init);

  /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */
  Howl.prototype.stereo = function(pan, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'stereo',
        action: function() {
          self.stereo(pan, id);
        }
      });

      return self;
    }

    // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
    var pannerType = (typeof Howler.ctx.createStereoPanner === 'undefined') ? 'spatial' : 'stereo';

    // Setup the group's stereo panning if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's stereo panning if no parameters are passed.
      if (typeof pan === 'number') {
        self._stereo = pan;
        self._pos = [pan, 0, 0];
      } else {
        return self._stereo;
      }
    }

    // Change the streo panning of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof pan === 'number') {
          sound._stereo = pan;
          sound._pos = [pan, 0, 0];

          if (sound._node) {
            // If we are falling back, make sure the panningModel is equalpower.
            sound._pannerAttr.panningModel = 'equalpower';

            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner || !sound._panner.pan) {
              setupPanner(sound, pannerType);
            }

            if (pannerType === 'spatial') {
              if (typeof sound._panner.positionX !== 'undefined') {
                sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
                sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
                sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
              } else {
                sound._panner.setPosition(pan, 0, 0);
              }
            } else {
              sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
            }
          }

          self._emit('stereo', sound._id);
        } else {
          return sound._stereo;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */
  Howl.prototype.pos = function(x, y, z, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change position when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'pos',
        action: function() {
          self.pos(x, y, z, id);
        }
      });

      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? 0 : y;
    z = (typeof z !== 'number') ? -0.5 : z;

    // Setup the group's spatial position if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's spatial position if no parameters are passed.
      if (typeof x === 'number') {
        self._pos = [x, y, z];
      } else {
        return self._pos;
      }
    }

    // Change the spatial position of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof x === 'number') {
          sound._pos = [x, y, z];

          if (sound._node) {
            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner || sound._panner.pan) {
              setupPanner(sound, 'spatial');
            }

            if (typeof sound._panner.positionX !== 'undefined') {
              sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
              sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
              sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
            } else {
              sound._panner.setPosition(x, y, z);
            }
          }

          self._emit('pos', sound._id);
        } else {
          return sound._pos;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */
  Howl.prototype.orientation = function(x, y, z, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'orientation',
        action: function() {
          self.orientation(x, y, z, id);
        }
      });

      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? self._orientation[1] : y;
    z = (typeof z !== 'number') ? self._orientation[2] : z;

    // Setup the group's spatial orientation if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's spatial orientation if no parameters are passed.
      if (typeof x === 'number') {
        self._orientation = [x, y, z];
      } else {
        return self._orientation;
      }
    }

    // Change the spatial orientation of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof x === 'number') {
          sound._orientation = [x, y, z];

          if (sound._node) {
            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner) {
              // Make sure we have a position to setup the node with.
              if (!sound._pos) {
                sound._pos = self._pos || [0, 0, -0.5];
              }

              setupPanner(sound, 'spatial');
            }

            if (typeof sound._panner.orientationX !== 'undefined') {
              sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
              sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
              sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
            } else {
              sound._panner.setOrientation(x, y, z);
            }
          }

          self._emit('orientation', sound._id);
        } else {
          return sound._orientation;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *
   * @return {Howl/Object} Returns self or current panner attributes.
   */
  Howl.prototype.pannerAttr = function() {
    var self = this;
    var args = arguments;
    var o, id, sound;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // Determine the values based on arguments.
    if (args.length === 0) {
      // Return the group's panner attribute values.
      return self._pannerAttr;
    } else if (args.length === 1) {
      if (typeof args[0] === 'object') {
        o = args[0];

        // Set the grou's panner attribute values.
        if (typeof id === 'undefined') {
          if (!o.pannerAttr) {
            o.pannerAttr = {
              coneInnerAngle: o.coneInnerAngle,
              coneOuterAngle: o.coneOuterAngle,
              coneOuterGain: o.coneOuterGain,
              distanceModel: o.distanceModel,
              maxDistance: o.maxDistance,
              refDistance: o.refDistance,
              rolloffFactor: o.rolloffFactor,
              panningModel: o.panningModel
            };
          }

          self._pannerAttr = {
            coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== 'undefined' ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
            coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== 'undefined' ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
            coneOuterGain: typeof o.pannerAttr.coneOuterGain !== 'undefined' ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
            distanceModel: typeof o.pannerAttr.distanceModel !== 'undefined' ? o.pannerAttr.distanceModel : self._distanceModel,
            maxDistance: typeof o.pannerAttr.maxDistance !== 'undefined' ? o.pannerAttr.maxDistance : self._maxDistance,
            refDistance: typeof o.pannerAttr.refDistance !== 'undefined' ? o.pannerAttr.refDistance : self._refDistance,
            rolloffFactor: typeof o.pannerAttr.rolloffFactor !== 'undefined' ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
            panningModel: typeof o.pannerAttr.panningModel !== 'undefined' ? o.pannerAttr.panningModel : self._panningModel
          };
        }
      } else {
        // Return this sound's panner attribute values.
        sound = self._soundById(parseInt(args[0], 10));
        return sound ? sound._pannerAttr : self._pannerAttr;
      }
    } else if (args.length === 2) {
      o = args[0];
      id = parseInt(args[1], 10);
    }

    // Update the values of the specified sounds.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      sound = self._soundById(ids[i]);

      if (sound) {
        // Merge the new values into the sound.
        var pa = sound._pannerAttr;
        pa = {
          coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : pa.coneInnerAngle,
          coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : pa.coneOuterAngle,
          coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : pa.coneOuterGain,
          distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : pa.distanceModel,
          maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : pa.maxDistance,
          refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : pa.refDistance,
          rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : pa.rolloffFactor,
          panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : pa.panningModel
        };

        // Update the panner values or create a new panner if none exists.
        var panner = sound._panner;
        if (panner) {
          panner.coneInnerAngle = pa.coneInnerAngle;
          panner.coneOuterAngle = pa.coneOuterAngle;
          panner.coneOuterGain = pa.coneOuterGain;
          panner.distanceModel = pa.distanceModel;
          panner.maxDistance = pa.maxDistance;
          panner.refDistance = pa.refDistance;
          panner.rolloffFactor = pa.rolloffFactor;
          panner.panningModel = pa.panningModel;
        } else {
          // Make sure we have a position to setup the node with.
          if (!sound._pos) {
            sound._pos = self._pos || [0, 0, -0.5];
          }

          // Create a new panner node.
          setupPanner(sound, 'spatial');
        }
      }
    }

    return self;
  };

  /** Single Sound Methods **/
  /***************************************************************************/

  /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */
  Sound.prototype.init = (function(_super) {
    return function() {
      var self = this;
      var parent = self._parent;

      // Setup user-defined default properties.
      self._orientation = parent._orientation;
      self._stereo = parent._stereo;
      self._pos = parent._pos;
      self._pannerAttr = parent._pannerAttr;

      // Complete initilization with howler.js core Sound's init function.
      _super.call(this);

      // If a stereo or position was specified, set it up.
      if (self._stereo) {
        parent.stereo(self._stereo);
      } else if (self._pos) {
        parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
      }
    };
  })(Sound.prototype.init);

  /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */
  Sound.prototype.reset = (function(_super) {
    return function() {
      var self = this;
      var parent = self._parent;

      // Reset all spatial plugin properties on this sound.
      self._orientation = parent._orientation;
      self._stereo = parent._stereo;
      self._pos = parent._pos;
      self._pannerAttr = parent._pannerAttr;

      // If a stereo or position was specified, set it up.
      if (self._stereo) {
        parent.stereo(self._stereo);
      } else if (self._pos) {
        parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
      } else if (self._panner) {
        // Disconnect the panner.
        self._panner.disconnect(0);
        self._panner = undefined;
        parent._refreshBuffer(self);
      }

      // Complete resetting of the sound.
      return _super.call(this);
    };
  })(Sound.prototype.reset);

  /** Helper Methods **/
  /***************************************************************************/

  /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */
  var setupPanner = function(sound, type) {
    type = type || 'spatial';

    // Create the new panner node.
    if (type === 'spatial') {
      sound._panner = Howler.ctx.createPanner();
      sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
      sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
      sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
      sound._panner.distanceModel = sound._pannerAttr.distanceModel;
      sound._panner.maxDistance = sound._pannerAttr.maxDistance;
      sound._panner.refDistance = sound._pannerAttr.refDistance;
      sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
      sound._panner.panningModel = sound._pannerAttr.panningModel;

      if (typeof sound._panner.positionX !== 'undefined') {
        sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
        sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
        sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
      } else {
        sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
      }

      if (typeof sound._panner.orientationX !== 'undefined') {
        sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
        sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
        sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
      } else {
        sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
      }
    } else {
      sound._panner = Howler.ctx.createStereoPanner();
      sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
    }

    sound._panner.connect(sound._node);

    // Update the connections.
    if (!sound._paused) {
      sound._parent.pause(sound._id, true).play(sound._id, true);
    }
  };
})();


/***/ })
/******/ 	]);
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AppConfigContext": () => (/* reexport safe */ _providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_4__.AppConfigContext),
/* harmony export */   "ErrorBoundary": () => (/* reexport safe */ _components__WEBPACK_IMPORTED_MODULE_8__.ErrorBoundary),
/* harmony export */   "FeedItemType": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.FeedItemType),
/* harmony export */   "GamificationPanel": () => (/* reexport safe */ _components__WEBPACK_IMPORTED_MODULE_8__.GamificationPanel),
/* harmony export */   "LayoutContext": () => (/* reexport safe */ _providers_LayoutContext__WEBPACK_IMPORTED_MODULE_3__.LayoutContext),
/* harmony export */   "QuizModal": () => (/* reexport safe */ _quiz__WEBPACK_IMPORTED_MODULE_0__["default"]),
/* harmony export */   "QuizProgressGraph": () => (/* reexport safe */ _components__WEBPACK_IMPORTED_MODULE_8__.QuizProgressGraph),
/* harmony export */   "ThemeContext": () => (/* reexport safe */ _providers_ThemeContext__WEBPACK_IMPORTED_MODULE_2__.ThemeContext),
/* harmony export */   "UserLevelIndicator": () => (/* reexport safe */ _components__WEBPACK_IMPORTED_MODULE_8__.UserLevelIndicator),
/* harmony export */   "_throw": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_5__._throw),
/* harmony export */   "assets": () => (/* reexport module object */ _components_assets__WEBPACK_IMPORTED_MODULE_9__),
/* harmony export */   "convertHMS": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_5__.convertHMS),
/* harmony export */   "createChapter": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.createChapter),
/* harmony export */   "createCourse": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.createCourse),
/* harmony export */   "createMedia": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.createMedia),
/* harmony export */   "createMediaForLink": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.createMediaForLink),
/* harmony export */   "createPartner": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.createPartner),
/* harmony export */   "createPublisher": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.createPublisher),
/* harmony export */   "createQuestion": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.createQuestion),
/* harmony export */   "createUploadMedia": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.createUploadMedia),
/* harmony export */   "createUserCourse": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.createUserCourse),
/* harmony export */   "deleteChapter": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.deleteChapter),
/* harmony export */   "deleteCourse": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.deleteCourse),
/* harmony export */   "deleteMedia": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.deleteMedia),
/* harmony export */   "deletePartner": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.deletePartner),
/* harmony export */   "deleteReview": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.deleteReview),
/* harmony export */   "deleteTopic": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.deleteTopic),
/* harmony export */   "deleteUser": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.deleteUser),
/* harmony export */   "dismissAllNotifications": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.dismissAllNotifications),
/* harmony export */   "fetchData": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.fetchData),
/* harmony export */   "generatePartnerQuiz": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.generatePartnerQuiz),
/* harmony export */   "generateQuiz": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.generateQuiz),
/* harmony export */   "getAdminHomeFeed": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getAdminHomeFeed),
/* harmony export */   "getAllMedia": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getAllMedia),
/* harmony export */   "getAllPartners": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getAllPartners),
/* harmony export */   "getAllPublishers": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getAllPublishers),
/* harmony export */   "getAllRequests": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getAllRequests),
/* harmony export */   "getAllTopics": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getAllTopics),
/* harmony export */   "getAllUsers": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getAllUsers),
/* harmony export */   "getCountedUsers": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getCountedUsers),
/* harmony export */   "getCourse": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getCourse),
/* harmony export */   "getCourses": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getCourses),
/* harmony export */   "getFilteredMedia": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getFilteredMedia),
/* harmony export */   "getGenerations": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getGenerations),
/* harmony export */   "getHomeFeed": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getHomeFeed),
/* harmony export */   "getLevel": () => (/* reexport safe */ _xp__WEBPACK_IMPORTED_MODULE_7__.getLevel),
/* harmony export */   "getMedia": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getMedia),
/* harmony export */   "getMediaData": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getMediaData),
/* harmony export */   "getMediaFromQuiz": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getMediaFromQuiz),
/* harmony export */   "getMediaReview": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getMediaReview),
/* harmony export */   "getMedias": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getMedias),
/* harmony export */   "getMyNotifications": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getMyNotifications),
/* harmony export */   "getMyTopics": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getMyTopics),
/* harmony export */   "getPublisher": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getPublisher),
/* harmony export */   "getQuestionFeedback": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getQuestionFeedback),
/* harmony export */   "getQuiz": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getQuiz),
/* harmony export */   "getQuizData": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getQuizData),
/* harmony export */   "getQuizFeedback": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getQuizFeedback),
/* harmony export */   "getQuizzes": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getQuizzes),
/* harmony export */   "getRecommendations": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getRecommendations),
/* harmony export */   "getRecommendationsForMedia": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getRecommendationsForMedia),
/* harmony export */   "getTags": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getTags),
/* harmony export */   "getTopic": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getTopic),
/* harmony export */   "getTopics": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getTopics),
/* harmony export */   "getTranscript": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getTranscript),
/* harmony export */   "getUserAchievements": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getUserAchievements),
/* harmony export */   "getUserCourse": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getUserCourse),
/* harmony export */   "getUserCourses": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getUserCourses),
/* harmony export */   "getUserData": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getUserData),
/* harmony export */   "getUserMediaTags": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getUserMediaTags),
/* harmony export */   "getUserPinned": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getUserPinned),
/* harmony export */   "getUserStats": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.getUserStats),
/* harmony export */   "logMetrics": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.logMetrics),
/* harmony export */   "refreshToken": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.refreshToken),
/* harmony export */   "registerFCMToken": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.registerFCMToken),
/* harmony export */   "requestQuiz": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.requestQuiz),
/* harmony export */   "requestReminder": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.requestReminder),
/* harmony export */   "saveAllChanges": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.saveAllChanges),
/* harmony export */   "saveChapter": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.saveChapter),
/* harmony export */   "saveNewUser": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.saveNewUser),
/* harmony export */   "saveQuestionAnswer": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.saveQuestionAnswer),
/* harmony export */   "saveQuizAnswers": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.saveQuizAnswers),
/* harmony export */   "saveQuizToLibrary": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.saveQuizToLibrary),
/* harmony export */   "saveUserChange": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.saveUserChange),
/* harmony export */   "saveUserTopics": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.saveUserTopics),
/* harmony export */   "sendMeTestNotification": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.sendMeTestNotification),
/* harmony export */   "setCourse": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.setCourse),
/* harmony export */   "setPartner": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.setPartner),
/* harmony export */   "setQuestionFeedback": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.setQuestionFeedback),
/* harmony export */   "setQuizFeedback": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.setQuizFeedback),
/* harmony export */   "setUserCourse": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.setUserCourse),
/* harmony export */   "setUserMediaTags": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.setUserMediaTags),
/* harmony export */   "setUserPinned": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.setUserPinned),
/* harmony export */   "setUserPublisher": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.setUserPublisher),
/* harmony export */   "setUserTopic": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.setUserTopic),
/* harmony export */   "setupRequests": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.setupRequests),
/* harmony export */   "signUserOut": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.signUserOut),
/* harmony export */   "sleep": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_5__.sleep),
/* harmony export */   "stripNullish": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_5__.stripNullish),
/* harmony export */   "stripUndefined": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_5__.stripUndefined),
/* harmony export */   "updateFeedItem": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.updateFeedItem),
/* harmony export */   "updateMedia": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.updateMedia),
/* harmony export */   "updateNotification": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.updateNotification),
/* harmony export */   "updateORCreateTopic": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.updateORCreateTopic),
/* harmony export */   "updatePublisher": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.updatePublisher),
/* harmony export */   "updateQuestion": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.updateQuestion),
/* harmony export */   "updateQuestionsForChapter": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.updateQuestionsForChapter),
/* harmony export */   "useAllUsers": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.useAllUsers),
/* harmony export */   "useButtonBopAnimation": () => (/* reexport safe */ _hooks__WEBPACK_IMPORTED_MODULE_1__.useButtonBopAnimation),
/* harmony export */   "useColourSample": () => (/* reexport safe */ _hooks__WEBPACK_IMPORTED_MODULE_1__.useColourSample),
/* harmony export */   "useKey": () => (/* reexport safe */ _hooks__WEBPACK_IMPORTED_MODULE_1__.useKey),
/* harmony export */   "useMedia": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.useMedia),
/* harmony export */   "useMediaReview": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.useMediaReview),
/* harmony export */   "useReview": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.useReview),
/* harmony export */   "useStarsAnimation": () => (/* reexport safe */ _hooks__WEBPACK_IMPORTED_MODULE_1__.useStarsAnimation),
/* harmony export */   "useTitle": () => (/* reexport safe */ _hooks__WEBPACK_IMPORTED_MODULE_1__.useTitle),
/* harmony export */   "useUserAchievements": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.useUserAchievements),
/* harmony export */   "useUserActivity": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.useUserActivity),
/* harmony export */   "useUserStats": () => (/* reexport safe */ _requests__WEBPACK_IMPORTED_MODULE_6__.useUserStats)
/* harmony export */ });
/* harmony import */ var _quiz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(234);
/* harmony import */ var _providers_ThemeContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(118);
/* harmony import */ var _providers_LayoutContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(204);
/* harmony import */ var _providers_AppConfigContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(105);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(236);
/* harmony import */ var _requests__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
/* harmony import */ var _xp__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(215);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(238);
/* harmony import */ var _components_assets__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(254);












})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});